webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(544);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jquery = __webpack_require__(19);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(531);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(405);
	
	__webpack_require__(397);
	
	var _veeValidate = __webpack_require__(537);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFacebookSigninButton = __webpack_require__(541);
	
	var _vueFacebookSigninButton2 = _interopRequireDefault(_vueFacebookSigninButton);
	
	var _fontAwesome = __webpack_require__(406);
	
	var _fontAwesome2 = _interopRequireDefault(_fontAwesome);
	
	var _Alert = __webpack_require__(66);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _vueChatScroll = __webpack_require__(540);
	
	var _vueChatScroll2 = _interopRequireDefault(_vueChatScroll);
	
	var _bootstrapDatepicker = __webpack_require__(324);
	
	var _bootstrapDatepicker2 = _interopRequireDefault(_bootstrapDatepicker);
	
	var _vueScrollto = __webpack_require__(668);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _vueAnalytics = __webpack_require__(538);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _vueSmoothscroll = __webpack_require__(669);
	
	var _vueSmoothscroll2 = _interopRequireDefault(_vueSmoothscroll);
	
	var _vueHead = __webpack_require__(542);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _timepicker = __webpack_require__(535);
	
	var _timepicker2 = _interopRequireDefault(_timepicker);
	
	var _blueimpCanvasToBlob = __webpack_require__(69);
	
	var _blueimpCanvasToBlob2 = _interopRequireDefault(_blueimpCanvasToBlob);
	
	var _fullcalendar = __webpack_require__(79);
	
	var _fullcalendar2 = _interopRequireDefault(_fullcalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = window.jQuery = _jquery2.default;
	
	
	_vue2.default.use(_vueScrollto2.default);
	var SocialSharing = __webpack_require__(670);
	_vue2.default.use(SocialSharing);
	
	_vue2.default.use(_vueAnalytics2.default, {
	  id: "UA-107726997-1",
	  disableScriptLoader: true
	});
	
	_vue2.default.component("alert", _Alert2.default);
	_vue2.default.use(_vueFacebookSigninButton2.default);
	_vue2.default.use(_vueHead2.default);
	_vue2.default.use(_fontAwesome2.default);
	_vue2.default.use(_vueChatScroll2.default);
	_vue2.default.use(_veeValidate2.default);
	_vue2.default.use(_vueSmoothscroll2.default);
	_vue2.default.mixin({
	  data: function data() {
	    return {
	      get countryCurrency() {
	        return _store2.default.getters.CountryData.Currency;
	      }
	    };
	  }
	});
	
	_vue2.default.config.debug = ("production") !== "production";
	
	window.moment = __webpack_require__(1);
	window.moment.tz = __webpack_require__(529);
	
	window.fbAsyncInit = function () {
	  FB.init({
	    appId: "279352372578608",
	    cookie: true,
	    xfbml: true,
	    version: "v2.8" });
	};
	(function (d, s, id) {
	  var js,
	      fjs = d.getElementsByTagName(s)[0];
	  if (d.getElementById(id)) return;
	  js = d.createElement(s);
	  js.id = id;
	  js.src = "//connect.facebook.net/en_US/sdk.js";
	  fjs.parentNode.insertBefore(js, fjs);
	})(document, "script", "facebook-jssdk");
	
	__webpack_require__(407);
	__webpack_require__(479);
	__webpack_require__(478);
	__webpack_require__(251);
	__webpack_require__(399);
	__webpack_require__(402);
	__webpack_require__(326);
	__webpack_require__(408);
	__webpack_require__(409);
	__webpack_require__(325);
	__webpack_require__(404);
	__webpack_require__(411);
	__webpack_require__(403);
	__webpack_require__(400);
	
	exports.default = {
	  user: {
	    authenticated: false
	  },
	  router: _router2.default
	};
	
	
	var app = new _vue2.default({
	  el: "#app",
	  router: _router2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount(app);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(68);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(673);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  email: "",
	  firstName: "",
	  lastName: "",
	  phoneNumber: "",
	  phoneConfirmed: false,
	  authenticated: false,
	  userRole: "",
	  customerId: "",
	  sitterProfile: "",
	  sitterPetPrefs: "",
	  sitterServices: "",
	  sitterHomeDetails: "",
	  sitterLocation: "",
	  regionsList: [{
	    RegionId: 1,
	    RegionName: "Central"
	  }, {
	    RegionId: 2,
	    RegionName: "East"
	  }, {
	    RegionId: 3,
	    RegionName: "North East"
	  }, {
	    RegionId: 4,
	    RegionName: "West"
	  }, {
	    RegionId: 5,
	    RegionName: "North"
	  }],
	  countriesList: [{
	    CountryId: 1,
	    CountryName: "United Arab Emirates",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/uae_flag.png"
	  }, {
	    CountryId: 9,
	    CountryName: "Singapore",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/singapore_flag.png"
	  }, {
	    CountryId: 3,
	    CountryName: "Qatar",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/qatar_flag.png"
	  }, {
	    CountryId: 4,
	    CountryName: "Kuwait",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/kuwait_flag.png"
	  }, {
	    CountryId: 5,
	    CountryName: "Bahrain",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/bahrain_flag.png"
	  }, {
	    CountryId: 6,
	    CountryName: "Jordan",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/jordan_flag.png"
	  }, {
	    CountryId: 7,
	    CountryName: "Oman",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/oman_flag.png"
	  }, {
	    CountryId: 8,
	    CountryName: "Lebanon",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/lebanon_flag.png"
	  }, {
	    CountryId: 2,
	    CountryName: "Saudi Arabia",
	    CountryFlag: "https://www.dupaws.com/services/images/countries/ksa_flag.png"
	  }],
	  citiesList: "",
	  selectCountry: "",
	  countryData: "",
	  staycationData: "",
	  areasList: "",
	  filteredAreasList: "",
	  profilePicUrl: "",
	  sitterId: "",
	  sittersList: "",
	  sitterPublicDetails: "",
	  queryData: {
	    countryId: "",
	    dogwalkingdays: "",
	    areaId: "",
	    cityId: "",
	    end: "",
	    sort: 0,
	    regionId: 0,
	    petpref: "",
	    homeType: "",
	    currentPage: 0,
	    serviceType: "",
	    start: "",
	    isOnline: ""
	  },
	  sitterPhotos: "",
	  petsList: "",
	  favoriteSitters: "",
	  signalRConnection: "",
	  signalRHub: "",
	  subscriptionStatus: "",
	  notifications: []
	};
	
	var mutations = (_mutations = {
	  authCheck: function authCheck(state, data) {
	    state.authenticated = data;
	  },
	  selectCountry: function selectCountry(state, data) {
	    state.selectCountry = data;
	  },
	  subscriptionStatus: function subscriptionStatus(state, data) {
	    state.subscriptionStatus = data;
	  },
	  phoneConfirmed: function phoneConfirmed(state, data) {
	    state.phoneConfirmed = data;
	  },
	  calendarEvent: function calendarEvent(state, data) {
	    state.calendarEvent = data;
	  },
	  userRole: function userRole(state, data) {
	    state.userRole = data;
	  },
	  phoneNumber: function phoneNumber(state, data) {
	    state.phoneNumber = data;
	  },
	  sitterProfile: function sitterProfile(state, data) {
	    state.sitterProfile = data;
	  },
	  firstName: function firstName(state, data) {
	    state.firstName = data;
	  },
	  sitterId: function sitterId(state, data) {
	    state.sitterId = data;
	  },
	  customerId: function customerId(state, data) {
	    state.customerId = data;
	  },
	  lastName: function lastName(state, data) {
	    state.lastName = data;
	  },
	  email: function email(state, data) {
	    state.email = data;
	  },
	  sitterPetPrefs: function sitterPetPrefs(state, data) {
	    state.sitterPetPrefs = data;
	  },
	  sitterServices: function sitterServices(state, data) {
	    state.sitterServices = data;
	  },
	  sitterHomeDetails: function sitterHomeDetails(state, data) {
	    state.sitterHomeDetails = data;
	  },
	  sitterLocation: function sitterLocation(state, data) {
	    state.sitterLocation = data;
	  },
	  countriesList: function countriesList(state, data) {
	    state.countriesList = data;
	  },
	  countryData: function countryData(state, data) {
	    state.countryData = data;
	  },
	  staycationData: function staycationData(state, data) {
	    state.staycationData = data;
	  },
	  citiesList: function citiesList(state, data) {
	    state.citiesList = data;
	  },
	  regionsList: function regionsList(state, data) {
	    state.regionsList = data;
	  },
	  areasList: function areasList(state, data) {
	    state.areasList = data;
	  },
	  filteredAreasList: function filteredAreasList(state, data) {
	    state.filteredAreasList = data;
	  },
	  profilePicUrl: function profilePicUrl(state, data) {
	    state.profilePicUrl = data;
	  }
	}, (0, _defineProperty3.default)(_mutations, "sitterId", function sitterId(state, data) {
	  state.sitterId = data;
	}), (0, _defineProperty3.default)(_mutations, "sittersList", function sittersList(state, data) {
	  state.sittersList = data;
	}), (0, _defineProperty3.default)(_mutations, "sitterPublicDetails", function sitterPublicDetails(state, data) {
	  state.sitterPublicDetails = data;
	}), (0, _defineProperty3.default)(_mutations, "queryData", function queryData(state, data) {
	  state.queryData = data;
	}), (0, _defineProperty3.default)(_mutations, "queryDataServiceType", function queryDataServiceType(state, data) {
	  state.queryData.serviceType = data;
	}), (0, _defineProperty3.default)(_mutations, "sitterPhotos", function sitterPhotos(state, data) {
	  state.sitterPhotos = data;
	}), (0, _defineProperty3.default)(_mutations, "deleteSitterPhoto", function deleteSitterPhoto(state, photo) {
	  var index = state.sitterPhotos.findIndex(function (t) {
	    return t.SitterPhotoId === photo.SitterPhotoId;
	  });
	  state.sitterPhotos.splice(index, 1);
	}), (0, _defineProperty3.default)(_mutations, "deletePet", function deletePet(state, pet) {
	  var index = state.petsList.findIndex(function (t) {
	    return t.PetId === pet.PetId;
	  });
	  state.petsList.splice(index, 1);
	}), (0, _defineProperty3.default)(_mutations, "petsList", function petsList(state, data) {
	  state.petsList = data;
	}), (0, _defineProperty3.default)(_mutations, "favoriteSitters", function favoriteSitters(state, data) {
	  state.favoriteSitters = data;
	}), (0, _defineProperty3.default)(_mutations, "signalRConnection", function signalRConnection(state, data) {
	  state.signalRConnection = data;
	}), (0, _defineProperty3.default)(_mutations, "signalRHub", function signalRHub(state, data) {
	  state.signalRHub = data;
	}), (0, _defineProperty3.default)(_mutations, "notifications", function notifications(state, data) {
	  state.notifications = data;
	}), (0, _defineProperty3.default)(_mutations, "deleteNotification", function deleteNotification(state, notification) {
	  var index = state.notifications.findIndex(function (t) {
	    return t.UserNotificationId === notification.UserNotificationId;
	  });
	  state.notifications.splice(index, 1);
	}), (0, _defineProperty3.default)(_mutations, "readNotification", function readNotification(state, notification) {
	  var index = state.notifications.findIndex(function (t) {
	    return t.UserNotificationId === notification.UserNotificationId;
	  });
	  if (index != null && state.notifications.length > 0) {
	    state.notifications[index].IsRead = true;
	  }
	}), (0, _defineProperty3.default)(_mutations, "readNotificationTrans", function readNotificationTrans(state, reservationId) {
	  var key = parseInt(reservationId);
	  state.notifications.forEach(function (element) {
	    if (element.ServiceTransactionId == key) element.IsRead = true;
	  }, this);
	}), (0, _defineProperty3.default)(_mutations, "addNotification", function addNotification(state, data) {
	  state.notifications.push(data);
	}), (0, _defineProperty3.default)(_mutations, "updateNotification", function updateNotification(state, data) {
	  var index = state.notifications.findIndex(function (t) {
	    return t.UserNotificationId === data.UserNotificationId;
	  });
	  if (index != null && index != -1 && state.notifications.length > 0) {
	    state.notifications[index].Message = data.Message;
	    state.notifications[index].SentDate = data.SentDate;
	    state.notifications[index].IsRead = false;
	  } else {
	    console.log("Couldn't update notification");
	  }
	}), (0, _defineProperty3.default)(_mutations, "clearFilters", function clearFilters(state) {
	  state.queryData = {
	    areaId: null,
	    cityId: null,
	    end: null,
	    sort: 0,
	    regionId: 0,
	    serviceType: null,
	    start: null,
	    homeType: null,
	    petpref: null,
	    priceRange: null
	  };
	}), _mutations);
	
	var actions = {
	  UserRole: function UserRole(_ref, data) {
	    var commit = _ref.commit;
	    return commit("userRole", data);
	  },
	  SubscriptionStatus: function SubscriptionStatus(_ref2, data) {
	    var commit = _ref2.commit;
	    return commit("subscriptionStatus", data);
	  },
	  FirstName: function FirstName(_ref3, data) {
	    var commit = _ref3.commit;
	    return commit("firstName", data);
	  },
	  LastName: function LastName(_ref4, data) {
	    var commit = _ref4.commit;
	    return commit("lastName", data);
	  },
	  SitterProfile: function SitterProfile(_ref5, data) {
	    var commit = _ref5.commit;
	    return commit("sitterProfile", data);
	  },
	  PhoneNumber: function PhoneNumber(_ref6, data) {
	    var commit = _ref6.commit;
	    return commit("phoneNumber", data);
	  },
	  PhoneConfirmed: function PhoneConfirmed(_ref7, data) {
	    var commit = _ref7.commit;
	    return commit("phoneConfirmed", data);
	  },
	  SitterPetPrefs: function SitterPetPrefs(_ref8, data) {
	    var commit = _ref8.commit;
	    return commit("sitterPetPrefs", data);
	  },
	  SitterServices: function SitterServices(_ref9, data) {
	    var commit = _ref9.commit;
	    return commit("sitterServices", data);
	  },
	  SitterHomeDetails: function SitterHomeDetails(_ref10, data) {
	    var commit = _ref10.commit;
	    return commit("sitterHomeDetails", data);
	  },
	  SitterLocation: function SitterLocation(_ref11, data) {
	    var commit = _ref11.commit;
	    return commit("sitterLocation", data);
	  },
	  CountriesList: function CountriesList(_ref12, data) {
	    var commit = _ref12.commit;
	    return commit("countriesList", data);
	  },
	  RegionsList: function RegionsList(_ref13, data) {
	    var commit = _ref13.commit;
	    return commit("regionsList", data);
	  },
	  CitiesList: function CitiesList(_ref14, data) {
	    var commit = _ref14.commit;
	    return commit("citiesList", data);
	  },
	  CountryData: function CountryData(_ref15, data) {
	    var commit = _ref15.commit;
	    return commit("countryData", data);
	  },
	  StaycationData: function StaycationData(_ref16, data) {
	    var commit = _ref16.commit;
	    return commit("staycationData", data);
	  },
	  SelectCountry: function SelectCountry(_ref17, data) {
	    var commit = _ref17.commit;
	    return commit("selectCountry", data);
	  },
	  AreasList: function AreasList(_ref18, data) {
	    var commit = _ref18.commit;
	    return commit("areasList", data);
	  },
	  FilteredAreasList: function FilteredAreasList(_ref19, data) {
	    var commit = _ref19.commit;
	    return commit("filteredAreasList", data);
	  },
	  Email: function Email(_ref20, data) {
	    var commit = _ref20.commit;
	    return commit("email", data);
	  },
	  ProfilePicUrl: function ProfilePicUrl(_ref21, data) {
	    var commit = _ref21.commit;
	    return commit("profilePicUrl", data);
	  },
	  SittersList: function SittersList(_ref22, data) {
	    var commit = _ref22.commit;
	    return commit("sittersList", data);
	  },
	  SitterPublicDetails: function SitterPublicDetails(_ref23, data) {
	    var commit = _ref23.commit;
	    return commit("sitterPublicDetails", data);
	  },
	  SitterId: function SitterId(_ref24, data) {
	    var commit = _ref24.commit;
	    return commit("sitterId", data);
	  },
	  QueryData: function QueryData(_ref25, data) {
	    var commit = _ref25.commit;
	    return commit("queryData", data);
	  },
	  SitterPhotos: function SitterPhotos(_ref26, data) {
	    var commit = _ref26.commit;
	    return commit("sitterPhotos", data);
	  },
	  sitterId: function sitterId(_ref27, data) {
	    var commit = _ref27.commit;
	    return commit("sitterId", data);
	  },
	  CustomerId: function CustomerId(_ref28, data) {
	    var commit = _ref28.commit;
	    return commit("customerId", data);
	  },
	  PetsList: function PetsList(_ref29, data) {
	    var commit = _ref29.commit;
	    return commit("petsList", data);
	  },
	  FavoriteSitters: function FavoriteSitters(_ref30, data) {
	    var commit = _ref30.commit;
	    return commit("favoriteSitters", data);
	  },
	  SignalRConnection: function SignalRConnection(_ref31, data) {
	    var commit = _ref31.commit;
	    return commit("signalRConnection", data);
	  },
	  SignalRHub: function SignalRHub(_ref32, data) {
	    var commit = _ref32.commit;
	    return commit("signalRHub", data);
	  },
	  Notifications: function Notifications(_ref33, data) {
	    var commit = _ref33.commit;
	    return commit("notifications", data);
	  }
	};
	
	var getters = {
	  authenticated: function authenticated(state) {
	    return state.authenticated;
	  },
	  firstName: function firstName(state) {
	    return state.firstName;
	  },
	  lastName: function lastName(state) {
	    return state.lastName;
	  },
	  userRole: function userRole(state) {
	    return state.userRole;
	  },
	  SitterProfile: function SitterProfile(state) {
	    return state.sitterProfile;
	  },
	  SitterPetPrefs: function SitterPetPrefs(state) {
	    return state.sitterPetPrefs;
	  },
	  SubscriptionStatus: function SubscriptionStatus(state) {
	    return state.subscriptionStatus;
	  },
	  PhoneNumber: function PhoneNumber(state) {
	    return state.phoneNumber;
	  },
	  PhoneConfirmed: function PhoneConfirmed(state) {
	    return state.phoneConfirmed;
	  },
	  SitterServices: function SitterServices(state) {
	    return state.sitterServices;
	  },
	  SitterHomeDetails: function SitterHomeDetails(state) {
	    return state.sitterHomeDetails;
	  },
	  SitterLocation: function SitterLocation(state) {
	    return state.sitterLocation;
	  },
	  CountriesList: function CountriesList(state) {
	    return state.countriesList;
	  },
	  CitiesList: function CitiesList(state) {
	    return state.citiesList;
	  },
	  RegionsList: function RegionsList(state) {
	    return state.regionsList;
	  },
	  CountryData: function CountryData(state) {
	    return state.countryData;
	  },
	  StaycationData: function StaycationData(state) {
	    return state.staycationData;
	  },
	  SelectCountry: function SelectCountry(state) {
	    return state.selectCountry;
	  },
	  AreasList: function AreasList(state) {
	    return state.areasList;
	  },
	  FilteredAreasList: function FilteredAreasList(state) {
	    return state.filteredAreasList;
	  },
	  email: function email(state) {
	    return state.email;
	  },
	  profilePicUrl: function profilePicUrl(state) {
	    return state.profilePicUrl;
	  },
	  sitterId: function sitterId(state) {
	    return state.sitterId;
	  },
	  SittersList: function SittersList(state) {
	    return state.sittersList;
	  },
	  sitterPublicDetails: function sitterPublicDetails(state) {
	    return state.sitterPublicDetails;
	  },
	  QueryData: function QueryData(state) {
	    return state.queryData;
	  },
	  SitterPhotos: function SitterPhotos(state) {
	    return state.sitterPhotos;
	  },
	  SitterId: function SitterId(state) {
	    return state.sitterId;
	  },
	  CustomerId: function CustomerId(state) {
	    return state.customerId;
	  },
	  PetsList: function PetsList(state) {
	    return state.petsList;
	  },
	  FavoriteSitters: function FavoriteSitters(state) {
	    return state.favoriteSitters;
	  },
	  SignalRConnection: function SignalRConnection(state) {
	    return state.signalRConnection;
	  },
	  SignalRHub: function SignalRHub(state) {
	    return state.signalRHub;
	  },
	  Notifications: function Notifications(state) {
	    return state.notifications;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	});

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _jquery = __webpack_require__(19);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/api/account/Register/";
	
	var LOGIN_URL = "https://www.dupaws.com/services/Token";
	var LOGINEXTERNAL_URL = "https://www.dupaws.com/services/api/account/RegisterExternalToken";
	var SIGNUP_URL = API_URL + "users/";
	
	exports.default = {
	  register: function register(context, creds, redirect) {
	    var self = this;
	    var credentials = "grant_type=password&username=" + encodeURIComponent(creds.Email) + "&password=" + encodeURIComponent(creds.Password) + "&FirstName=" + encodeURIComponent(creds.FirstName) + "&LastName=" + encodeURIComponent(creds.LastName);
	    var loginCreds = {
	      grant_type: "password",
	      username: creds.Email,
	      password: creds.Password,
	      FirstName: creds.FirstName,
	      LastName: creds.LastName
	    };
	    context.error = "";
	    context.notification = "Registering account..";
	    $.ajax({
	      type: "POST",
	      url: API_URL,
	      data: (0, _stringify2.default)(creds),
	      dataType: "json",
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        context.notification = data;
	        context.error = "";
	
	        if (creds.userRole == "Sitter") {
	          fbq("track", "CompleteRegistration", {
	            content_name: "Sitter registration"
	          });
	          context.$ga.event("Signup Complete", "Sitter registration");
	        } else {
	          fbq("track", "CompleteRegistration", {
	            content_name: "Client registration"
	          });
	          context.$ga.event("Signup Complete", "Client registration");
	        }
	        self.login(context, loginCreds, redirect);
	      },
	      error: function error(data, status, _error) {
	        try {
	          context.notification = "";
	          context.error = data.responseJSON.ModelState[""][0];
	        } catch (e) {
	          context.notification = "";
	          context.error = "Oops we are having error with your registration, server is not reachable..";
	        }
	      }
	    });
	  },
	  login: function login(context, loginCreds, redirect) {
	    context.error = "";
	    context.notification = "Logging you in";
	    $.ajax({
	      type: "POST",
	      headers: {
	        "Content-Type": "x-www-form-urlencoded"
	      },
	      url: LOGIN_URL,
	      data: loginCreds,
	      success: function success(data) {
	        localStorage.setItem("access_token", data.access_token);
	        localStorage.setItem("email", data.userName);
	        localStorage.setItem("loggedDate", (0, _stringify2.default)(moment()));
	        _store2.default.commit("email", data.userName);
	
	        if (data.phoneConfirmed == "True" || data.phoneConfirmed == "true") {
	          localStorage.setItem("phoneConfirmed", "True");
	          _store2.default.commit("phoneConfirmed", true);
	        } else {
	          localStorage.setItem("phoneConfirmed", "False");
	          _store2.default.commit("phoneConfirmed", false);
	        }
	        localStorage.setItem("firstName", data.firstName);
	        localStorage.setItem("lastName", data.lastName);
	        localStorage.setItem("doubleRole", data.doubleRole);
	        _store2.default.commit("firstName", localStorage.getItem("firstName"));
	        _store2.default.commit("lastName", localStorage.getItem("lastName"));
	        localStorage.setItem("userRole", data.userRole);
	        if (data.userRole == "Sitter") {
	          localStorage.setItem("sitterId", data.sitterId);
	          _store2.default.commit("sitterId", localStorage.getItem("sitterId"));
	
	          if (data.CountryId != null) {
	            localStorage.setItem("CountryId", data.CountryId);
	          }
	        }
	        if (data.userRole == "Client") {
	          localStorage.setItem("customerId", data.customerId);
	          _store2.default.commit("customerId", localStorage.getItem("customerId"));
	        }
	
	        localStorage.setItem("emailConfirmed", data.emailConfirmed);
	        localStorage.setItem("expires", data.expires_in);
	        localStorage.setItem("profilePicUrl", data.profilePicUrl);
	
	        _store2.default.commit("profilePicUrl", data.profilePicUrl);
	        _store2.default.commit("userRole", data.userRole);
	        _store2.default.commit("authCheck", true);
	
	        if (redirect != null) {
	          _index2.default.push({ path: "/" + redirect });
	          _index2.default.go({ path: "/" + redirect });
	        } else {
	          _index2.default.push({ path: "/" });
	          _index2.default.go({ path: "/" });
	        }
	      },
	      error: function error(data, status, _error2) {
	        try {
	          context.notification = "";
	          context.error = data.responseJSON.error_description;
	        } catch (e) {
	          context.notification = "";
	          context.error = "Oops we are having problem logging to the server, please try again in a moment..";
	        }
	      }
	    });
	  },
	  fbLogin: function fbLogin(context, FBTokenInfo, redirect) {
	    context.notification = "Logging you in";
	    context.error = "";
	    $.ajax({
	      type: "POST",
	      url: LOGINEXTERNAL_URL,
	      data: FBTokenInfo,
	      success: function success(data) {
	        localStorage.setItem("access_token", data.access_token);
	        localStorage.setItem("loggedDate", (0, _stringify2.default)(moment()));
	        localStorage.setItem("firstName", data.firstName);
	        localStorage.setItem("emailConfirmed", data.emailConfirmed);
	        if (data.phoneConfirmed == "True" || data.phoneConfirmed == "true") {
	          localStorage.setItem("phoneConfirmed", "True");
	          _store2.default.commit("phoneConfirmed", true);
	        } else {
	          localStorage.setItem("phoneConfirmed", "False");
	          _store2.default.commit("phoneConfirmed", false);
	        }
	        localStorage.setItem("lastName", data.lastName);
	        localStorage.setItem("firstName", data.firstName);
	        localStorage.setItem("doubleRole", data.doubleRole);
	        localStorage.setItem("lastName", data.lastName);
	        if (data.CountryId != null) {
	          localStorage.setItem("CountryId", data.CountryId);
	        }
	        _store2.default.commit("firstName", localStorage.getItem("firstName"));
	        _store2.default.commit("lastName", localStorage.getItem("lastName"));
	        localStorage.setItem("expires", data.expires_in);
	        localStorage.setItem("email", data.userName);
	        _store2.default.commit("email", localStorage.getItem("email"));
	        localStorage.setItem("userRole", data.userRole);
	
	        if (data.userRole == "Sitter") {
	          localStorage.setItem("sitterId", data.sitterId);
	          _store2.default.commit("sitterId", localStorage.getItem("sitterId"));
	        }
	        if (data.userRole == "Client") {
	          localStorage.setItem("customerId", data.customerId);
	          _store2.default.commit("customerId", localStorage.getItem("customerId"));
	        }
	        localStorage.setItem("profilePicUrl", data.profilePicUrl);
	        _store2.default.commit("profilePicUrl", data.profilePicUrl);
	        _store2.default.commit("userRole", data.userRole);
	        _store2.default.commit("authCheck", true);
	
	        if (redirect) {
	          _index2.default.push({ path: "/" + redirect });
	          _index2.default.go({ path: "/" + redirect });
	        } else {
	          _index2.default.push({ path: "/" });
	          _index2.default.go({ path: "/" });
	        }
	      },
	      error: function error(data, status, _error3) {
	        try {
	          context.notification = "";
	          context.error = data.responseJSON.error_description;
	        } catch (e) {
	          context.notification = "";
	          context.error = "Oops we are having problem logging to the server, please try again in a moment..";
	        }
	      }
	    });
	  },
	  logout: function logout() {
	    var self = this;
	    if (localStorage.getItem("logged_as") !== null) {
	      localStorage.removeItem("logged_as");
	    }
	    if (localStorage.getItem("loggedDate") !== null) {
	      localStorage.removeItem("loggedDate");
	    }
	    if (localStorage.getItem("user_role") !== null) {
	      localStorage.removeItem("user_role");
	    }
	    if (localStorage.getItem("access_token") != null) {
	      localStorage.removeItem("access_token");
	    }
	    if (localStorage.getItem("firstName") != null) {
	      localStorage.removeItem("firstName");
	    }
	
	    if (localStorage.getItem("expires") != null) {
	      localStorage.removeItem("expires");
	    }
	
	    if (localStorage.getItem("doubleRole") != null) {
	      localStorage.removeItem("doubleRole");
	    }
	
	    if (localStorage.getItem("phoneNumber") != null) {
	      localStorage.removeItem("phoneNumber");
	    }
	
	    if (localStorage.getItem("phoneConfirmed") != null) {
	      localStorage.removeItem("phoneConfirmed");
	    }
	
	    if (sessionStorage.getItem("SessionId") != null) {
	      sessionStorage.removeItem("SessionId");
	    }
	
	    if (localStorage.getItem("email") != null) {
	      localStorage.removeItem("email");
	    }
	
	    if (localStorage.getItem("lastName") != null) {
	      localStorage.removeItem("lastName");
	    }
	
	    if (localStorage.getItem("profilePicUrl") != null) {
	      localStorage.removeItem("profilePicUrl");
	    }
	
	    if (localStorage.getItem("sitterId") != null) {
	      localStorage.removeItem("sitterId");
	    }
	
	    if (localStorage.getItem("customerId") != null) {
	      localStorage.removeItem("customerId");
	    }
	
	    if (localStorage.getItem("emailConfirmed") != null) {
	      localStorage.removeItem("emailConfirmed");
	    }
	
	    if (localStorage.getItem("userRole") != null) {
	      localStorage.removeItem("userRole");
	    }
	
	    FB.logout(function (response) {});
	    _store2.default.commit("authCheck", false);
	    _store2.default.commit("sitterId", "");
	    _store2.default.commit("customerId", "");
	    _store2.default.commit("email", "");
	    _store2.default.commit("firstName", "");
	    _store2.default.commit("lastName", "");
	    _store2.default.commit("userRole", "");
	    _store2.default.commit("profilePicUrl", "");
	    _index2.default.push({ path: "/login" });
	    _index2.default.go({ path: "/login" });
	  },
	  checkTokenExpiry: function checkTokenExpiry() {
	    if (localStorage.getItem("access_token") != null) {
	      var loggedDate = moment(JSON.parse(localStorage.getItem("loggedDate")));
	      var currentDate = moment();
	      var difference = currentDate.diff(loggedDate, "seconds");
	      if (difference >= localStorage.getItem("expires")) {
	        swal("Session Expired", "Your session expired, please login again to continue.", "info");
	        this.logout();
	      }
	    }
	  },
	  getAuthHeader: function getAuthHeader() {
	    var data = localStorage.getItem("access_token");
	    return data;
	  },
	  checkToken: function checkToken() {
	    if (localStorage.getItem("access_token")) {
	      _store2.default.commit("authCheck", true);
	    }
	    if (localStorage.getItem("phoneConfirmed") == "True") {
	      _store2.default.commit("phoneConfirmed", true);
	    }
	  }
	};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(666);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _FindSitters = __webpack_require__(571);
	
	var _FindSitters2 = _interopRequireDefault(_FindSitters);
	
	var _SitterProfileView = __webpack_require__(596);
	
	var _SitterProfileView2 = _interopRequireDefault(_SitterProfileView);
	
	var _SitterProfileEdit = __webpack_require__(595);
	
	var _SitterProfileEdit2 = _interopRequireDefault(_SitterProfileEdit);
	
	var _UnSubscribe = __webpack_require__(599);
	
	var _UnSubscribe2 = _interopRequireDefault(_UnSubscribe);
	
	var _Home = __webpack_require__(572);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Chat = __webpack_require__(67);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _Signup = __webpack_require__(550);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _AccountView = __webpack_require__(545);
	
	var _AccountView2 = _interopRequireDefault(_AccountView);
	
	var _Login = __webpack_require__(548);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Success = __webpack_require__(552);
	
	var _Success2 = _interopRequireDefault(_Success);
	
	var _Subscribe = __webpack_require__(551);
	
	var _Subscribe2 = _interopRequireDefault(_Subscribe);
	
	var _Cancel = __webpack_require__(546);
	
	var _Cancel2 = _interopRequireDefault(_Cancel);
	
	var _PasswordReset = __webpack_require__(243);
	
	var _PasswordReset2 = _interopRequireDefault(_PasswordReset);
	
	var _SitterSignup = __webpack_require__(597);
	
	var _SitterSignup2 = _interopRequireDefault(_SitterSignup);
	
	var _Calendar = __webpack_require__(585);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _AboutMe = __webpack_require__(584);
	
	var _AboutMe2 = _interopRequireDefault(_AboutMe);
	
	var _PetPrefs = __webpack_require__(587);
	
	var _PetPrefs2 = _interopRequireDefault(_PetPrefs);
	
	var _ServiceRates = __webpack_require__(589);
	
	var _ServiceRates2 = _interopRequireDefault(_ServiceRates);
	
	var _PetsView = __webpack_require__(574);
	
	var _PetsView2 = _interopRequireDefault(_PetsView);
	
	var _PetRegister = __webpack_require__(577);
	
	var _PetRegister2 = _interopRequireDefault(_PetRegister);
	
	var _MyPets = __webpack_require__(573);
	
	var _MyPets2 = _interopRequireDefault(_MyPets);
	
	var _MyFavoriteSitters = __webpack_require__(565);
	
	var _MyFavoriteSitters2 = _interopRequireDefault(_MyFavoriteSitters);
	
	var _BecomeSitter = __webpack_require__(582);
	
	var _BecomeSitter2 = _interopRequireDefault(_BecomeSitter);
	
	var _InitReservation = __webpack_require__(566);
	
	var _InitReservation2 = _interopRequireDefault(_InitReservation);
	
	var _ReservationSuccess = __webpack_require__(568);
	
	var _ReservationSuccess2 = _interopRequireDefault(_ReservationSuccess);
	
	var _MyReservations = __webpack_require__(567);
	
	var _MyReservations2 = _interopRequireDefault(_MyReservations);
	
	var _viewReservation = __webpack_require__(570);
	
	var _viewReservation2 = _interopRequireDefault(_viewReservation);
	
	var _MyReservations3 = __webpack_require__(592);
	
	var _MyReservations4 = _interopRequireDefault(_MyReservations3);
	
	var _ViewSitterReservation = __webpack_require__(593);
	
	var _ViewSitterReservation2 = _interopRequireDefault(_ViewSitterReservation);
	
	var _ConfirmedReservations = __webpack_require__(248);
	
	var _ConfirmedReservations2 = _interopRequireDefault(_ConfirmedReservations);
	
	var _SitterProfileView3 = __webpack_require__(564);
	
	var _SitterProfileView4 = _interopRequireDefault(_SitterProfileView3);
	
	var _CustomerConfirmedReservations = __webpack_require__(244);
	
	var _CustomerConfirmedReservations2 = _interopRequireDefault(_CustomerConfirmedReservations);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _NotFound = __webpack_require__(580);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Dashboard = __webpack_require__(583);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _FeedbackAndPerformance = __webpack_require__(246);
	
	var _FeedbackAndPerformance2 = _interopRequireDefault(_FeedbackAndPerformance);
	
	var _Shortcuts = __webpack_require__(249);
	
	var _Shortcuts2 = _interopRequireDefault(_Shortcuts);
	
	var _ContactSupport = __webpack_require__(579);
	
	var _ContactSupport2 = _interopRequireDefault(_ContactSupport);
	
	var _AdminLogin = __webpack_require__(555);
	
	var _AdminLogin2 = _interopRequireDefault(_AdminLogin);
	
	var _SittersDashboard = __webpack_require__(561);
	
	var _SittersDashboard2 = _interopRequireDefault(_SittersDashboard);
	
	var _BookingsDashboard = __webpack_require__(556);
	
	var _BookingsDashboard2 = _interopRequireDefault(_BookingsDashboard);
	
	var _UsersDashboard = __webpack_require__(563);
	
	var _UsersDashboard2 = _interopRequireDefault(_UsersDashboard);
	
	var _ChartsDashboard = __webpack_require__(557);
	
	var _ChartsDashboard2 = _interopRequireDefault(_ChartsDashboard);
	
	var _CustomEmail = __webpack_require__(560);
	
	var _CustomEmail2 = _interopRequireDefault(_CustomEmail);
	
	var _TicketsDashboard = __webpack_require__(562);
	
	var _TicketsDashboard2 = _interopRequireDefault(_TicketsDashboard);
	
	var _viewReservationAdmin = __webpack_require__(559);
	
	var _viewReservationAdmin2 = _interopRequireDefault(_viewReservationAdmin);
	
	var _TermsAndConditions = __webpack_require__(598);
	
	var _TermsAndConditions2 = _interopRequireDefault(_TermsAndConditions);
	
	var _Privacy = __webpack_require__(578);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	    mode: 'history',
	    base: __dirname,
	    routes: [{ name: 'home', path: '/', component: _Home2.default }, { name: 'contact-support', path: '/contact-support/', component: _ContactSupport2.default }, { name: 'become-a-sitter', path: '/become-a-sitter', component: _BecomeSitter2.default }, { name: 'notfound', path: '*', component: _NotFound2.default }, { name: 'signup', path: '/signup', component: _Signup2.default }, {
	        name: 'pets-view',
	        path: '/pets-view',
	        component: _PetsView2.default,
	        children: [{ name: 'addPet', path: 'addPet', component: _PetRegister2.default }, { name: 'updatePet', path: 'updatePet/:petId', component: _PetRegister2.default }, { name: 'mypets', path: 'mypets', component: _MyPets2.default }],
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Client") next({ path: '/login' });else next(function (vm) {});
	        }
	
	    }, { name: 'sitter-signup', path: '/sitter-signup', component: _SitterSignup2.default }, {
	        name: 'reservation',
	        path: '/reservation/:sitterId',
	        component: _InitReservation2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            if (localStorage.getItem('userRole') != "Client") next({ path: '/login' });
	            if (from.name != "sitter") {
	                next({ name: 'sitter', params: to.params });
	            } else next(function (vm) {});
	        }
	    }, {
	        name: 'view-reservation',
	        path: '/view-reservation/:reservationId',
	        component: _viewReservation2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Client") next({ path: '/login' });else next(function (vm) {});
	        }
	
	    }, {
	        name: 'subscribe',
	        path: '/subscribe',
	        component: _Subscribe2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('access_token') == null) next({ path: '/login' });else next(function (vm) {});
	        }
	
	    }, {
	        name: 'success',
	        path: '/success/:subscriptionId',
	        component: _Success2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('access_token') == null) next({ path: '/login' });else next(function (vm) {});
	        }
	
	    }, {
	        name: 'view-sitter-reservation',
	        path: '/view-sitter-reservation/:reservationId',
	        component: _ViewSitterReservation2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Sitter") next({ path: '/login' });else next(function (vm) {});
	        }
	    }, {
	        name: 'reservation-success',
	        path: '/reservation-success',
	        component: _ReservationSuccess2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Client") next({ path: '/login' });else next(function (vm) {});
	        }
	    }, {
	        name: 'my-reservations',
	        path: '/my-reservations',
	        component: _MyReservations2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Client") next({ path: '/login' });else next(function (vm) {});
	        }
	    }, {
	        name: 'my-sitter-reservations',
	        path: '/my-sitter-reservations',
	        component: _MyReservations4.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Sitter") next({ path: '/login' });else {
	                next(function (vm) {});
	            }
	        }
	    }, {
	        name: 'dashboard',
	        path: '/dashboard',
	        component: _Dashboard2.default,
	        children: [{
	            name: 'feedback-performance',
	            path: 'feedback-performance',
	            component: _FeedbackAndPerformance2.default
	        }, {
	            name: 'shortcuts',
	            path: 'shortcuts',
	            component: _Shortcuts2.default
	        }],
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Sitter") next({ path: '/login' });
	            if (to.path != '/dashboard/feedback-performance') {
	                next({ path: '/dashboard/feedback-performance' });
	            } else {
	                next(function (vm) {});
	            }
	        }
	    }, {
	        name: 'chat',
	        path: '/chat',
	        component: _Chat2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('access_token') == null) next({ path: '/login' });else next(function (vm) {});
	        }
	    }, { name: 'unsubscribe', path: '/unsubscribe', component: _UnSubscribe2.default }, { name: 'findSitters', path: '/findsitters', component: _FindSitters2.default }, { name: 'findSittersCity', path: '/findsitters/:cityId', component: _FindSitters2.default }, {
	        name: 'account',
	        path: '/account',
	        component: _AccountView2.default,
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('access_token') == null) next({ path: '/login' });else next(function (vm) {});
	        }
	    }, { name: 'sitter', path: '/sitter/:sitterId', component: _SitterProfileView2.default }, { name: 'admin-sitter-view', path: '/admin/:sitterId', component: _SitterProfileView4.default }, {
	        path: '/sitter-profile-edit',
	        component: _SitterProfileEdit2.default,
	        children: [{ path: 'calendar', component: _Calendar2.default }, { path: 'about', component: _AboutMe2.default }, { path: 'petpreferences', component: _PetPrefs2.default }, { path: 'servicerates', component: _ServiceRates2.default }],
	        beforeEnter: function beforeEnter(to, from, next) {
	            _index2.default.checkTokenExpiry();
	            if (localStorage.getItem('userRole') != "Sitter") next({ path: '/login' });else {
	                next(function (vm) {});
	            }
	        }
	    }, { name: 'login', path: '/login', component: _Login2.default }, { name: 'cancel', path: '/cancel', component: _Cancel2.default }, { name: 'favorite-sitters', path: '/favorite-sitters', component: _MyFavoriteSitters2.default }, { name: 'passwordReset', path: '/passwordReset', component: _PasswordReset2.default }, { name: 'default', path: '*', redirect: '/home' }, { name: 'adminLogin', path: '/admin', component: _AdminLogin2.default }, { name: 'sitters-dashboard', path: '/sitters-dashboard', component: _SittersDashboard2.default }, { name: 'bookings-dashboard', path: '/bookings-dashboard', component: _BookingsDashboard2.default }, { name: 'users-dashboard', path: '/users-dashboard', component: _UsersDashboard2.default }, { name: 'charts-dashboard', path: '/charts-dashboard', component: _ChartsDashboard2.default }, { name: 'email-dashboard', path: '/email-dashboard', component: _CustomEmail2.default }, { name: 'tickets-dashboard', path: '/tickets-dashboard', component: _TicketsDashboard2.default }, { name: 'view-admin-reservation', path: '/view-admin-reservation/:reservationId', component: _viewReservationAdmin2.default }, { name: 'terms-and-conditions', path: '/terms-and-conditions', component: _TermsAndConditions2.default }, { name: 'privacy-policy', path: '/privacy-policy', component: _Privacy2.default }],
	
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	        return { x: 0, y: 0 };
	    }
	});
	
	exports.default = router;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	
	exports.default = {
	  updateCountry: function updateCountry(countryId) {
	    var self = this;
	    return $.ajax({
	      type: "GET",
	      url: "https://www.dupaws.com/services/api/account/updateCountry/" + countryId,
	      contentType: "application/json; charset=utf-8",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      success: function success(data) {},
	      error: function error() {
	        try {
	          self.error = "Updating user failed, try again..";
	        } catch (e) {
	          self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	        }
	      }
	    });
	  },
	  initCountry: function initCountry() {
	    var self = this;
	    var countryId = 0;
	    if (localStorage.getItem("CountryId") != null) countryId = localStorage.getItem("CountryId");
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "public/initCountry/" + countryId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        if (data.IsSupportedCountry == true) {
	          _store2.default.dispatch("CountryData", data);
	          self.getCitiesList(data.CountryId, 0);
	          _store2.default.dispatch("SelectCountry", false);
	          localStorage.setItem("CountryId", data.CountryId);
	        } else {
	          _store2.default.dispatch("SelectCountry", true);
	        }
	      },
	      error: function error(data, status, _error) {
	        console.log("Unable to get Country Data" + data.responseText);
	      }
	    });
	  },
	  initUserSubscription: function initUserSubscription() {
	    var self = this;
	    return $.ajax({
	      type: "GET",
	      url: "https://www.dupaws.com/services/api/initUserSubscriptionStatus/",
	      contentType: "application/json; charset=utf-8",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      success: function success(data) {
	        _store2.default.dispatch("SubscriptionStatus", data);
	      },
	      error: function error() {
	        try {
	          self.error = "Init user subscription failed..";
	        } catch (e) {
	          self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	        }
	      }
	    });
	  },
	  initStaycationData: function initStaycationData() {
	    var self = this;
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "public/initStaycationData/",
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("StaycationData", data);
	        if (data.Manifest != null) {
	          if (localStorage.getItem("manifest") != null && localStorage.getItem("manifest") == data.Manifest) {} else if (localStorage.getItem("manifest") == null) {
	            localStorage.setItem("manifest", data.Manifest);
	          } else if (localStorage.getItem("manifest") != data.Manifest) {
	            localStorage.setItem("manifest", data.Manifest);
	            location.reload();
	          } else {
	            console.log("unknown error with manifest");
	          }
	        } else {
	          console.log("manifest was null");
	        }
	      },
	      error: function error(data, status, _error2) {
	        console.log("Unable to get Staycation Data" + data.responseText);
	      }
	    });
	  },
	  getCitiesList: function getCitiesList(countryId, regionId) {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/cities/" + countryId + "/" + regionId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("CitiesList", data);
	      },
	      error: function error(data, status, _error3) {
	        console.log("Unable to get Cities" + data.responseText);
	      }
	    });
	  },
	  getAreasList: function getAreasList(cityId) {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/areas/" + cityId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("AreasList", data);
	      },
	      error: function error(data, status, _error4) {
	        console.log("Unable to get Areas" + data.responseText);
	      }
	    });
	  },
	  getFilteredAreasList: function getFilteredAreasList(queryData) {
	    return $.ajax({
	      type: "POST",
	      url: API_URL + "api/filteredAreas/",
	      dataType: "json",
	      data: (0, _stringify2.default)(queryData),
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("FilteredAreasList", data);
	      },
	      error: function error(data, status, _error5) {
	        console.log("Unable to get Filtered Areas" + data.responseText);
	      }
	    });
	  },
	  getNotifications: function getNotifications(userRole) {
	    return $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/getNotifications/" + userRole,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        if (data != null) if (data.length > 0) _store2.default.dispatch("Notifications", data);
	      },
	      error: function error(data, status, _error6) {
	        console.log("failed to get Notifications");
	      }
	    });
	  },
	  getSittersList: function getSittersList(queryData) {
	    return $.ajax({
	      type: "POST",
	      url: API_URL + "/public/sittersList/" + localStorage.getItem("CountryId"),
	      dataType: "json",
	      data: (0, _stringify2.default)(queryData),
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SittersList", data);
	        if (_store2.default.getters.QueryData.cityId != null && data.Areas != null) _store2.default.dispatch("FilteredAreasList", data.Areas);
	      },
	      error: function error(data, status, _error7) {
	        console.log("failed to get Sitter getSittersList()" + data.responseText);
	      }
	    });
	  },
	  getSitterPublicDetails: function getSitterPublicDetails(sitterId) {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "public/getSitterPublicDetails/" + sitterId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SitterPublicDetails", data);
	      },
	      error: function error(data, status, _error8) {
	        console.log("failed to get Sitter getPublicSitterDetails()" + data.responseText);
	      }
	    });
	  },
	  initQuery: function initQuery() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "public/getQueryData/",
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("QueryData", data);
	      },
	      error: function error(data, status, _error9) {}
	    });
	  }
	};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(19);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	
	exports.default = {
	  getPetsList: function getPetsList() {
	    return $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/getPetsList/",
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("PetsList", data);
	      },
	      error: function error(data, status, _error) {
	        console.log("failed to get Pets List" + data.responseText);
	      }
	    });
	  },
	  addSitterToFavorites: function addSitterToFavorites(sitter) {
	    var self = this;
	    return $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/addSitterToFavorites/" + sitter.SitterId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("FavoriteSitters", data);
	        self.notifyAddedFavorite(sitter.SitterId);
	      },
	      error: function error(data, status, _error2) {
	        console.log("Couldn't add sitter to favorites" + data.responseText);
	      }
	    });
	  },
	  initFavoriteSitters: function initFavoriteSitters() {
	    return $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/initFavoriteSitters",
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("FavoriteSitters", data);
	      },
	      error: function error(data, status, _error3) {
	        console.log("Couldn't add sitter to favorites" + data.responseText);
	      }
	    });
	  },
	  notifyAddedFavorite: function notifyAddedFavorite(sitterId) {
	    var self = this;
	    $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: "https://www.dupaws.com/services/api/addedFavorite/" + sitterId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        console.log(data);
	      },
	      error: function error(data, status, _error4) {
	        console.log(data);
	      }
	    });
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _jquery = __webpack_require__(19);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	
	exports.default = {
	  getSitterProfile: function getSitterProfile() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/initSitterData",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SitterProfile", data);
	      },
	      error: function error(data, status, _error) {
	        console.log("Couldn't retrieve sitter through initSitterData() call: " + data.responseText);
	      }
	    });
	  },
	  updateSitterProfile: function updateSitterProfile() {
	    return $.ajax({
	      type: "POST",
	      url: API_URL + "api/updateSitterData",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      crossDomain: true,
	      data: (0, _stringify2.default)(_store2.default.getters.SitterProfile),
	      contentType: "application/json",
	      success: function success(data) {},
	      error: function error(data, status, _error2) {
	        console.log("failed to update SitterProfile " + data.responseText);
	      }
	    });
	  },
	  updateSitterPetPrefs: function updateSitterPetPrefs() {
	    return $.ajax({
	      type: "POST",
	      url: API_URL + "api/PetPref",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      crossDomain: true,
	      data: (0, _stringify2.default)(_store2.default.getters.SitterPetPrefs),
	      contentType: "application/json",
	      success: function success(data) {},
	      error: function error(data, status, _error3) {
	        console.log("failed to update SitterProfile " + data.responseText);
	      }
	    });
	  },
	  getSitterPetPrefs: function getSitterPetPrefs() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/PetPref",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SitterPetPrefs", data);
	      },
	      error: function error(data, status, _error4) {
	        console.log("failed to get Sitter Pet Prefs " + data.responseText);
	      }
	    });
	  },
	  getSitterServices: function getSitterServices() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/sitterServices",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SitterServices", data);
	      },
	      error: function error(data, status, _error5) {
	        console.log("failed to get Sitter Services " + data.responseText);
	      }
	    });
	  },
	  getSitterProfileStatus: function getSitterProfileStatus() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/getSitterProfileStatus",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {},
	      error: function error(data, status, _error6) {
	        console.log("failed to get Sitter Profile Status" + data.responseText);
	      }
	    });
	  },
	  getSitterPhotos: function getSitterPhotos() {
	    return $.ajax({
	      type: "GET",
	      url: API_URL + "api/getSitterPhotosList",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        _store2.default.dispatch("SitterPhotos", data);
	      },
	      error: function error(data, status, _error7) {
	        console.log("failed to get Sitter Photos " + data.responseText);
	      }
	    });
	  },
	  updateSitterServices: function updateSitterServices() {
	    return $.ajax({
	      type: "POST",
	      url: API_URL + "api/sitterServices",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      crossDomain: true,
	      data: (0, _stringify2.default)(_store2.default.getters.SitterServices),
	      contentType: "application/json",
	      success: function success(data) {},
	      error: function error(data, status, _error8) {
	        console.log("failed to update Sitter Services " + data.responseText);
	      }
	    });
	  }
	};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(474)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(297),
	  /* template */
	  __webpack_require__(662),
	  /* scopeId */
	  "data-v-ec549d4e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(473)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(291),
	  /* template */
	  __webpack_require__(661),
	  /* scopeId */
	  "data-v-e25590ec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(469)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(292),
	  /* template */
	  __webpack_require__(657),
	  /* scopeId */
	  "data-v-c1cf74cc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABCCAYAAADXLcH0AAAACXBIWXMAAAOGAAADhgF8+3poAAAEVklEQVR42u1c0XHaQBB9ZviHDqxUYDpAriC4ApMKjL98f3H+9s+kgsgVWK4g5woiKohUQaAC8qG9cGGE0Ik7IaF7MxrNYFvCj3e7+/YWXW23W1SBEGIMIAQw0V5OASRElMCjFFdViBZCLAA8Axgd+JUNgBhARETS02pINKs4AvDZ4JofAGZEtPb07jDUSA04LKhjzOeR4TWnANQK8FCKfnp6GvOyn1q87gZA4FW9w0BToU2M+MPzUESz6jIH154KISJP8f+KdkXIPcd+TzSflxxXXcATrYjm8DF3dI+xp3mnaBBRDOAWwCvXwvrxnY86mHuaKzpDrdaWNSuU2747xkFD8XbJLtMTXRHXNe9z03enOGjwXg9CiOe+KnvQ8P2+AkiFEL1LkKbJMOEwYAMZG6WIiFJPtDuidazYNKWXWp1cGeywhAB+NvS+1EaCRL6Ls2bjk3ZV/SZExzDbAHD9QSR8rEscacC/kwKIz9m2NSE6APC74yv4HcDyHOHJhOgFgJcLCZkqNMXcemgV0XXtdxdIlxxipCu1mxA9A/DWg5LXidpNxg1e0D9kABY2CK/qDBO42e5qO64BvAkh5Klu1iR0rGE+enCp8VxyPE9cEL2FxyHi42N1etUYPQbwx/Nav073inaDD06iiWkyVMvEoxqmAH4JIf7tLJkQ3ZfRXJvV1QOARAgxNyE67QnRc+TTALYIvwawMCE66su652Q24VibaaRnyHvnKoyuAHzj8yGsAIRDQ0Xf9cSGq6GiUCsGQuzarkDeng2JKALwzN3NZ02UIfL+eWRUdfTIuDwS0bLuHwshgqLNiTqbs2pJXSomJ66E9JRex/6F4iNxqcsIXFx0UPNTW+Jyp0SnrSFaW2Lv3ps4JppDSIR+tk8bVbQa9V14Gh0TrZHdZAjZaOdbPo6ZhrNjaOk6C7ib+VixOVAzHJKIJBuIhI2FZNMQckU0OvF+1mFsWEoK9SU3UcqUeIyADLueilRnk51p7pZJ1B9d+6LcXBsVrWznQwmBMatyvyxM2Kpa6Q4S0ZqVndZUtmy1ollNKYqH1U+ytTXfS4h6s4LvRDRrXTLcw6Ft+RkaBoebuxox97OL+W3bRMsm3VbFiiiEeW9m1lWiz1Z6EdGaiEIAj5yQs4qqlq0lumS7/eymRuvPzAF8qqDysc3v2wwb+j/nrrJ5DSGo9xEeqbtv+GdhG0NHET7OkQwNEmbZapsKISZdITrCic10x2RHyL+WfQidUHSG/PlKKdqNRUnCHreVaD2rpy6Kf0exO0TxkNC6rUS3Xb1lZBf1OJK2Eq0vtUnH+C4iOmgd0Vx36l2zEZdQXcG6K8lwXhCvuzSzF7hKhkNLSlaF/X7hH3fs2XdFRMetIJo7XUW7Kxt07xkdRUTLtij6kLNadkXNnFtmBaEPtjyADaIlK2GkKTlB/rSCrmAG4EfB66+2bmB1h6Wr4CdO3u+9vCKiiSfaXQiZcMiQNq/9FxHH1rP3gjEeAAAAAElFTkSuQmCC"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAA1CAYAAAATWvbVAAAACXBIWXMAAANGAAADRgGm6bOSAAADvElEQVRo3u2ay3GjQBCGf1MzZ2sjsDJYHIHIYMnAOAMUwbIZ4AgWZ4AzwBEszkDKAM59YA9uyuMxj5kRyJJQV1E21gxIn7v/foibpmlwtQ+TUvoAEgC5uOL4BCYC8JdPd94VyRcwNYAtEcVXz3kHkwF4YDABEZUA4F3BdINZPJwhMIuGwxrzwKexDgYAbpaYyjld/+PTJyKKu9YtDo6UcgWgBHAH4I2I/L61SwyrmMEAQDS00FuY16wZDgD86dKZxYaVkp32RLQeW+8tCMxKyU6JyR6v4yIhu9+lgSn4dE9EmRMctpLT3aVYDuAn/56ZbuqC4wO4BVBcAiDWmY3yJ2M4XwRZSrlTUl0NIFVcEgCqMZU/oUIvUzwGAF6JKHCCI6VMAPw23PvG0Aoiyk8ESMCeH2re0tqjqd58gqMNemyt5rjOjwWKPaOFESjePmQ/iKiygnMgmNlAMYAVf3jwz5UWKqb2QkShzYYWTsUiPIe9Wq53/fBjtiWi1GaD4Di9nTECNiei0dZJ5DpDHoGzW8hnta7ZPCLaOejCOVpgu0EoM46ExbCNz4pp+4Zp8tTNul80GlmwaCcnJK6udm9T3RsJMhEVXHZvzxxONLnnaF40ZcF4bDMacjmncu5NHs8Uzp3NpMGpzmFAT5eetQ4pAtNLh3PQgF1Kea7TeaPufKntQzhrWJ35ED6aFY5Lr8JWc7tSfyOcDRe2Ru3DbK6p1hgAIiIqtMo7UMr79RHHHMmYODsLsjaIn0wEe8K37fFCjA/CtnifbacGkIdnyk3TWB9CiEAI0WhHKYQI+fVEf93lPj33zjrurR6BsjYUQlQDayshxKrvXt5EgvZMRP4xhutEFAF4MVybc6j2rb8dqtc8BzdXv3MG3r8L0mHpne/bDNlmbwio4sF6X9P80CfOLp4Ta5mnS5h1bckn9p7KtsPm4fp9T5ZMpoKjvqnIUGSzGcKrgOUEk2c5focnb7rqNs8ypCIlQ70aaswLj2LnsMwB6o5TeD1WGNp6TtITXkNWzKjPpUFI94VlPNaQeo5e82wxbpwTjg6iPuB9+Yd4TqKIcGI4FtjP/ERGYCKsA+Glp3V7OPz0Res1qYGG+ANuP4lxSZFqJUVqsX+0t/IMLrLGx2Mp9diQi9/0rznh8KizVP7btUOvN2omjad608QgdccjgjkFmEILg8ilb+uYFliHVZv/TZ9SWCkpPD8CmCfH+5RKlV13duiGzd7asjlcT9VoatcttcYxmeCafl/zeVYPaSsPMwFAOUEoDdp/4yjUU9hidl8AAAAASUVORK5CYII="

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABCCAYAAADXLcH0AAAACXBIWXMAAAOGAAADhgF8+3poAAAEUElEQVR42u2c7XGbQBCG3/X4v+jAuIKQCowrMKnASgUmHTgdqIPgCowrMK4guIKgDqCCzQ+WmBAgHNwhELczN9Jg5pAflv28g5gZQ4SIHAA+AK92OAOQMnMKK/38hoAmohDAI4BdxykFgBhAxMyJxaoIWrQ4AnCnMOcbgICZc4u3BTQRuWIWquHI527EvN+Z+dHirYEWoDGAG43zFgBcq9UfciGfN5rn3cnNs1KBFq07Gpj7hogii/hvjTYF5F5svwUtnwexqybEgq5Ai/nYG7qGYzE34mgi8gV4UwurzO9hxDVemDmwoAem4HIjkpERyu3WM8aLmeztQbJMC3qgXI28zieUtRILegZ5IKLHrWq2qo1mDdcsAITMHFnQ3aBTMQM65CiJUsTMmQVtDnRd3iVpys41OiGFDosP4HWm31U1EhKUXZxcEp9srdqvAjqGWgPA9I1IZeQ9Gakr52QA4lOWbVVAuwB+rfwJfgFwOIV5UgnvziGNvgPwSkQ5EUVEFCxRo8em30uXQnxBCiAxpu3MPGiIRvMGRi5hZzCUzSB+AyGHG4HcHJku4ENtdAoz7a6lyxWAZyJKiGg/l43OMW7pwTna80TseWoCNMNKF/j4v3H6QBvtbNRGq44YgD/aGQpsC3L4SAB4Y0HnFqDyOABwVEEnGwrpdM+3V0nBs404uD2AW43h7BWAUEWj/Y1otF8LAKoybVbTzrRmRlOUvdC0Z74UgKNavfMAPJ+5RrcujZB6fFV2rXyWX7XkhM+j/C0Sxcz+tOyUc/bzd4rhpJpGuVx5dApeFw/lqv5zFW9ikS6bWo+uTxSj7POdo7gnrUdvqfbBzHTKDkvbI/Ziyx2GQYsJiTZaPlWWy4mPWExE2EDIdzob3bDXcy5FKMQ3FPhoGPvyXcviHhM2WhdoF+aWIrxL7F5lZAkzJ5JApPUasByLJzrpd2b2Fgla/skD+ncEFAMAHGs1lSo7U+pMy2rVZIJ2fzWxAFMnaA/Azx6AsWhlM05NJVXVtnFfYGcjNfvayLIzrS317hJjqPM6hotgsYnfo3shetdu2dlXOYm5+TIig72b2vHWnbC0SZctPckKJ2aORbNVazPBWkGfrC7CzDkz+wC+iUM+DtTqZLGge9rt4QLqFwdxxHsA1wO03NG638aAE2pzMNHczlDBYfbV1xNd19IW3tVCq+aEbyhb74vcjSWO70fPKZ91hJ5zbH+LMLGYbtikRACeek7xl+gM2xKVYAX7TsIeh+0sFXTdq2dr2HAvTtxH+6s08qWCXrr29sFuq3GkSwVdf9S8lfFuA+0uDrTEnfWq2U5Kl2uRfC3OcN9ir9f0Ok3XlDO81KTJVU2hWZaMV/buuzbQ8SJAS8Df1sYqsL53dLgK9ZvZNbqrjnFYizaLbwlaTB905QA6QCeiCbuaJqcoF2GvRYKONPxJ283UXetYo8gbJ+8bh7U2aS3of02IJyYj0Tn3bwLRT1i8Xm2gAAAAAElFTkSuQmCC"

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAA2CAYAAABkxd/2AAAACXBIWXMAAANSAAADUgEQACRKAAAD10lEQVRo3u2bwXGjMBSGfzO5O1tB3MGSCsJWEFJBSAVxTtFtye3dllQQu4IlFSypYO0K1nRgKvAeeEwUrWwkQM5i0IyHMAEbf/r19L8nebLb7TC2j00IcQ4gALDyRhz/wPEBZAB+AgjPRiRaOFMAbwDSEdA7nBDAguE8EFECACOgEk4E4IVP74hoUf3PG+HshzN4QEKIQILzpMIBgMlQp3klIL8SUai7bsgKqgJyASDad5E3UPXEAL7yaUhE2xHQO5wZgDmfPhNRduj6ISooloZWXHexN0D13PLp/NDQGqqCEj7muindCJAQImbzdGrqSQBcK6DQVEEvHOlPyS3fK1N8Y0AzPn4/BUhCiLnklsGmcGt6/wcnzUHsj3JNriG+AbAiotV/nkbEAK6Uf90QUWoNiKtomWSgTFrB96QAUpue6RjGOQAfZRVwxscL3fMS0bnNe092u11TOLq2ZFDpEdRRgfAtnntJRFYTUFUP6gIO2GPcCiEKVlUGICOijWUSWfVyoByvWj6fdcdNHh8ffQC/B+KDvtiGAU/qrVNv6yYxckhOulEI8QBsh0KI45sdIPYy64EwsgZUzWIhPlbVNvyqptHroQIyqkmzT4qVfKaPrZlRtDRoKcqCU1+bVaphNYtxeTLgFKOvLXQ6zXNQ7zMkt4AkSH0thUxtpvs2RnHR42EWOAf0WaWNjlp0DAX1Ou3g4qA7QOyN+tzmrhUUNLwvR7l767PTm8ikk8+OCKhAuVi3kFQ4w3tlEPz3TEoLXBrSKaso7sxJK0NsA33dtxMHq8nCq9e9gUKr+nRi8IyXhxYfvBYPrH7wGsA3IpoAeNDc1njWI6IVES2IaA7gssakbohoy53hA3hqY1eaxiA1wC0BBNJOCWfLQTZOnkHFDDU/MKPNOwPEgU2262siiup8Ud02E5dOnq/3uSN1Ld4XsJsoKJKCZ7Ent1EV9OpASQnPhsbGlpd87g4E7E4AyW8U65Z0NGpKHI24uAHYBYAbzRBtD4g3AVxIQ8vki+ddDi/NsM0b3JdqlD/lzeStFBTbOlGUi4cuW9YCrhqT/MaAFPW8HVKFkue4BrRtASyrM79eQ/XUZcMyoNQxoFBx6zZlmE0nuRjvE6rUszRYaw+l+OOsLML+RTaskc0+AJN0yTN4iJkUbwrD2BOa9lALOBGAH7KVcLGrxDP8spXvSeoUwSsfFy7jj/IDlCr/ilx8lgmgKp48s203lW0OB2VZDZwCNbvlDYP0Wjc6TBcOfZvtdqyiVdfxh9/3lwInajO0pJKL9nl79Wsf/jIhyi07K5Sbs5zWxv8CJu6b0hpPcusAAAAASUVORK5CYII="

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAAwCAYAAABpJ5bJAAAACXBIWXMAAAOkAAADpAGRLZh1AAADEUlEQVRo3u2bPXLaQBTHfyH04gbmBpATWJ6ht28Q3cB0vC6U28U3CDmBoWfG4gSRbwBdukBHpxQ8jdcKxLCSkJB4M5rxx2h3+fnt+/jvmjiOOfUZjUa+y3t1fT7FccxHJiIBEAC3e369AKbAxBizpoH2IUQRCQ/AS9sGGBpjJk2D2PoA4PhIgAAe8CQi/SvEN4APwLcTx/OAqydaMfDZccyevt8Ya6fgdYEh8Jhx3KBJHtlWeL5+8K85jXvbJE/8vN1uk62ba0KYz+ezwWDwuykxsaj45TcpsSwLGnsoIp2mQHzSQjlvu9Ek1YyORWvCidZ5edudMSasfZ1ojJlqDFsUMMe07l3MP72z1opdhZp40BIYZyiBXgG/rgLFUSqOBTgCeo5zbRRk1CgB4kAnsnKcywN+iciw0Z6o3tgB/mScd6VVQS00yJMhKsg4p/k37ATdqSa3RkHMEhv/BzQEoiShXUpp5AoxPLPI8Aqs9UkSU2VAXwrEY7w4sp9zVgFV2s5F2FkO0VqO710CQHS3fAeWRartZZU4ZdkMCPL2ShdPvOQ++B4ItbW9QsxgPSDSI5HSINZBaPWAFxF5ykM4doHoUx97zCPptLiaB/wQEedYeYX4vhyKVOUvHGJYM3iLlFc+i8j0FK+8Qty1iXe810nv1SuPuqBVl945k7hhjOnr5wqAB4Vo28rqy+0qpQtMXCF22J27eDUB+SUtWGgd6SusxBvfqUiJguQEUSfpanPfqwHETOc/ztnZGLPUv9TPKm1N3C4ieFnaQWdPTHllwO7MxDuz94T6RLY4q2XK0CFuO100yAWitb0nBSeck85kNK6NT1hTuRAzLDxXcAfW1NfQkySKzoFYXg2IFsgXx9dXmvlDOwMWYXvWWR2IusB4T9BfK6Cl9fOkbFiXcTtCRCa8XY9xgtguaGH7slxV7+KEFsS+S0fWKgBgRzN1uiSq6k0He1c4Cc7tAgCGF1aA+we+Ls0T/QMAZ1Wkp4nF/oenm6pA3GdVvWcTpL5flL6dNRamgUUVjodjVWISQWHsMshfG4NTUNQpMUYAAAAASUVORK5CYII="

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAAwCAYAAABpJ5bJAAAACXBIWXMAAAOkAAADpAGRLZh1AAADBElEQVRo3u2a63HaQBCAv9X4P3RgOjCpwHIFVgehg9BBXAIdmFRguQKLCiw6gAqCK9j8YBWLRxxxpwMhaWduhtGM7pZPe7ePW1FVThURiVU1oxcAoorQJiKSiYiKiAJvxW97PhWRYVchyv8sUUQy4L7CXB/AVFXnvSXuAnyqCBBgAMxEZNxb4ifABHhxmHOpquPOW6KITBwBAtzZ+92EKCIjEZkBz57zTjq3nUUktj/+va6JVVU6A9HgPQeY+5uq5l3ZzqG2XtylM3EVaO7OBOARMLNAuW65BaZdciwJMLeAuW55aHueHZknTe0MWwRYI217FnOQsYjICBgZ1MKCVsCTRwi0BGJV3XSyALEHOAfuHNf6MJB5K7fziZnI2nGtAfAuItNOW6JZ4xD47bnu2qKCeRu2uDhWtrWm9T+AFEjNuXUKos/Z+BXQDMgLh3YtoZErxIzqxdo6ZAlsbBSOqTGgrwViFSvOy+OcUUCTtnMIWdiZG9SBXdqxnNNSg12iXSrEuZS8ApO6rTJyeOea8+BHILPUtofoIXdAblciF4PYhkLrgG0Xx6yOwrELxJj2yA9g5XvFG9HLAHi2nqJRD9FP7u2sTM4BMWsZvMWeVb6ISHqKVfYQt2niA7t10kezykoNWm3Jnb2KG0UDljmYxCCWZV3Ky8tRygiYu0Icsr13GbQE5EG3hsWRscEqrHGnivS3gqSqTsO+Qg5oC8YGGDuzcH3RQA7Z3lc3BUZuQFxBjs4OsQRz4qG8j/WkbLss4j19EnOAp84ZXwxiaXtnZwA3B5KKOsUn6nRZiB6K1wruHzqNzWJTPu9xaoPo5J0reO8YeHN8fW2eP9vxgCGKqYd6OvUN3YRQTlUzkYNG2eKyacVuO18RNmzO3R1hev7Cs0P4JtAXPpYyNbUXJytBHLtkZFEAgEO23Q37X72pnQ4r34LzTQCAGddxE3isPupUK40CKHQM4GsT6Zlj+Vl6dNsUiMekqX02ky/KYtU/Rp0hTqlBdKfU1NTz0PSdlwoKTy7z/AH8JfmUDbCkzgAAAABJRU5ErkJggg=="

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(470)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(259),
	  /* template */
	  __webpack_require__(658),
	  /* scopeId */
	  "data-v-c370dc40",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(433)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(281),
	  /* template */
	  __webpack_require__(621),
	  /* scopeId */
	  "data-v-2f6785e4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(424)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(296),
	  /* template */
	  __webpack_require__(612),
	  /* scopeId */
	  "data-v-1d102b2a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(420)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(300),
	  /* template */
	  __webpack_require__(608),
	  /* scopeId */
	  "data-v-0f82eaff",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(466)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(303),
	  /* template */
	  __webpack_require__(654),
	  /* scopeId */
	  "data-v-b00f2e6c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(445)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(313),
	  /* template */
	  __webpack_require__(633),
	  /* scopeId */
	  "data-v-5592799e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(451)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(314),
	  /* template */
	  __webpack_require__(639),
	  /* scopeId */
	  "data-v-69853088",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueChartjs = __webpack_require__(539);
	
	var reactiveProp = _vueChartjs.mixins.reactiveProp;
	exports.default = {
	    extends: _vueChartjs.Line,
	    mixins: [reactiveProp],
	    props: ['options'],
	
	    mounted: function mounted() {
	        this.renderChart(this.chartData, this.options);
	    }
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flickity = __webpack_require__(484);
	
	var _flickity2 = _interopRequireDefault(_flickity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    options: Object
	  },
	
	  mounted: function mounted() {
	    this.init();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$flickity.destroy();
	    this.$flickity = null;
	  },
	
	
	  methods: {
	    init: function init() {
	      this.$flickity = new _flickity2.default(this.$el, this.options);
	      this.$emit('init', this.$flickity);
	    },
	    flickity: function flickity() {
	      return this.$flickity;
	    },
	    select: function select(index, isWrapped, isInstant) {
	      this.$flickity.select(index, isWrapped, isInstant);
	    },
	    next: function next(isWrapped, isInstant) {
	      this.$flickity.next(isWrapped, isInstant);
	    },
	    previous: function previous(isWrapped, isInstant) {
	      this.$flickity.previous(isWrapped, isInstant);
	    },
	    selectCell: function selectCell(value, isWrapped, isInstant) {
	      this.$flickity.selectCell(value, isWrapped, isInstant);
	    },
	    resize: function resize() {
	      this.$flickity.resize();
	    },
	    reposition: function reposition() {
	      this.$flickity.reposition();
	    },
	    prepend: function prepend(elements) {
	      this.$flickity.prepend(elements);
	    },
	    append: function append(elements) {
	      this.$flickity.append(elements);
	    },
	    insert: function insert(elements, index) {
	      this.$flickity.insert(elements, index);
	    },
	    remove: function remove(elements) {
	      this.$flickity.remove(elements);
	    },
	    playPlayer: function playPlayer() {
	      this.$flickity.playPlayer();
	    },
	    stopPlayer: function stopPlayer() {
	      this.$flickity.stopPlayer();
	    },
	    pausePlayer: function pausePlayer() {
	      this.$flickity.pausePlayer();
	    },
	    unpausePlayer: function unpausePlayer() {
	      this.$flickity.unpausePlayer();
	    },
	    rerender: function rerender() {
	      this.$flickity.destroy();
	      this.init();
	    },
	    destroy: function destroy() {
	      this.$flickity.destroy();
	    },
	    reloadCells: function reloadCells() {
	      this.$flickity.reloadCells();
	    },
	    getCellElements: function getCellElements() {
	      return this.$flickity.getCellElements();
	    },
	    data: function data() {
	      return _flickity2.default.data(this.$el);
	    },
	    on: function on(eventName, listener) {
	      this.$flickity.on(eventName, listener);
	    },
	    off: function off(eventName, listener) {
	      this.$flickity.off(eventName, listener);
	    },
	    once: function once(eventName, listener) {
	      this.$flickity.once(eventName, listener);
	    },
	    selectedElement: function selectedElement() {
	      return this.$flickity.selectedElement;
	    },
	    selectedElements: function selectedElements() {
	      return this.$flickity.selectedElements;
	    },
	    selectedIndex: function selectedIndex() {
	      return this.$flickity.selectedIndex;
	    },
	    cells: function cells() {
	      return this.$flickity.cells;
	    },
	    slides: function slides() {
	      return this.$flickity.slides;
	    }
	  }
	
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(68);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _computed;
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	var _Notifications = __webpack_require__(581);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      alert: '',
	      authenticated: false,
	      sitter: "Sitter",
	      customer: "Client",
	      admin: "Admin",
	      connection: '',
	      refreshInterval: '',
	      reminderClass: false,
	      heartClass: false,
	      chatHub: '',
	      mobileDropdown: 'mobileDropdown',
	      webDropdown: 'webDropdown',
	      active: false
	    };
	  },
	
	
	  methods: {
	    checkStatus: function checkStatus(connectionId) {
	      var self = this;
	      this.refreshInterval = setInterval(function () {
	        $.ajax({
	          type: 'GET',
	          beforeSend: function beforeSend(xhr) {
	            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	          },
	          url: 'https://www.dupaws.com/services/public/checkStatus/' + connectionId,
	          dataType: "json",
	          contentType: "application/json; charset=utf-8",
	          success: function success(data) {
	            console.log(data);
	            if (data == -1) {
	              self.logout();
	            }
	            if (data.Manifest != null) {
	              if (localStorage.getItem('manifest') != null && localStorage.getItem('manifest') == data.Manifest) {} else if (localStorage.getItem('manifest') == null) {
	                localStorage.setItem('manifest', data.Manifest);
	              } else if (localStorage.getItem('manifest') != data.Manifest) {
	                localStorage.setItem('manifest', data.Manifest);
	                location.reload();
	              } else {
	                console.log('unknown error with manifest');
	              }
	            } else {
	              console.log('manifest was null');
	            }
	          },
	          error: function error(data) {
	            try {
	              if (data.status == 401) {
	                swal({
	                  title: "Session disconnected from server",
	                  text: data.responseJSON.Message,
	                  type: "info",
	                  confirmButtonClass: 'btn-success',
	                  confirmButtonText: "Logout and login again to continue",
	                  closeOnConfirm: true,
	                  html: true
	                }, function () {
	                  self.logout();
	                });
	              } else {
	                swal("Session disconnected from server", "Your session has been disconnected, please refresh the page to continue.", "info");
	              }
	            } catch (e) {
	              swal("Session disconnected from server with unknown error", "Your session has been disconnected, please check your network settings.", "info");
	            }
	          }
	        });
	      }, 30000);
	    },
	    getSessionId: function getSessionId() {
	      if (sessionStorage.getItem("SessionId") == null) {
	        var uuid = guid();
	        sessionStorage.setItem("SessionId", uuid);
	        return uuid;
	      } else {
	        return sessionStorage.getItem("SessionId");
	      }
	
	      function guid() {
	        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	      }
	
	      function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	      }
	    },
	    getNewCountry: function getNewCountry() {
	      var self = this;
	      $('#selectCountry').modal('hide');
	      swal({
	        title: "Enter country name below",
	        type: "input",
	        showCancelButton: true,
	        closeOnConfirm: false,
	        inputPlaceholder: "Country Name"
	      }, function (inputValue) {
	        if (inputValue === false) return false;
	        if (inputValue === "") {
	          swal.showInputError("Oops, please write your country name and press OK");
	          return false;
	        }
	        self.addCountry(inputValue);
	        return;
	      });
	    },
	
	    shareLinkedin: function shareLinkedin() {
	      this.$ga.event('Share Button Clicked', 'linkedin', 'https://www.dupaws.com');
	    },
	    shareWhatsApp: function shareWhatsApp() {
	      this.$ga.event('Share Button Clicked', 'whatsup', 'https://www.dupaws.com');
	    },
	    shareGooglePlus: function shareGooglePlus() {
	      this.$ga.event('Share Button Clicked', 'google+', 'https://www.dupaws.com');
	    },
	    shareMail: function shareMail() {
	      this.$ga.event('Share Button Clicked', 'mail', 'https://www.dupaws.com');
	    },
	    shareFacebook: function shareFacebook(myQuoteComp) {
	      this.$ga.event('Share Button Clicked', 'facebook', 'https://www.dupaws.com');
	      var self = this;
	      FB.ui({
	        method: 'share',
	        href: 'https://www.dupaws.com',
	        quote: myQuoteComp,
	        hashtag: '#dupaws',
	        mobile_iframe: true
	      }, function (response) {
	        if (response && !response.error_message) {} else {}
	      });
	    },
	    addCountry: function addCountry(countryName) {
	      var self = this;
	      return $.ajax({
	        type: 'GET',
	        url: 'https://www.dupaws.com/services/public/suggestCountry/' + countryName,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          swal("Thank you", "Country: " + countryName + " has been sent to our system, we will direct you to UAE country now to see how the website works", "success");
	          localStorage.setItem('CountryId', 1);
	          _commonApi2.default.initCountry();
	        },
	        error: function error(data, status, _error) {
	          console.log("Couldn't retrieve sitter through initSitterData() call: " + data.responseText);
	        }
	      });
	    },
	    goToSupport: function goToSupport() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/contact-support',
	        force: true
	      });
	    },
	    routerGoHome: function routerGoHome() {
	      this.closeNavbarIfOpen();
	      if (_index2.default.currentRoute.name == "home") _index2.default.go('/');
	
	      _index2.default.push({
	        path: '/',
	        force: true
	      });
	    },
	
	    mouseOver: function mouseOver() {
	      if (this.pulse == '') this.pulse = 'animated pulse';else this.pulse = '';
	    },
	    closeNavbarIfOpen: function closeNavbarIfOpen() {
	      $('#navbar').collapse('hide');
	    },
	    goMyReservations: function goMyReservations() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/my-reservations/',
	        force: true
	      });
	    },
	    goSitterReservations: function goSitterReservations() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/my-sitter-reservations',
	        force: true
	      });
	    },
	
	    setCountry: function setCountry(countryId) {
	      $('#selectCountry').modal('hide');
	      setTimeout(function () {
	        localStorage.setItem("CountryId", countryId);
	        _commonApi2.default.initCountry();
	        _index2.default.go('/');
	      }, 200);
	    },
	    goDashboard: function goDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/dashboard/feedback-performance',
	        force: true
	      });
	    },
	    goCalendar: function goCalendar() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/sitter-profile-edit/calendar',
	        force: true
	      });
	    },
	    goSitterProfileEdit: function goSitterProfileEdit() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({
	        path: '/sitter-profile-edit/about',
	        force: true
	      });
	    },
	    logout: function logout() {
	      this.closeNavbarIfOpen();
	      _auth2.default.logout();
	      _index2.default.push({ path: '/login' });
	      _index2.default.go({ path: '/login' });
	    },
	    goFindSitters: function goFindSitters() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/findsitters' });
	    },
	    goAccount: function goAccount() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/account', force: true });
	    },
	    goSubscribe: function goSubscribe() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/subscribe', force: true });
	    },
	    hidePremium: function hidePremium() {
	      localStorage.setItem('hidePremium', (0, _stringify2.default)(moment()));
	    },
	    goPetsView: function goPetsView() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/pets-view/mypets' });
	    },
	    goFavoriteSitters: function goFavoriteSitters() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/favorite-sitters' });
	    },
	    showCountries: function showCountries() {
	      if (this.compUserRole == 'Sitter') swal("Oops", "Sorry you cant change country while logged in as a Sitter, please contact support to change your details.", "info");else $('#selectCountry').modal('show');
	    },
	    goBecomeSitter: function goBecomeSitter() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/become-a-sitter' });
	    },
	    goToSitterProfile: function goToSitterProfile() {
	      this.closeNavbarIfOpen();
	      if (this.$route.params.sitterId == null) {
	        if (_index2.default.path = "/sitter-profile-edit/about") _index2.default.push({ path: '/' });
	        _index2.default.push({ path: this.sitterIdComp });
	      }
	    },
	    goUsersDashboard: function goUsersDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/users-dashboard' });
	    },
	    goSittersDashboard: function goSittersDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/sitters-dashboard' });
	    },
	    goTicketsDashboard: function goTicketsDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/tickets-dashboard' });
	    },
	    goCustomEmailDashboard: function goCustomEmailDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/email-dashboard' });
	    },
	    goChartsDashboard: function goChartsDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/charts-dashboard' });
	    },
	    goBookingsDashboard: function goBookingsDashboard() {
	      this.closeNavbarIfOpen();
	      _index2.default.push({ path: '/bookings-dashboard' });
	    },
	    goTerms: function goTerms() {
	      _index2.default.push({ path: '/terms-and-conditions' });
	    },
	    goAbout: function goAbout() {
	      _index2.default.go({ path: 'https://www.dupaws.com/pub/about' });
	    },
	    goPrivacy: function goPrivacy() {
	      _index2.default.push({ path: '/privacy-policy' });
	    },
	    goLogin: function goLogin() {
	      _index2.default.push({ path: '/login' });
	    }
	  },
	  watch: {
	    'selectCountryComp': function selectCountryComp() {
	      if (this.selectCountryComp == true) $('#selectCountry').modal('show');else $('#selectCountry').modal('hide');
	    }
	  },
	  updated: function updated() {
	    var self = this;
	    setTimeout(function () {
	      if (self.reminderClass == true) self.reminderClass = false;else self.reminderClass = true;
	    }, 15000);
	
	    if (self.checkUser == true) if (_store2.default.getters.email && self.compUserName) {}
	    if (localStorage.getItem('profilePicUrl') != null) _store2.default.commit('profilePicUrl', localStorage.getItem('profilePicUrl'));
	    if (localStorage.getItem('HideZopim') == null) {
	      setTimeout(function () {
	        localStorage.setItem('HideZopim', '1');
	      }, 5000);
	    } else {}
	  },
	  mounted: function mounted() {
	    var self = this;
	    _auth2.default.checkTokenExpiry();
	    _commonApi2.default.initCountry();
	
	    _commonApi2.default.initStaycationData();
	
	    $('.nav li').on('click', function () {
	      $('.navbar-collapse').collapse('hide');
	    });
	    _auth2.default.checkToken();
	    if (localStorage.getItem('userRole') != null) _store2.default.commit('userRole', localStorage.getItem('userRole'));
	    if (localStorage.getItem('profilePicUrl') != null) _store2.default.commit('profilePicUrl', localStorage.getItem('profilePicUrl'));
	    if (localStorage.getItem('email') != null) _store2.default.commit('email', localStorage.getItem('email'));
	    if (localStorage.getItem('sitterId') != null) _store2.default.commit('sitterId', localStorage.getItem('sitterId'));
	    if (localStorage.getItem('customerId') != null) _store2.default.commit('customerId', localStorage.getItem('customerId'));
	
	    if (localStorage.getItem('userRole') != null) if (localStorage.getItem('userRole') == "Client") {
	      _customerApi2.default.initFavoriteSitters();
	      _customerApi2.default.getPetsList();
	    }
	    _commonApi2.default.initQuery();
	    if (this.checkUser == true && this.compUserRole != "Admin") {
	      _commonApi2.default.getNotifications(_store2.default.getters.userRole);
	    }
	
	    var userId;
	    if (_store2.default.getters.userRole == "Sitter") {
	      userId = _store2.default.getters.SitterId;
	    } else if (_store2.default.getters.userRole == "Client") {
	      userId = _store2.default.getters.CustomerId;
	    }
	
	    self.$nextTick(function () {
	
	      $('#mobileNotificationDropdown .dropdown-menu').click(function (e) {
	        e.stopPropagation();
	      });
	
	      $('#webNotificationDropdown .dropdown-menu').click(function (e) {
	        e.stopPropagation();
	      });
	
	      self.connection = $.hubConnection('https://www.dupaws.com/services');
	
	
	      self.connection.qs = { SessionId: self.getSessionId() };
	      self.connection.logging = true;
	      self.chatHub = self.connection.createHubProxy('chatHub');
	      self.chatHub.on('SendNotification', function (userNotification) {
	        _store2.default.commit('addNotification', userNotification);
	      });
	      self.chatHub.on('UpdateNotification', function (userNotification) {
	        _store2.default.commit('updateNotification', userNotification);
	      });
	
	      var ua = navigator.userAgent.toLowerCase();
	      var isAndroid = ua.indexOf("android") > -1;
	      if (isAndroid) {
	        self.connection.start({ transport: ['longPolling'] }).done(function () {
	          _store2.default.commit('signalRHub', self.chatHub);
	          self.chatHub.invoke('RegisterNotification', userId, _store2.default.getters.userRole);
	          if (self.checkUser) self.checkStatus(self.connection.id);
	          console.log('signalRHub started in longPolling mode');
	        }).fail(function () {
	          console.error('Could not connect to SignalR');
	        });
	      } else {
	        self.connection.start({ transport: ['longPolling'] }).done(function () {
	          _store2.default.commit('signalRHub', self.chatHub);
	          self.chatHub.invoke('RegisterNotification', userId, _store2.default.getters.userRole);
	
	          if (self.checkUser) self.checkStatus(self.connection.id);
	          console.log('signalRHub started in autodetect mode');
	        }).fail(function () {
	          console.error('Could not connect to SignalR');
	        });
	      }
	
	      _store2.default.commit('signalRConnection', self.connection);
	
	      if (_store2.default.getters.authenticated) {
	        _commonApi2.default.initUserSubscription();
	      }
	    });
	  },
	  computed: (_computed = {
	    singaporeComp: function singaporeComp() {
	      if (_store2.default.getters.CountryData.CountryId == 9) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    whatsappUrl: function whatsappUrl() {
	
	      return 'whatsapp://send?text=' + "https://www.dupaws.com";
	    },
	    twitterUrl: function twitterUrl() {
	
	      return 'https://twitter.com/share?url=' + "https://www.dupaws.com" + '&via=dupaws&hashtags=dupaws';
	    },
	    linkedinUrl: function linkedinUrl() {
	
	      return 'https://www.linkedin.com/shareArticle?mini=true&url=' + "https://www.dupaws.com" + '&source=LinkedIn';
	    },
	    googleUrl: function googleUrl() {
	      return 'https://plus.google.com/share?url=' + "https://www.dupaws.com";
	    },
	    mailUrl: function mailUrl() {
	      return 'mailto:?subject=Checkout this great idea for your pet :)&body=' + 'https://www.dupaws.com';
	    },
	    mobileConfirmedComp: function mobileConfirmedComp() {
	      var self = this;
	      if (self.compUserRole == "Admin" || self.checkUser == false) return false;
	      if (self.checkUser) if (_store2.default.getters.PhoneConfirmed == false) return true;else return false;
	    },
	    sitterPremiumComp: function sitterPremiumComp() {
	      var self = this;
	      if (!_store2.default.getters.SubscriptionStatus) {
	        return true;
	      }
	      if (self.checkUser == false || self.compUserRole != 'Sitter') {
	        return true;
	      }
	      if (self.$route.name == 'subscribe') {
	        return true;
	      }
	      if (self.compUserRole == "Sitter" && _store2.default.getters.SubscriptionStatus.IsActive == true) {
	        return true;
	      }
	      if (localStorage.getItem('hidePremium') != null) {
	        var hideTime = moment(JSON.parse(localStorage.getItem('hidePremium')));
	        var now = moment();
	        var diff = now.diff(hideTime, 'days');
	        if (diff > 60) {
	          return false;
	        } else {
	          return true;
	        }
	      }
	
	      return false;
	    },
	    doubleRoleComp: function doubleRoleComp() {
	      if (localStorage.getItem('doubleRole') == "True" || this.compUserRole == "Sitter") return true;else return false;
	    },
	    checkUser: function checkUser() {
	      return _store2.default.getters.authenticated;
	    },
	    compUserName: function compUserName() {
	      if (_store2.default.getters.firstName && _store2.default.getters.lastName) return _store2.default.getters.firstName + ' ' + _store2.default.getters.lastName;else if (localStorage.getItem('firstName') != null && localStorage.getItem('lastName') != null) return localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName');else return "Guest";
	    },
	    compUserRole: function compUserRole() {
	      return _store2.default.getters.userRole;
	    },
	    compProfilePicUrl: function compProfilePicUrl() {
	      if (_store2.default.getters.profilePicUrl != null) {
	        return _store2.default.getters.profilePicUrl;
	      } else {
	        return localStorage.getItem('profilePicUrl');
	      }
	    },
	    countryDataComp: function countryDataComp() {
	      return _store2.default.getters.CountryData;
	    },
	    sitterIdComp: function sitterIdComp() {
	      if (_store2.default.getters.SitterId != null) {
	        return 'sitter/' + _store2.default.getters.SitterId;
	      }
	    },
	    signalReady: function signalReady() {
	      if (_store2.default.getters.SignalRHub != null) if (_store2.default.getters.SignalRHub.connection != null) return true;
	      return false;
	    }
	  }, (0, _defineProperty3.default)(_computed, 'countryDataComp', function countryDataComp() {
	    return _store2.default.getters.CountryData;
	  }), (0, _defineProperty3.default)(_computed, 'countriesList', function countriesList() {
	    return _store2.default.getters.CountriesList;
	  }), (0, _defineProperty3.default)(_computed, 'selectCountryComp', function selectCountryComp() {
	    return _store2.default.getters.SelectCountry;
	  }), (0, _defineProperty3.default)(_computed, 'myQuoteComp', function myQuoteComp() {
	    return 'Dupaws Pet Boarding at Homes available in ' + this.countryDataComp.CountryName;
	  }), (0, _defineProperty3.default)(_computed, 'subscriptionStatusComp', function subscriptionStatusComp() {
	    return _store2.default.getters.SubscriptionStatus.IsActive;
	  }), _computed),
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    clearInterval(this.refreshInterval);
	  },
	  components: {
	    Notifications: _Notifications2.default
	  }
	
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ChangePassword = __webpack_require__(547);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _VerifyEmail = __webpack_require__(553);
	
	var _VerifyEmail2 = _interopRequireDefault(_VerifyEmail);
	
	var _VerifyPhone = __webpack_require__(554);
	
	var _VerifyPhone2 = _interopRequireDefault(_VerifyPhone);
	
	var _ProfilePicUpload = __webpack_require__(549);
	
	var _ProfilePicUpload2 = _interopRequireDefault(_ProfilePicUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AccountView',
	  data: function data() {
	    return {
	      error: '',
	      userData: '',
	      alert: '',
	      number: '',
	      admin: "Admin"
	    };
	  },
	  updated: function updated() {
	    this.$ga.page(this.$router);
	    $('[data-toggle="popover"]').popover();
	  },
	
	  methods: {
	    hideAccountManagementModal: function hideAccountManagementModal() {
	      $('#accountManager').modal('hide');
	    },
	    showAccountManagementModal: function showAccountManagementModal() {
	      $('#accountManager').modal('show');
	    },
	    changePassword: function changePassword() {
	      $('#changePassword').modal('show');
	    },
	    verifyEmail: function verifyEmail() {
	
	      $('#verifyEmail').modal('show');
	    },
	    verifyPhone: function verifyPhone() {
	      var self = this;
	      $('#verifyPhone').modal('show');
	    },
	    confirmSwitchAccount: function confirmSwitchAccount() {
	      var self = this;
	      swal({
	        title: "Switch Account Confirmation",
	        text: "You are currently logged in as " + self.compUserRole + " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " + self.compUserRole + " anytime",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Yes, switch account",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.switchAccount();
	      });
	    },
	    suspendAccountConfirm: function suspendAccountConfirm() {
	      var self = this;
	      $.ajax("https://www.dupaws.com/services/api/sitter/suspendAccount/", {
	        type: 'GET',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          console.log('succes');
	          swal({
	            title: 'Account Suspended',
	            text: "Your account was suspended as per your request, to enable it back send an email to info@dupaws.com",
	            type: "success",
	            confirmButtonClass: "btn-success",
	            confirmButtonText: 'Woof!',
	            allowOutsideClick: false,
	            closeOnConfirm: true
	          }, function (isConfirm) {
	            return;
	          });
	        },
	        error: function error() {
	          swal("error", "a problem happened while trying to suspend your account, please contact support", "error");
	        }
	      });
	    },
	    goSuspend: function goSuspend() {
	      var self = this;
	      swal({
	        title: "Are you sure you want to suspend your account?",
	        text: "By doing so your profile will no longer be visible to any user, the only way to enable it back is to send us an email and request your account to be re-enabled",
	        type: "warning",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-danger',
	        cancelButtonClass: 'btn-default',
	        confirmButtonText: "Yes Suspend",
	        cancelButtonText: "Cancel",
	        allowOutsideClick: false,
	        closeOnConfirm: false
	
	      }, function (isConfirm) {
	        if (isConfirm) {
	          self.suspendAccountConfirm();
	          return;
	        } else {}
	      });
	    },
	    goSubscribe: function goSubscribe() {
	      var self = this;
	      self.hideAccountManagementModal();
	      if (_store2.default.getters.SubscriptionStatus.IsActive == true) {
	
	        swal("Subscription Status", "Your membership is active, you can upgrade when it expires", "success");
	      } else {
	        self.$router.push({ path: '/subscribe' });
	      }
	    },
	    switchAccount: function switchAccount() {
	      var self = this;
	      $.ajax({
	        type: 'GET',
	        url: 'https://www.dupaws.com/services/api/account/SwitchRole/' + self.countryDataComp.CountryId,
	        contentType: "application/json; charset=utf-8",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        success: function success(data) {
	          self.alert = data;
	          _index2.default.logout();
	          self.$router.push({ path: '/login', query: { switch: 'yes' } });
	        },
	        error: function error() {
	          try {
	            self.error = "Failed switching account";
	          } catch (e) {
	            self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    },
	    updateUser: function updateUser() {
	      var self = this;
	      if (!self.userData.FirstName || !self.userData.LastName) {
	        swal("Something is missing", "Please fill in First and Last Name before saving", "info");
	        return;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://www.dupaws.com/services/api/account/updateUser',
	        data: (0, _stringify2.default)(self.userData),
	        contentType: "application/json; charset=utf-8",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        success: function success(data) {
	          self.alert = data;
	
	          localStorage.setItem('firstName', self.userData.FirstName);
	          localStorage.setItem('lastName', self.userData.LastName);
	          localStorage.setItem('phoneNumber', self.userData.PhoneNumber);
	          _store2.default.commit('firstName', localStorage.getItem('firstName'));
	          _store2.default.commit('lastName', localStorage.getItem('lastName'));
	          _store2.default.commit('phoneNumber', localStorage.getItem('phoneNumber'));
	          self.$router.push({ path: '/' });
	        },
	        error: function error() {
	          try {
	            self.error = "Updating user failed, try again..";
	          } catch (e) {
	            self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    },
	    updateSitter: function updateSitter(route) {
	      var self = this;
	      if (!self.userData.FirstName || !self.userData.LastName) {
	        swal("Something is missing", "Please fill in First and Last Name before saving", "info");
	        return;
	      }
	      $.ajax({
	        type: 'POST',
	        url: 'https://www.dupaws.com/services/api/account/updateUser',
	        data: (0, _stringify2.default)(self.userData),
	        contentType: "application/json; charset=utf-8",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        success: function success(data) {
	          self.alert = data;
	
	          localStorage.setItem('firstName', self.userData.FirstName);
	          localStorage.setItem('lastName', self.userData.LastName);
	          localStorage.setItem('phoneNumber', self.userData.PhoneNumber);
	          _store2.default.commit('firstName', localStorage.getItem('firstName'));
	          _store2.default.commit('lastName', localStorage.getItem('lastName'));
	          _store2.default.commit('phoneNumber', localStorage.getItem('phoneNumber'));
	          if (route == "dashboard") {
	            self.$router.push({ path: '/dashboard/feedback-performance' });
	          } else if (route == "calendar") {
	            self.$router.push({ path: '/sitter-profile-edit/calendar' });
	          } else {
	            self.$router.push({ path: '/' });
	          }
	        },
	        error: function error() {
	          try {
	            self.error = "Updating user failed, try again..";
	          } catch (e) {
	            self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    $.ajax({
	      type: 'GET',
	      url: 'https://www.dupaws.com/services/api/account/whoami',
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	      },
	      success: function success(data) {
	        self.userData = data;
	        _store2.default.commit('profilePicUrl', data.ProfilePicUrl);
	        localStorage.setItem('profilePicUrl', data.ProfilePicUrl);
	      },
	      error: function error(_error) {
	        try {
	          self.error = _error.responseJSON;
	        } catch (e) {
	          self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	        }
	      }
	    });
	  },
	  computed: {
	    phoneNumberComp: function phoneNumberComp() {
	      if (this.userDataComp.PhoneNumber != null) {
	        if (this.userDataComp.PhoneNumber.startsWith(this.countryDataComp.CountryCode, 0)) {
	          swal("Phone Number", "Please enter your phone number without country code", "info");
	          return false;
	        }
	        if (this.userDataComp.PhoneNumber.length > 10) {
	          swal("Phone Number", "Phone number incorrect, maximum length should be 10 numbers", "info");
	          return false;
	        }
	
	        if (this.userDataComp.PhoneNumber.length > 6) return true;else return false;
	      }
	    },
	    countryDataComp: function countryDataComp() {
	      return _store2.default.getters.CountryData;
	    },
	    phoneNumberConfirmedComp: function phoneNumberConfirmedComp() {
	      if (_store2.default.getters.PhoneConfirmed == true || localStorage.getItem('phoneConfirmed') == "True") return true;else return false;
	    },
	    compUserRole: function compUserRole() {
	      return _store2.default.getters.userRole;
	    },
	    userDataComp: function userDataComp() {
	      if (this.userData != null) return this.userData;
	    },
	    emailStatusComp: function emailStatusComp() {
	      if (localStorage.getItem('emailConfirmed') == "True") return 'Email Confirmed';else return 'Confirm Email';
	    },
	    phoneStatusComp: function phoneStatusComp() {
	      if (_store2.default.getters.PhoneConfirmed == true || localStorage.getItem('phoneConfirmed') == "True") return 'Mobile Confirmed';else return 'Confirm Mobile';
	    }
	  },
	  components: {
	    ChangePassword: _ChangePassword2.default,
	    VerifyEmail: _VerifyEmail2.default,
	    VerifyPhone: _VerifyPhone2.default,
	    ProfilePicUpload: _ProfilePicUpload2.default
	
	  }
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ChangePassword",
	  data: function data() {
	    return {
	      userData: {
	        OldPassword: "",
	        NewPassword: "",
	        ConfirmPassword: ""
	      },
	      code: "",
	      error: "",
	      alert: "",
	      pending: true
	    };
	  },
	
	  methods: {
	    closeModal: function closeModal() {
	      $("#changePassword").modal("hide");
	    },
	    changePassword: function changePassword() {
	      self = this;
	      self.userData.ConfirmPassword = self.userData.NewPassword;
	      $.ajax({
	        type: "POST",
	        url: "https://www.dupaws.com/services/api/account/ChangePassword",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        data: (0, _stringify2.default)(self.userData),
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.alert = "Password successfully changed..";
	          self.pending = false;
	          self.error = "";
	        },
	        error: function error() {
	          try {
	            self.error = "Password save failed, is old password correct?";
	          } catch (e) {
	            context.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    }
	  },
	  mounted: function mounted() {},
	  computed: {
	    errorMsg: function errorMsg() {
	      return this.error;
	    },
	    alertMsg: function alertMsg() {
	      return this.alert;
	    },
	    email: function email() {
	      return localStorage.getItem("email");
	    }
	  }
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Alert = __webpack_require__(66);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _PasswordReset = __webpack_require__(243);
	
	var _PasswordReset2 = _interopRequireDefault(_PasswordReset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  data: function data() {
	    return {
	      fbSignInParams: {
	        scope: 'email,public_profile',
	        return_scopes: true
	
	      },
	      scrollPosition: '',
	      credentials: {
	        username: '',
	        password: ''
	
	      },
	      FBTokenInfo: {
	        Token: '',
	        Email: '',
	        Provider: 'Facebook',
	        FirstName: '',
	        LastName: '',
	        UserRole: '',
	        CountryId: '',
	        ProfilePicUrl: ''
	
	      },
	      notification: '',
	      error: '',
	      alert: false,
	      alertMsg: ''
	
	    };
	  },
	  updated: function updated() {
	    var self = this;
	  },
	
	
	  methods: {
	    goSignup: function goSignup() {
	      this.$router.push({ path: '/signup' });
	    },
	    goBack: function goBack() {
	      this.$router.push({ path: '/' });
	    },
	    goAccount: function goAccount() {
	      this.$router.push({ path: '/account' });
	    },
	    validateBeforeSubmit: function validateBeforeSubmit() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this.submit();
	          return;
	        }
	
	        swal("Something is missing", "Please complete all the required fields to continue.", "info");
	      });
	    },
	    submit: function submit() {
	      $(window).scrollTop(0);
	
	      var loginCreds = {
	        grant_type: "password",
	        username: this.credentials.username,
	        password: this.credentials.password
	      };
	      localStorage.setItem('email', this.credentials.username);
	      _store2.default.commit('email', localStorage.getItem('email'));
	
	      if (this.$route.query.redirect != null) {
	        _index2.default.login(this, loginCreds, this.$route.query.redirect);
	      } else if (this.$route.query.sitter != null) {
	        var redirectBack = "sitter/" + this.$route.query.sitter;
	        _index2.default.login(this, loginCreds, redirectBack);
	      } else {
	        _index2.default.login(this, loginCreds);
	      }
	    },
	    forgotPassword: function forgotPassword() {
	      if (this.credentials.username != null) {
	        localStorage.setItem('email', this.credentials.username);
	        _store2.default.commit('email', localStorage.getItem('email'));
	      }
	      this.$router.push({ path: '/passwordreset' });
	    },
	    onSignInSuccess: function onSignInSuccess(response) {
	      var self = this;
	      self.error = '';
	      self.FBTokenInfo.ProfilePicUrl = "images/sitterProfilePic.png";
	
	      FB.api('/me', { fields: 'first_name,last_name,email' }, function (response) {
	        self.FBTokenInfo.FirstName = response.first_name;
	        self.FBTokenInfo.LastName = response.last_name;
	        self.FBTokenInfo.Email = response.email, self.FBTokenInfo.CountryId = localStorage.getItem('CountryId');
	        localStorage.setItem('email', response.email);
	        _store2.default.commit('email', localStorage.getItem('email'));
	        self.notification = 'Logging in through Facebook';
	        FB.getLoginStatus(function (response) {
	          self.FBTokenInfo.Token = response.authResponse.accessToken;
	          if (self.$route.query.redirect) {
	            _index2.default.fbLogin(self, self.FBTokenInfo, self.$router, self.$route.query.redirect);
	          } else if (self.$route.query.sitter) {
	            var redirectBack = "sitter/" + self.$route.query.sitter;
	            _index2.default.fbLogin(self, self.FBTokenInfo, redirectBack);
	          } else {
	            _index2.default.fbLogin(self, self.FBTokenInfo);
	          }
	        });
	      });
	    },
	    onSignInError: function onSignInError(error) {
	      self.notification = '';
	      this.error = "Sorry but Facebook login failed";
	    },
	    SignOut: function SignOut(response) {
	      FB.logout(function (response) {});
	    }
	  },
	  computed: {
	    switchAccountComp: function switchAccountComp() {
	      if (this.$route.query.switch == "yes") return true;else return false;
	    },
	    alertData: function alertData() {
	      if (this.$route.query.redirect) {
	        this.alertMsg = "Hello sir please sign in";
	        this.alert = true;
	      } else {
	        this.alert = false;
	      }
	      return this.alertMsg;
	    },
	    filledRequired: function filledRequired() {
	      if (this.credentials.username == '' || this.credentials.password == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    authenticatedComp: function authenticatedComp() {
	      return _store2.default.getters.authenticated;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    }
	
	  },
	
	  components: {
	    Alert: _Alert2.default,
	    PasswordReset: _PasswordReset2.default
	  }
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'PasswordReset',
	
	    data: function data() {
	        return {
	            userData: {
	                Email: '',
	                Password: '',
	                Code: ''
	
	            },
	            codeSent: false,
	            pressed: false,
	            count: '',
	            code: '',
	            codeSentSuccess: false,
	            codeVerifySuccess: false,
	            error: '',
	            codeFilled: false,
	            alert: '',
	            pending: true
	        };
	    },
	
	    methods: {
	        validateBeforeSubmit: function validateBeforeSubmit() {
	            if (this.errors.has('email') || !this.userData.Email) {
	                swal("Email required", "Please make sure your email is valid before sending.", "info");
	                return;
	            }
	            this.sendCode();
	        },
	        validatePassword: function validatePassword() {
	            if (this.errors.has('password') || !this.userData.Password) {
	                swal("Password required", "Please make sure your password is at least 6 characters before sending.", "info");
	                return;
	            }
	            this.changePassword();
	        },
	        startCountDown: function startCountDown() {
	            var self = this;
	            self.count = 10;
	            var timer = setInterval(function () {
	                self.count--;
	                if (self.count == 0) {
	                    self.count = '';
	                    clearInterval(timer);
	                }
	            }, 1000);
	        },
	        redirectLogin: function redirectLogin() {
	            this.$router.push({ path: '/login' });
	        },
	        sendCode: function sendCode() {
	            self = this;
	            self.pressed = true;
	            self.codeSent = true;
	            self.startCountDown();
	
	            $.ajax({
	                type: 'POST',
	                contentType: "application/json",
	                url: 'https://www.dupaws.com/services/api/account/SendPasswordCode',
	                dataType: "json",
	                data: (0, _stringify2.default)(self.userData),
	                success: function success(data) {
	                    self.error = '';
	                    self.alert = data, self.codeSentSuccess = true;
	                },
	                error: function error(_error) {
	                    try {
	                        self.error = _error.responseJSON.Message;
	                    } catch (e) {
	                        context.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        },
	        redirectToLogin: function redirectToLogin() {
	            this.$router.push({ path: "/login" });
	        },
	        changePassword: function changePassword() {
	            self = this;
	            self.error = '';
	            self.userData;
	            $.ajax({
	                type: 'POST',
	                contentType: "application/json",
	                data: (0, _stringify2.default)(self.userData),
	                dataType: "json",
	                url: 'https://www.dupaws.com/services/api/account/ConfirmPassword',
	                success: function success(data) {
	                    self.alert = "Password changed successfully, Sign in with your new password";
	                    self.pending = false;
	                    self.codeVerifySuccess = true;
	                    swal({
	                        title: "Password Reset Success!",
	                        text: "Press Login to be directed to login page and use your new credentials",
	                        type: "success",
	                        showCancelButton: true,
	                        confirmButtonClass: 'btn-success',
	                        confirmButtonText: "Take me to login",
	                        closeOnConfirm: true,
	                        html: true
	                    }, function () {
	                        self.redirectLogin();
	                    });
	                },
	                error: function error() {
	                    try {
	                        self.error = "Password change failed, check the code is correct and try again";
	                    } catch (e) {
	                        context.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        }
	    },
	    created: function created() {
	        if (_store2.default.getters.email != null) this.userData.Email = _store2.default.getters.email;
	    },
	    mounted: function mounted() {},
	    watch: {
	        'userData.Code': function userDataCode() {
	            if (this.userData.Code.length < 6) {
	                return false;
	            } else if (this.userData.Code.length == 6) {
	                this.codeFilled = true;
	            }
	        }
	    },
	    computed: {
	
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        }
	
	    }
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blueimpLoadImage = __webpack_require__(38);
	
	var _blueimpLoadImage2 = _interopRequireDefault(_blueimpLoadImage);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ProfilePicUpload",
	  data: function data() {
	    return {
	      filePath: "",
	      cropOptions: {
	        aspectRatio: 5 / 5,
	        background: false,
	        autoCropArea: 0.8,
	        checkCrossOrigin: true,
	        modal: true,
	        preview: ".img-preview"
	      },
	      uploadCompletePct: "",
	      uploading: false,
	      profilePhoto: {
	        Path: "",
	        PhotoId: 0,
	        Type: ""
	      },
	      uploadedImageSrc: ""
	    };
	  },
	
	  methods: {
	    previewThumbnail: function previewThumbnail(event) {
	      var orientationVal = true;
	      var input = event.target;
	      if (input.files && input.files[0]) {
	        var self = this;
	        self.uploadCompletePct = "";
	        var file = input.files[0];
	
	        _blueimpLoadImage2.default.parseMetaData(file, function (data) {
	          if (data.exif) {
	            orientationVal = data.exif.get("Orientation");
	          } else orientationVal = true;
	
	          var loadingImage = (0, _blueimpLoadImage2.default)(file);
	
	          loadingImage.onload = function (e) {
	            var scaledImage = _blueimpLoadImage2.default.scale(loadingImage, { orientation: orientationVal });
	
	            var canvas = document.createElement("canvas");
	            var ctx = canvas.getContext("2d");
	
	            var maxWidth = 800,
	                maxHeight = 800,
	                imageWidth = scaledImage.width,
	                imageHeight = scaledImage.height;
	
	            if (imageWidth > imageHeight) {
	              if (imageWidth > maxWidth) {
	                imageHeight *= maxWidth / imageWidth;
	                imageWidth = maxWidth;
	              }
	            } else {
	              if (imageHeight > maxHeight) {
	                imageWidth *= maxHeight / imageHeight;
	                imageHeight = maxHeight;
	              }
	            }
	            canvas.width = imageWidth;
	            canvas.height = imageHeight;
	
	            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);
	
	            var finalFile = canvas.toDataURL("image/png");
	
	            $("#profilePicModal").modal("show");
	            self.uploadedImageSrc = finalFile;
	          };
	        });
	      }
	    },
	    cancelSave: function cancelSave() {
	      $("#profilePicCropper").cropper("destroy");
	    },
	    saveImage: function saveImage() {
	      var self = this;
	      self.uploading = true;
	      self.uploadCompletePct = "";
	      $("#profilePicCropper").cropper("getCroppedCanvas", { width: "400", height: "400" }).toBlob(function (blob) {
	        var formData = new FormData();
	        formData.append("image", blob);
	        $.ajax("https://www.dupaws.com/services/api/account/postProfilePic/", {
	          type: "POST",
	          data: formData,
	          beforeSend: function beforeSend(xhr) {
	            xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	          },
	          xhr: function xhr() {
	            var xhr = new window.XMLHttpRequest();
	            xhr.upload.addEventListener("progress", function (evt) {
	              if (evt.lengthComputable) {
	                var percentComplete = evt.loaded / evt.total;
	                self.uploadCompletePct = Math.round(percentComplete * 100) + "%";
	              }
	            }, false);
	            return xhr;
	          },
	          crossDomain: true,
	          processData: false,
	          contentType: false,
	          success: function success(data) {
	            self.profilePhoto.Path = data;
	            localStorage.setItem("profilePicUrl", data);
	            _store2.default.commit("profilePicUrl", data);
	            self.uploading = false;
	            self.uploadedCompletePct = 0;
	          },
	          error: function error() {
	            self.uploading = false;
	            self.uploadedCompletePct = 0;
	          }
	        });
	      }, "image/jpeg", 0.85);
	    }
	  },
	  created: function created() {
	    var self = this;
	    $.ajax("https://www.dupaws.com/services/api/account/getProfilePic/", {
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      contentType: "application/json; charset=utf-8",
	      crossDomain: true,
	      success: function success(data) {
	        self.profilePhoto.Path = data;
	      },
	      error: function error() {}
	    });
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.$nextTick(function () {
	      $("#profilePicModal").on("shown.bs.modal", function () {
	        $("#profilePicCropper").cropper(self.cropOptions);
	      }).on("hidden.bs.modal", function () {
	        $("#profilePicCropper").cropper("destroy");
	      });
	    });
	  },
	  computed: {
	    uploadStatusPct: function uploadStatusPct() {
	      var self = this;
	      return "Uploading " + self.uploadCompletePct + " complete.";
	    },
	    photoComp: function photoComp() {
	      self = this;
	      return self.profilePhoto.Path;
	    }
	  }
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        email: '',
	        firstName: '',
	        lastName: '',
	        password: '',
	        confirmPassword: ''
	
	      },
	      focused: null,
	      error: '',
	      notification: ''
	
	    };
	  },
	  updated: function updated() {
	    var self = this;
	  },
	
	  methods: {
	    validateBeforeSubmit: function validateBeforeSubmit() {
	      var _this = this;
	
	      var self = this;
	      this.$validator.validateAll().then(function (result) {
	        if (self.credentials.email.substr(self.credentials.email.length - 3) == "con") {
	          swal("Oops, your email looks incorrect", self.credentials.email, "info");
	          return;
	        }
	        if (result) {
	          _this.submit();
	          return;
	        }
	
	        swal("Something is missing", "Please complete all the required fields to continue.", "info");
	      });
	    },
	    submit: function submit() {
	      var self = this;
	      $(window).scrollTop(0);
	      var countryId = localStorage.getItem('CountryId');
	      var credentials = {
	        Email: this.credentials.email,
	        firstName: this.credentials.firstName,
	        lastName: this.credentials.lastName,
	        Password: this.credentials.password,
	        CountryId: countryId,
	        Provider: 'Direct',
	        confirmPassword: this.credentials.password,
	        userRole: "Client"
	      };
	
	      _auth2.default.register(this, credentials, 'account');
	    }
	  },
	  computed: {
	    filledRequired: function filledRequired() {
	
	      if (this.credentials.email == '' || this.credentials.password == '') {
	        return false;
	      }
	    }
	
	  }
	
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueScript = __webpack_require__(667);
	
	var _vueScript2 = _interopRequireDefault(_vueScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "subscribe",
	  data: function data() {
	    return {
	      myTotal: 100,
	      paypalNonce: "",
	      braintreeClient: "",
	      selectedPlan: "",
	      paypalDone: false,
	      plansDto: "",
	      paymentDto: "",
	      paypalPayDto: {
	        PlanId: "",
	        SubscriptionId: "",
	        PaypalEmail: "",
	        PaypalFirstName: "",
	        PaypalLastName: "",
	        PaypalTransId: "",
	        InvoiceNumber: "",
	        Status: "",
	        PaypalAmount: "",
	        PaypalCurrency: ""
	      },
	      testDto: {
	        intent: "sale",
	        payer: {
	          payment_method: "paypal",
	          payer_info: {
	            email: "m.khomakho-buyer@dupaws.com",
	            first_name: "Mohammed",
	            last_name: "Khomakho",
	            billing_address: {
	              line1: "12345",
	              city: "Dubai",
	              state: "Dubai",
	              country_code: "AE",
	              postal_code: "12345",
	              phone: "0551764478"
	            }
	          }
	        },
	        application_context: {
	          brand_name: "Dupaws.com",
	          locale: "en_AE",
	          shipping_preference: "NO_SHIPPING"
	        },
	        transactions: [{
	          amount: {
	            total: "50",
	            currency: "USD"
	          },
	          description: "Dupaws 3 month subscription.",
	          invoice_number: "48787589634336",
	          payment_options: {
	            allowed_payment_method: "INSTANT_FUNDING_SOURCE"
	          },
	          payee: {
	            email: "business@dupaws.com"
	          }
	        }]
	      }
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    this.$ga.page(this.$router);
	
	    self.initPlans();
	    fbq("track", "Lead", { content_name: "Visit Subscribe Page" });
	    self.$ga.event("Visit Subscribe Page");
	  },
	  updated: function updated() {
	    var self = this;
	    $("input").focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $("input").blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	
	    if (self.paypalDone == false) {
	      _vueScript2.default.load("https://www.paypalobjects.com/api/checkout.min.js").then(function () {
	        if (self.subscriptionAllowedComp == false) {
	          self.swalAlert();
	        }
	        if (self.subscriptionComp == false) {
	          self.initPaypalButton();
	          self.paypalDone = true;
	        }
	      });
	    }
	  },
	
	  methods: {
	    swalAlert: function swalAlert() {
	      var self = this;
	      swal({
	        title: "You are getting closer!",
	        text: "To upgrade your account, you must have a completed and approved Pet Sitter account first",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: "btn-success",
	        confirmButtonText: "Setup Profile",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.$router.push({ path: "/sitter-profile-edit/about" });
	      });
	    },
	
	    goHome: function goHome() {
	      this.$router.push({ path: "/" });
	    },
	    showPaypalModal: function showPaypalModal(plan) {
	      var self = this;
	      self.selectedPlan = plan;
	      if (self.subscriptionAllowedComp == false) {
	        self.swalAlert();
	        return;
	      }
	
	      self.initPaymentDto(self.selectedPlan).then(function (paymentDto_server) {
	        self.paymentDto = paymentDto_server;
	        fbq("track", "InitiateCheckout", {
	          currency: "USD",
	          content_name: self.selectedPlan.Description,
	          value: self.selectedPlan.TotalPrice
	        });
	        self.$ga.event("Initiate Checkout", self.selectedPlan.Description, self.selectedPlan.TotalPrice);
	        $("#paypalModal").modal("show");
	      }).fail(function (error) {
	        console.log(error);
	      });
	    },
	    hidePaypalModal: function hidePaypalModal() {
	      $("#paypalModal").modal("hide");
	    },
	    showPendingModal: function showPendingModal() {
	      $("#pendingModal").modal("show");
	    },
	    hidePendingModal: function hidePendingModal() {
	      $("#pendingModal").modal("hide");
	    },
	
	    initPaymentDto: function initPaymentDto(selectedPlan) {
	      var self = this;
	      return $.ajax({
	        type: "GET",
	        url: "https://www.dupaws.com/services/api/initPaymentDto/" + selectedPlan.PlanId,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {},
	        error: function error(data, status, _error) {
	          console.log("failed to get Sitter Profile Status" + data.responseText);
	        }
	      });
	    },
	    initPlans: function initPlans() {
	      var self = this;
	      $.ajax({
	        type: "GET",
	        url: "https://www.dupaws.com/services/api/initPlans",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          self.plansDto = data;
	        },
	        error: function error(data, status, _error2) {
	          try {
	            console.log(data);
	            swal("Error", data.responseJSON.Message, "error");
	          } catch (e) {
	            swal("Error", e, "error");
	          }
	        }
	      });
	    },
	
	    confirmPayment: function confirmPayment(payment) {
	      var self = this;
	      self.paypalPayDto.Status = payment.state;
	      self.paypalPayDto.PaypalEmail = payment.payer.payer_info.email;
	      self.paypalPayDto.PaypalFirstName = payment.payer.payer_info.first_name;
	      self.paypalPayDto.PaypalLastName = payment.payer.payer_info.last_name;
	      self.paypalPayDto.InvoiceNumber = payment.transactions[0].invoice_number;
	      self.paypalPayDto.PaypalTransId = payment.transactions[0].related_resources[0].sale.id;
	      self.paypalPayDto.PaypalAmount = payment.transactions[0].related_resources[0].sale.amount.total;
	      self.paypalPayDto.PaypalCurrency = payment.transactions[0].related_resources[0].sale.amount.currency;
	      self.paypalPayDto.PlanId = self.selectedPlan.PlanId;
	      fbq("track", "Purchase", {
	        currency: "USD",
	        content_name: self.selectedPlan.Description,
	        value: self.selectedPlan.TotalPrice
	      });
	      self.$ga.event("Purchase Completed", self.selectedPlan.Description, self.selectedPlan.TotalPrice + " USD", self.selectedPlan.TotalPrice);
	      self.submitPaymentDto(self.paypalPayDto);
	    },
	    submitPaymentDto: function submitPaymentDto(paypalPayment) {
	      var self = this;
	      self.hidePaypalModal();
	      $.ajax({
	        type: "POST",
	        contentType: "application/json",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        data: (0, _stringify2.default)(paypalPayment),
	        dataType: "json",
	        url: "https://www.dupaws.com/services/api/confirmPayment",
	        success: function success(data) {
	          if (data.SubscriptionId == null) {
	            swal("Payment Error", "Please contact support immediately and provide the invoice number: " + paypalPayment.InvoiceNumber, "error");
	          }
	          self.hidePendingModal();
	          swal({
	            title: "Payment successfull",
	            text: "Payment with Invoice Number: " + data.InvoiceNumber + " was success, thank you!",
	            type: "success",
	            confirmButtonClass: "btn-success",
	            confirmButtonText: "Woof",
	            timer: 500
	          }, function () {
	            self.$router.push({ path: "/success/" + data.SubscriptionId });
	          });
	        },
	        error: function error() {
	          try {
	            swal("Payment Error", "Please contact support immediately and provide the invoice number: " + paypalPayment.InvoiceNumber, "error");
	          } catch (e) {
	            swal("Payment Error", "Please contact support immediately and provide the invoice number: " + paypalPayment.InvoiceNumber, "error");
	          }
	        }
	      });
	    },
	    initPaypalButton: function initPaypalButton() {
	      var self = this;
	      if (self.paypalDone == true) return;
	      paypal.Button.render({
	        locale: "en_AE",
	        commit: true,
	        style: {
	          layout: "vertical",
	          size: "responsive",
	          shape: "rect",
	          color: "gold" },
	        onClick: function onClick() {
	          self.hidePaypalModal();
	          self.showPendingModal();
	        },
	        funding: {
	          allowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT],
	          disallowed: []
	        },
	        client: {
	          sandbox: "AZES99kM2cu_67z3ijKQrf4BByAPzPqiVrIruRWz48LFyUvFjHi60BpvczS5ixrP2RTL8JADjgya8eSV",
	          production: "AfBinNS7DZc6ujcGkHaau5GgG_DcoYVwljPl7njs-zam-Aguc79nP7RYGHOiZIKQma45njhJHq35fB7N"
	        },
	        env: "production",
	        payment: function payment() {
	          var env = this.props.env;
	          var client = this.props.client;
	
	          return paypal.rest.payment.create(env, client, self.paymentDto);
	        },
	        onCancel: function onCancel(data, actions) {
	          self.hidePaypalModal();
	          self.hidePendingModal();
	          swal("Oops", "You cancelled this transaction", "error");
	        },
	        onError: function onError(actions, err) {
	          self.hidePendingModal();
	          self.hidePaypalModal();
	          swal("Oops Paypal error", "Seems like paypal duplicate invoice_number or paypal generic server error", "error");
	        },
	
	        onAuthorize: function onAuthorize(data, actions) {
	          return actions.payment.execute().then(function (payment) {
	            if (payment.state == "approved") {
	              self.confirmPayment(payment);
	            } else {
	              self.hidePendingModal();
	              self.hidePaypalModal();
	              swal("Payment failure", "Payment was not approved, status: " + payment.state + ", please try again", "error");
	            }
	          });
	        }
	      }, "#paypal-button-container");
	    }
	  },
	  computed: {
	    authenticatedComp: function authenticatedComp() {
	      return _store2.default.getters.authenticated;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    },
	    subscriptionComp: function subscriptionComp() {
	      return _store2.default.getters.SubscriptionStatus.IsActive;
	    },
	    subscriptionAllowedComp: function subscriptionAllowedComp() {
	      return _store2.default.getters.SubscriptionStatus.IsValid;
	    }
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "success",
	  data: function data() {
	    return {
	      subscriptionDto: "",
	      loading: true
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.initSubscription(this.$route.params.subscriptionId);
	  },
	  updated: function updated() {
	    var self = this;
	    $("input").focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $("input").blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	  },
	
	  methods: {
	    goHome: function goHome() {
	      this.$router.push({ path: "/" });
	    },
	    initSubscription: function initSubscription(subscriptionId) {
	      var self = this;
	      return $.ajax({
	        type: "GET",
	        url: "https://www.dupaws.com/services/api/initSubscription/" + subscriptionId,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.subscriptionDto = data;
	          self.loading = false;
	          _commonApi2.default.initUserSubscription();
	        },
	        error: function error(data, status, _error) {
	          try {
	            swal("Error", data.responseJSON.Message, "error");
	            self.goHome();
	          } catch (e) {
	            swal("Error", e, "error");
	            self.goHome();
	          }
	        }
	      });
	    }
	  },
	  computed: {
	    authenticatedComp: function authenticatedComp() {
	      return _store2.default.getters.authenticated;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    },
	    endDateComp: function endDateComp() {
	      var self = this;
	      return moment(self.subscriptionDto.EndDate).format("DD MMM YYYY");
	    },
	    paymentDateComp: function paymentDateComp() {
	      var self = this;
	      return moment(self.subscriptionDto.PaymentDate).format("DD MMM YYYY");
	    }
	  },
	  components: {}
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'VerifyEmail',
	    data: function data() {
	        return {
	            code: '',
	            error: '',
	            alert: 'Please check your email and enter the 6 digits verification code below:',
	            pending: true,
	            codeSent: false,
	            count: ''
	        };
	    },
	
	    methods: {
	        closeEmail: function closeEmail() {
	            $('#verifyEmail').modal('hide');
	        },
	        startCountDown: function startCountDown() {
	            var self = this;
	            self.count = 60;
	            var timer = setInterval(function () {
	                self.count--;
	                if (self.count == 0) {
	                    self.count = '';
	                    clearInterval(timer);
	                }
	            }, 1000);
	        },
	        sendCode: function sendCode() {
	            var self = this;
	            self.codeSent = true;
	            $.ajax({
	                type: 'GET',
	                url: 'https://www.dupaws.com/services/api/account/SendEmailCode',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    self.alert = "Code sent, check your email (ensure to check spam folder).";
	                    self.startCountDown();
	                },
	                error: function error() {
	                    try {
	                        self.error = "Code sending Failed, try again..";
	                        self.codeSent = false;
	                    } catch (e) {
	                        self.codeSent = false;
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        },
	        initVerify: function initVerify() {
	            var check = localStorage.getItem('emailConfirmed');
	            if (check == "True") {
	                this.pending = false;
	                this.codeSent = true;
	                this.alert = 'Has been verified, thank you.';
	            }
	        },
	        verifyCode: function verifyCode() {
	            self = this;
	            $.ajax({
	                type: 'POST',
	                url: 'https://www.dupaws.com/services/api/account/ConfirmEmail?code=' + this.code,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    localStorage.setItem('emailConfirmed', 'True');
	                    self.initVerify();
	                },
	                error: function error() {
	                    try {
	                        self.error = "Verification Failed, try again..";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.initVerify();
	    },
	    watch: {
	        'code': function code() {
	            if (this.code.length < 6) {
	                this.error = '';
	                return false;
	            } else if (this.code.length == 6) {
	                this.verifyCode();
	            }
	        }
	    },
	    computed: {
	
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        email: function email() {
	            return localStorage.getItem('email');
	        }
	
	    }
	
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['mobileNumber', 'countryCode'],
	    name: 'verifyPhone',
	    data: function data() {
	        return {
	            code: '',
	            error: '',
	            notReceiving: false,
	            alert: 'Please check your mobile and enter the 6 digits verification code below:',
	            pending: true,
	            codeSent: false,
	            count: ''
	        };
	    },
	
	    methods: {
	        closePhone: function closePhone() {
	            $('#verifyPhone').modal('hide');
	        },
	        startCountDown: function startCountDown() {
	            var self = this;
	            self.count = 60;
	            var timer = setInterval(function () {
	                self.count--;
	                if (self.count == 0) {
	                    self.count = '';
	                    clearInterval(timer);
	                    self.notReceiving = true;
	                }
	            }, 1000);
	        },
	        notReceivingMessages: function notReceivingMessages() {
	            var self = this;
	            swal({
	                title: 'Cant Receive SMS',
	                text: "Yes its frustrating to wait too long for an SMS! we face this occasionally with some mobile operators in specific countries. please send us an email with your number and we will verify it for you.",
	                type: "success",
	                confirmButtonClass: "btn-success",
	                confirmButtonText: 'Woof!',
	                allowOutsideClick: false,
	                closeOnConfirm: true
	            }, function (isConfirm) {
	                return;
	            });
	        },
	        sendCode: function sendCode() {
	            var self = this;
	            self.codeSent = true;
	            $.ajax({
	                type: 'GET',
	                url: 'https://www.dupaws.com/services/api/account/SendMobileCode/' + self.countryCode + '/' + self.mobileNumber,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    self.alert = "Code sent, you will receive an SMS soon with a 6 digit code.";
	                    self.error = "";
	                    self.startCountDown();
	                },
	                error: function error() {
	                    try {
	                        self.error = "Code sending Failed, try again..";
	                        self.codeSent = false;
	                    } catch (e) {
	                        self.codeSent = false;
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        },
	        initVerify: function initVerify() {
	            var check = localStorage.getItem('phoneConfirmed');
	            if (check == "True") {
	                this.pending = false;
	                this.codeSent = true;
	                this.alert = 'Has been verified, thank you.';
	            }
	        },
	        verifyCode: function verifyCode() {
	            self = this;
	            $.ajax({
	                type: 'POST',
	                url: 'https://www.dupaws.com/services/api/account/ConfirmPhone?code=' + this.code + '&countryCode=' + self.countryCode + '&phoneNumber=' + self.mobileNumber,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    localStorage.setItem('phoneConfirmed', 'True');
	                    _store2.default.dispatch('PhoneConfirmed', true);
	
	                    self.initVerify();
	                    self.$forceUpdate();
	                    $('#verifyPhone').modal('hide');
	                    if (self.userRoleComp == "Client") swal({
	                        title: "Thank you, Mobile Confirmed",
	                        text: "Would you like to save changes and go to Home page?",
	                        type: "success",
	                        showCancelButton: true,
	                        confirmButtonClass: 'btn-success',
	                        confirmButtonText: "Save and exit",
	                        closeOnConfirm: true,
	                        html: true
	                    }, function () {
	                        self.$parent.updateUser();
	                    });else if (self.userRoleComp == "Sitter") swal({
	                        title: "Thank you, Mobile Confirmed",
	                        text: "Would you like to go to Dashboard to see your profile effectiveness or go to Calendar and set your availability?",
	                        type: "success",
	                        showCancelButton: true,
	                        confirmButtonClass: 'btn-success',
	                        cancelButtonClass: 'btn-success',
	                        confirmButtonText: "Dashboard",
	                        cancelButtonText: "Calendar",
	                        closeOnConfirm: true,
	                        html: true
	                    }, function (isConfirm) {
	                        if (isConfirm) {
	                            self.$parent.updateSitter('dashboard');
	                        } else {
	                            self.$parent.updateSitter('calendar');
	                        }
	                    });
	                },
	                error: function error() {
	                    try {
	                        self.error = "Verification Failed, try again..";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.initVerify();
	    },
	    watch: {
	        'code': function code() {
	            if (this.code.length < 6) {
	                this.error = '';
	                return false;
	            } else if (this.code.length == 6) {
	                this.verifyCode();
	            }
	        }
	    },
	    computed: {
	
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        }
	
	    }
	
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Alert = __webpack_require__(66);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  data: function data() {
	    return {
	      scrollPosition: '',
	      credentials: {
	        username: '',
	        password: ''
	
	      },
	      notification: '',
	      error: '',
	      alert: false,
	      alertMsg: ''
	
	    };
	  },
	  updated: function updated() {
	    var self = this;
	    $('input').focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $('input').blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	  },
	
	  methods: {
	    validateBeforeSubmit: function validateBeforeSubmit() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (result) {
	        if (result) {
	          _this.submit();
	          return;
	        }
	
	        swal("Something is missing", "Please complete all the required fields to continue.", "info");
	      });
	    },
	    submit: function submit() {
	      $(window).scrollTop(0);
	      var loginCreds = {
	        grant_type: "password",
	        username: this.credentials.username,
	        password: this.credentials.password
	      };
	
	      _index2.default.login(this, loginCreds, 'sitters-dashboard');
	    }
	  },
	  computed: {
	    filledRequiredComp: function filledRequiredComp() {
	      if (this.credentials.username == '' || this.credentials.password == '') {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    authenticatedComp: function authenticatedComp() {
	      return _store2.default.getters.authenticated;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    }
	
	  },
	
	  components: {
	    Alert: _Alert2.default
	
	  }
	
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            error: '',
	            bookingsList: '',
	            alert: '',
	            loading: true,
	            searchData: {
	                SearchText: '',
	                BookingFilterCountryId: 0,
	                BookingState: 0,
	                FromDate: '',
	                ToDate: '',
	                SortBy: 0
	            },
	            emailConfirmed: true,
	            title: "Dupaws Bookings Control",
	            pending: true
	        };
	    },
	
	    updated: function updated() {
	        var self = this;
	        $('[data-toggle="popover"]').popover();
	
	        if (this.userRoleComp != "Admin") {
	            this.$router.push({ path: '/404' });
	            return;
	        }
	
	        self.$nextTick(function () {
	            var self = this;
	            $('#bookingsDashbaordFrom').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {}
	            }).on('changeDate', function (selected) {
	                self.searchData.FromDate = moment(selected.date).format('YYYY-MM-DD');
	            });
	            $('#bookingsDashbaordTo').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {}
	            }).on('changeDate', function (selected) {
	                self.searchData.ToDate = moment(selected.date).format('YYYY-MM-DD');
	            });
	        });
	    },
	    mounted: function mounted() {
	
	        if (sessionStorage.getItem('BookingSearchText') != null) {
	            this.searchData.SearchText = sessionStorage.getItem('BookingSearchText');
	        }
	
	        if (sessionStorage.getItem('BookingFilterCountryId') != null) {
	            this.searchData.BookingFilterCountryId = sessionStorage.getItem('BookingFilterCountryId');
	        }
	        if (sessionStorage.getItem('BookingFilterFromDate') != null) {
	
	            this.searchData.FromDate = sessionStorage.getItem('BookingFilterFromDate');
	        }
	
	        if (sessionStorage.getItem('BookingState') != null) {
	            this.searchData.BookingState = sessionStorage.getItem('BookingState');
	        }
	
	        if (sessionStorage.getItem('BookingSortId') != null) {
	            this.searchData.SortBy = sessionStorage.getItem('BookingSortId');
	        }
	        if (sessionStorage.getItem('BookingFromDate') != null) {
	            this.searchData.FromDate = moment(JSON.parse(sessionStorage.getItem('BookingFromDate')));
	        }
	        if (sessionStorage.getItem('BookingToDate') != null) {
	            this.searchData.ToDate = moment(JSON.parse(sessionStorage.getItem('BookingToDate')));
	        }
	
	        this.$forceUpdate();
	        this.getFilteredBookings();
	    },
	    methods: {
	        sortList: function sortList(value) {
	            var self = this;
	            self.loading = true;
	            self.searchData.SortBy = value;
	            this.getFilteredBookings();
	        },
	        isCurrentSort: function isCurrentSort(value) {
	            if (this.searchData.SortBy == value) return true;else return false;
	        },
	        adminHideBooking: function adminHideBooking(booking) {
	            var self = this;
	
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to Hide this booking?",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-danger',
	                confirmButtonText: "Yes hide!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/hideBooking/" + booking.ServiceTransactionId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        swal("success", "Booking will no longer show up in search", "success");
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	
	        applyFilters: function applyFilters() {
	            this.loading = true;
	            this.getFilteredBookings();
	        },
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY');
	        },
	        viewBooking: function viewBooking(booking) {
	            this.$router.push({ path: '/view-admin-reservation/' + booking.ReservationId });
	        },
	        getFilteredBookings: function getFilteredBookings() {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/getFilteredBookings/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.searchData),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.bookingsList = data;
	                    self.loading = false;
	                },
	                error: function error() {}
	            });
	        }
	    },
	    watch: {
	        'searchData.SearchText': function searchDataSearchText() {
	            sessionStorage.setItem('BookingSearchText', this.searchData.SearchText);
	        },
	        'searchData.BookingFilterCountryId': function searchDataBookingFilterCountryId() {
	            sessionStorage.setItem('BookingFilterCountryId', this.searchData.BookingFilterCountryId);
	            this.applyFilters();
	        },
	        'searchData.SortBy': function searchDataSortBy() {
	            sessionStorage.setItem('BookingSortId', this.searchData.SortBy);
	            this.applyFilters();
	        },
	        'searchData.BookingState': function searchDataBookingState() {
	            sessionStorage.setItem('BookingState', this.searchData.BookingState);
	            this.applyFilters();
	        },
	        'searchData.FromDate': function searchDataFromDate() {
	            var self = this;
	            sessionStorage.setItem('BookingFromDate', (0, _stringify2.default)(moment(self.searchData.FromDate)));
	            this.applyFilters();
	        },
	        'searchData.ToDate': function searchDataToDate() {
	            var self = this;
	            sessionStorage.setItem('BookingToDate', (0, _stringify2.default)(moment(self.searchData.ToDate)));
	            this.applyFilters();
	        }
	
	    },
	    head: {
	        title: function title() {
	            return {
	                inner: this.title
	            };
	        }
	    },
	    computed: {
	        countriesListComp: function countriesListComp() {
	            return _store2.default.getters.CountriesList;
	        },
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        bookingsListComp: function bookingsListComp() {
	            if (this.bookingsList != null) return this.bookingsList;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        }
	
	    }
	
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	var _LineChart = __webpack_require__(253);
	
	var _LineChart2 = _interopRequireDefault(_LineChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      chartOptions: {
	        responsive: true,
	        scales: {
	          xAxes: [{
	            type: "time",
	            time: {
	              unitStepSize: 1,
	              unit: "day",
	              displayFormats: {
	                day: "MMM D"
	              }
	            },
	            ticks: {
	              source: "auto"
	            }
	          }]
	        },
	        legend: {
	          display: true
	        }
	      },
	      error: "",
	      usersSittersData: null,
	      bookingsChartData: null,
	      alert: "",
	      emailConfirmed: true,
	      query: {
	        Incremental: false,
	        CountryId: 0,
	        FromDate: null,
	        ToDate: null
	      },
	      title: "Dupaws admin control",
	      pending: true
	    };
	  },
	
	  components: {
	    LineChart: _LineChart2.default
	  },
	  updated: function updated() {
	    $('[data-toggle="popover"]').popover();
	
	    if (this.userRoleComp != "Admin") {
	      this.$router.push({
	        path: "/404"
	      });
	      return;
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    this.getBookingsChartData();
	    this.getUsersSittersChartData();
	
	
	    self.$nextTick(function () {
	      var self = this;
	      $("#chartsFromDate").datepicker({
	        autoclose: true,
	        format: "yyyy-mm-dd",
	        todayHighlight: true,
	        beforeShowDay: function beforeShowDay(date) {}
	      }).on("changeDate", function (selected) {
	        self.query.FromDate = moment(selected.date).format("YYYY-MM-DD");
	      });
	      $("#chartsToDate").datepicker({
	        autoclose: true,
	        format: "yyyy-mm-dd",
	        todayHighlight: true,
	        beforeShowDay: function beforeShowDay(date) {}
	      }).on("changeDate", function (selected) {
	        self.query.ToDate = moment(selected.date).format("YYYY-MM-DD");
	      });
	    });
	  },
	  methods: {
	    getBookingsChartData: function getBookingsChartData() {
	      var self = this;
	      $.ajax("https://www.dupaws.com/services/api/admin/getBookingsChart/", {
	        type: "POST",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        data: (0, _stringify2.default)(self.query),
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          self.loading = false;
	          self.searching = false;
	          self.bookingsChartData = data;
	        },
	        error: function error(_error) {
	          self.loading = false;
	          self.searching = false;
	        }
	      });
	    },
	    getUsersSittersChartData: function getUsersSittersChartData() {
	      var self = this;
	      $.ajax("https://www.dupaws.com/services/api/admin/getUsersSittersChart/", {
	        type: "POST",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        data: (0, _stringify2.default)(self.query),
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          self.loading = false;
	          self.searching = false;
	          self.usersSittersData = data;
	        },
	        error: function error(_error2) {
	          self.loading = false;
	          self.searching = false;
	        }
	      });
	    }
	  },
	  watch: {
	    "query.FromDate": function queryFromDate() {
	      this.getUsersSittersChartData();
	      this.getBookingsChartData();
	    },
	    "query.ToDate": function queryToDate() {
	      this.getUsersSittersChartData();
	      this.getBookingsChartData();
	    },
	    "query.CountryId": function queryCountryId() {
	      this.getUsersSittersChartData();
	      this.getBookingsChartData();
	    },
	    "query.Incremental": function queryIncremental() {
	      this.getUsersSittersChartData();
	      this.getBookingsChartData();
	    }
	  },
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    }
	  },
	  computed: {
	    countriesListComp: function countriesListComp() {
	      return _store2.default.getters.CountriesList;
	    },
	    errorMsg: function errorMsg() {
	      return this.error;
	    },
	    alertMsg: function alertMsg() {
	      return this.alert;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    }
	  }
	};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "chat",
	  props: ["transactionId", "preventChat", "submittedDate"],
	  data: function data() {
	    return {
	      sender: "",
	      messages: [],
	      newMessage: "",
	      scrollPosition: ""
	    };
	  },
	  updated: function updated() {},
	
	  methods: {
	    sentDate: function sentDate(date) {
	      var submittedDate = moment(this.submittedDate);
	      return moment(date).fromNow(submittedDate);
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/admin/getReservationMessages/" + self.transactionId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        if (data.length > 0) self.messages = data;
	      },
	      error: function error(data, status, _error) {}
	    });
	
	    this.refreshInterval = setInterval(function () {
	      self.$forceUpdate();
	    }, 15000);
	  },
	  computed: {}
	};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ChatHistory = __webpack_require__(558);
	
	var _ChatHistory2 = _interopRequireDefault(_ChatHistory);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PetSelectCard = __webpack_require__(37);
	
	var _PetSelectCard2 = _interopRequireDefault(_PetSelectCard);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            existingReservation: null,
	            notification: '',
	            reviewDesc: '',
	            error: false,
	
	            summaryCollapse: false,
	            sending: false,
	            ready: true,
	            customerRating: '',
	            rated: false,
	            sent: false,
	
	            loading: false,
	            reviewDto: {
	                Description: '',
	                Rating: ''
	            }
	
	        };
	    },
	
	    components: {
	        PetSelectCard: _PetSelectCard2.default,
	        ChatHistory: _ChatHistory2.default
	
	    },
	    updated: function updated() {
	        var self = this;
	        $('[data-toggle="popover"]').popover();
	    },
	    computed: {
	
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        },
	        timezoneComp: function timezoneComp() {
	            return _store2.default.getters.CountryData.CountryTimeZone;
	        },
	
	        notStartedComp: function notStartedComp() {
	            var self = this;
	            var now = moment();
	            var startDate = moment(self.existingReservationComp.StartDate);
	            if (startDate.isAfter(now)) return true;else return false;
	        },
	        rejectedComp: function rejectedComp() {
	            var self = this;
	            if (self.existingReservationComp.IsSitterRejected == true || self.existingReservationComp.IsCustomerCancelled == true) return true;else return false;
	        },
	        totalPriceComputed: function totalPriceComputed() {
	            var totalPrice = this.existingReservation.TotalPrice;
	            return totalPrice;
	        },
	        startDateComp: function startDateComp() {
	            var self = this;
	            return moment(self.existingReservation.StartDate).format('DD MMM YYYY');
	        },
	        endDateComp: function endDateComp() {
	            var self = this;
	            return moment(self.existingReservation.OriginalEndDate).format('DD MMM YYYY');
	        },
	        existingReservationComp: function existingReservationComp() {
	            return this.existingReservation;
	        },
	        reservationIdComp: function reservationIdComp() {
	            var self = this;
	            if (self.$route.params != null) return self.$route.params.reservationId;
	        }
	    },
	    methods: {
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('HH:MM A - DD MMM YYYY');
	        },
	
	        goBookingsDashboard: function goBookingsDashboard() {
	            this.$router.push({ path: '/bookings-dashboard' });
	        },
	        goSupport: function goSupport() {
	            _router2.default.push({
	                path: '/contact-support/' + '?bookingId=' + this.existingReservationComp.BookingNumber,
	                force: true
	            });
	        },
	        initReservation: function initReservation() {
	            var self = this;
	            self.loading = true;
	            $.ajax("https://www.dupaws.com/services/api/admin/getReservation/" + self.$route.params.reservationId, {
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.existingReservation = data;
	                    self.ready = true;
	                    self.loading = false;
	                },
	                error: function error(data, status, _error) {
	                    self.loading = false;
	                    self.error = data.responseJSON.Message;
	                }
	
	            });
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        self.$forceUpdate();
	        self.initReservation();
	    }
	
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      sent: false,
	      error: '',
	      customEmailData: null,
	      alert: '',
	      emailConfirmed: true,
	      title: "Dupaws admin control",
	      pending: true
	    };
	  },
	
	  updated: function updated() {
	    $('[data-toggle="popover"]').popover();
	
	    if (this.userRoleComp != "Admin") {
	      this.$router.push({
	        path: '/404'
	      });
	      return;
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    this.initCustomEmailData();
	  },
	  methods: {
	    sendCustomEmail: function sendCustomEmail() {
	      var self = this;
	      self.sent = false;
	      $.ajax("https://www.dupaws.com/services/api/admin/sendCustomEmail/", {
	        type: 'POST',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        data: (0, _stringify2.default)(self.customEmailData),
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          swal("Success", "The emails has been successfully sent", "success");
	        },
	        error: function error(_error) {
	          swal("Error", "The emails couldn't be sent!", "error");
	        }
	      });
	    },
	    initCustomEmailData: function initCustomEmailData() {
	      var self = this;
	      $.ajax("https://www.dupaws.com/services/api/admin/initCustomEmailData/", {
	        type: 'GET',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        data: (0, _stringify2.default)(self.query),
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          self.customEmailData = data;
	        },
	        error: function error(_error2) {}
	      });
	    }
	
	  },
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    }
	  },
	  computed: {
	    countriesListComp: function countriesListComp() {
	      return _store2.default.getters.CountriesList;
	    },
	    errorMsg: function errorMsg() {
	      return this.error;
	    },
	    alertMsg: function alertMsg() {
	      return this.alert;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    }
	
	  }
	
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            error: '',
	            sittersList: '',
	            alert: '',
	            loading: true,
	            searching: false,
	            remarkDto: {
	                SitterId: '',
	                Remars: ''
	            },
	            updateEmailDto: {
	                OldEmail: '',
	                NewEmail: ''
	            },
	            updateRankDto: {
	                SitterId: '',
	                ProfileRankRate: ''
	            },
	            searchData: {
	                SearchText: '',
	                IsProfileApproved: true,
	                ShowNewRegistrations: false,
	                ShowProfileReady: true,
	                IsRegisteredLastWeek: false,
	                ShowHalfCompleted: true,
	                FilterCountryId: null,
	                ShowSuspendedProfiles: false
	            },
	            emailConfirmed: true,
	            title: "Dupaws admin control",
	            pending: true
	        };
	    },
	
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	
	        if (this.userRoleComp != "Admin") {
	            this.$router.push({ path: '/404' });
	            return;
	        }
	    },
	    mounted: function mounted() {
	
	        if (sessionStorage.getItem('SearchText') != null) {
	            this.searchData.SearchText = sessionStorage.getItem('SearchText');
	        }
	
	        if (sessionStorage.getItem('IsProfileApproved') != null) {
	            if (sessionStorage.getItem('IsProfileApproved') == "true") this.searchData.IsProfileApproved = true;else this.searchData.IsProfileApproved = false;
	        }
	
	        if (sessionStorage.getItem('ShowNewRegistrations') != null) {
	            if (sessionStorage.getItem('ShowNewRegistrations') == "true") this.searchData.ShowNewRegistrations = true;else this.searchData.ShowNewRegistrations = false;
	        }
	        if (sessionStorage.getItem('ShowSuspendedProfiles') != null) {
	            if (sessionStorage.getItem('ShowSuspendedProfiles') == "true") this.searchData.ShowSuspendedProfiles = true;else this.searchData.ShowSuspendedProfiles = false;
	        }
	
	        if (sessionStorage.getItem('ShowProfileReady') != null) {
	            if (sessionStorage.getItem('ShowProfileReady') == "true") this.searchData.ShowProfileReady = true;else this.searchData.ShowProfileReady = false;
	        }
	
	        if (sessionStorage.getItem('FilterCountryId') != null) {
	            this.searchData.FilterCountryId = sessionStorage.getItem('FilterCountryId');
	        }
	
	        if (sessionStorage.getItem('IsRegisteredLastWeek') != null) {
	            if (sessionStorage.getItem('IsRegisteredLastWeek') == "true") this.searchData.IsRegisteredLastWeek = true;else this.searchData.IsRegisteredLastWeek = false;
	        }
	
	        if (sessionStorage.getItem('ShowHalfCompleted') != null) {
	            if (sessionStorage.getItem('ShowHalfCompleted') == "true") this.searchData.ShowHalfCompleted = true;else this.searchData.ShowHalfCompleted = false;
	        }
	
	        this.getFilteredSitters();
	    },
	    methods: {
	        applyFilters: function applyFilters() {
	            this.loading = true;
	            this.getFilteredSitters();
	        },
	        resetFilters: function resetFilters() {
	            sessionStorage.removeItem('SearchText');
	            sessionStorage.removeItem('ShowNewRegistrations');
	            sessionStorage.removeItem('IsRegisteredLastWeek');
	            sessionStorage.removeItem('ShowSuspendedProfiles');
	            sessionStorage.removeItem('ShowHalfCompleted');
	            sessionStorage.removeItem('IsProfileApproved');
	            sessionStorage.removeItem('ShowProfileReady');
	            sessionStorage.removeItem('FilterCountryId');
	            this.loading = true;
	            this.searchData.SearchText = '';
	            this.searchData.IsRegisteredLastWeek = false;
	            this.searchData.ShowSuspendedProfiles = false;
	            this.searchData.ShowProfileReady = true;
	            this.searchData.IsProfileApproved = false;
	            this.searchData.ShowNewRegistrations = false;
	            this.searchData.ShowHalfCompleted = true;
	            this.searchData.FilterCountryId = null;
	
	            this.getFilteredSitters();
	        },
	        getSearchText: function getSearchText() {
	            sessionStorage.setItem('SearchText', this.searchData.SearchText);
	            this.loading = true;
	            this.getFilteredSitters();
	        },
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY');
	        },
	        viewProfile: function viewProfile(sitter) {
	            this.$router.push({ path: '/admin/' + sitter.SitterId });
	        },
	        getNumber: function getNumber(sitter) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/getNumber/" + sitter.SitterId, {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal(sitter.FirstName + " number below:", data, "success");
	                },
	                error: function error() {
	                    swal("", "couldn't get number", "warning");
	                }
	            });
	        },
	        updateEmail: function updateEmail(email) {
	            var self = this;
	
	            swal({
	                title: "Enter sitters new Email",
	                type: "input",
	                showCancelButton: true,
	                closeOnConfirm: false,
	                inputPlaceholder: "New Email"
	            }, function (inputValue) {
	                if (inputValue === false) return false;
	                if (inputValue === "") {
	                    swal.showInputError("Oops, please a valid email");
	                    return false;
	                } else {
	                    self.updateEmailDto.OldEmail = email;
	                    self.updateEmailDto.NewEmail = inputValue;
	                    console.log('sending now');
	                    self.updateEmailRequest(self.updateEmailDto);
	                    return;
	                }
	            });
	        },
	        updateEmailRequest: function updateEmailRequest(updateEmailDto) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/updateEmail", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(updateEmailDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Email changed successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Email couldn't be changed", "warning");
	                }
	            });
	        },
	        getFilteredSitters: function getFilteredSitters() {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/getFilteredSitters/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.searchData),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.loading = false;
	                    self.searching = false;
	                    console.log(data);
	                    self.sittersList = data;
	                },
	                error: function error(_error) {
	                    self.loading = false;
	                    self.searching = false;
	                }
	            });
	        },
	        removeApproval: function removeApproval(sitter) {
	            var self = this;
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to remove this approval?",
	                type: "info",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Yes remove!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/removeApproval/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsProfileApproved = false;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        saveRemarks: function saveRemarks(sitter) {
	            var url = "";
	            var self = this;
	            self.remarkDto.SitterId = sitter.SitterId;
	            self.remarkDto.Remarks = sitter.Remarks;
	
	            $.ajax('https://www.dupaws.com/services/api/admin/saveRemarks/', {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.remarkDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("Success", "Sitter Remarks Saved", "success");
	                },
	                error: function error() {}
	            });
	        },
	        suspendProfile: function suspendProfile(sitter) {
	            var self = this;
	
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to suspend this profile?",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-danger',
	                confirmButtonText: "Yes suspend!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/suspendSitter/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsAdminSuspended = true;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        instagramWinner: function instagramWinner(sitter) {
	            var self = this;
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to make this sitter a winner?",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Yes please!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/instagramWinner/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsInstagramWinner = true;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        removeInstagramWinner: function removeInstagramWinner(sitter) {
	            var self = this;
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to demote this sitter from instagram winner?",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Yes please!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/removeInstagramWinner/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsInstagramWinner = false;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        updateRank: function updateRank(sitter) {
	            var self = this;
	            self.updateRankDto.SitterId = sitter.SitterId;
	            self.updateRankDto.ProfileRankRate = sitter.ProfileRankRate;
	            $.ajax("https://www.dupaws.com/services/api/admin/updateRank", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.updateRankDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Rank changed successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Rank couldn't be changed", "warning");
	                }
	            });
	        },
	        addFreeSubscription: function addFreeSubscription() {
	            $.ajax("https://www.dupaws.com/services/api/admin/addFreeSubscription/", {
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	
	                    swal("Free Subscription", data, "success");
	                },
	                error: function error(_error2) {
	                    console.log(_error2);
	                    swal("Error", _error2.responseJSON.Message, "error");
	                }
	
	            });
	        },
	        removeSuspension: function removeSuspension(sitter) {
	            var self = this;
	
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to remove suspespension for this profile?",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-danger',
	                confirmButtonText: "Yes remove!",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/removeSuspension/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsAdminSuspended = false;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        approveProfile: function approveProfile(sitter) {
	            var self = this;
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to approve this profile?",
	                type: "info",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Yes please",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/approveSitter/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        sitter.IsProfileApproved = true;
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        extendSubscription: function extendSubscription(sitter) {
	            var self = this;
	            swal({
	                title: "Confirmation",
	                text: "Are you sure you want to extend free subscription for this profile?",
	                type: "info",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Yes please",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                $.ajax("https://www.dupaws.com/services/api/admin/addFreeSubscriptionDays/" + sitter.SitterId, {
	                    type: 'GET',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        swal("Done", "Sitter has been granted 30 dates, new expiry date has been set.", "info");
	                    },
	                    error: function error() {}
	                });
	            });
	        },
	        sendCustomEmail: function sendCustomEmail() {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/sendCustomEmail/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("Done", "Your message has been sent!", "info");
	                },
	                error: function error() {}
	            });
	        }
	    },
	    watch: {
	        'searchData.SearchText': function searchDataSearchText() {
	            var self = this;
	            sessionStorage.setItem('SearchText', this.searchData.SearchText);
	        },
	
	        'searchData.IsProfileApproved': function searchDataIsProfileApproved() {
	            sessionStorage.setItem('IsProfileApproved', this.searchData.IsProfileApproved);
	        },
	        'searchData.ShowProfileReady': function searchDataShowProfileReady() {
	            sessionStorage.setItem('ShowProfileReady', this.searchData.ShowProfileReady);
	        },
	        'searchData.FilterCountryId': function searchDataFilterCountryId() {
	            sessionStorage.setItem('FilterCountryId', this.searchData.FilterCountryId);
	        },
	        'searchData.IsRegisteredLastWeek': function searchDataIsRegisteredLastWeek() {
	            sessionStorage.setItem('IsRegisteredLastWeek', this.searchData.IsRegisteredLastWeek);
	        },
	        'searchData.ShowNewRegistrations': function searchDataShowNewRegistrations() {
	            sessionStorage.setItem('ShowNewRegistrations', this.searchData.ShowNewRegistrations);
	        },
	        'searchData.ShowHalfCompleted': function searchDataShowHalfCompleted() {
	            sessionStorage.setItem('ShowHalfCompleted', this.searchData.ShowHalfCompleted);
	        },
	        'searchData.ShowSuspendedProfiles': function searchDataShowSuspendedProfiles() {
	            sessionStorage.setItem('ShowSuspendedProfiles', this.searchData.ShowSuspendedProfiles);
	        }
	    },
	    head: {
	        title: function title() {
	            return {
	                inner: this.title
	            };
	        }
	    },
	    computed: {
	        countriesListComp: function countriesListComp() {
	            return _store2.default.getters.CountriesList;
	        },
	        approvedProfilesTextComp: function approvedProfilesTextComp() {
	            if (this.searchData.IsProfileApproved) return 'Show Approved';else return 'Hide Approved';
	        },
	        lastWeekProfilesComp: function lastWeekProfilesComp() {
	            if (this.searchData.IsRegisteredLastWeek) return 'Registered Anytime';else return 'Registered within 7 days';
	        },
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        sittersListComp: function sittersListComp() {
	            if (this.sittersList != null) return this.sittersList;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        }
	
	    }
	
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            error: '',
	            ticketsList: '',
	            alert: '',
	            ticketStatusList: [{
	                StatusCode: 0,
	                StatusName: 'Open'
	            }, {
	                StatusCode: 1,
	                StatusName: 'Assigned'
	            }, {
	                StatusCode: 2,
	                StatusName: 'Resolved'
	            }],
	
	            searchData: {
	                SearchText: '',
	                HideAssigned: false,
	                HideOpen: false,
	                HideResolved: true
	            },
	            emailConfirmed: true,
	            title: "Dupaws Tickets Control",
	            pending: true
	        };
	    },
	
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	
	        if (this.userRoleComp != "Admin") {
	            this.$router.push({ path: '/404' });
	            return;
	        }
	    },
	    mounted: function mounted() {
	
	        if (sessionStorage.getItem('TicketSearchText') != null) {
	            this.searchData.SearchText = sessionStorage.getItem('TicketSearchText');
	        }
	
	        if (sessionStorage.getItem('HideOpen') != null) {
	            if (sessionStorage.getItem('HideOpen') == "true") this.searchData.HideOpen = true;else this.searchData.HideOpen = false;
	        }
	
	        if (sessionStorage.getItem('HideResolved') != null) {
	            if (sessionStorage.getItem('HideResolved') == "true") this.searchData.HideResolved = true;else this.searchData.HideResolved = false;
	        }
	
	        if (sessionStorage.getItem('HideAssigned') != null) {
	            if (sessionStorage.getItem('HideAssigned') == "true") this.searchData.HideAssigned = true;else this.searchData.HideAssigned = false;
	        }
	
	        this.$forceUpdate();
	        this.getFilteredTickets();
	    },
	    methods: {
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY HH:MM');
	        },
	        viewBooking: function viewBooking(booking) {
	            this.$router.push({ path: '/view-admin-reservation/' + booking.ReservationId });
	        },
	        saveTicket: function saveTicket(ticket) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/saveTicket/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(ticket),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Ticket saved", "success");
	                },
	                error: function error() {}
	            });
	        },
	        getFilteredTickets: function getFilteredTickets() {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/getFilteredTickets/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.searchData),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.ticketsList = data;
	                },
	                error: function error() {}
	            });
	        }
	    },
	    watch: {
	        'searchData.HideAssigned': function searchDataHideAssigned() {
	            sessionStorage.setItem('HideAssigned', this.searchData.HideAssigned);
	            this.getFilteredTickets();
	        },
	        'searchData.SearchText': function searchDataSearchText() {
	            sessionStorage.setItem('TicketSearchText', this.searchData.SearchText);
	            this.getFilteredTickets();
	        },
	        'searchData.HideResolved': function searchDataHideResolved() {
	            sessionStorage.setItem('HideResolved', this.searchData.HideResolved);
	            this.getFilteredTickets();
	        },
	        'searchData.HideOpen': function searchDataHideOpen() {
	            sessionStorage.setItem('HideOpen', this.searchData.HideOpen);
	            this.getFilteredTickets();
	        }
	
	    },
	    head: {
	        title: function title() {
	            return {
	                inner: this.title
	            };
	        }
	    },
	    computed: {
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        },
	        ticketsListComp: function ticketsListComp() {
	            return this.ticketsList;
	        }
	
	    }
	
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            error: '',
	            datacollection: null,
	            usersList: '',
	            alert: '',
	            loading: true,
	            searchData: {
	                SearchText: ''
	            },
	            searching: false,
	
	            disableAccountDto: {
	                Email: ''
	            },
	
	            confirmPhoneDto: {
	                Email: ''
	            },
	            updatePhoneDto: {
	                Email: '',
	                NewPhone: ''
	            },
	            updateEmailDto: {
	                OldEmail: '',
	                NewEmail: ''
	            },
	            emailConfirmed: true,
	            title: "Dupaws admin control",
	            pending: true
	        };
	    },
	
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	
	        if (this.userRoleComp != "Admin") {
	            this.$router.push({ path: '/404' });
	            return;
	        }
	    },
	    mounted: function mounted() {
	        this.getFilteredUsers();
	    },
	    methods: {
	        updateEmail: function updateEmail(email) {
	            var self = this;
	            swal({
	                title: "Enter new Email",
	                type: "input",
	                showCancelButton: true,
	                closeOnConfirm: false,
	                inputPlaceholder: "New Email"
	            }, function (inputValue) {
	                if (inputValue === false) return false;
	                if (inputValue === "") {
	                    swal.showInputError("Oops, please a valid email");
	                    return false;
	                } else {
	                    self.updateEmailDto.OldEmail = email;
	                    self.updateEmailDto.NewEmail = inputValue;
	                    console.log('sending now');
	                    self.updateEmailRequest(self.updateEmailDto);
	                    return;
	                }
	            });
	        },
	        updatePhone: function updatePhone(email) {
	            var self = this;
	
	            swal({
	                title: "Enter user new phone no.",
	                type: "input",
	                showCancelButton: true,
	                closeOnConfirm: false,
	                inputPlaceholder: "New Phone Number"
	            }, function (inputValue) {
	                if (inputValue === false) return false;
	                if (inputValue === "") {
	                    swal.showInputError("Oops, please a valid phone number");
	                    return false;
	                } else {
	                    self.updatePhoneDto.Email = email;
	                    self.updatePhoneDto.NewPhone = inputValue;
	                    console.log('sending now');
	                    self.updatePhoneRequest(self.updatePhoneDto);
	                    return;
	                }
	            });
	        },
	        confirmPhone: function confirmPhone(email) {
	            var self = this;
	            self.confirmPhoneDto.Email = email;
	            self.confirmPhoneNumber(self.confirmPhoneDto);
	        },
	        confirmPhoneNumber: function confirmPhoneNumber(confirmPhoneDto) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/confirmPhone", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(confirmPhoneDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Phone confirmed successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Phone couldn't be confirmed", "warning");
	                }
	            });
	        },
	        disableAccount: function disableAccount(email) {
	            var self = this;
	            self.disableAccountDto.Email = email;
	            $.ajax("https://www.dupaws.com/services/api/admin/disableAccount", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.disableAccountDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Account disabled successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Account couldn't be disabled", "warning");
	                }
	            });
	        },
	        enableAccount: function enableAccount(email) {
	            var self = this;
	            self.disableAccountDto.Email = email;
	            $.ajax("https://www.dupaws.com/services/api/admin/enableAccount", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.disableAccountDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Account Enabled Successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Account couldn't be enabled", "warning");
	                }
	            });
	        },
	        updatePhoneRequest: function updatePhoneRequest(updatePhoneDto) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/updatePhone", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(updatePhoneDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Phone changed successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Phone couldn't be changed", "warning");
	                }
	            });
	        },
	        updateEmailRequest: function updateEmailRequest(updateEmailDto) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/updateEmail", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(updateEmailDto),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    swal("", "Email changed successfully", "success");
	                },
	                error: function error() {
	                    swal("", "Email couldn't be changed", "warning");
	                }
	            });
	        },
	
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY');
	        },
	        getFilteredUsers: function getFilteredUsers() {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/admin/getFilteredUsers/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.searchData),
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.loading = false;
	                    self.searching = false;
	
	                    self.usersList = data;
	                },
	                error: function error(_error) {
	                    self.loading = false;
	                    self.searching = false;
	                }
	            });
	        },
	        getSearchText: function getSearchText() {
	            sessionStorage.setItem('UsersSearch', this.searchData.SearchText);
	            this.loading = true;
	            this.getFilteredUsers();
	        }
	    },
	    watch: {},
	    head: {
	        title: function title() {
	            return {
	                inner: this.title
	            };
	        }
	    },
	    computed: {
	        countriesListComp: function countriesListComp() {
	            return _store2.default.getters.CountriesList;
	        },
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        }
	
	    }
	
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CalendarView = __webpack_require__(247);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'profileView',
	  data: function data() {
	    return {
	      title: 'Dupaws Sitter Profile',
	      number: 5,
	      SitterPublicDetails: '',
	      SitterPublicReviews: '',
	      errorMsg: ''
	
	    };
	  },
	  created: function created() {
	    if (this.$route.params.sitterId != null) {
	      this.getSitterPublicDetails(this.$route.params.sitterId);
	      this.getSitterPublicReviews(this.$route.params.sitterId);
	    }
	  },
	  mounted: function mounted() {
	
	    $('[data-tooltip]').tooltip();
	
	    if (this.$route.params.sitterId != null) {
	      this.getSitterPublicDetails(this.$route.params.sitterId);
	      this.getSitterPublicReviews(this.$route.params.sitterId);
	      this.setSitterProfileView(this.$route.params.sitterId);
	    }
	
	    if (localStorage.getItem('userRole') == "Client") {
	      _customerApi2.default.getPetsList();
	    }
	  },
	
	  computed: {
	    countryCurrencyComp: function countryCurrencyComp() {
	      return _store2.default.getters.CountryData.Currency;
	    },
	    hasSkillsComp: function hasSkillsComp() {
	      if (this.petPrefComp.CanCPR || this.petPrefComp.CanInject || this.petPrefComp.CanOral) return true;else return false;
	    },
	    compProfilePic: function compProfilePic() {
	      return _store2.default.getters.profilePicUrl;
	    },
	    sitterPublicDetailComp: function sitterPublicDetailComp() {
	      return this.SitterPublicDetails;
	    },
	    bgImageComp: function bgImageComp() {
	      if (this.SitterPublicDetails.SitterPhotoDtos) if (this.SitterPublicDetails.SitterPhotoDtos.length > 0) {
	        var index = this.SitterPublicDetails.SitterPhotoDtos.findIndex(function (t) {
	          return t.Type === 0;
	        });
	        if (index != null && index != -1) {
	          return this.SitterPublicDetails.SitterPhotoDtos[index].Path;
	        }
	      }
	    },
	    LocationComp: function LocationComp() {
	      if (this.SitterPublicDetails.SitterLocationDtos) return this.SitterPublicDetails.SitterLocationDtos.CityName + ', ' + this.SitterPublicDetails.SitterLocationDtos.AreaName;
	    },
	    sitterPublicReviewsComp: function sitterPublicReviewsComp() {
	      if (this.SitterPublicReviews.length == 0) {
	        return null;
	      } else {
	        return this.SitterPublicReviews;
	      }
	    },
	    petPrefComp: function petPrefComp() {
	      if (this.SitterPublicDetails.PetPrefDtos) {
	        return this.SitterPublicDetails.PetPrefDtos;
	      }
	    },
	    homeDetailsComp: function homeDetailsComp() {
	      if (this.SitterPublicDetails.HomeDetailDtos) {
	        return this.SitterPublicDetails.HomeDetailDtos;
	      }
	    }
	
	  },
	  updated: function updated() {
	    $('[data-toggle="popover"]').popover();
	
	    $zopim(function () {
	      $zopim.livechat.sendVisitorPath();
	    });
	    $("[data-fancybox]").fancybox({
	      selector: '[data-fancybox="images"]',
	      loop: true
	    });
	  },
	
	  methods: {
	    isFavorite: function isFavorite(sitterId) {
	      if (this.userRoleComp == "Sitter") return false;
	      var result = $.grep(_store2.default.getters.FavoriteSitters, function (e) {
	        return e.SitterId == sitterId;
	      });
	      if (result.length > 0) return true;else return false;
	    },
	    contactSitter: function contactSitter() {
	      var self = this;
	      if (_store2.default.getters.authenticated == false) swal({
	        title: "Sign In",
	        text: "You need to be logged in to Request a Reservation",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Login",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.$router.push({ path: '/login', query: { sitter: self.$route.params.sitterId } });
	      });else if (_store2.default.getters.userRole != "Client") {
	        swal("Hello", 'You need to be logged in as a Customer to request reservation', "info");
	      } else if (_store2.default.getters.CountryData.CountryId != this.sitterPublicDetailComp.SitterLocationDtos.CountryId) {
	        swal("Hello", 'You cant contact Sitters that are in different country than yours, please change your country settings.', "info");
	      } else {
	        if (_store2.default.getters.PetsList.length < 1) {
	          swal({
	            title: "No Pets Found",
	            text: "Please register your Pet details before contacting a Sitter",
	            type: "info",
	            showCancelButton: true,
	            confirmButtonClass: 'btn-info',
	            confirmButtonText: "Add Pets",
	            closeOnConfirm: true,
	            html: true
	          }, function () {
	            self.$router.push({ path: '/pets-view/addpet', query: { sitter: self.$route.params.sitterId } });
	          });
	        } else {
	          self.$router.push({ path: '/reservation/' + self.$route.params.sitterId });
	        }
	      }
	    },
	    getSitterPublicDetails: function getSitterPublicDetails(sitterId) {
	      var self = this;
	      return $.ajax({
	        type: 'GET',
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        url: "https://www.dupaws.com/services/admin/getSitterAdminProfile/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.SitterPublicDetails = data;
	          self.title = data.Name + ' ' + data.Title;
	          self.$emit('updateHead');
	        },
	        error: function error(data, status, _error) {
	          self.errorMsg = data.responseJSON.Message;
	        }
	      });
	    },
	    setSitterProfileView: function setSitterProfileView(sitterId) {
	      var self = this;
	      if (_store2.default.getters.authenticated == false) $.ajax({
	        type: 'POST',
	        url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {},
	        error: function error(data, status, _error2) {
	          self.errorMsg = data.responseJSON.Message;
	        }
	      });else if (_store2.default.getters.authenticated == true) {
	        $.ajax({
	          type: 'POST',
	          beforeSend: function beforeSend(xhr) {
	            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	          },
	          url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
	          dataType: "json",
	          crossDomain: true,
	          contentType: "application/json; charset=utf-8",
	          success: function success(data) {},
	          error: function error(data, status, _error3) {
	            self.errorMsg = data.responseJSON.Message;
	          }
	        });
	      }
	    },
	    getSitterPublicReviews: function getSitterPublicReviews(sitterId) {
	      var self = this;
	      return $.ajax({
	        type: 'GET',
	        url: "https://www.dupaws.com/services/public/getSitterPublicReviews/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.SitterPublicReviews = data;
	        },
	        error: function error(data, status, _error4) {
	          console.log("failed to get Sitter getSitterPublicReviews()" + data.responseText);
	        }
	      });
	    },
	
	    goSearchSitters: function goSearchSitters() {
	      this.$router.push({ path: '/findsitters' });
	    },
	    goHome: function goHome() {
	      this.$router.push({ path: '/' });
	    },
	    addToFavorites: function addToFavorites(sitter) {
	      self = this;
	      if (_store2.default.getters.authenticated == false) swal({
	        title: "Hello",
	        text: "You need to be logged in as a Customer to add sitters to your favorite account",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Login",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.$router.push({ path: '/login', query: { sitter: self.$route.params.sitterId } });
	      });else if (_store2.default.getters.userRole == "Sitter") {
	        swal("Hello", 'You cant add Sitters as favorites while logged in as a Sitter, please switch to Customer login then try again', "info");
	      } else {
	        _customerApi2.default.addSitterToFavorites(sitter);
	      }
	    }
	
	  },
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	
	      };
	    },
	    meta: function meta() {
	      return;
	      [{ name: 'application-name', content: 'Dupaws.com Sitter Profile' }, { name: 'description', content: this.title }, { name: 'keywords', content: this.title }, { property: 'fb:app_id', content: '279352372578608' }, { property: 'fb:admins', content: '636428053' }, { property: 'fb:pages', content: '1623158747696830' }];
	    }
	  },
	  components: {
	    CalendarView: _CalendarView2.default
	  }
	
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: 'favoriteSitters',
	    data: function data() {
	        return {
	            favoriteSitters: '',
	            loading: true
	        };
	    },
	
	    methods: {
	        premiumSwal: function premiumSwal() {
	
	            swal({
	                title: 'Premium Member',
	                text: "You can contact and book Premium accounts directly without subscription or membership.",
	                type: "success",
	                confirmButtonClass: "btn-success",
	                confirmButtonText: 'Woof!',
	                allowOutsideClick: false,
	                closeOnConfirm: true
	            }, function (isConfirm) {
	                return;
	            });
	        },
	        goFindSitters: function goFindSitters() {
	            this.$router.push({ path: '/findsitters' });
	        },
	
	        addToFavorites: function addToFavorites(sitter) {
	            var self = this;
	            _customerApi2.default.addSitterToFavorites(sitter);
	            var index = self.favoriteSitters.findIndex(function (t) {
	                return t.SitterId === sitter.SitterId;
	            });
	            self.favoriteSitters.splice(index, 1);
	            $(".popover").popover("hide");
	        },
	        viewProfile: function viewProfile(sitter) {
	            this.$router.push({ path: '/sitter/' + sitter.SitterId });
	        },
	        isFavorite: function isFavorite(sitterId) {
	            var result = $.grep(_store2.default.getters.FavoriteSitters, function (e) {
	                return e.SitterId == sitterId;
	            });
	            if (result.length > 0) return true;else return false;
	        }
	
	    },
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	
	        $.ajax({
	            type: 'GET',
	            beforeSend: function beforeSend(xhr) {
	                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	            },
	            url: API_URL + "api/getFavoriteSitters",
	            dataType: "json",
	            crossDomain: true,
	            contentType: "application/json; charset=utf-8",
	            success: function success(data) {
	                self.loading = false;
	                self.favoriteSitters = data;
	            },
	            error: function error(data, status, _error) {
	                self.loading = false;
	            }
	        });
	    },
	    computed: {
	        favoriteSittersComp: function favoriteSittersComp() {
	            return this.favoriteSitters;
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        }
	    }
	
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PetSelectCard = __webpack_require__(37);
	
	var _PetSelectCard2 = _interopRequireDefault(_PetSelectCard);
	
	var _PetDetailsView = __webpack_require__(245);
	
	var _PetDetailsView2 = _interopRequireDefault(_PetDetailsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            initReservation: '',
	            notification: '',
	            error: false,
	            sending: false,
	            sittingDogs: false,
	            walksPerWeek: [{ name: '1 time only', time: 1 }, { name: '2 times', time: 2 }, { name: '3 times', time: 3 }, { name: '4 times', time: 4 }, { name: '5 times', time: 5 }, { name: '6 times', time: 6 }, { name: '7 times', time: 7 }],
	            sittingCats: false,
	            boardingDogs: false,
	            boardingCats: false,
	            dogWalking: false,
	            serviceType: 0,
	            sent: false
	        };
	    },
	
	    components: {
	        PetSelectCard: _PetSelectCard2.default,
	        PetDetailsView: _PetDetailsView2.default
	    },
	    computed: {
	        messageToSitterComp: function messageToSitterComp() {
	            if (this.serviceType != 6) {
	                return 'Provide the sitter with details about your pets, their routine, behavior etc, they might ask more if needed.';
	            } else {
	                return 'Provide the sitter on your home/location details, what time they would need to pick up your dog, and any additional info that might be useful.';
	            }
	        },
	        startDateMobileComp: function startDateMobileComp() {
	            if (this.datesData.start == null && this.serviceType != 6) {
	                return 'Pickup Date';
	            } else if (this.datesData.start == null && this.serviceType == 6) {
	                return 'Choose your first date';
	            } else {
	                return this.datesData.start;
	            }
	        },
	        endDateMobileComp: function endDateMobileComp() {
	            if (this.datesData.end == null) {
	                return 'Dropoff Date';
	            } else {
	                return this.datesData.end;
	            }
	        },
	
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        },
	        datesData: function datesData() {
	            return _store2.default.getters.QueryData;
	        },
	        buttonText: function buttonText() {
	            if (this.sent == true) {
	                return "Sent Successfully";
	            }
	            if (this.sending == false && this.error == false) {
	                return "Send Request";
	            } else if (this.sending == true) {
	                return "Sending";
	            } else if (this.sending == false && this.error == true) {
	                return "Sending Failed";
	            }
	        },
	        selectedPetsComp: function selectedPetsComp() {
	            var self = this;
	            var selectedPets = false;
	            if (self.initReservation.AvailablePetDtos != null) {
	                $.each(self.initReservation.AvailablePetDtos, function (index, pet) {
	                    if (pet.IsSelected == true) selectedPets = true;
	                });
	
	                return selectedPets;
	            }
	        }
	    },
	    watch: {
	        'datesData.end': function datesDataEnd() {
	            if (this.datesData.end != null) {
	                this.checkData();
	            }
	        },
	        'datesData.start': function datesDataStart() {
	            if (this.datesData.end != null) {
	                this.checkData();
	            }
	        },
	        'datesData.dogWalkStart': function datesDataDogWalkStart() {
	            if (this.datesData.dogWalkStart != null) {
	                this.checkData();
	            }
	        }
	
	    },
	    created: function created() {
	        var self = this;
	
	        $.ajax("https://www.dupaws.com/services/api/customer/initReservation/" + self.$route.params.sitterId, {
	            type: 'GET',
	            beforeSend: function beforeSend(xhr) {
	                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	            },
	            dataType: "json",
	            contentType: "application/json; charset=utf-8",
	            crossDomain: true,
	            success: function success(data) {
	                self.initReservation = data;
	                self.initReservation.StartDate = self.datesData.start;
	                self.initReservation.EndDate = self.datesData.end;
	                $.each(self.initReservation.AvailableSitterServiceDtos, function (index, service) {
	                    if (service.ServiceType == 1) self.boardingDogs = true;
	                    if (service.ServiceType == 2) self.boardingCats = true;
	                    if (service.ServiceType == 3) self.sittingDogs = true;
	                    if (service.ServiceType == 4) self.sittingCats = true;
	                    if (service.ServiceType == 6) self.dogWalking = true;
	                });
	            },
	            error: function error() {}
	        });
	    },
	    methods: {
	        setServiceBoarding: function setServiceBoarding() {
	            var self = this;
	
	
	            $.each(self.initReservation.AvailablePetDtos, function (index, pet) {
	                pet.IsSelected = false;
	            });
	
	            self.serviceType = 1;
	        },
	        setServiceSitting: function setServiceSitting() {
	            var self = this;
	
	
	            $.each(self.initReservation.AvailablePetDtos, function (index, pet) {
	                pet.IsSelected = false;
	            });
	
	            self.serviceType = 2;
	        },
	        setServiceDogWalking: function setServiceDogWalking() {
	            var self = this;
	            $.each(self.initReservation.AvailableSitterServiceDtos, function (index, service) {
	                service.IsSelected = false;
	                if (service.ServiceType == 6) service.IsSelected = true;
	            });
	
	            $.each(self.initReservation.AvailablePetDtos, function (index, pet) {
	                pet.IsSelected = false;
	            });
	
	            self.datesData.end = self.datesData.start;
	            self.serviceType = 6;
	        },
	        selectPet: function selectPet(petCard) {
	            var self = this;
	            if (self.serviceType == 0) {
	                swal("Service Type", "Please select service type first", "info");
	                return;
	            }
	
	            if (petCard.PetType == 1) {
	                if (self.serviceType == 6 && self.dogWalking == false) {
	                    swal("Dog Walking not offered", "Please make sure the sitter provide dog walking in their services", "info");
	                    return;
	                }
	
	                if (self.serviceType == 1 && self.boardingDogs == false) {
	                    swal("Dog Boarding not offered", "Please make sure the sitter provide dog boarding before adding a dog", "info");
	                    return;
	                }
	                if (self.serviceType == 2 && self.sittingDogs == false) {
	                    swal("Dog Sitting not offered", "Please make sure the sitter provide Dog Sitting before adding a dog", "info");
	                    return;
	                }
	            } else if (petCard.PetType == 2) {
	                if (self.serviceType == 1 && self.boardingCats == false) {
	                    swal("Cat Boarding not offered", "Please make sure the sitter provide cat boarding before adding a cat", "info");
	                    return;
	                }
	
	                if (self.serviceType == 2 && self.sittingCats == false) {
	                    swal("Cat Sitting not offered", "Please make sure the sitter provide Cat Sitting before adding a cat", "info");
	                    return;
	                }
	
	                if (self.serviceType == 6) {
	                    {
	                        swal("You have choosen Dog Walking service", "Please make sure to select a dog pet and not a cat :)", "info");
	                        return;
	                    }
	                }
	            }
	
	            if (petCard.IsSelected == false) {
	                petCard.IsSelected = true;
	                $.each(self.initReservation.AvailableSitterServiceDtos, function (index, service) {
	                    if (petCard.PetType == 1) {
	                        if (service.ServiceType == 1 && self.serviceType == 1) service.IsSelected = true;else if (service.ServiceType == 3 && self.serviceType == 2) service.IsSelected = true;
	                    } else if (petCard.PetType == 2) {
	                        if (service.ServiceType == 2 && self.serviceType == 1) service.IsSelected = true;else if (service.ServiceType == 4 && self.serviceType == 2) service.IsSelected = true;
	                    }
	                });
	                self.checkData();
	            } else {
	                var dogSitting = false;
	                var catSitting = false;
	                petCard.IsSelected = false;
	
	                $.each(self.initReservation.AvailablePetDtos, function (index, pet) {
	                    if (pet.IsSelected == true) {
	                        if (pet.PetType == 1) dogSitting = true;
	                        if (pet.PetType == 2) catSitting = true;
	                    }
	                });
	
	                if (petCard.PetType == 1 && dogSitting == false && self.serviceType == 1) {
	                    var self = this;
	                    var index = self.initReservation.AvailableSitterServiceDtos.findIndex(function (t) {
	                        return t.ServiceType === 1;
	                    });
	                    if (index != null) {
	                        self.initReservation.AvailableSitterServiceDtos[index].IsSelected = false;
	                    }
	                }
	                if (petCard.PetType == 1 && dogSitting == false && self.serviceType == 2) {
	                    var self = this;
	                    var _index = self.initReservation.AvailableSitterServiceDtos.findIndex(function (t) {
	                        return t.ServiceType === 3;
	                    });
	                    if (_index != null) {
	                        self.initReservation.AvailableSitterServiceDtos[_index].IsSelected = false;
	                    }
	                }
	                if (petCard.PetType == 2 && catSitting == false && self.serviceType == 1) {
	                    var self = this;
	                    var _index2 = self.initReservation.AvailableSitterServiceDtos.findIndex(function (t) {
	                        return t.ServiceType === 2;
	                    });
	                    if (_index2 != null) {
	                        self.initReservation.AvailableSitterServiceDtos[_index2].IsSelected = false;
	                    }
	                }
	                if (petCard.PetType == 2 && catSitting == false && self.serviceType == 2) {
	                    var self = this;
	                    var _index3 = self.initReservation.AvailableSitterServiceDtos.findIndex(function (t) {
	                        return t.ServiceType === 4;
	                    });
	                    if (_index3 != null) {
	                        self.initReservation.AvailableSitterServiceDtos[_index3].IsSelected = false;
	                    }
	                }
	
	                self.checkData();
	            }
	        },
	        submitRequest: function submitRequest() {
	            var self = this;
	            var phoneSuspect = /\d(([\. \- \_\!\@\`\~\+\<\>\,  ]){0,5}?\d){6,12}/;
	            if (phoneSuspect.test(this.initReservation.Message)) {
	                swal("Sharing Mobile Phones", "Please do not include your phone number in the Message to Sitter, phone numbers can be exchanged later when the pet sitter accepts your request", "info");
	                return;
	            }
	            if (self.datesData.start == null && self.serviceType == 6) {
	                swal("Oops.", "Dog Walking Start date required, please fill in the start of your preferred date", "error");
	            }
	            if ((self.datesData.start == null || self.datesData.end == null) && self.serviceType != 6) {
	                swal("Oops.", "Pickup or Dropoff date is empty, please fill both dates accordingly", "error");
	            } else if (self.notification.DateMessage) {
	                swal("Oops.", self.notification.DateMessage, "error");
	            } else if (!self.selectedPetsComp) {
	                swal("Oops.", "Please select at least one Pet before sending", "error");
	            } else {
	                self.sent = false;
	                self.sending = true;
	                $.ajax("https://www.dupaws.com/services/api/customer/submitReservation/", {
	                    type: 'POST',
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    data: (0, _stringify2.default)(self.initReservation),
	                    contentType: "application/json; charset=utf-8",
	                    crossDomain: true,
	                    success: function success(data) {
	                        console.log(data);
	                        self.sent = true;
	                        self.sending = false;
	                        self.error = false;
	
	                        self.$router.push({ path: '/view-reservation/' + data });
	                    },
	                    error: function error(data, status, _error) {
	                        self.sending = false;
	                        self.error = true, swal("Oops.", data.responseJSON.Message, "error");
	                    }
	                });
	            }
	        },
	        viewProfile: function viewProfile() {
	            var self = this;
	            this.$router.push({ path: '/sitter/' + self.$route.params.sitterId });
	        },
	        goHome: function goHome() {
	            this.$router.push({ path: '/' });
	        },
	        selectService: function selectService(service) {
	            var self = this;
	            if (service.IsSelected == false) {
	                service.IsSelected = true;
	                self.checkData();
	            } else {
	                service.IsSelected = false;
	                self.checkData();
	            }
	        },
	        checkData: function checkData() {
	            var self = this;
	            self.initReservation.StartDate = self.datesData.start;
	            self.initReservation.EndDate = self.datesData.end;
	
	            $.ajax("https://www.dupaws.com/services/api/customer/verifyReservation/", {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                data: (0, _stringify2.default)(self.initReservation),
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.notification = data;
	                },
	                error: function error(data, status, _error2) {}
	            });
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	        self.$nextTick(function () {
	            $('#ReservationTo').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    if (!self.datesData.start) {
	                        return date.valueOf() >= new Date();
	                    } else {
	                        return date.valueOf() >= moment(self.datesData.start);
	                    }
	                }
	            }).on('changeDate', function (selected) {
	                self.datesData.end = moment(selected.date).format('YYYY-MM-DD');
	            });
	
	            $('#ReservationFrom').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    return moment(date).add(1, "days") >= moment();
	                }
	            }).on('changeDate', function (selected) {
	
	                self.datesData.start = moment(selected.date).format('YYYY-MM-DD');
	                if (!self.datesData.end) {
	                    $('#ReservationTo').datepicker('update', self.datesData.start);
	                    self.datesData.end = self.datesData.start;
	                } else if (self.datesData.end < self.datesData.start) {
	
	                    $('#ReservationTo').datepicker('update', self.datesData.start);
	                    self.datesData.end = self.datesData.start;
	                } else {
	                    $('#ReservationTo').datepicker('destroy');
	                    $('#ReservationTo').datepicker({
	                        autoclose: true,
	                        format: 'yyyy-mm-dd',
	                        todayHighlight: true,
	                        beforeShowDay: function beforeShowDay(date) {
	                            return date.valueOf() >= moment(self.datesData.start);
	                        }
	                    }).on('changeDate', function (selected) {
	                        self.datesData.end = moment(selected.date).format('YYYY-MM-DD');
	                    });
	                }
	            });
	        });
	    }
	
	};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CustomerConfirmedReservations = __webpack_require__(244);
	
	var _CustomerConfirmedReservations2 = _interopRequireDefault(_CustomerConfirmedReservations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "myReservations",
	  data: function data() {
	    return {};
	  },
	
	  components: {
	    CustomerConfirmedReservations: _CustomerConfirmedReservations2.default
	  },
	  updated: function updated() {},
	
	  mounted: function mounted() {
	    this.$ga.page(this.$router);
	  }
	};

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'reservation-success',
	    data: function data() {
	        return {};
	    },
	
	    methods: {
	        goHome: function goHome() {
	            this.$router.push({ path: '/' });
	        },
	        findSitters: function findSitters() {
	            this.$router.push({ path: '/findsitters' });
	        },
	        myReservations: function myReservations() {
	            this.$router.push({ path: '/my-reservations' });
	        }
	
	    },
	    mounted: function mounted() {
	        var self = this;
	    },
	    computed: {}
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vueStarRating = __webpack_require__(671);
	
	var _vueStarRating2 = _interopRequireDefault(_vueStarRating);
	
	var _Chat = __webpack_require__(67);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PetSelectCard = __webpack_require__(37);
	
	var _PetSelectCard2 = _interopRequireDefault(_PetSelectCard);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            existingReservation: null,
	            notification: '',
	            reviewDesc: '',
	            error: '',
	            isDogWalking: false,
	            summaryCollapse: true,
	            sending: false,
	            ready: true,
	            customerRating: '',
	            rated: false,
	            sent: false,
	            loading: true,
	            reviewDto: {
	                Description: '',
	                Rating: ''
	            }
	
	        };
	    },
	
	    components: {
	        PetSelectCard: _PetSelectCard2.default,
	        Chat: _Chat2.default,
	        StarRating: _vueStarRating2.default
	    },
	    updated: function updated() {
	        var self = this;
	
	        $('[data-toggle="popover"]').popover();
	        if (this.existingReservationComp != null) if (this.existingReservationComp.IsCompleted == true && this.existingReservationComp.RatingRequired == true) $('#ratingRequest').modal('show');
	
	        $('#summary').collapse('show');
	    },
	    computed: {
	        isActiveComp: function isActiveComp() {
	            if (this.existingReservationComp != null) return this.existingReservationComp.IsSitterCustomerActive;
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        },
	        rejectedComp: function rejectedComp() {
	            var self = this;
	            if (self.existingReservationComp.IsSitterRejected == true || self.existingReservationComp.IsCustomerCancelled == true) return true;else return false;
	        },
	        summaryComp: function summaryComp() {
	            if (this.summaryCollapse == true) return 'Hide Summary';else return 'Show Summary';
	        },
	        totalPriceComputed: function totalPriceComputed() {
	            var totalPrice = this.existingReservation.TotalPrice;
	            return totalPrice;
	        },
	        startDateComp: function startDateComp() {
	            var self = this;
	            return moment(self.existingReservation.StartDate).format('DD MMM YYYY');
	        },
	        endDateComp: function endDateComp() {
	            var self = this;
	            return moment(self.existingReservation.OriginalEndDate).format('DD MMM YYYY');
	        },
	        signalReadyComp: function signalReadyComp() {
	            if (_store2.default.getters.SignalRHub != null && this.ready == true) if (_store2.default.getters.SignalRHub.connection != null) return true;
	            return false;
	        },
	        signalRHubComp: function signalRHubComp() {
	            if (_store2.default.getters.SignalRHub != null) return _store2.default.getters.SignalRHub;
	        },
	        existingReservationComp: function existingReservationComp() {
	            return this.existingReservation;
	        },
	        reservationIdComp: function reservationIdComp() {
	            var self = this;
	            if (self.$route.params != null) return self.$route.params.reservationId;
	        },
	        reservationReadyComp: function reservationReadyComp() {
	            if (this.existingReservation != null && this.signalReadyComp == true) return true;
	            return false;
	        }
	
	    },
	    watch: {
	        '$route.params.reservationId': function $routeParamsReservationId() {
	            this.ready = false;
	            this.initReservation();
	            this.$forceUpdate();
	        }
	    },
	    methods: {
	        confirmBooking: function confirmBooking() {
	            var self = this;
	            self.existingReservation.IsConfirmedBooking = true;
	            self.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	            $.ajax("https://www.dupaws.com/services/api/customer/confirmBooking/" + self.$route.params.reservationId, {
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {},
	                error: function error(data, status, _error) {
	                    swal("Oops", "failure happened when you tried to confirm booking, contact support", "info");
	                }
	
	            });
	        },
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY');
	        },
	        setRating: function setRating(rating) {
	            this.customerRating = rating;
	            this.reviewDto.Rating = rating;
	            this.reviewDto.Description = this.reviewDesc;
	        },
	        submitRating: function submitRating() {
	            var self = this;
	            self.reviewDto.Description = self.reviewDesc;
	            self.reviewDto.Rating = self.customerRating;
	            self.customerRating = '';
	            $.ajax("https://www.dupaws.com/services/api/customer/submitReview/" + self.$route.params.reservationId, {
	                type: 'POST',
	                data: (0, _stringify2.default)(self.reviewDto),
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.alert = data;
	                    $('#ratingRequest').modal('hide');
	                    swal({
	                        title: "Thank you for your feedback!",
	                        type: "success",
	                        confirmButtonClass: 'btn-info',
	                        confirmButtonText: "OK",
	                        closeOnConfirm: true,
	                        html: true
	                    }, function () {
	                        _router2.default.push({ path: '/' });
	                    });
	                },
	                error: function error(data, status, _error2) {}
	
	            });
	        },
	
	        whatToDoNext: function whatToDoNext() {
	            var self = this;
	            swal({
	                title: 'Request has been sent',
	                text: self.existingReservationComp.SitterName + " will be notified of your request, you can use chat to send a message. also we suggest that you request at least another sitter in case " + self.existingReservationComp.SitterName + " is busy or not available.",
	                type: "success",
	                confirmButtonClass: "btn-success",
	                confirmButtonText: 'Woof!',
	                allowOutsideClick: false,
	                closeOnConfirm: true
	            }, function (isConfirm) {
	                return;
	            });
	        },
	        goSubscribe: function goSubscribe() {
	            var self = this;
	            self.$router.push({ path: '/subscribe' });
	            self.$router.go({ path: '/subscribe' });
	        },
	        goSupport: function goSupport() {
	            _router2.default.push({
	                path: '/contact-support/' + '?bookingId=' + this.existingReservationComp.BookingNumber,
	                force: true
	            });
	        },
	        cancelRequest: function cancelRequest() {
	            var self = this;
	            self.existingReservation.IsCustomerRemoved = true;
	            self.existingReservation.IsCustomerCancelled = true;
	            self.existingReservation.CustomerCancelledDate = new Date();
	            self.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	        },
	        switchCollapse: function switchCollapse() {
	            if (this.summaryCollapse == true) this.summaryCollapse = false;else this.summaryCollapse = true;
	        },
	        initReservation: function initReservation() {
	            var self = this;
	            self.loading = true;
	            $.ajax("https://www.dupaws.com/services/api/customer/getReservation/" + self.$route.params.reservationId, {
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.existingReservation = data;
	                    $.each(data.AvailableSitterServiceDtos, function (index, item) {
	                        if (item.ServiceType == 6 && item.IsSelected == true) self.isDogWalking = true;
	                    });
	
	                    self.ready = true;
	                    self.loading = false;
	                },
	                error: function error(data, status, _error3) {
	                    self.loading = false;
	                    self.error = data.responseJSON.Message;
	                }
	
	            });
	        },
	
	        findSitters: function findSitters() {
	            this.$router.push({ path: '/findsitters' });
	        },
	        goMyReservations: function goMyReservations() {
	            this.$router.push({ path: '/my-reservations' });
	        },
	        updateReservation: function updateReservation() {
	            var self = this;
	            this.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	        self.$forceUpdate();
	        self.initReservation();
	        _store2.default.commit('readNotificationTrans', self.reservationIdComp);
	
	        self.signalRHubComp.on('UpdateReservation', function (reservationDto) {
	            if (reservationDto.ServiceTransactionId == self.existingReservation.ServiceTransactionId) self.existingReservation = reservationDto;
	        });
	    }
	
	};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: 'my-reservations',
	    data: function data() {
	        return {
	            myReservations: '',
	            hidden: false,
	            loading: true,
	            tempReservations: '',
	            sort: 0
	        };
	    },
	
	    methods: {
	        switchCollapse: function switchCollapse() {
	            if (this.summaryCollapse == true) this.summaryCollapse = false;else this.summaryCollapse = true;
	        },
	
	        goSearchSitters: function goSearchSitters() {
	            this.$router.push({ path: '/findsitters' });
	        },
	        bookingRemovable: function bookingRemovable(reservation) {
	            var self = this;
	            var now = moment();
	            var endDate = moment(reservation.OriginalEndDate);
	
	            if (reservation.IsCustomerRemoved == true) return false;
	            if (reservation.IsSitterRejected == true || reservation.IsCustomerCancelled == true) return true;
	            if (endDate <= now) return true;else return false;
	        },
	        showCompleted: function showCompleted() {
	            this.hidden = false;
	            this.myReservations = this.tempReservations;
	        },
	        hideCompleted: function hideCompleted() {
	            var self = this;
	            self.hidden = true;
	            var now = moment();
	            self.tempReservations = self.myReservations.slice();
	
	            $.each(self.myReservations, function (index, reservation) {
	                if (reservation != null) {
	                    var originalEndDate = moment(reservation.OriginalEndDate);
	                    var endDate = moment(reservation.EndDate);
	                    if (endDate <= now || originalEndDate <= now || reservation.IsCustomerCancelled || reservation.IsSitterRejected) {
	                        self.myReservations.splice(index, 1);
	                    }
	                }
	            });
	        },
	        removeBooking: function removeBooking(reservation) {
	            var self = this;
	            $.ajax({
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                url: API_URL + "api/customer/removeBooking/" + reservation.ReservationId,
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    setTimeout(function () {
	                        var index = self.myReservations.findIndex(function (t) {
	                            return t.ReservationId === reservation.ReservationId;
	                        });
	                        self.myReservations.splice(index, 1);
	                    }, 100);
	                },
	                error: function error(data, status, _error) {}
	            });
	        },
	        customerTotalPrice: function customerTotalPrice(totalPrice) {
	            return totalPrice.toFixed(2);
	        },
	        startDateComp: function startDateComp(reservation) {
	            return moment(reservation.StartDate).format('DD MMM YYYY');
	        },
	        endDateComp: function endDateComp(reservation) {
	            return moment(reservation.EndDate).format('DD MMM YYYY');
	        },
	        sentDate: function sentDate(date) {
	            return moment(date).fromNow();
	        },
	        startDate: function startDate(date, bookingNumber) {
	            var currentDate = moment();
	            var sittingDate = moment(date);
	            var difference = sittingDate.diff(currentDate, 'hours');
	            if (difference < -25) {
	                return 'Already Started';
	            }
	            if (difference < 0 && difference >= -24) return 'Today';else if (difference <= 24) return moment(date).fromNow();else return moment(new Date()).to(date);
	        },
	        goSitter: function goSitter(sitterId) {
	            this.$router.push({ path: '/sitter/' + sitterId });
	        },
	        goToReservation: function goToReservation(reservation) {
	            this.$router.push({ name: 'view-reservation', params: { reservationId: reservation.ReservationId } });
	        },
	        loadData: function loadData() {
	            var self = this;
	            $.ajax({
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                url: API_URL + "api/customer/getMyReservations",
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    self.myReservations = data;
	                    self.tempReservations = data;
	                    self.loading = false;
	                },
	                error: function error(data, status, _error2) {}
	            });
	        }
	
	    },
	    computed: {
	        summaryComp: function summaryComp() {
	            if (this.summaryCollapse == true) return 'Hide filters and sort';else return 'Show filters and sort';
	        },
	        sortedReservationsComp: function sortedReservationsComp() {
	            var self = this;
	            function start(a, b) {
	                if (a.StartDate < b.StartDate) return -1;
	                if (a.StartDate > b.StartDate) return 1;
	                return 0;
	            }
	
	            function submitted(a, b) {
	                if (a.SubmittedDate > b.SubmittedDate) return -1;
	                if (a.SubmittedDate < b.SubmittedDate) return 1;
	                return 0;
	            }
	
	            function price(a, b) {
	                if (a.TotalPrice > b.TotalPrice) return -1;
	                if (a.TotalPrice < b.TotalPrice) return 1;
	                return 0;
	            }
	
	            if (self.sort == 0) self.myReservations.sort(submitted);else if (self.sort == 1) self.myReservations.sort(start);else if (self.sort == 2) self.myReservations.sort(price);
	
	            return self.myReservations;
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	        self.loadData();
	        this.refreshInterval = setInterval(function () {
	            self.loadData();
	        }, 360000);
	    },
	    updated: function updated() {},
	    beforeDestroy: function beforeDestroy() {
	        clearInterval(this.refreshInterval);
	    }
	
	};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ViewReservationComponent = __webpack_require__(569);
	
	var _ViewReservationComponent2 = _interopRequireDefault(_ViewReservationComponent);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	
	  mounted: function mounted() {},
	  components: {
	    ViewReservationComponent: _ViewReservationComponent2.default
	  },
	  computed: {
	    signalReady: function signalReady() {
	      if (_store2.default.getters.SignalRHub) if (_store2.default.getters.SignalRHub.connection != null) if (_store2.default.getters.SignalRHub.connection.id != null) {
	        console.log("signalRHub completed");
	        console.log(_store2.default.getters.SignalRHub);
	        return true;
	      }
	      {
	        console.log("signalRHub failed to mount");
	        console.log(_store2.default.getters.SignalRHub);
	        return false;
	      }
	    }
	  }
	};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            loading: false,
	            error: '',
	            alert: '',
	            emailConfirmed: true,
	            days: 0,
	            sun: 0,
	            mon: 0,
	            tue: 0,
	            wed: 0,
	            thu: 0,
	            fri: 0,
	            sat: 0,
	            sortingList: [{ SortId: 0, SortName: 'Sort by Recommended' }, { SortId: 4, SortName: 'Fastest Response' }, { SortId: 3, SortName: 'Highest Reviews' }, { SortId: 1, SortName: 'Lowest Price' }, { SortId: 2, SortName: 'Highest Price' }],
	            servicesList: [{ ServiceType: 1, ServiceName: 'Dog Boarding (Sitter Home)' }, { ServiceType: 2, ServiceName: 'Cat Boarding (Sitter Home)' }, { ServiceType: 3, ServiceName: 'Dog Sitting (Your Home)' }, { ServiceType: 4, ServiceName: 'Cat Sitting (Your Home)' }, { ServiceType: 5, ServiceName: 'Pick up and Delivery' }, { ServiceType: 6, ServiceName: 'Dog Walking' }],
	            homeTypesList: [{ HomeType: 0, HomeTypeName: 'Show All' }, { HomeType: 1, HomeTypeName: 'Resident Dog at home' }, { HomeType: 2, HomeTypeName: 'Resident Cat at home' }, { HomeType: 3, HomeTypeName: 'Children at home' }, { HomeType: 4, HomeTypeName: 'None at home' }],
	            petprefsList: [{ PetPref: 0, PetPrefName: 'Show All' }, { PetPref: 1, PetPrefName: 'Accepts Small Dogs 0-7 KG' }, { PetPref: 2, PetPrefName: 'Accepts Medium Dogs 8-18 KG' }, { PetPref: 3, PetPrefName: 'Accepts Large Dogs 19+ KG' }],
	            title: "Pet Sitters Search",
	            pending: true,
	            priceList: [{ label: 'Price Range (All prices)', priceRange: null }, { label: 'From 50 to 99 aed', priceRange: 0 }, { label: 'From 100 to 149 aed', priceRange: 1 }, { label: 'From 150 to 200 aed', priceRange: 2 }, { label: 'From 199 to 250 aed', priceRange: 3 }]
	        };
	    },
	
	    updated: function updated() {
	        this.$ga.page(this.$router);
	        var self = this;
	        $('[data-toggle="popover"]').popover();
	
	        if (this.$route.hash) {
	            location.href = this.$route.hash;
	        }
	
	        if (this.$route.params.cityId != null) self.queryDataComp.cityId = this.$route.params.cityId;
	
	        var idToScrollTo = this.$router.currentRoute.hash;
	
	        if (!self.loading && idToScrollTo) {
	            console.log('entering');
	            console.log($(window).width());
	            setTimeout(function () {
	                var smallPage = '#sm' + idToScrollTo.substr(1);
	                if (document.querySelector(smallPage) && $(window).width() < 992) {
	                    self.$scrollTo(smallPage);
	                } else if (document.querySelector(idToScrollTo) && $(window).width() > 991) {
	                    self.$scrollTo(idToScrollTo);
	                }
	
	                self.cleanAnchor();
	            }, 10);
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	
	        self.loading = true;
	
	        _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	            self.loading = false;
	        }).fail(function (error) {
	            swal("Oops", "Failed to get sitters list, please contact support for assistance", "error");
	        });
	
	        if (_store2.default.getters.authenticated) {
	            if (localStorage.getItem('emailConfirmed') != null) {
	                var check = localStorage.getItem('emailConfirmed');
	                if (check == "False") {
	                    this.emailConfirmed = false;
	                }
	            }
	        }
	
	        self.$nextTick(function () {
	            var self = this;
	
	            $('#findSittersDatePickerToMobile').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    if (!self.queryDataComp.start) {
	                        return date.valueOf() >= new Date();
	                    } else {
	                        return date.valueOf() >= moment(self.queryDataComp.start);
	                    }
	                }
	            }).on('changeDate', function (selected) {
	                self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	            });
	
	            $('#findSittersDatePickerFromMobile').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    return moment(date).add(1, "days") >= moment();
	                }
	            }).on('changeDate', function (selected) {
	                self.queryDataComp.start = moment(selected.date).format('YYYY-MM-DD');
	                if (!self.queryDataComp.end) {
	                    $('#findSittersDatePickerToMobile').datepicker('update', self.queryDataComp.start);
	                    self.queryDataComp.end = self.queryDataComp.start;
	                } else if (self.queryDataComp.end < self.queryDataComp.start) {
	
	                    $('#findSittersDatePickerToMobile').datepicker('update', self.queryDataComp.start);
	                    self.queryDataComp.end = self.queryDataComp.start;
	                } else {
	                    $('#findSittersDatePickerToMobile').datepicker('destroy');
	                    $('#findSittersDatePickerToMobile').datepicker({
	                        autoclose: true,
	                        format: 'yyyy-mm-dd',
	                        todayHighlight: true,
	                        beforeShowDay: function beforeShowDay(date) {
	                            return date.valueOf() >= moment(self.queryDataComp.start);
	                        }
	                    }).on('changeDate', function (selected) {
	                        self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	                    });
	                }
	            });
	
	            $('#findSittersDatePickerTo').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    if (!self.queryDataComp.start) {
	                        return date.valueOf() >= new Date();
	                    } else {
	                        return date.valueOf() >= moment(self.queryDataComp.start);
	                    }
	                }
	            }).on('changeDate', function (selected) {
	                self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	            });
	
	            $('#findSittersDatePickerFrom').datepicker({
	                autoclose: true,
	                format: 'yyyy-mm-dd',
	                todayHighlight: true,
	                beforeShowDay: function beforeShowDay(date) {
	                    return moment(date).add(1, "days") >= moment();
	                }
	            }).on('changeDate', function (selected) {
	                self.queryDataComp.start = moment(selected.date).format('YYYY-MM-DD');
	                if (!self.queryDataComp.end) {
	                    $('#findSittersDatePickerTo').datepicker('update', self.queryDataComp.start);
	                    self.queryDataComp.end = self.queryDataComp.start;
	                } else if (self.queryDataComp.end < self.queryDataComp.start) {
	
	                    $('#findSittersDatePickerTo').datepicker('update', self.queryDataComp.start);
	                    self.queryDataComp.end = self.queryDataComp.start;
	                } else {
	                    $('#findSittersDatePickerTo').datepicker('destroy');
	                    $('#findSittersDatePickerTo').datepicker({
	                        autoclose: true,
	                        format: 'yyyy-mm-dd',
	                        todayHighlight: true,
	                        beforeShowDay: function beforeShowDay(date) {
	                            return date.valueOf() >= moment(self.queryDataComp.start);
	                        }
	                    }).on('changeDate', function (selected) {
	                        self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	                    });
	                }
	            });
	        });
	    },
	    methods: {
	        cleanAnchor: function cleanAnchor() {
	            this.$router.replace({ path: '/findsitters' });
	        },
	        getHref: function getHref(sitter) {
	            return 'https://www.dupaws.com/sitter/' + sitter.SitterId;
	        },
	        goSubscribe: function goSubscribe() {
	            swal({
	                title: "Basic Account",
	                text: "Basic account is a free membership access to pet sitters, if you want to book a basic account user, you will need to have an active subscription.",
	                type: "info",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Subscribe",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                self.$router.push({ path: '/subscribe' });
	            });
	        },
	        lastSeenDate: function lastSeenDate(_lastSeenDate) {
	            return moment(_lastSeenDate).fromNow();
	        },
	        premiumSwal: function premiumSwal() {
	            swal({
	                title: 'Premium Member',
	                text: "You can contact and book Premium accounts directly without subscription or membership.",
	                type: "success",
	                confirmButtonClass: "btn-success",
	                confirmButtonText: 'Woof!',
	                allowOutsideClick: false,
	                closeOnConfirm: true
	            }, function (isConfirm) {
	                return;
	            });
	        },
	        gaClick: function gaClick() {
	            var self = this;
	        },
	        reviewString: function reviewString(count) {
	            if (count == 1) return 'Review';else return 'Reviews';
	        },
	        timeString: function timeString(count) {
	            if (count == 1) return 'time';else return 'times';
	        },
	
	        sortList: function sortList(value) {
	            var self = this;
	            self.loading = true;
	            self.$ga.event('Sort filter changed', 'Action');
	            self.queryDataComp.sort = value;
	            this.queryDataComp.currentPage = 0;
	            _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                self.loading = false;
	            }).fail(function (error) {
	                console.log(error);
	            });
	        },
	        changeArea: function changeArea(area) {
	            this.queryDataComp.areaId = parseInt(area.AreaId);
	            this.loading = true;
	            self.$ga.event('Area Changed', 'Action', 'AreaId', area.AreaId);
	            _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                self.loading = false;
	            }).fail(function (error) {
	                console.log(error);
	            });
	        },
	        isCurrentSort: function isCurrentSort(value) {
	            if (this.queryDataComp.sort == value) return true;else return false;
	        },
	        isCurrentItem: function isCurrentItem(page) {
	            if (this.paginationComp.CurrentPage == page) return true;else return false;
	        },
	        goAccount: function goAccount() {
	            this.$router.push({ path: '/account', force: true });
	        },
	        hideFilters: function hideFilters() {
	            this.$SmoothScroll(0, 200);
	        },
	        resetFilters: function resetFilters() {
	            var self = this;
	            self.$router.push({ path: '/findsitters' });
	            _store2.default.commit('clearFilters');
	            self.$ga.event('Filters Cleared', 'Action', 'Cleared Filters');
	            _commonApi2.default.getCitiesList(_store2.default.getters.CountryData.CountryId, 0);
	            _commonApi2.default.getSittersList(_store2.default.getters.QueryData);
	        },
	
	        addToFavorites: function addToFavorites(sitter) {
	            self = this;
	            self.cleanAnchor();
	            if (_store2.default.getters.authenticated == false) swal({
	                title: "Hello",
	                text: "You need to be logged in as a Customer to add sitters to your favorite account",
	                type: "info",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Login",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                self.$router.push({ path: '/login', query: { redirect: 'findSitters' } });
	            });else if (self.userRoleComp == "Sitter") {
	                swal("Hello", 'You cant add Sitters as favorites while logged in as a Sitter, please switch to Customer login then try again', "info");
	            } else {
	                _customerApi2.default.addSitterToFavorites(sitter);
	            }
	        },
	        instagramWinner: function instagramWinner(sitter) {
	            swal("Dupaws Instagram Photo Winner", sitter.Name + "Is the latest Dupaws Instagram contest winner", "success");
	        },
	        viewProfile: function viewProfile(sitter) {
	            this.$router.push('#user' + sitter.SitterId);
	            this.$router.push({ path: '/sitter/' + sitter.SitterId });
	        },
	        goHome: function goHome() {
	            this.$router.push({ path: '/' });
	        },
	        updatePage: function updatePage(page) {
	            var self = this;
	            self.loading = true;
	            self.queryDataComp.currentPage = page;
	            self.$ga.event('Pagination clicked', 'Action', 'Page Number', page);
	            _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                self.loading = false;
	            }).fail(function (error) {
	                console.log(error);
	            });
	        },
	        updatePetPref: function updatePetPref(PetPref) {
	            this.queryDataComp.PetPref = parseInt(PetPref);
	        },
	        isFavorite: function isFavorite(sitterId) {
	            if (this.userRoleComp == "Sitter") return false;
	            var result = $.grep(_store2.default.getters.FavoriteSitters, function (e) {
	                return e.SitterId == sitterId;
	            });
	            if (result.length > 0) return true;else return false;
	        }
	    },
	    watch: {
	        'queryDataComp.sort': function queryDataCompSort(sortId) {
	            if (sortId != null) {
	                this.cleanAnchor();
	                this.sortList(sortId);
	            }
	        },
	        'queryDataComp.cityId': function queryDataCompCityId(cityId) {
	            var self = this;
	
	            this.queryDataComp.currentPage = 0;
	            this.queryDataComp.areaId = null;
	            _store2.default.dispatch('FilteredAreasList', null);
	            if (_store2.default.getters.QueryData.cityId != null) {
	                self.loading = true;
	                self.$ga.event('City Changed', 'Action', 'CityId', _store2.default.getters.QueryData.cityId);
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.areaId': function queryDataCompAreaId() {
	            var self = this;
	            this.queryDataComp.currentPage = 0;
	            if (_store2.default.getters.QueryData.areaId != null) {
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'dogWalkingDaysComp': function dogWalkingDaysComp() {
	            var self = this;
	            this.queryDataComp.currentPage = 0;
	            _store2.default.getters.QueryData.dogwalkingdays = self.dogWalkingDaysComp;
	            if (_store2.default.getters.QueryData.dogwalkingdays != null) {
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.$ga.event('Dogwalking Days Changed', 'Action', 'Days Per Week', _store2.default.getters.QueryData.dogwalkingdays);
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.serviceType': function queryDataCompServiceType() {
	            var self = this;
	            this.queryDataComp.currentPage = 0;
	            if (_store2.default.getters.QueryData.serviceType != null) {
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.$ga.event('ServiceType Changed', 'Action', 'ServiceId', _store2.default.getters.QueryData.serviceType);
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.homeType': function queryDataCompHomeType() {
	            var self = this;
	            this.queryDataComp.currentPage = 0;
	            if (_store2.default.getters.QueryData.homeType != null) {
	                self.$ga.event('HomeType Changed', 'Action', 'HomeTypeId', _store2.default.getters.QueryData.homeType);
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.petpref': function queryDataCompPetpref() {
	            var self = this;
	            console.log('changed');
	            this.queryDataComp.currentPage = 0;
	            if (_store2.default.getters.QueryData.petpref != null) {
	
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.start': function queryDataCompStart() {
	            var self = this;
	            if (_store2.default.getters.QueryData.start != null) {
	                self.$ga.event('Date Range changed', 'Action', 'StartDate Changed');
	                self.loading = true;
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        },
	        'queryDataComp.end': function queryDataCompEnd() {
	            var self = this;
	            if (_store2.default.getters.QueryData.end != null) {
	                self.loading = true;
	                self.$ga.event('Data Range changed', 'Action', 'EndDate Changed');
	                _commonApi2.default.getSittersList(_store2.default.getters.QueryData).then(function (data) {
	                    self.loading = false;
	                }).fail(function (error) {
	                    console.log(error);
	                });
	            }
	        }
	    },
	    head: {
	        title: function title() {
	            return {
	                inner: this.title
	            };
	        },
	        meta: [{ name: 'application-name', content: 'Dupaws.com Pet Sitting' }, { name: 'description', content: 'Find the Perfect Pet Sitter, Cat and Dog boarding at homes.', id: 'desc' }, { property: 'fb:app_id', content: '279352372578608' }, { property: 'og:title', content: 'Find a loving home for your pets' }, { property: 'og:url', content: 'https://www.dupaws.com/findsitters' }, { property: 'og:type', content: 'website' }, { property: 'fb:admins', content: '636428053' }, { property: 'fb:pages', content: '1623158747696830' }],
	        link: [{ rel: 'canonical', href: 'https://www.dupaws.com/findsitters', id: 'canonical' }]
	    },
	    computed: {
	        dogWalkingDaysComp: function dogWalkingDaysComp() {
	            return this.sun | this.mon | this.tue | this.wed | this.thu | this.fri | this.sat;
	        },
	        startDateMobileComp: function startDateMobileComp() {
	            if (this.queryDataComp.start == null) {
	                return 'Pick up date';
	            } else return this.queryDataComp.start;
	        },
	        endDateMobileComp: function endDateMobileComp() {
	            if (this.queryDataComp.end == null) {
	                return 'Drop off date';
	            } else return this.queryDataComp.end;
	        },
	        selectCityStatusComp: function selectCityStatusComp() {
	            if (_store2.default.getters.CountryData.CountryId != 9) return 'Select a City';
	            if (_store2.default.getters.CountryData.CountryId == 9) return 'Select your Area';
	        },
	        selectAreaStatusComp: function selectAreaStatusComp() {
	            if (_store2.default.getters.CountryData.CountryId != 9) return 'Select City to filter neighbors';
	            if (_store2.default.getters.CountryData.CountryId == 9) return 'Select Area to see available neighbors';
	        },
	        totalPagesComp: function totalPagesComp() {
	            return Math.min(this.paginationComp.TotalPages, 9);
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        },
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        sittersList: function sittersList() {
	            return _store2.default.getters.SittersList.SitterDtos;
	        },
	        paginationComp: function paginationComp() {
	            return _store2.default.getters.SittersList;
	        },
	        timezoneComp: function timezoneComp() {
	            return _store2.default.getters.CountryData.CountryTimezone;
	        },
	        queryDataComp: function queryDataComp() {
	            return _store2.default.getters.QueryData;
	        },
	        citiesList: function citiesList() {
	            return _store2.default.getters.CitiesList;
	        },
	        filteredAreasList: function filteredAreasList() {
	            return _store2.default.getters.FilteredAreasList;
	        },
	        userRoleComp: function userRoleComp() {
	            return _store2.default.getters.userRole;
	        },
	        countryDataComp: function countryDataComp() {
	            return _store2.default.getters.CountryData;
	        }
	
	    }
	
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueFlickity = __webpack_require__(543);
	
	var _vueFlickity2 = _interopRequireDefault(_vueFlickity);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  data: function data() {
	    return {
	      flickityOptions: {
	        fullscreen: false,
	        pageDots: false,
	        wrapAround: true,
	        dragThreshold: 35,
	        draggable: false,
	        lazyload: 1
	
	      },
	      updatedNow: false,
	      active: false,
	      share: false,
	      message: false,
	      scrollPosition: ''
	    };
	  },
	  updated: function updated() {
	    var self = this;
	
	    $('#citySelect').focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $('#citySelect').blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	    self.$nextTick(function () {
	      $('#citySelect').focus(function () {
	        self.scrollPosition = window.scrollY;
	      });
	      $('#citySelect').blur(function () {
	        self.$SmoothScroll(self.scrollPosition, 350);
	      });
	    });
	  },
	
	  components: {
	    Flickity: _vueFlickity2.default
	  },
	  watch: {
	    'queryDataComp.regionId': function queryDataCompRegionId(regionId) {
	      var self = this;
	      console.log('changed');
	      if (regionId && regionId != 0 && self.countryDataComp) _commonApi2.default.getCitiesList(self.countryDataComp.CountryId, regionId);
	    },
	    'queryDataComp.cityId': function queryDataCompCityId(cityId) {
	      var self = this;
	      this.queryDataComp.currentPage = 0;
	      this.queryDataComp.areaId = null;
	    }
	  },
	  mounted: function mounted() {
	    self = this;
	    this.$ga.page(this.$router);
	    self.$nextTick(function () {
	
	      $('#homeDatePickerTo').datepicker({
	        autoclose: true,
	        format: 'yyyy-mm-dd',
	        todayHighlight: true,
	        ignoreReadyonly: true,
	        allowInputToggle: true,
	        beforeShowDay: function beforeShowDay(date) {
	          if (!self.queryDataComp.start) {
	            return date.valueOf() >= new Date();
	          } else {
	            return date.valueOf() >= moment(self.queryDataComp.start);
	          }
	        }
	      }).on('changeDate', function (selected) {
	        self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	      });
	
	      $('#homeDatePickerFrom').datepicker({
	        autoclose: true,
	        format: 'yyyy-mm-dd',
	        todayHighlight: true,
	        ignoreReadyonly: true,
	        allowInputToggle: true,
	        beforeShowDay: function beforeShowDay(date) {
	          return moment(date).tz("Asia/Dubai").add(1, "days") >= moment().tz("Asia/Dubai");
	        }
	      }).on('changeDate', function (selected) {
	        self.queryDataComp.start = moment(selected.date).format('YYYY-MM-DD');
	        if (!self.queryDataComp.end) {
	          $('#homeDatePickerTo').datepicker('update', self.queryDataComp.start);
	          self.queryDataComp.end = self.queryDataComp.start;
	        } else if (self.queryDataComp.end < self.queryDataComp.start) {
	
	          $('#homeDatePickerTo').datepicker('update', self.queryDataComp.start);
	          self.queryDataComp.end = self.queryDataComp.start;
	        } else {
	          $('#homeDatePickerTo').datepicker('destroy');
	          $('#homeDatePickerTo').datepicker({
	            autoclose: true,
	            format: 'yyyy-mm-dd',
	            todayHighlight: true,
	            beforeShowDay: function beforeShowDay(date) {
	              return date.valueOf() >= moment(self.queryDataComp.start);
	            }
	          }).on('changeDate', function (selected) {
	            self.queryDataComp.end = moment(selected.date).format('YYYY-MM-DD');
	          });
	        }
	      });
	    });
	  },
	
	  methods: {
	    goBecomeSitter: function goBecomeSitter() {
	      this.$router.push({ path: '/become-a-sitter' });
	    },
	    next: function next() {
	      this.$refs.flickity.next();
	    },
	    previous: function previous() {
	      this.$refs.flickity.previous();
	    },
	
	
	    sendFacebook: function sendFacebook() {
	      FB.ui({
	        method: 'send',
	        link: 'https://www.dupaws.com'
	      });
	    },
	    shareFacebook: function shareFacebook(myQuote) {
	      FB.ui({
	        method: 'share',
	        href: 'https://www.dupaws.com',
	        quote: myQuote,
	        hashtag: '#dupaws',
	        mobile_iframe: true
	      }, function (response) {
	        if (response && !response.error_message) {} else {}
	      });
	    },
	    searchSitters: function searchSitters() {
	      this.$router.push({ path: '/findsitters' });
	    },
	
	    searchDogWalkers: function searchDogWalkers() {
	      _store2.default.getters.QueryData.serviceType = 6;
	      this.$router.push({ path: '/findsitters' });
	    }
	
	  },
	
	  computed: {
	    updatedComp: function updatedComp() {
	      return this.updatedNow;
	    },
	    regionsList: function regionsList() {
	      return _store2.default.getters.RegionsList;
	    },
	    citiesList: function citiesList() {
	      return _store2.default.getters.CitiesList;
	    },
	    queryDataComp: function queryDataComp() {
	      return _store2.default.getters.QueryData;
	    },
	    countryDataComp: function countryDataComp() {
	      return _store2.default.getters.CountryData;
	    },
	    staycationDataComp: function staycationDataComp() {
	      return _store2.default.getters.StaycationData;
	    },
	    myQuoteComp: function myQuoteComp() {
	      return 'Airbnb for pets now available in ' + this.countryDataComp.CountryName;
	    }
	
	  }
	
	};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PetProfileCard = __webpack_require__(576);
	
	var _PetProfileCard2 = _interopRequireDefault(_PetProfileCard);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.$ga.page(this.$router);
	    setTimeout(function () {
	      _customerApi2.default.getPetsList();
	    }, 20);
	  },
	
	  methods: {
	    addNewPet: function addNewPet() {
	      this.$router.push({ path: "/pets-view/addpet" });
	    }
	  },
	  components: {
	    PetProfileCard: _PetProfileCard2.default
	  },
	  computed: {
	    petsListComp: function petsListComp() {
	      if (_store2.default.getters.PetsList) return _store2.default.getters.PetsList;
	    }
	  }
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: '',
	    data: function data() {
	        return {};
	    },
	
	    mounted: function mounted() {
	        if (this.$route.path == '/pets-view') _index2.default.push({ path: '/pets-view/mypets' });
	    },
	    components: {},
	    computed: {}
	};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    photoIdProp: String,
	    photo: ["photo"]
	  },
	  data: function data() {
	    return {
	      filePath: ""
	    };
	  },
	
	  created: function created() {
	    var self = this;
	    $.ajax("https://www.dupaws.com/services/api/getPetProfilePhoto/" + self.photoIdProp, {
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      contentType: "application/json; charset=utf-8",
	      crossDomain: true,
	      success: function success(data) {
	        self.filePath = data.Path;
	      },
	      error: function error() {
	        console.log('Couldnt get sitter profile photo "api/getPetProfilePhoto"');
	      }
	    });
	  },
	  methods: {
	    deleteImage: function deleteImage() {
	      var self = this;
	      $.ajax("https://www.dupaws.com/services/api/deletePetProfilePhoto/" + self.photoIdProp, {
	        type: "GET",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        crossDomain: true,
	        success: function success(data) {
	          var index = self.$parent.newPet.PetPhotoDtos.findIndex(function (t) {
	            return t.PetPhotoId === self.photoIdProp;
	          });
	          self.$parent.newPet.PetPhotoDtos.splice(index, 1);
	        },
	        error: function error() {
	          console.log("Couldnt delete photo from server");
	        }
	      });
	    }
	  },
	  computed: {
	    photoComp: function photoComp() {
	      self = this;
	      return "https://www.dupaws.com/services" + self.filePath;
	    }
	  }
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: '',
	    props: ['petId'],
	    data: function data() {
	        return {
	            petData: '',
	            profilePhotoPath: ''
	        };
	    },
	
	    methods: {
	        updatePetDetails: function updatePetDetails() {
	            this.$router.push({ path: 'updatePet/' + this.petId });
	        },
	        genderToString: function genderToString(gender) {
	            if (gender == 1) return "Male";else if (gender == 0) return "Female";else return "Unknown";
	        },
	        petTypeToString: function petTypeToString(petType) {
	            if (petType == 1) return "Dog";else if (petType == 2) return "Cat";else return "Unknown";
	        },
	        ageToString: function ageToString(ageYears, ageMonths) {
	            if ((ageYears === null || ageYears == 0) && (ageMonths === null || ageMonths == 0)) return "Age not set";
	            if (ageMonths === null || ageMonths == 0) return ageYears + " years";else if (ageYears == null || ageYears == 0) return ageMonths + " months";else return ageYears + " years " + ageMonths + " months";
	        },
	        viewPetDetails: function viewPetDetails() {
	            $('#' + this.petId).modal('show');
	        },
	        deletePet: function deletePet() {
	            self = this;
	            swal({
	                title: "Are you sure you want to delete " + self.petData.Name + "?",
	                type: "warning",
	                confirmButtonClass: 'btn-warning',
	                confirmButtonText: "Yes delete",
	                closeOnConfirm: false,
	                showCancelButton: true,
	                html: true
	            }, function () {
	                $.ajax({
	                    type: 'POST',
	                    url: API_URL + "api/deletePetData/" + self.petData.PetId,
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    crossDomain: true,
	                    contentType: "application/json; charset=utf-8",
	                    success: function success(data) {
	                        _store2.default.commit('deletePet', self.petData);
	                        swal("Deleted!", self.petData.Name, "success");
	                    },
	                    error: function error(data, status, _error) {
	                        swal("Oops", data.responseJSON.Message, "error");
	                    }
	                });
	            });
	        }
	    },
	    updated: function updated() {
	        $("[data-fancybox]").fancybox({
	            modal: false,
	            selector: '[data-fancybox="pet-photo"]',
	            loop: true
	        });
	    },
	    mounted: function mounted() {
	        self = this;
	        var result = $.grep(_store2.default.getters.PetsList, function (e) {
	            return e.PetId == self.petId;
	        });
	        if (result.length == 0) {} else if (result.length == 1) {
	            self.petData = result[0];
	        }
	    },
	    computed: {
	        petComp: function petComp() {
	            self = this;
	            if (self.petData) return self.petData;
	        },
	        profilePhotoPathComp: function profilePhotoPathComp() {
	            self = this;
	            if (self.petComp) if (self.petComp.PetPhotoDtos) {
	                if (self.petComp.PetPhotoDtos.length > 0) return self.petComp.PetPhotoDtos[0].Path;else return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png";
	            } else return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png";
	        }
	    }
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _PetPicView = __webpack_require__(575);
	
	var _PetPicView2 = _interopRequireDefault(_PetPicView);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _blueimpLoadImage = __webpack_require__(38);
	
	var _blueimpLoadImage2 = _interopRequireDefault(_blueimpLoadImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: 'addPet',
	    data: function data() {
	        return {
	            newPet: '',
	            saved: false,
	            initializing: false,
	            PetTypeSelected: true,
	            PetGenderSelected: true,
	            editingMode: false,
	            filePath: '',
	            cropOptions: {
	                aspectRatio: 5 / 5,
	                background: false,
	                autoCropArea: 0.8,
	                checkCrossOrigin: true,
	                modal: true,
	                preview: '.img-preview'
	            },
	            uploadCompletePct: '',
	            uploading: false,
	            profilePhoto: {
	                Path: '',
	                SitterPhotoId: 0,
	                Type: ''
	
	            },
	            uploadedImageSrc: ''
	        };
	    },
	
	    methods: {
	        cancelSave: function cancelSave() {},
	        previewThumbnail: function previewThumbnail(event) {
	            var orientationVal = true;
	            var input = event.target;
	            if (input.files && input.files[0]) {
	                var self = this;
	                self.uploadCompletePct = '';
	                var file = input.files[0];
	
	                _blueimpLoadImage2.default.parseMetaData(file, function (data) {
	                    if (data.exif) {
	                        orientationVal = data.exif.get('Orientation');
	                    } else orientationVal = true;
	
	                    var loadingImage = (0, _blueimpLoadImage2.default)(file);
	
	                    loadingImage.onload = function (e) {
	                        var scaledImage = _blueimpLoadImage2.default.scale(loadingImage, { orientation: orientationVal });
	
	                        var canvas = document.createElement('canvas');
	                        var ctx = canvas.getContext("2d");
	
	                        var maxWidth = 800,
	                            maxHeight = 800,
	                            imageWidth = scaledImage.width,
	                            imageHeight = scaledImage.height;
	
	                        if (imageWidth > imageHeight) {
	                            if (imageWidth > maxWidth) {
	                                imageHeight *= maxWidth / imageWidth;
	                                imageWidth = maxWidth;
	                            }
	                        } else {
	                            if (imageHeight > maxHeight) {
	                                imageWidth *= maxHeight / imageHeight;
	                                imageHeight = maxHeight;
	                            }
	                        }
	                        canvas.width = imageWidth;
	                        canvas.height = imageHeight;
	
	                        ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);
	
	                        var finalFile = canvas.toDataURL("image/png");
	
	                        $('#cropPetPhotoModal').modal('show');
	                        self.uploadedImageSrc = finalFile;
	                    };
	                });
	            }
	        },
	        updatePetType: function updatePetType(petType) {
	            this.PetTypeSelected = true;
	            this.newPet.PetType = parseInt(petType);
	        },
	        addNewPet: function addNewPet() {
	            var self = this;
	            self.initializing = true;
	            $.ajax({
	                type: 'GET',
	                url: API_URL + "api/initPetData",
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    self.newPet = data;
	                    self.newPet.Name = '';
	                    self.newPet.Gender = '';
	                    self.newPet.PetType = '', self.initializing = false;
	                },
	                error: function error(data, status, _error) {
	                    console.log("failed to get pet init data" + data.responseText);
	                    swal("Oops", "We had an issue while creating your pet, please refresh your browser to continue", "error");
	                    self.initializing = false;
	                }
	            });
	        },
	        updatePet: function updatePet() {
	            var self = this;
	
	            console.log(self.newPet);
	            if (self.newPet.Name == '' || self.newPet.AgeYears == '' && self.newPet.AgeMonths == '') {
	                console.log("Pet data missing");
	            } else {
	                $.ajax({
	                    type: 'POST',
	                    url: API_URL + "api/savePetData",
	                    data: (0, _stringify2.default)(self.newPet),
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    crossDomain: true,
	                    contentType: "application/json; charset=utf-8",
	                    success: function success(data) {
	                        self.saved = true;
	                        _store2.default.commit('deletePet', self.newPet);
	                        _store2.default.getters.PetsList.push(data);
	                        _index2.default.push({ path: '/pets-view/mypets' });
	                    },
	                    error: function error(data, status, _error2) {
	                        swal("Error while saving", data.responseText, "error");
	                    }
	                });
	            }
	        },
	        validateUpdate: function validateUpdate() {
	            var _this = this;
	
	            var self = this;
	            this.$validator.validateAll().then(function (result) {
	                if (result) {
	                    if (self.newPet.PetType == '') {
	                        swal("Something is missing", "Please select Cat or Dog to continue.", "info");
	                        self.PetTypeSelected = false;
	                        return;
	                    }
	                    if (self.newPet.Gender == '' && self.newPet.Gender != false) {
	                        swal("Something is missing", "Please choose the correct Gender (Male or Female) to continue.", "info");
	                        self.PetGenderSelected = false;
	                        return;
	                    }
	                    if (self.newPet.AgeYears == 0 && self.newPet.AgeMonths == 0) {
	                        swal("Something is missing", "Please set the Age Years and Age Months fields.", "info");
	                        return;
	                    }
	
	                    if (self.petPhotoList.length == 0) {
	                        swal("Photo is missing", "Please upload one or more photos of your pet.", "info");
	                        return;
	                    }
	                    _this.updatePet();
	                    return;
	                }
	
	                swal("Something is missing", "Please complete all the required fields to continue.", "info");
	            });
	        },
	        validateBeforeSubmit: function validateBeforeSubmit() {
	            var _this2 = this;
	
	            var self = this;
	            this.$validator.validateAll().then(function (result) {
	                if (result) {
	                    if (self.newPet.PetType == '') {
	                        swal("Something is missing", "Please select Cat or Dog to continue.", "info");
	                        self.PetTypeSelected = false;
	                        return;
	                    }
	                    if (self.newPet.Gender == '' && self.newPet.Gender != false) {
	                        swal("Something is missing", "Please choose the correct Gender (Male or Female) to continue.", "info");
	                        self.PetGenderSelected = false;
	                        return;
	                    }
	                    if (self.newPet.AgeYears == 0 && self.newPet.AgeMonths == 0) {
	                        swal("Something is missing", "Please set the Age Years and Age Months fields.", "info");
	                        return;
	                    }
	
	                    if (self.petPhotoList.length == 0) {
	                        swal("Photo is missing", "Please upload one or more photos of your pet.", "info");
	                        return;
	                    }
	                    _this2.savePet();
	                    return;
	                }
	
	                swal("Something is missing", "Please complete all the required fields to continue.", "info");
	            });
	        },
	
	        savePet: function savePet() {
	            var self = this;
	
	            if (self.newPet.Name == '') {
	                console.log("Pet data missing");
	            } else {
	                $.ajax({
	                    type: 'POST',
	                    url: API_URL + "api/savePetData",
	                    data: (0, _stringify2.default)(self.newPet),
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    crossDomain: true,
	                    contentType: "application/json; charset=utf-8",
	                    success: function success(data) {
	                        _store2.default.getters.PetsList.push(data);
	                        self.saved = true;
	                        swal({
	                            title: "Pet successfully added!",
	                            type: "success",
	                            confirmButtonClass: 'btn-info',
	                            confirmButtonText: "OK",
	                            closeOnConfirm: true,
	                            html: true
	                        }, function () {
	                            if (self.$route.query.sitter) {
	                                _index2.default.push({ path: '/sitter/' + self.$route.query.sitter });
	                            } else {
	                                _index2.default.push({ path: '/pets-view/mypets' });
	                            }
	                        });
	                    },
	                    error: function error(data, status, _error3) {
	                        console.log("failed to save Pet" + data.responseText);
	                    }
	                });
	            }
	        },
	        getPetData: function getPetData() {
	            var self = this;
	            $.ajax({
	                type: 'GET',
	                url: API_URL + "api/getPetData/" + self.$route.params.petId,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	
	                    self.newPet = data;
	                },
	                error: function error(data, status, _error4) {
	                    console.log("failed to get Sitter Location" + data.responseText);
	                }
	            });
	        },
	        cancel: function cancel() {
	            var self = this;
	            if (self.saved == false) {
	                console.log("Left page without saving Pet");
	                $.ajax({
	                    type: 'POST',
	                    url: API_URL + "api/deletePetData/" + self.newPet.PetId,
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    dataType: "json",
	                    crossDomain: true,
	                    contentType: "application/json; charset=utf-8",
	                    success: function success(data) {},
	                    error: function error(data, status, _error5) {
	                        console.log("failed to delete Pet" + data.responseText);
	                    }
	                });
	            }
	        },
	        saveImage: function saveImage() {
	            var self = this;
	            self.uploading = true;
	            self.uploadCompletePct = '';
	
	            $('#cropPetPhotoCropper').cropper('getCroppedCanvas').toBlob(function (blob) {
	
	                var formData = new FormData();
	                formData.append('image', blob);
	
	                $.ajax("https://www.dupaws.com/services/api/postPetProfilePhoto/" + self.newPet.PetId, {
	                    type: 'POST',
	                    data: formData,
	                    xhr: function xhr() {
	                        var xhr = new window.XMLHttpRequest();
	                        xhr.upload.addEventListener("progress", function (evt) {
	                            if (evt.lengthComputable) {
	                                var percentComplete = evt.loaded / evt.total;
	                                self.uploadCompletePct = Math.round(percentComplete * 100) + "%";
	                            }
	                        }, false);
	                        return xhr;
	                    },
	                    beforeSend: function beforeSend(xhr) {
	                        xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                    },
	                    crossDomain: true,
	                    processData: false,
	                    contentType: false,
	                    success: function success(data) {
	
	                        self.petPhotoList.push(data);
	                        self.uploading = false;
	                        self.uploadedCompletePct = 0;
	                        $('#cropPetPhotoModal').modal('hide');
	                    },
	                    error: function error() {
	                        self.uploading = false;
	                        self.uploadedCompletePct = 0;
	                        console.log('Upload error');
	                    }
	                });
	            }, 'image/jpeg', 0.85);
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        var self = this;
	        if (self.editingMode == false) self.cancel();
	    },
	    updated: function updated() {
	        var self = this;
	        self.$nextTick(function () {
	            $('#cropPetPhotoModal').on('shown.bs.modal', function () {
	                $('#cropPetPhotoCropper').cropper(self.cropOptions);
	            }).on('hidden.bs.modal', function () {
	                $('#cropPetPhotoCropper').cropper('destroy');
	            });
	        });
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	
	        if (self.$route.params.petId != null) {
	            self.editingMode = true;
	            self.getPetData();
	        } else {
	            self.addNewPet();
	        }
	    },
	    components: {
	        PetPicView: _PetPicView2.default
	
	    },
	    computed: {
	        uploadStatusPct: function uploadStatusPct() {
	            var self = this;
	            return 'Uploading image ' + self.uploadCompletePct + ' complete.';
	        },
	        PetGenderSelectedComp: function PetGenderSelectedComp() {
	            if (!this.newPet) return true;
	            if (this.PetGenderSelected == true && this.newPet.Gender != '') return true;else if (this.PetGenderSelected == true && this.newPet.Gender == '') return true;else if (this.PetGenderSelected == false && this.newPet.Gender != '') return true;else return false;
	        },
	        newPetComp: function newPetComp() {
	            var self = this;
	            return self.newPet;
	        },
	        photoComp: function photoComp() {
	            return 'https://www.dupaws.com/services/images/site/addMore.jpg';
	        },
	        petPhotoList: function petPhotoList() {
	            var self = this;
	            if (self.newPet.PetPhotoDtos) {
	                return self.newPet.PetPhotoDtos;
	            }
	        },
	        uploadedImageSrcComp: function uploadedImageSrcComp() {
	            return this.uploadedImageSrc;
	        }
	    }
	};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "terms",
	  data: function data() {
	    return {
	      active: false,
	      title: "Dupaws.com Privacy Policy",
	      scrollPosition: ""
	    };
	  },
	  updated: function updated() {},
	  mounted: function mounted() {
	    this.$ga.page(this.$router);
	  },
	
	  methods: {},
	
	  computed: {},
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: "application-name", content: "Dupaws.com Pet Sitting" }, {
	      name: "description",
	      content: "Find the Perfect Pet Sitter, Cat and Dog boarding at homes.",
	      id: "desc"
	    }, { property: "fb:app_id", content: "279352372578608" }, { property: "fb:admins", content: "636428053" }, { property: "fb:pages", content: "1623158747696830" }],
	    link: [{ rel: "canonical", href: "https://www.dupaws.com/", id: "canonical" }]
	  }
	};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'alert',
	    props: {
	        message: String,
	        type: String
	    },
	    data: function data() {
	        return {};
	    },
	
	    computed: {
	        alertType: function alertType() {
	
	            return this.type;
	        }
	    }
	};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "chat",
	  props: ["transactionId", "preventChat", "isSitterAccepted"],
	  data: function data() {
	    return {
	      sender: "",
	      messages: [],
	      newMessage: "",
	      scrollPosition: ""
	    };
	  },
	  updated: function updated() {
	    var self = this;
	    $("input").focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $("input").blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	  },
	
	  methods: {
	    sendMessage: function sendMessage() {
	      var self = this;
	      if (this.newMessage.length == 0) {
	        return;
	      }
	
	      var phoneSuspect = /\d(([\. \- \_\!\@\`\~\+\<\>\,  ]){0,5}?\d){6,12}/;
	
	      if (phoneSuspect.test(this.newMessage) && this.isSitterAccepted == false) {
	        swal("Sharing Numbers", "Please do not share phone numbers until the booking is accepted", "info");
	        return;
	      }
	
	      var message = {
	        MessageText: this.newMessage,
	        SenderId: this.senderIdComp
	      };
	      self.signalRHubComp.invoke("SendMessage", this.senderIdComp, _store2.default.getters.userRole, message, self.transactionId);
	      self.newMessage = "";
	    },
	    sentDate: function sentDate(date) {
	      return moment(date).fromNow();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.signalRHubComp.invoke("LeaveChat", self.transactionId);
	    clearInterval(this.refreshInterval);
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/getReservationMessages/" + self.transactionId,
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        if (data.length > 0) self.messages = data;
	      },
	      error: function error(data, status, _error) {
	        console.log("Couldn't get reservation messages" + data.responseText);
	      }
	    });
	
	    this.refreshInterval = setInterval(function () {
	      self.$forceUpdate();
	    }, 15000);
	
	    self.signalRHubComp.on("SendMessage", function (message, transId) {
	      if (transId == self.transactionId) self.messages.push(message);
	    });
	
	    var userId;
	    if (_store2.default.getters.userRole == "Sitter") {
	      userId = _store2.default.getters.SitterId;
	    } else if (_store2.default.getters.userRole == "Client") {
	      userId = _store2.default.getters.CustomerId;
	    }
	
	    self.signalRHubComp.invoke("JoinChat", self.transactionId, userId, _store2.default.getters.userRole);
	  },
	
	  computed: {
	    senderIdComp: function senderIdComp() {
	      if (_store2.default.getters.userRole == "Client") return _store2.default.getters.CustomerId;else return _store2.default.getters.SitterId;
	    },
	    signalRHubComp: function signalRHubComp() {
	      if (_store2.default.getters.SignalRHub != null) return _store2.default.getters.SignalRHub;
	    }
	  }
	};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "contactSupport",
	  data: function data() {
	    return {
	      userRequest: "",
	      pending: true,
	      errorMsg: "",
	      alertMsg: "",
	      sent: false,
	      scrollPosition: "",
	      ticket: {
	        BookingNo: "",
	        Description: ""
	      },
	      related: true
	    };
	  },
	  updated: function updated() {
	    var self = this;
	
	
	    $("#supportTextArea").focus(function () {
	      self.scrollPosition = window.scrollY;
	    });
	    $("#supportTextArea").blur(function () {
	      self.$SmoothScroll(self.scrollPosition, 350);
	    });
	  },
	
	  methods: {
	    goLogin: function goLogin() {
	      this.$router.push({ path: "/login" });
	    },
	    goHome: function goHome() {
	      this.$router.push({ path: "/" });
	    },
	    createTicket: function createTicket() {
	      var self = this;
	      if (self.compBookingId != null && self.related == true) self.ticket.BookingNo = self.compBookingId;
	      $.ajax({
	        type: "POST",
	        url: API_URL + "api/createTicket",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        data: (0, _stringify2.default)(self.ticket),
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.ticket = data;
	          if (self.ticket.TicketNo != null) {
	            self.alertMsg = "Thank you, your Ticket No " + self.ticket.TicketNo + " has been successfuly created, we will get back to you shortly";
	            self.errorMsg = "";
	            self.sent = true;
	            self.pending = false;
	          }
	        },
	        error: function error(data, status, _error) {
	          self.sent = true;
	          self.pending = false;
	          self.errorMsg = data.responseText;
	          self.alertMsg = "";
	          console.log("couldn't create ticket" + data.responseText);
	        }
	      });
	    }
	  },
	  mounted: function mounted() {},
	  computed: {
	    checkUser: function checkUser() {
	      return _store2.default.getters.authenticated;
	    },
	    compUserName: function compUserName() {
	      if (_store2.default.getters.firstName && _store2.default.getters.lastName) return _store2.default.getters.firstName + " " + _store2.default.getters.lastName;else if (localStorage.getItem("firstName") != null && localStorage.getItem("lastName") != null) return localStorage.getItem("firstName") + " " + localStorage.getItem("lastName");else return "Guest";
	    },
	    compUserRole: function compUserRole() {
	      return _store2.default.getters.userRole;
	    },
	    compEmail: function compEmail() {
	      return _store2.default.getters.email;
	    },
	    compBookingId: function compBookingId() {
	      if (this.$route.query) {
	        return this.$route.query.bookingId;
	      }
	    }
	  }
	};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	      name: 'notfound',
	      data: function data() {
	            return {};
	      },
	
	      methods: {
	            goBack: function goBack() {
	                  _router2.default.push({ path: '/' });
	            }
	      }
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	
	    props: ['bindId'], data: function data() {
	        return {
	            active: false
	
	        };
	    },
	
	    methods: {
	        sentDate: function sentDate(date) {
	            return moment(date).fromNow();
	        },
	        deleteNotification: function deleteNotification(notification) {
	            $.ajax({
	                type: 'GET',
	                url: API_URL + "api/deleteNotification/" + notification.UserNotificationId,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    _store2.default.commit('deleteNotification', notification);
	                },
	                error: function error(data, status, _error) {
	                    console.log("failed to delete Notification" + data.responseText);
	                }
	            });
	        },
	        readNotification: function readNotification(notification) {
	            $.ajax({
	                type: 'GET',
	                url: API_URL + "api/readNotification/" + notification.UserNotificationId,
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	
	                    _store2.default.commit('readNotification', notification);
	                },
	                error: function error(data, status, _error2) {
	                    console.log("failed to mark Notification as read" + data.responseText);
	                }
	            });
	        },
	        viewNotification: function viewNotification(notification) {
	            var self = this;
	
	            if (_store2.default.getters.userRole == "Sitter") {
	                _index2.default.push({ name: 'view-sitter-reservation', params: { reservationId: notification.ServiceTransactionId } });
	            } else if (_store2.default.getters.userRole == "Client") {
	                _index2.default.push({ name: 'view-reservation', params: { reservationId: notification.ServiceTransactionId } });
	            }
	            self.readNotification(notification);
	
	            $('#' + this.bindId).removeClass('open');
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	
	        this.refreshInterval = setInterval(function () {
	            self.$forceUpdate();
	        }, 15000);
	    },
	    beforeDestroy: function beforeDestroy() {
	        var self = this;
	        clearInterval(this.refreshInterval);
	    },
	    computed: {
	        notificationsComp: function notificationsComp() {
	            if (_store2.default.getters.Notifications != null) return _store2.default.getters.Notifications.slice().reverse();
	        },
	        unreadNotificationsComp: function unreadNotificationsComp() {
	            if (_store2.default.getters.Notifications != null) return _store2.default.getters.Notifications.slice().reverse().filter(function (obj) {
	                return obj.IsRead == false;
	            });
	        }
	    }
	
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(9);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: '',
	    props: ['petId'],
	    data: function data() {
	        return {
	            petData: '',
	            profilePhotoPath: ''
	        };
	    },
	
	    methods: {
	        genderToString: function genderToString(gender) {
	            if (gender == 1) return "Male";else return "Female";
	        },
	        petTypeToString: function petTypeToString(petType) {
	            if (petType == 1) return "Dog";else if (petType == 2) return "Cat";else return "Unknown";
	        },
	        goUpdatePet: function goUpdatePet(petData) {
	            _index2.default.push({ name: 'updatePet', params: { petId: petData.PetId } });
	        },
	        ageToString: function ageToString(ageYears, ageMonths) {
	            if ((ageYears === null || ageYears == 0) && (ageMonths === null || ageMonths == 0)) return "Age not set";
	            if (ageMonths === null || ageMonths == 0) return ageYears + " years old";else if (ageYears === null || ageYears == 0) return ageMonths + " months old";else return ageYears + " years " + ageMonths + " months old";
	        }
	
	    },
	    updated: function updated() {
	        $("[data-fancybox]").fancybox({
	            modal: false,
	            selector: '[data-fancybox="pet-photo"]',
	            loop: true
	        });
	    },
	    mounted: function mounted() {
	        var self = this;
	        $.ajax("https://www.dupaws.com/services/api/getPetData/" + self.petId, {
	            type: 'GET',
	            beforeSend: function beforeSend(xhr) {
	                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	            },
	            dataType: "json",
	            contentType: "application/json; charset=utf-8",
	            crossDomain: true,
	            success: function success(data) {
	                self.petData = data;
	                $('#' + self.petId).modal('show');
	            },
	            error: function error() {
	                console.log('Couldnt get pet profile data');
	            }
	        });
	
	        $('#' + self.petId).on('hidden.bs.modal', function () {
	            self.$parent.viewPetModal = false;
	        });
	    },
	    computed: {
	        compUserRole: function compUserRole() {
	            return _store2.default.getters.userRole;
	        },
	        noPetInfoComp: function noPetInfoComp() {
	            var self = this;
	            if (self.petComp.RabiesVaccinated != true && self.petComp.TicksOrFleas != true && self.compUserRole == 'Sitter') return true;
	            return false;
	        },
	        petComp: function petComp() {
	            var self = this;
	            return self.petData;
	        },
	        profilePhotoPathComp: function profilePhotoPathComp() {
	            var self = this;
	            if (self.petComp.PetPhotoDtos) return self.petComp.PetPhotoDtos[0].Path;else return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png";
	        },
	        morePics: function morePics() {
	            var self = this;
	            if (self.petComp.PetPhotoDtos) if (self.petComp.PetPhotoDtos.length > 1) return true;else return false;
	        }
	    }
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PetDetailsView = __webpack_require__(245);
	
	var _PetDetailsView2 = _interopRequireDefault(_PetDetailsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: '',
	    props: ['petId', 'showDetails'],
	    data: function data() {
	        return {
	            petData: '',
	            profilePhotoPath: '',
	            viewPetModal: false
	        };
	    },
	
	    methods: {
	        updatePetDetails: function updatePetDetails() {
	            this.$router.push({ path: 'updatePet/' + this.petId });
	        },
	        genderToString: function genderToString(gender) {
	            if (gender == 1) return "Male";else return "Female";
	        },
	        petTypeToString: function petTypeToString(petType) {
	            if (petType == 1) return "Dog";else if (petType == 2) return "Cat";else return "Unknown";
	        },
	        viewPet: function viewPet() {
	            if (this.viewPetModal == false) this.viewPetModal = true;else this.viewPetModal == false;
	        },
	        ageToString: function ageToString(petData) {
	            var ageYears = petData.AgeYears;
	            var ageMonths = petData.AgeMonths;
	            if ((ageYears === null || ageYears == 0) && (ageMonths === null || ageMonths == 0)) return "Age not set";
	            if (ageMonths === null || ageMonths == 0) return ageYears + " years";else if (ageYears === null || ageYears == 0) return ageMonths + " months";else return ageYears + " years " + ageMonths + " month";
	        }
	
	    },
	    components: {
	        PetDetailsView: _PetDetailsView2.default
	    },
	    mounted: function mounted() {
	        var self = this;
	        $.ajax({
	            type: 'GET',
	            url: API_URL + "api/getPetData/" + self.petId,
	            beforeSend: function beforeSend(xhr) {
	                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	            },
	            dataType: "json",
	            crossDomain: true,
	            contentType: "application/json; charset=utf-8",
	            success: function success(data) {
	                self.petData = data;
	            },
	            error: function error(data, status, _error) {
	                console.log("failed to get Sitter Location" + data.responseText);
	            }
	        });
	    },
	    computed: {
	        petComp: function petComp() {
	            var self = this;
	            return self.petData;
	        },
	        profilePhotoPathComp: function profilePhotoPathComp() {
	            var self = this;
	            if (self.petComp.PetPhotoDtos) {
	                if (self.petComp.PetPhotoDtos.length > 0) return self.petComp.PetPhotoDtos[0].Path;else return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png";
	            } else return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png";
	        }
	    }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(5);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      title: "Become a Pet Sitter on Dupaws"
	    };
	  },
	
	  methods: {
	    goSitterSignup: function goSitterSignup() {
	      this.$router.push({ path: "/sitter-signup" });
	    },
	    goFindSitters: function goFindSitters() {
	      this.$router.push({ path: "/findsitters" });
	    },
	    confirmSwitchAccount: function confirmSwitchAccount() {
	      var self = this;
	      swal({
	        title: "Switch Account Confirmation",
	        text: "You are currently logged in as " + self.compUserRole + " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " + self.compUserRole + " anytime",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: "btn-success",
	        confirmButtonText: "Yes, switch account",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.switchAccount();
	      });
	    },
	    switchAccount: function switchAccount() {
	      var self = this;
	      $.ajax({
	        type: "GET",
	        url: "https://www.dupaws.com/services/api/account/SwitchRole/" + self.countryDataComp.CountryId,
	        contentType: "application/json; charset=utf-8",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        success: function success(data) {
	          self.alert = data;
	          _index2.default.logout();
	          self.$router.push({ path: "/login", query: { switch: "yes" } });
	        },
	        error: function error() {
	          try {
	            self.error = "Failed switching account";
	          } catch (e) {
	            self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    }
	  },
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: "application-name", content: "Dupaws.com Pet Sitting" }, {
	      name: "description",
	      content: "Become a Cat or Dog boarding member",
	      id: "desc"
	    }, { property: "fb:app_id", content: "279352372578608" }, {
	      property: "og:title",
	      content: "Join Dupaws and become a Cat or Dog boarding member"
	    }, { property: "og:url", content: "https://www.dupaws.com/become-a-sitter" }, {
	      property: "og:image",
	      content: "https://www.dupaws.com/services/images/site/become-a-sitter.jpg"
	    }, { property: "og:type", content: "website" }, { property: "fb:admins", content: "636428053" }, { property: "fb:pages", content: "1623158747696830" }],
	    link: [{
	      rel: "canonical",
	      href: "https://www.dupaws.com/become-a-sitter",
	      id: "canonical"
	    }]
	  },
	
	  updated: function updated() {
	    this.$ga.page(this.$router);
	  },
	
	  computed: {
	    doubleRoleComp: function doubleRoleComp() {
	      if (localStorage.getItem("doubleRole") == "True") return true;else return false;
	    },
	    checkUserComp: function checkUserComp() {
	      return _store2.default.getters.authenticated;
	    },
	    countryDataComp: function countryDataComp() {
	      return _store2.default.getters.CountryData;
	    }
	  }
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FeedbackAndPerformance = __webpack_require__(246);
	
	var _FeedbackAndPerformance2 = _interopRequireDefault(_FeedbackAndPerformance);
	
	var _Shortcuts = __webpack_require__(249);
	
	var _Shortcuts2 = _interopRequireDefault(_Shortcuts);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "dashboard",
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    sitterIdComp: function sitterIdComp() {
	      if (_store2.default.getters.SitterId != null) {
	        return "/sitter/" + _store2.default.getters.SitterId;
	      }
	    }
	  },
	  components: {
	    FeedbackAndPerformance: _FeedbackAndPerformance2.default,
	    Shortcuts: _Shortcuts2.default
	  },
	  updated: function updated() {
	    this.$ga.page(this.$router);
	  },
	
	  mounted: function mounted() {}
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "feedback",
	  data: function data() {
	    return {
	      performance: ""
	    };
	  },
	  updated: function updated() {
	    this.$ga.page(this.$router);
	    $('[data-toggle="popover"]').popover();
	    $(".disabled").click(function (e) {
	      e.preventDefault();
	    });
	  },
	  mounted: function mounted() {
	    var self = this;
	    $.ajax({
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      url: API_URL + "api/sitter/dashboardPerformance",
	      dataType: "json",
	      crossDomain: true,
	      contentType: "application/json; charset=utf-8",
	      success: function success(data) {
	        self.performance = data;
	      },
	      error: function error(data, status, _error) {
	        console.log("Couldn't get myReservations list" + data.responseText);
	      }
	    });
	  },
	
	  methods: {
	    goSubscribe: function goSubscribe() {
	      var self = this;
	      self.$router.push({ path: "/subscribe" });
	      self.$router.go({ path: "/subscribe" });
	    },
	    hasTooltip: function hasTooltip() {
	      $(function () {
	        var HasTooltip = $(".hastooltip");
	        HasTooltip.on("click", function (e) {
	          e.preventDefault();
	          var isShowing = $(this).data("isShowing");
	          HasTooltip.removeData("isShowing");
	          if (isShowing !== "true") {
	            HasTooltip.not(this).tooltip("hide");
	            $(this).data("isShowing", "true");
	            $(this).tooltip("show");
	          } else {
	            $(this).tooltip("hide");
	          }
	        }).tooltip({
	          animation: true,
	          trigger: "manual"
	        });
	      });
	    },
	    goCalendar: function goCalendar() {
	      var self = this;
	      self.$router.push({ path: "/sitter-profile-edit/calendar", force: true });
	    },
	    goBookingPreference: function goBookingPreference() {
	      var self = this;
	      self.$router.push({
	        path: "/sitter-profile-edit/servicerates",
	        force: true
	      });
	    },
	    routerGo: function routerGo(location) {
	      var self = this;
	      self.$router.push({ path: location, force: true });
	    },
	
	    shareFacebook: function shareFacebook() {
	      var self = this;
	      var myQuote = self.performanceComp.Name + " pet sitter page on Dupaws.com";
	      FB.ui({
	        method: "share",
	        href: self.performanceComp.SitterMarketingUrl,
	        quote: myQuote,
	        hashtag: "#dupaws",
	        mobile_iframe: true
	      }, function (response) {
	        if (response && !response.error_message) {} else {}
	      });
	    }
	  },
	  computed: {
	    singaporeComp: function singaporeComp() {
	      if (_store2.default.getters.CountryData.CountryId == 9) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    isActiveComp: function isActiveComp() {
	      return _store2.default.getters.SubscriptionStatus.IsActive;
	    },
	    whatsappUrl: function whatsappUrl() {
	      return "whatsapp://send?text=" + this.performanceComp.SitterMarketingUrl;
	    },
	    twitterUrl: function twitterUrl() {
	      return "https://twitter.com/share?url=" + this.performanceComp.SitterMarketingUrl + "&via=dupaws&hashtags=dupaws&text=Hey guys check out my stunning sitter profile :)";
	    },
	    linkedinUrl: function linkedinUrl() {
	      return "https://www.linkedin.com/shareArticle?mini=true&url=" + this.performanceComp.SitterMarketingUrl + "&source=LinkedIn";
	    },
	    googleUrl: function googleUrl() {
	      return "https://plus.google.com/share?url=" + this.performanceComp.SitterMarketingUrl;
	    },
	    longAvgResponseComp: function longAvgResponseComp() {
	      if (this.performanceComp != null) {
	        if (this.performanceComp.AverageResponseSeconds > 86400) {
	          return true;
	        }
	        return false;
	      }
	    },
	    responseRateComp: function responseRateComp() {
	      if (this.performanceComp != null) {
	        if (this.performanceComp.ResponseRate < 65) {
	          return true;
	        }
	        return false;
	      }
	    },
	    profileMissingInfoComp: function profileMissingInfoComp() {
	      if (this.profileStatusComp != null) if (this.profileStatusComp.ProfileMissingInfoDtos) return this.profileStatusComp.ProfileMissingInfoDtos;
	    },
	    currentStatusComp: function currentStatusComp() {
	      if (this.profileStatusComp != null) if (this.profileStatusComp.CurrentStatus) return this.profileStatusComp.CurrentStatus;
	    },
	    profileStatusComp: function profileStatusComp() {
	      var self = this;
	      if (self.performanceComp != null) if (self.performanceComp.ProfileStatusDto != null) return self.performanceComp.ProfileStatusDto;
	    },
	    performanceComp: function performanceComp() {
	      var self = this;
	      if (self.performance) return self.performance;
	      return false;
	    },
	    ratingComp: function ratingComp() {
	      var self = this;
	      if (self.performanceComp.AverageRatings > 0 && self.performanceComp.RatingsCounts > 0) {
	        return self.performanceComp.AverageRatings + "/5, profile has been rated " + self.performanceComp.RatingsCounts + " times";
	      } else return "no ratings yet";
	    }
	  }
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _ProfilePhotoView = __webpack_require__(588);
	
	var _ProfilePhotoView2 = _interopRequireDefault(_ProfilePhotoView);
	
	var _UploadBackgroundPhoto = __webpack_require__(591);
	
	var _UploadBackgroundPhoto2 = _interopRequireDefault(_UploadBackgroundPhoto);
	
	var _UploadAddMore = __webpack_require__(590);
	
	var _UploadAddMore2 = _interopRequireDefault(_UploadAddMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'about',
	    components: {
	        UploadBackgroundPhoto: _UploadBackgroundPhoto2.default,
	        ProfilePhotoView: _ProfilePhotoView2.default,
	        UploadAddMore: _UploadAddMore2.default
	
	    },
	    data: function data() {
	        return {
	            saveChanges: "Save Changes",
	            editing: false,
	            backgroundImage: false,
	            homeTypes: [{ text: 'Studio Apartment', value: 0 }, { text: '1 Bedroom Apartment', value: 1 }, { text: '2 Bedroom Apartment', value: 2 }, { text: '3 Bedroom Apartment', value: 3 }, { text: '4 Townhouse', value: 4 }, { text: '5 Villa', value: 5 }]
	
	        };
	    },
	
	    watch: {
	        'sitterProfile.SitterLocationDto.CityId': function sitterProfileSitterLocationDtoCityId(cityId) {
	            _commonApi2.default.getAreasList(cityId);
	        }
	    },
	    update: function update() {
	        $('[data-toggle="popover"]').popover();
	    },
	    methods: {
	        updateSitterProfile: function updateSitterProfile() {
	            var self = this;
	            if (!self.sitterProfile.Title || !self.sitterProfile.AboutMe) {
	                swal("Title or About Me incomplete", "Please fill in title and about me fields", "info");
	                return;
	            }
	            if (self.sitterProfile.SitterLocationDto.CityId == null || self.sitterProfile.SitterLocationDto.CityId == null) {
	                swal("Location missing", "Please fill set your location details", "info");
	                return;
	            }
	            self.saveChanges = "Saved";
	            self.editing = false;
	            _sitterApi2.default.updateSitterProfile().then(function (data) {
	                self.$parent.updateProfileStatus();
	                if (self.profileReadyComp == false) _router2.default.push({ path: '/sitter-profile-edit/petpreferences' });
	            }).fail(function (error) {
	                console.log(error);
	                swal("Save failed", error.responseJSON.Message, "error");
	            });
	        },
	        somethingChanged: function somethingChanged() {
	            this.editing = true;
	            this.saveChanges = "Changes Pending Save";
	        },
	        deleteImage: function deleteImage(photo) {
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/deletePhoto/" + photo.SitterPhotoId, {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success() {
	                    _store2.default.commit('deleteSitterPhoto', photo);
	                    self.$parent.updateProfileStatus();
	                },
	                error: function error(_error) {
	                    swal("Oops", _error.responseJSON.Message, "info");
	                }
	            });
	        }
	
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	        if (!_store2.default.getters.authenticated && !localStorage.getItem('access_token')) {
	            _router2.default.router.push({ path: '/login', query: { redirect: 'sitterprofile/about' } });
	        }
	
	        _sitterApi2.default.getSitterProfile();
	
	        if (!_store2.default.getters.SitterPhotos) {
	            _sitterApi2.default.getSitterPhotos();
	        }
	    },
	    computed: {
	        selectCityComp: function selectCityComp() {
	            if (_store2.default.getters.CountryData.CountryId != 9) {
	                return 'Select your city';
	            } else {
	                return 'Select your area';
	            }
	        },
	        sitterProfile: function sitterProfile() {
	            return _store2.default.getters.SitterProfile;
	        },
	        citiesList: function citiesList() {
	            return _store2.default.getters.CitiesList;
	        },
	        areasList: function areasList() {
	            return _store2.default.getters.AreasList;
	        },
	        sitterPhotoList: function sitterPhotoList() {
	            return _store2.default.getters.SitterPhotos;
	        },
	        profileReadyComp: function profileReadyComp() {
	            return this.$parent.profileStatus.IsProfileReady;
	        }
	    }
	
	};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _fullcalendar = __webpack_require__(79);
	
	var _fullcalendar2 = _interopRequireDefault(_fullcalendar);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'calendar',
	    data: function data() {
	        return {
	            eventTypes: [{ type: 0, title: 'Not Available for Bookings', color: '#337ab7' }, { type: 2, title: 'Fully Boarded (Only can pet sit)', color: 'green' }],
	            tempEvent: {
	                id: '',
	                title: '',
	                start: '',
	                end: '',
	                blocking: '',
	                bookingNumber: '',
	                type: '',
	                reservationId: ''
	            },
	            saving: false,
	            error: '',
	            alert: '',
	            datepicked: '',
	            newEvent: {
	                id: '',
	                title: '',
	                eventType: 0,
	                start: '',
	                color: '',
	                end: ''
	            },
	            events: []
	        };
	    },
	
	    methods: {
	        goDashboard: function goDashboard() {
	            var self = this;
	            if (self.compUserRole == "Sitter" && localStorage.getItem('phoneConfirmed') == "False") {
	
	                swal({
	                    title: "Mobile needs verifcation",
	                    text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
	                    type: "success",
	                    showCancelButton: true,
	                    confirmButtonClass: 'btn-success',
	                    confirmButtonText: "Yes take me there!",
	                    cancelButtonText: "Later",
	                    allowOutsideClick: false,
	                    closeOnConfirm: true
	                }, function (isConfirm) {
	                    if (isConfirm) {
	                        self.$router.push({ path: '/account', force: true });
	                        return;
	                    } else {
	                        self.$router.push({ path: '/dashboard/feedback-performance', force: true });
	                    }
	                });
	            } else {
	                self.$router.push({ path: '/dashboard/feedback-performance', force: true });
	            }
	        },
	        initCalendar: function initCalendar() {
	
	            self = this;
	            var now = new Date();
	            $('#calendar').fullCalendar({
	
	                selectable: true,
	                dayRender: function dayRender(date, cell) {
	                    if (date < now) {
	                        $(cell).addClass('disabled');
	                    }
	                },
	                allDay: true,
	                ignoreTimezone: false,
	                selectLongPressDelay: 50,
	                displayEventTime: false,
	                eventLongPressDelay: 50,
	                eventRender: function eventRender(event, element) {
	                    if (event.type == 0 || event.eventType == 0) element.find('.fc-content').prepend(" <i style='display: initial; margin-left:2px;' class='fa fa-plane'/> ");else if (event.type == 1 || event.eventType == 1) element.find('.fc-content').prepend("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> ");else if (event.type == 2 || event.eventType == 2) element.find('.fc-content').prepend("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> ");
	                },
	                select: function select(start, end) {
	
	                    if (start <= now) {
	                        start = moment(now).format('YYYY-MM-DD');
	                    }
	
	                    var tempStart = moment(start);
	                    var tempStartTz = tempStart.tz("Asia/Dubai");
	                    var tempEnd = moment(end);
	                    var tempEndTz = tempEnd.tz("Asia/Dubai");
	
	                    var duration = moment.duration(tempEndTz.diff(tempStartTz));
	                    var hours = duration.asHours();
	                    if (duration.asHours() <= 24) {
	
	                            tempEndTz = moment(tempEndTz).subtract(23, "hours");
	                        } else {
	                        tempEndTz = moment(tempEndTz).subtract(1, "days");
	                    }
	
	                    self.newEvent.start = moment(tempStartTz).format('YYYY-MM-DD');
	                    self.newEvent.end = moment(tempEndTz).format('YYYY-MM-DD');
	
	                    $('#datetimepickerFrom').datepicker('setDate', moment(self.newEvent.start).format('YYYY-MM-DD'));
	
	                    $('#datetimepickerFrom').datepicker().on('changeDate', function (selected) {
	                        self.newEvent.start = moment(selected.date).format('YYYY-MM-DD');
	                    });
	
	                    $('#datetimepickerTo').datepicker('setDate', moment(self.newEvent.end).format('YYYY-MM-DD'));
	
	                    $('#datetimepickerTo').datepicker().on('changeDate', function (selected) {
	                        self.newEvent.end = moment(selected.date).format('YYYY-MM-DD');
	                    });
	
	                    $('#newEntryModal').modal('toggle');
	                },
	                editable: true,
	                eventClick: function eventClick(event) {
	                    self.tempEvent.id = event.id;
	                    self.tempEvent.title = event.title;
	                    self.tempEvent.blocking = event.blocking, self.tempEvent.bookingNumber = event.bookingNumber, self.tempEvent.reservationId = event.reservationId;
	                    if (event.eventType != null) {
	                        self.tempEvent.type = event.eventType;
	                    } else if (event.type != null) {
	                        self.tempEvent.type = event.type;
	                    } else {
	                        self.tempEvent.type = 0;
	                    }
	                    self.tempEvent.start = moment(event.start._d).format('MMM Do');
	                    if (event.end) {
	                        self.tempEvent.end = moment(event.end._d).format('MMM Do');
	                    } else {
	                        self.tempEvent.end = moment(event.start._d).add(1, 'days').format('MMM Do');
	                    }
	                    $('#calModal').modal('toggle');
	                    $('#calModal').on('hidden.bs.modal', function () {
	
	                        self.tempEvent = {
	                            id: '',
	                            title: '',
	                            start: '',
	                            end: '',
	                            type: '',
	                            blocking: '',
	                            reservationId: ''
	                        };
	                    });
	                },
	                header: {
	                    center: 'title',
	                    right: 'next',
	                    left: 'prev'
	                }
	            });
	
	            $('#datetimepickerFrom').datepicker({
	                autoclose: true,
	                ignoreReadonly: true,
	                allowInputToggle: true,
	                format: 'yyyy-mm-dd',
	                beforeShowDay: function beforeShowDay(date) {
	                    return date.valueOf() >= now;
	                }
	            });
	
	            $('#datetimepickerTo').datepicker({
	                format: 'yyyy-mm-dd',
	                beforeShowDay: function beforeShowDay(date) {
	                    if (!$('#datetimepickerFrom').datepicker("getDate")) {
	                        return date.valueOf() >= now;
	                    } else {
	                        return date.valueOf() > $('#datetimepickerFrom').datepicker("getDate");
	                    }
	                },
	                ignoreReadonly: true,
	                allowInputToggle: true,
	                disableTouchKeyboard: true,
	                autoclose: true
	            });
	        },
	
	        goReservation: function goReservation(reservationId) {
	            $('#calModal').modal('hide');
	            this.$router.push({ name: 'view-sitter-reservation', params: { reservationId: reservationId } });
	        },
	        noBlocking: function noBlocking(eventId) {
	            self = this;
	
	            $.ajax({
	                type: 'POST',
	                url: 'https://www.dupaws.com/services/api/updateEvent/' + eventId,
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success() {
	                    self.tempEvent.blocking = !self.tempEvent.blocking;
	                    if (self.tempEvent.color == "green") {
	                        self.tempEvent.color = "#ff0066";
	                    } else {
	                        self.tempEvent.color = "green";
	                    }
	
	                    $('#calendar').fullCalendar('removeEventSources');
	
	                    var index = self.events.findIndex(function (t) {
	                        return t.id === eventId;
	                    });
	                    if (index != null && self.events.length > 0) {
	                        self.events[index].blocking = !self.events[index].blocking;
	
	                        if (self.events[index].color == "green") {
	                            self.events[index].color = "#ff0066";
	                        } else {
	                            self.events[index].color = "green";
	                        }
	                    }
	
	                    $('#calendar').fullCalendar('addEventSource', self.events);
	                },
	                error: function error() {
	                    try {
	                        self.error = "Couldn't update Event sorry";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        },
	        initEvents: function initEvents() {
	            self = this;
	            $.ajax({
	                type: 'GET',
	                url: 'https://www.dupaws.com/services/api/getEvents',
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    var tempEvents = [];
	                    if (data) {
	
	                        var len = data.length;
	                        for (var i = 0; i < len; i++) {
	                            tempEvents.push({
	                                id: data[i].Id,
	                                start: moment(data[i].Start).format('YYYY-MM-DD'),
	                                end: moment(data[i].End).add(12, 'hours').format('YYYY-MM-DD HH'),
	                                title: data[i].Title,
	                                bookingNumber: data[i].BookingNumber,
	                                type: data[i].EventType,
	                                color: data[i].Color,
	                                blocking: data[i].Blocking,
	                                reservationId: data[i].ReservationId
	                            });
	                        }
	
	                        self.events = tempEvents;
	
	                        $('#calendar').fullCalendar('addEventSource', self.events);
	                    } else {}
	                },
	                error: function error() {
	                    try {
	                        self.error = "Couldn't add Event sorry";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	
	            $('#calendar').fullCalendar('rerenderEvents');
	        },
	        cancelEvent: function cancelEvent() {
	
	            $('#newEntryModal').modal('hide');
	            this.newEvent = {
	                id: '',
	                title: '',
	                start: '',
	                end: '',
	                type: 0
	            };
	        },
	        saveEvent: function saveEvent() {
	            self = this;
	
	            self.newEvent.title = self.eventTypes.find(function (obj) {
	                return obj.type === self.newEvent.eventType;
	            }).title;
	
	            self.newEvent.color = self.eventTypes.find(function (obj) {
	                return obj.type === self.newEvent.eventType;
	            }).color;
	
	            self.saving = true;
	            if (self.newEvent.start > self.newEvent.end) {
	                swal("Oops", "Please make sure the start date begins before end date", "info");
	                return;
	            }
	            $.ajax({
	                type: 'POST',
	                url: 'https://www.dupaws.com/services/api/addEvent',
	                data: (0, _stringify2.default)(self.newEvent),
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	                    self.newEvent.id = data.Id;
	                    self.newEvent.end = moment(self.newEvent.end).add(12, 'hours').format('YYYY-MM-DD HH');
	                    $('#calendar').fullCalendar('renderEvent', self.newEvent, true);
	
	                    self.newEvent = {
	                        id: '',
	                        title: '',
	                        start: '',
	                        end: '',
	                        eventType: 0
	
	                    };
	
	                    $('#newEntryModal').modal('hide');
	                    self.saving = false;
	                },
	                error: function error() {
	                    try {
	                        self.error = "Couldn't add Event sorry";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        },
	        addNewEventButton: function addNewEventButton() {
	            var self = this;
	            var now = new Date();
	            self.newEvent.title = "Traveling";
	
	            self.newEvent.type = 0;
	            var tempStart = moment(now);
	            var tempStartTz = tempStart.tz("Asia/Dubai");
	            var tempEnd = moment(tempStart).add(1, 'd');
	            var tempEndTz = tempEnd.tz("Asia/Dubai");
	
	            var duration = moment.duration(tempEndTz.diff(tempStartTz));
	            var hours = duration.asHours();
	            if (duration.asHours() <= 24) {
	
	                    tempEndTz = moment(tempEndTz).subtract(23, "hours");
	                } else {
	                tempEndTz = moment(tempEndTz).subtract(1, "days");
	            }
	
	            self.newEvent.start = moment(tempStartTz).format('YYYY-MM-DD');
	            self.newEvent.end = moment(tempEndTz).format('YYYY-MM-DD');
	
	            $('#datetimepickerFrom').datepicker('setDate', moment(self.newEvent.start).format('YYYY-MM-DD'));
	
	            $('#datetimepickerFrom').datepicker().on('changeDate', function (selected) {
	                self.newEvent.start = moment(selected.date).format('YYYY-MM-DD');
	            });
	
	            $('#datetimepickerTo').datepicker('setDate', moment(self.newEvent.end).format('YYYY-MM-DD'));
	
	            $('#datetimepickerTo').datepicker().on('changeDate', function (selected) {
	                self.newEvent.end = moment(selected.date).format('YYYY-MM-DD');
	            });
	
	            $('#newEntryModal').modal('toggle');
	        },
	        deleteEvent: function deleteEvent() {
	            var self = this;
	            var id = self.tempEvent.id;
	            $.ajax({
	                type: 'POST',
	                url: 'https://www.dupaws.com/services/api/deleteEvent/' + id,
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                success: function success(data) {
	
	                    $('#calendar').fullCalendar('removeEvents', self.tempEvent.id);
	                    $('#calModal').modal('hide');
	
	                    self.tempEvent = {
	                        id: '',
	                        title: '',
	                        start: '',
	                        end: ''
	                    };
	                },
	                error: function error() {
	                    try {
	                        self.error = "Couldn't delete Event sorry";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        }
	    },
	    created: function created() {},
	    mounted: function mounted() {
	        self = this;
	        this.$ga.page(this.$router);
	
	        self.initEvents();
	        self.initCalendar();
	    },
	    updated: function updated() {
	        $('#datetimePreventFrom').click(function (event) {
	            event.preventDefault();
	        });
	
	        $('#datetimePreventTo').click(function (event) {
	            event.preventDefault();
	        });
	    },
	    beforeDestroy: function beforeDestroy() {
	        $('#calendar').fullCalendar('destroy');
	    },
	
	    computed: {
	        scheduleComp: function scheduleComp() {
	            if (this.saving == false) {
	                return 'Schedule and Calendar';
	            } else if (this.saving == true) {
	                return 'Saving..';
	            }
	        },
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        eventsComp: function eventsComp() {
	            return this.events;
	        },
	        compUserRole: function compUserRole() {
	            return _store2.default.getters.userRole;
	        }
	
	    }
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'CalendarView',
	    props: ['sitterId'],
	    data: function data() {
	        return {
	            tempEvent: {
	                id: '',
	                title: '',
	                start: '',
	                end: ''
	            },
	            error: '',
	            alert: '',
	            datepicked: '',
	            newEvent: {
	                id: '',
	                title: '',
	                start: '',
	                end: ''
	            },
	            events: []
	        };
	    },
	
	    methods: {
	        initCalendar: function initCalendar() {
	
	            self = this;
	            var now = new Date();
	            $('#calendar').fullCalendar({
	                selectable: false,
	                dayRender: function dayRender(date, cell) {
	                    if (date < now) {
	                        $(cell).addClass('disabled');
	                    }
	                },
	                height: 'auto',
	                allDay: true,
	                displayEventTime: false,
	                ignoreTimezone: false,
	                header: {
	                    left: 'title',
	                    center: '',
	                    right: 'prev,next'
	
	                },
	                eventRender: function eventRender(event, element) {
	                    if (event.end < new Date()) {
	                        element.hide();
	                    }
	                    if (event.type == 0) element.find('.fc-content').prepend(" <i style='display: initial; margin-left:2px;' class='fa fa-plane'/> ");else if (event.type == 1) element.find('.fc-content').prepend("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> ");
	                }
	            });
	        },
	        initEvents: function initEvents() {
	            self = this;
	            $.ajax({
	                type: 'GET',
	                url: 'https://www.dupaws.com/services/public/GetPublicEvents/' + self.sitterId,
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	
	                success: function success(data) {
	                    var tempEvents = [];
	                    if (data) {
	
	                        var len = data.length;
	                        for (var i = 0; i < len; i++) {
	                            tempEvents.push({
	                                start: moment(data[i].Start).format('YYYY-MM-DD'),
	                                end: moment(data[i].End).add(12, 'hours').format('YYYY-MM-DD HH'),
	                                title: data[i].Title,
	                                type: data[i].EventType,
	                                color: data[i].Color,
	                                blocking: data[i].Blocking
	                            });
	                        }
	
	                        self.events = tempEvents;
	                        $('#calendar').fullCalendar('addEventSource', self.events);
	                    } else {
	                        console.log("no events found");
	                    }
	                },
	                error: function error() {
	                    try {
	                        self.error = "Couldn't connect to server, please try again later";
	                    } catch (e) {
	                        self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	                    }
	                }
	            });
	        }
	    },
	    created: function created() {},
	    mounted: function mounted() {
	        self = this;
	
	        self.initEvents();
	        self.initCalendar();
	    },
	    beforeDestroy: function beforeDestroy() {
	        $('#calendar').fullCalendar('destroy');
	    },
	
	    computed: {
	        errorMsg: function errorMsg() {
	            return this.error;
	        },
	        alertMsg: function alertMsg() {
	            return this.alert;
	        },
	        eventsComp: function eventsComp() {
	            return this.events;
	        }
	
	    }
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _swiper = __webpack_require__(534);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _awesomplete = __webpack_require__(252);
	
	var _awesomplete2 = _interopRequireDefault(_awesomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(410);
	__webpack_require__(401);
	
	exports.default = {
	  name: "dogwalking",
	  props: ["cityId"],
	  components: {},
	
	  data: function data() {
	    return {
	      dogWalkingProfile: "",
	      myPlaceholder: "Add location or multiple locations",
	      allDays: false,
	      days: 0,
	      sun: 0,
	      mon: 0,
	      tue: 0,
	      wed: 0,
	      thu: 0,
	      fri: 0,
	      sat: 0
	    };
	  },
	
	  watch: {},
	  update: function update() {},
	  created: function created() {},
	
	  methods: {
	    saveChanges: function saveChanges() {
	      var self = this;
	      if (this.allDays == true) self.dogWalkingProfile.DaysOfWeek = 127;else {
	        self.dogWalkingProfile.DaysOfWeek = this.sun | this.mon | this.tue | this.wed | this.thu | this.fri | this.sat;
	      }
	
	      var self = this;
	      $.ajax({
	        type: "POST",
	        data: (0, _stringify2.default)(self.dogWalkingProfile),
	        url: "https://www.dupaws.com/services/api/dogWalkingProfile/",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          console.log("success saving post");
	          $("#dogWalkingModal").modal("hide");
	        },
	        error: function error(data, status, _error) {
	          try {} catch (e) {}
	        }
	      });
	    },
	    removeLocation: function removeLocation(location) {
	      var self = this;
	      var index = self.dogWalkingProfile.Areas.findIndex(function (t) {
	        return t.AreaId === location.AreaId;
	      });
	      self.dogWalkingProfile.Areas.splice(index, 1);
	    },
	    getDogWalkingProfile: function getDogWalkingProfile() {
	      var self = this;
	      $.ajax({
	        type: "GET",
	        url: "https://www.dupaws.com/services/api/dogWalkingProfile/",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        dataType: "json",
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.dogWalkingProfile = data;
	          if (data.DaysOfWeek == 127) {
	            self.allDays = true;
	          }
	          self.sun = data.DaysOfWeek & 1;
	          self.mon = data.DaysOfWeek & 2;
	          self.tue = data.DaysOfWeek & 4;
	          self.wed = data.DaysOfWeek & 8;
	          self.thu = data.DaysOfWeek & 16;
	          self.fri = data.DaysOfWeek & 32;
	          self.sat = data.DaysOfWeek & 64;
	        },
	        error: function error(data, status, _error2) {
	          try {} catch (e) {}
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    this.$ga.page(this.$router);
	    self.getDogWalkingProfile();
	    _commonApi2.default.getAreasList(self.cityId).done(function () {
	      console.log("success areas list");
	      var input = document.getElementById("myinput");
	      new _awesomplete2.default(input, {
	        minChars: 1,
	        maxItems: 15,
	        autoFirst: true,
	        list: self.areasList,
	        replace: function replace(suggestion) {
	          this.input.value = "";
	        },
	        data: function data(item, input) {
	          return { label: item.AreaName, value: item.AreaId };
	        }
	      });
	      input.addEventListener("awesomplete-select", function (item) {
	        var newArea = { AreaName: item.text.label, AreaId: item.text.value };
	        if (self.dogWalkingProfile.Areas.length < 5) self.dogWalkingProfile.Areas.push(newArea);else {
	          swal("Info", "Maximum number of areas you can add is 5", "info");
	        }
	      });
	    });
	
	    if (!_store2.default.getters.authenticated && !localStorage.getItem("access_token")) {
	      _router2.default.router.push({
	        path: "/login",
	        query: { redirect: "sitterprofile/about" }
	      });
	    }
	
	    var countriesSwiper = new _swiper2.default("#countriesSwiper", {
	      spaceBetween: 30,
	      slidesPerView: "auto",
	
	      observer: true,
	      observeParents: true,
	      pagination: {
	        el: ".swiper-pagination",
	        clickable: true
	      },
	      navigation: {
	        nextEl: ".swiper-button-next",
	        prevEl: ".swiper-button-prev"
	      },
	      breakpoints: {
	        480: {
	          slidesPerView: "auto",
	          spaceBetween: 20,
	          width: 300
	        },
	
	        640: {
	          slidesPerView: "auto",
	          spaceBetween: 30,
	          width: 480
	        }
	      }
	    });
	  },
	  computed: {
	    areasList: function areasList() {
	      return _store2.default.getters.AreasList;
	    }
	  }
	};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'PetPrefs',
	    data: function data() {
	        return {
	            saveChanges: "Save Changes",
	            editing: false
	
	        };
	    },
	
	
	    methods: {
	        updateSitterPetPrefs: function updateSitterPetPrefs() {
	            var self = this;
	            if (self.sitterPetPrefs.AcceptCats == false && self.sitterPetPrefs.AcceptSmallDogs == false && self.sitterPetPrefs.AcceptMediumDogs == false && self.sitterPetPrefs.AcceptLargeDogs == false) {
	                swal("Something is missing", "Please accept at least cats or dogs to enable your profile", "info");
	                return;
	            }
	            self.saveChanges = "Saving..";
	            _sitterApi2.default.updateSitterPetPrefs().then(function () {
	                self.saveChanges = "Saved";
	                self.editing = false;
	                self.$parent.updateProfileStatus();
	                if (self.profileReadyComp == false) _router2.default.push({ path: '/sitter-profile-edit/servicerates' });
	            }).fail(function () {
	                self.saveChanges = "Failed to Save";
	                self.editing = false;
	            });
	        },
	        somethingChanged: function somethingChanged() {
	            this.editing = true;
	            this.saveChanges = "Changes Pending Save";
	        }
	
	    },
	    created: function created() {
	        var self = this;
	        this.$ga.page(this.$router);
	        if (!_store2.default.getters.authenticated && !localStorage.getItem('access_token')) {
	            _router2.default.router.push({ path: '/login', query: { redirect: 'sitterprofile/petpreferences' } });
	        }
	
	        if (!_store2.default.getters.SitterPetPrefs) {
	            _sitterApi2.default.getSitterPetPrefs();
	        }
	    },
	    computed: {
	        sitterPetPrefs: function sitterPetPrefs() {
	            return _store2.default.getters.SitterPetPrefs;
	        },
	        profileReadyComp: function profileReadyComp() {
	            return this.$parent.profileStatus.IsProfileReady;
	        }
	
	    }
	
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ProfilePhotoView",
	  props: {
	    photoIdProp: String,
	    index: Number
	  },
	  data: function data() {
	    return {
	      filePath: "",
	      profilePhoto: {
	        Path: "",
	        SitterPhotoId: 0,
	        Type: ""
	      },
	      uploadedImageSrc: ""
	    };
	  },
	
	  created: function created() {
	    var self = this;
	    $.ajax("https://www.dupaws.com/services/api/getSitterProfilePhoto/" + self.photoIdProp, {
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      contentType: "application/json; charset=utf-8",
	      crossDomain: true,
	      success: function success(data) {
	        self.profilePhoto = data;
	      },
	      error: function error() {
	        console.log('Couldnt get sitter profile photo "api/getSitterProfilePhoto"');
	      }
	    });
	  },
	  computed: {
	    photoComp: function photoComp() {
	      self = this;
	      if (self.profilePhoto.Path) return "https://www.dupaws.com/services/" + self.profilePhoto.Path;
	    },
	    photoIdComp: function photoIdComp() {
	      return this.profilePhoto.SitterPhotoId;
	    }
	  }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _DogWalking = __webpack_require__(586);
	
	var _DogWalking2 = _interopRequireDefault(_DogWalking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'servicerates',
	    data: function data() {
	        return {
	            tempValue: '',
	            saveChanges: "Save Changes",
	            editing: false
	
	        };
	    },
	
	    components: {
	        DogWalking: _DogWalking2.default
	    },
	    watch: {
	        selectedLocations: function selectedLocations() {
	            if (this.selectedLocations.length > 0) {
	                this.myPlaceholder = 'You can add more locations';
	            } else {
	                this.myPlaceholder = 'Add location or multiple locations';
	            }
	        }
	    },
	    methods: {
	
	        checkCityId: function checkCityId(service) {
	            console.log(service);
	            if (this.sitterServices.CityId == null && service.ServiceType == 6) {
	                swal("Oopsy", "It seems you forgot to fill your Location details, we have taken you back to About Me page to complete them first.", "info");
	
	                service.IsOffered = false;
	            }
	        },
	        dogWalkingShow: function dogWalkingShow() {
	            $('#dogWalkingModal').modal('toggle');
	        },
	        goDashboard: function goDashboard() {
	            var self = this;
	
	            if (self.compUserRole == "Sitter" && localStorage.getItem('phoneConfirmed') == "False") {
	                swal({
	                    title: "Mobile needs verifcation",
	                    text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
	                    type: "success",
	                    showCancelButton: true,
	                    confirmButtonClass: 'btn-success',
	                    confirmButtonText: "Yes take me there!",
	                    cancelButtonText: "Later",
	                    allowOutsideClick: false,
	                    closeOnConfirm: true
	                }, function (isConfirm) {
	                    if (isConfirm) {
	                        self.$router.push({ path: '/account', force: true });
	                        return;
	                    } else {
	                        _router2.default.push({ path: '/sitter-profile-edit/calendar' });
	                    }
	                });
	            } else {
	                _router2.default.push({ path: '/sitter-profile-edit/calendar' });
	            }
	        },
	
	        updateSitterServices: function updateSitterServices() {
	            var self = this;
	
	            var index = this.sitterServices.SitterServicesDto.findIndex(function (t) {
	                return t.IsOffered === true;
	            });
	            if (index == null || index == -1) {
	                swal("Something is missing", "Please add at least one service to your profile", "info");
	                return;
	            }
	
	            self.saveChanges = "Saving..";
	            _sitterApi2.default.updateSitterServices().then(function () {
	                self.saveChanges = "Saved";
	                self.editing = false;
	                self.$parent.updateProfileStatus();
	                if (self.profileReadyComp == false) self.goDashboard();
	            }).fail(function () {
	                self.saveChanges = "Failed to Save";
	                self.editing = false;
	            });
	        },
	        somethingChanged: function somethingChanged() {
	            this.editing = true;
	            this.saveChanges = "Changes Pending Save";
	        }
	
	    },
	    created: function created() {
	        var self = this;
	
	        if (!_store2.default.getters.authenticated && !localStorage.getItem('access_token')) {
	            _router2.default.router.push({ path: '/login', query: { redirect: 'sitterprofile/servicerates' } });
	        }
	        if (!_store2.default.getters.SitterServices) {
	            _sitterApi2.default.getSitterServices();
	        }
	    },
	    mounted: function mounted() {},
	    updated: function updated() {
	        this.$ga.page(this.$router);
	    },
	
	    computed: {
	        sitterServices: function sitterServices() {
	            return _store2.default.getters.SitterServices;
	        },
	        compUserRole: function compUserRole() {
	            return _store2.default.getters.userRole;
	        },
	        profileReadyComp: function profileReadyComp() {
	            return this.$parent.profileStatus.IsProfileReady;
	        }
	
	    }
	
	};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _blueimpLoadImage = __webpack_require__(38);
	
	var _blueimpLoadImage2 = _interopRequireDefault(_blueimpLoadImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "UploadAddMore",
	  data: function data() {
	    return {
	      filePath: "",
	      cropOptions: {
	        aspectRatio: 5 / 5,
	        background: false,
	        autoCropArea: 0.8,
	        checkCrossOrigin: true,
	        modal: true,
	        preview: ".img-preview",
	        checkOrientation: false
	      },
	      cropNames: {
	        cropMe: "cropMeAddMore",
	        modal: "cropModalAddMore"
	      },
	      uploadCompletePct: "",
	      uploading: false,
	      profilePhoto: {
	        Path: "",
	        SitterPhotoId: 0,
	        Type: ""
	      },
	      uploadedImageSrc: ""
	    };
	  },
	
	  methods: {
	    previewThumbnail: function previewThumbnail(event) {
	      var orientationVal = true;
	      var input = event.target;
	      if (input.files && input.files[0]) {
	        var self = this;
	        self.uploadCompletePct = "";
	        var file = input.files[0];
	
	        _blueimpLoadImage2.default.parseMetaData(file, function (data) {
	          if (data.exif) {
	            orientationVal = data.exif.get("Orientation");
	          } else orientationVal = true;
	
	          var loadingImage = (0, _blueimpLoadImage2.default)(file);
	
	          loadingImage.onload = function (e) {
	            var scaledImage = _blueimpLoadImage2.default.scale(loadingImage, { orientation: orientationVal });
	
	            var canvas = document.createElement("canvas");
	            var ctx = canvas.getContext("2d");
	
	            var maxWidth = 800,
	                maxHeight = 800,
	                imageWidth = scaledImage.width,
	                imageHeight = scaledImage.height;
	
	            if (imageWidth > imageHeight) {
	              if (imageWidth > maxWidth) {
	                imageHeight *= maxWidth / imageWidth;
	                imageWidth = maxWidth;
	              }
	            } else {
	              if (imageHeight > maxHeight) {
	                imageWidth *= maxHeight / imageHeight;
	                imageHeight = maxHeight;
	              }
	            }
	            canvas.width = imageWidth;
	            canvas.height = imageHeight;
	
	            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);
	
	            var finalFile = canvas.toDataURL("image/png");
	
	            $("#" + self.cropNames.modal).modal("show");
	            self.uploadedImageSrc = finalFile;
	          };
	        });
	      }
	    },
	    cancelSave: function cancelSave() {},
	    saveImage: function saveImage() {
	      var self = this;
	      self.uploading = true;
	      self.uploadCompletePct = "";
	      $("#" + self.cropNames.cropMe).cropper("getCroppedCanvas").toBlob(function (blob) {
	        var formData = new FormData();
	        formData.append("image", blob);
	
	        $.ajax("https://www.dupaws.com/services/api/postSitterProfilePhoto/" + 1, {
	          type: "POST",
	          data: formData,
	          xhr: function xhr() {
	            var xhr = new window.XMLHttpRequest();
	            xhr.upload.addEventListener("progress", function (evt) {
	              if (evt.lengthComputable) {
	                var percentComplete = evt.loaded / evt.total;
	                self.uploadCompletePct = Math.round(percentComplete * 100) + "%";
	              }
	            }, false);
	            return xhr;
	          },
	          beforeSend: function beforeSend(xhr) {
	            xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	          },
	
	          cache: false,
	          crossDomain: true,
	          processData: false,
	          contentType: false,
	          success: function success(data) {
	            _store2.default.getters.SitterPhotos.push(data);
	            self.uploading = false;
	            self.uploadCompletePct = "";
	            $("#" + self.cropNames.modal).modal("hide");
	            self.$parent.$parent.updateProfileStatus();
	          },
	          error: function error() {
	            self.uploadCompletePct = "";
	            self.uploading = false;
	          }
	        });
	      }, "image/jpeg", 0.85);
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    $("#" + self.cropNames.modal).on("shown.bs.modal", function () {
	      $("#" + self.cropNames.cropMe).cropper(self.cropOptions);
	    }).on("hidden.bs.modal", function () {
	      $("#" + self.cropNames.cropMe).cropper("destroy");
	    });
	  },
	  computed: {
	    uploadStatusPct: function uploadStatusPct() {
	      var self = this;
	      return "Uploading image " + self.uploadCompletePct + " complete.";
	    },
	    photoComp: function photoComp() {
	      return "https://www.dupaws.com/services/images/site/addMore.jpg";
	    }
	  }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _blueimpLoadImage = __webpack_require__(38);
	
	var _blueimpLoadImage2 = _interopRequireDefault(_blueimpLoadImage);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataURLtoBlob = __webpack_require__(69);
	exports.default = {
	  name: "UploadBackgroundPhoto",
	  data: function data() {
	    return {
	      filePath: "",
	      cropOptions: {
	        aspectRatio: 16 / 9,
	        background: false,
	        autoCropArea: 1.0,
	        strict: true,
	        guides: false,
	        highlight: false,
	        dragCrop: false,
	        zoomable: true,
	        checkCrossOrigin: true,
	        cropBoxResizable: false,
	        modal: true,
	        preview: ".img-preview"
	      },
	      uploadCompletePct: "",
	      uploading: false,
	      photo: {
	        Path: "",
	        SitterPhotoId: 0
	      },
	      uploadedImageSrc: ""
	    };
	  },
	
	  methods: {
	    previewThumbnail: function previewThumbnail(event) {
	      var orientationVal = true;
	      var input = event.target;
	      if (input.files && input.files[0]) {
	        var self = this;
	        self.uploadCompletePct = "";
	        var file = input.files[0];
	
	        _blueimpLoadImage2.default.parseMetaData(file, function (data) {
	          if (data.exif) {
	            orientationVal = data.exif.get("Orientation");
	          } else orientationVal = true;
	          var loadingImage = (0, _blueimpLoadImage2.default)(file);
	
	          loadingImage.onload = function (e) {
	            var scaledImage = _blueimpLoadImage2.default.scale(loadingImage, { orientation: orientationVal });
	
	            var canvas = document.createElement("canvas");
	            var ctx = canvas.getContext("2d");
	
	            var maxWidth = 1920,
	                maxHeight = 1080,
	                imageWidth = scaledImage.width,
	                imageHeight = scaledImage.height;
	
	            if (imageWidth > imageHeight) {
	              if (imageWidth > maxWidth) {
	                imageHeight *= maxWidth / imageWidth;
	                imageWidth = maxWidth;
	              }
	            } else {
	              if (imageHeight > maxHeight) {
	                imageWidth *= maxHeight / imageHeight;
	                imageHeight = maxHeight;
	              }
	            }
	            canvas.width = imageWidth;
	            canvas.height = imageHeight;
	
	            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);
	
	            var finalFile = canvas.toDataURL("image/png");
	
	            $("#modalBackground").modal("show");
	            self.uploadedImageSrc = finalFile;
	          };
	        });
	      }
	    },
	    saveImage: function saveImage() {
	      var self = this;
	      self.uploading = true;
	      self.uploadCompletePct = "";
	
	      var dataUrlImage = $("#cropMeBackground").cropper("getCroppedCanvas").toDataURL("image/jpeg");
	
	      var blob = dataURLtoBlob(dataUrlImage);
	
	      var formData = new FormData();
	
	      formData.append("image", blob);
	
	      $.ajax("https://www.dupaws.com/services/api/postSitterBackgroundPhoto", {
	        type: "POST",
	        xhr: function xhr() {
	          var xhr = new window.XMLHttpRequest();
	          xhr.upload.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              self.uploadCompletePct = Math.round(percentComplete * 100) + "%";
	            }
	          }, false);
	          return xhr;
	        },
	        data: formData,
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	        },
	        crossDomain: true,
	        processData: false,
	        contentType: false,
	        success: function success(data) {
	          self.photo = data;
	          self.uploading = false;
	          self.uploadedCompletePct = 0;
	          self.$parent.$parent.updateProfileStatus();
	        },
	        error: function error() {
	          console.log("Upload error");
	          self.uploadedCompletePct = 0;
	          self.uploading = false;
	        }
	      });
	    },
	    cancelSave: function cancelSave() {},
	    deleteImage: function deleteImage() {
	      var self = this;
	      if (!this.photo.SitterPhotoId) {
	        console.log("No photo to delete");
	        return;
	      } else {
	        swal("", "Please click on Change Background Image instead", "info");
	      }
	    }
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    var self = this;
	    if (!_store2.default.getters.authenticated && !localStorage.getItem("access_token")) {
	      _router2.default.router.push({ path: "/login", query: { redirect: "home" } });
	    }
	
	    $.ajax("https://www.dupaws.com/services/api/getSitterBackgroundPhoto", {
	      type: "GET",
	      beforeSend: function beforeSend(xhr) {
	        xhr.setRequestHeader("Authorization", "bearer " + localStorage.getItem("access_token"));
	      },
	      dataType: "json",
	      contentType: "application/json; charset=utf-8",
	      crossDomain: true,
	      success: function success(data) {
	        self.photo = data;
	      },
	      error: function error() {
	        console.log('Couldnt get sitter background photo "api/getSitterBackgroundPhoto"');
	      }
	    });
	
	    $("#modalBackground").on("shown.bs.modal", function () {
	      $("#cropMeBackground").cropper(self.cropOptions);
	    }).on("hidden.bs.modal", function () {
	      $("#cropMeBackground").cropper("destroy");
	    });
	  },
	  computed: {
	    uploadStatusPct: function uploadStatusPct() {
	      var self = this;
	      return "Uploading image " + self.uploadCompletePct + " complete.";
	    },
	    photoComp: function photoComp() {
	      if (this.photo.Path) return "https://www.dupaws.com/services" + this.photo.Path;
	    },
	    photoIdComp: function photoIdComp() {
	      if (this.photo.SitterPhotoId) return this.photo.SitterPhotoId;
	    },
	    UploadPhotoTxtComp: function UploadPhotoTxtComp() {
	      if (this.photo.SitterPhotoId == 0) return "Upload Fresh Background Image";else {
	        return "Change Background Image";
	      }
	    }
	  }
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PetSelectCard = __webpack_require__(37);
	
	var _PetSelectCard2 = _interopRequireDefault(_PetSelectCard);
	
	var _ConfirmedReservations = __webpack_require__(248);
	
	var _ConfirmedReservations2 = _interopRequireDefault(_ConfirmedReservations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "myReservations",
	  data: function data() {
	    return {};
	  },
	
	  components: {
	    ConfirmedReservations: _ConfirmedReservations2.default
	  },
	  updated: function updated() {},
	
	  mounted: function mounted() {}
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ViewSitterReservationComponent = __webpack_require__(594);
	
	var _ViewSitterReservationComponent2 = _interopRequireDefault(_ViewSitterReservationComponent);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  components: {
	    ViewSitterReservationComponent: _ViewSitterReservationComponent2.default
	  },
	  computed: {
	    signalReady: function signalReady() {
	      if (_store2.default.getters.SignalRHub != null) if (_store2.default.getters.SignalRHub.connection != null) return true;
	      return false;
	    }
	  }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _PetSelectCard = __webpack_require__(37);
	
	var _PetSelectCard2 = _interopRequireDefault(_PetSelectCard);
	
	var _Chat = __webpack_require__(67);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            existingReservation: '',
	            notification: '',
	            error: false,
	            sending: false,
	            sent: false,
	            loading: true,
	            blocking: '',
	            selectedTime: '',
	            summaryCollapse: true,
	            ready: true,
	            allowTimeEdit: false,
	            isAccepted: false,
	            errorMsg: ''
	        };
	    },
	
	    components: {
	        PetSelectCard: _PetSelectCard2.default,
	        Chat: _Chat2.default
	
	    },
	    computed: {
	        isActiveComp: function isActiveComp() {
	            if (this.reservationComp != null) return this.reservationComp.IsSitterCustomerActive;
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        },
	        notStartedComp: function notStartedComp() {
	            var self = this;
	
	            var startDate = moment(self.existingReservation.StartDate);
	            if (startDate.isBefore(moment(), 'day')) return false;else return true;
	        },
	        rejectedComp: function rejectedComp() {
	            var self = this;
	            var startDate = moment(self.reservationComp.StartDate);
	
	            if (self.reservationComp.IsSitterRejected == true || self.reservationComp.IsCustomerCancelled == true) return true;else if (self.reservationComp.SitterResponseDate == null && startDate.isBefore(moment(), 'day')) return true;else return false;
	        },
	        summaryComp: function summaryComp() {
	            if (this.summaryCollapse == true) return 'Hide Summary';else return 'Show Summary';
	        },
	        startDateComp: function startDateComp() {
	            var self = this;
	            return moment(self.existingReservation.StartDate).format('DD MMM YYYY');
	        },
	        endDateComp: function endDateComp() {
	            var self = this;
	            return moment(self.existingReservation.EndDate).format('DD MMM YYYY');
	        },
	        reservationIdComp: function reservationIdComp() {
	            var self = this;
	            if (self.$route.params != null) return self.$route.params.reservationId;
	        },
	        signalReadyComp: function signalReadyComp() {
	            if (_store2.default.getters.SignalRHub != null && this.ready == true) if (_store2.default.getters.SignalRHub.connection != null) return true;
	            return false;
	        },
	        reservationComp: function reservationComp() {
	            var self = this;
	            if (self.existingReservation) if (self.existingReservation) return self.existingReservation;
	        },
	        reservationReadyComp: function reservationReadyComp() {
	            if (this.existingReservation != null && this.signalReadyComp == true) return true;
	            return false;
	        },
	        senderIdComp: function senderIdComp() {
	            if (_store2.default.getters.userRole == "Client") return _store2.default.getters.CustomerId;else return _store2.default.getters.SitterId;
	        },
	        signalRHubComp: function signalRHubComp() {
	            if (this.signalReadyComp) return _store2.default.getters.SignalRHub;
	        },
	        acceptedButton: function acceptedButton() {
	            if (this.existingReservation.IsSitterAccepted == false) return "Accept invitation";else {
	                this.isAccepted = true;
	                return "Accepted invitation";
	            }
	        },
	        timezoneComp: function timezoneComp() {
	            return _store2.default.getters.CountryData.CountryTimezone;
	        }
	
	    },
	    watch: {
	        '$route.params.reservationId': function $routeParamsReservationId() {
	            this.ready = false;
	            this.initReservation();
	            this.$forceUpdate();
	        }
	    },
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	
	        $('#summary').collapse('show');
	    },
	    methods: {
	        goSubscribe: function goSubscribe() {
	            var self = this;
	            self.$router.push({ path: '/subscribe' });
	            self.$router.go({ path: '/subscribe' });
	        },
	        dateFormatter: function dateFormatter(date) {
	            return moment(date).format('DD MMM YYYY');
	        },
	        goSupport: function goSupport() {
	            this.$router.push({
	                path: '/contact-support/' + '?bookingId=' + this.existingReservation.BookingNumber,
	                force: true
	            });
	        },
	        rejectRequest: function rejectRequest() {
	            var self = this;
	
	            swal({
	                title: 'Rejecting Booking',
	                text: "Are you sure you want to reject this booking? you will not be able to view it later",
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonClass: "btn-warning",
	                confirmButtonText: 'Yes Reject',
	                cancelButtonText: 'Cancel',
	                allowOutsideClick: false,
	                closeOnConfirm: true,
	                closeOnCancel: true
	            }, function (isConfirm) {
	                if (isConfirm == true) {
	                    self.rejectReservation();
	                } else if (isConfirm == false) {}
	            });
	        },
	        removeDashboard: function removeDashboard() {
	            var self = this;
	            self.existingReservation.IsSitterRemoved = true;
	            self.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	        },
	        rejectReservation: function rejectReservation() {
	            var self = this;
	            self.existingReservation.IsSitterRemoved = true;
	            self.existingReservation.IsSitterRejected = true;
	            self.existingReservation.SitterRejectedDate = new Date();
	            if (self.existingReservation.SitterResponseDate == null) self.existingReservation.SitterResponseDate = new Date();
	            self.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	        },
	        switchCollapse: function switchCollapse() {
	            if (this.summaryCollapse == true) this.summaryCollapse = false;else this.summaryCollapse = true;
	        },
	        initReservation: function initReservation() {
	            var self = this;
	            self.loading = true;
	            $.ajax("https://www.dupaws.com/services/api/sitter/getReservation/" + self.$route.params.reservationId, {
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success(data) {
	                    self.existingReservation = data;
	                    self.loading = false;
	                    self.ready = true;
	                },
	                error: function error() {
	                    self.loading = false;
	                    swal("Oops", "an error happened while retrieving this booking, maybe it was expired?", "warning");
	                    self.$router.push({ path: '/my-sitter-reservations' });
	                }
	            });
	        },
	
	        goMySitterReservations: function goMySitterReservations() {
	            this.$router.push({ path: '/my-sitter-reservations' });
	        },
	        acceptReservation: function acceptReservation() {
	            var self = this;
	
	            swal({
	                title: 'Calendar Updated',
	                text: "New entry was added to your calendar, no one else can book you through those dates, if you want to change that go to Calendar and click on the entry and mark yourself as available or if you or the customer cancel this booking it will be removed automatically.",
	                type: "info",
	                confirmButtonClass: "btn-info",
	                confirmButtonText: 'Okay, got it!',
	                allowOutsideClick: false,
	                closeOnConfirm: false
	            }, function (isConfirm) {
	                if (isConfirm == true) {
	                    self.acceptReservationAjax(true);
	                    return;
	                }
	            });
	        },
	        acceptReservationAjax: function acceptReservationAjax(blocking) {
	
	            var self = this;
	            $.ajax("https://www.dupaws.com/services/api/sitter/acceptReservationCalendar/" + self.existingReservation.ReservationId + "?blocking=" + blocking, {
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                dataType: "json",
	                contentType: "application/json; charset=utf-8",
	                crossDomain: true,
	                success: function success() {
	                    self.existingReservation.IsSitterAccepted = true;
	                    self.updateReservation();
	
	                    swal({
	                        title: 'Excellent job',
	                        text: "To get rated or reviewed on this booking, ask customer to confirm it before start date",
	                        type: "success",
	                        confirmButtonClass: "btn-success",
	                        confirmButtonText: 'Woof!',
	                        allowOutsideClick: false,
	                        closeOnConfirm: true
	                    }, function (isConfirm) {
	                        return;
	                    });
	                },
	                error: function error() {
	                    console.log("Error happened at acceptReservationCalendar");
	                }
	            });
	        },
	        updateReservation: function updateReservation() {
	            var self = this;
	            this.signalRHubComp.invoke('UpdateReservation', self.existingReservation, _store2.default.getters.userRole);
	        }
	
	    },
	    mounted: function mounted() {
	        var self = this;
	        self.initReservation();
	
	        self.$forceUpdate();
	
	        _store2.default.commit('readNotificationTrans', self.reservationIdComp);
	
	        self.signalRHubComp.on('UpdateReservation', function (reservationDto) {
	            if (reservationDto.ServiceTransactionId == self.existingReservation.ServiceTransactionId) self.existingReservation = reservationDto;
	        });
	    }
	
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	    name: 'myReservations',
	    data: function data() {
	        return {
	            myReservations: '',
	            hidden: false,
	            tempReservations: '',
	            loading: true,
	            summaryCollapse: false,
	            sort: 0
	        };
	    },
	
	    methods: {
	        switchCollapse: function switchCollapse() {
	            if (this.summaryCollapse == true) this.summaryCollapse = false;else this.summaryCollapse = true;
	        },
	        goDashboard: function goDashboard() {
	            this.$router.push({
	                path: '/dashboard/feedback-performance',
	                force: true
	            });
	        },
	        goSitterProfileEdit: function goSitterProfileEdit() {
	            this.$router.push({
	                path: '/sitter-profile-edit/about',
	                force: true
	            });
	        },
	
	        startDateComp: function startDateComp(reservation) {
	            return moment(reservation.StartDate).format('DD MMM YYYY');
	        },
	        endDateComp: function endDateComp(reservation) {
	            return moment(reservation.EndDate).format('DD MMM YYYY');
	        },
	        sentDate: function sentDate(date) {
	            return moment(date).fromNow();
	        },
	        bookingRemovable: function bookingRemovable(reservation) {
	            var now = moment();
	            var endDate = moment(reservation.OriginalEndDate);
	            var startDate = moment(reservation.StartDate);
	
	            var self = this;
	            if (reservation.IsSitterRemoved == true) return false;
	            if (reservation.IsSitterRejected == true || reservation.IsCustomerCancelled == true) return true;
	            if (endDate <= now) return true;
	            if (reservation.SitterResponseDate == null && startDate.isBefore(moment(), 'day')) return true;else return false;
	        },
	        showCompleted: function showCompleted() {
	            var self = this;
	            this.hidden = false;
	            console.log(self.tempReservations);
	            self.myReservations = self.tempReservations;
	            self.$forceUpdate();
	        },
	        hideCompleted: function hideCompleted() {
	            var self = this;
	            self.hidden = true;
	            var now = moment();
	            self.tempReservations = self.myReservations.slice();
	            console.log(self.tempReservations);
	            $.each(self.myReservations, function (index, reservation) {
	                if (reservation != null) {
	                    var originalEndDate = moment(reservation.OriginalEndDate);
	                    var endDate = moment(reservation.EndDate);
	                    if (endDate <= now || originalEndDate <= now || reservation.IsCustomerCancelled || reservation.IsSitterRejected) {
	                        self.myReservations.splice(index, 1);
	                    }
	                }
	            });
	        },
	        removeBooking: function removeBooking(reservation) {
	            var self = this;
	            $.ajax({
	                type: 'POST',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                url: API_URL + "api/sitter/removeBooking/" + reservation.ReservationId,
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    setTimeout(function () {
	                        var index = self.myReservations.findIndex(function (t) {
	                            return t.ReservationId === reservation.ReservationId;
	                        });
	                        self.myReservations.splice(index, 1);
	                    }, 100);
	                },
	                error: function error(data, status, _error) {
	                    console.log("Couldn't cancel this reservation" + data.responseText);
	                }
	            });
	        },
	        startDate: function startDate(date) {
	            var currentDate = moment();
	
	            var sittingDate = moment(date);
	
	            var difference = sittingDate.diff(currentDate, 'hours');
	
	            if (sittingDate.isBefore(moment(), 'day')) {
	                return 'already started';
	            }
	            if (sittingDate.isSame(moment(), 'day')) return 'today';else if (sittingDate.isAfter(moment(), 'day')) return moment(date).fromNow();else return moment(new Date()).to(date);
	        },
	        goToReservation: function goToReservation(reservation) {
	            this.$router.push({ name: 'view-sitter-reservation', params: { reservationId: reservation.ReservationId } });
	        },
	        loadData: function loadData() {
	            var self = this;
	            self.loading = true;
	            $.ajax({
	                type: 'GET',
	                beforeSend: function beforeSend(xhr) {
	                    xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	                },
	                url: API_URL + "api/sitter/getReservations",
	                dataType: "json",
	                crossDomain: true,
	                contentType: "application/json; charset=utf-8",
	                success: function success(data) {
	                    self.loading = false;
	                    self.myReservations = data;
	                    self.tempReservations = data;
	                },
	                error: function error(data, status, _error2) {
	                    console.log("Couldn't get myReservations list" + data.responseText);
	                }
	            });
	        }
	
	    },
	    computed: {
	        summaryComp: function summaryComp() {
	            if (this.summaryCollapse == true) return 'Hide filters and sort';else return 'Show filters and sort';
	        },
	        sortedReservationsComp: function sortedReservationsComp() {
	            function start(a, b) {
	                if (a.StartDate < b.StartDate) return -1;
	                if (a.StartDate > b.StartDate) return 1;
	                return 0;
	            }
	
	            function submitted(a, b) {
	                if (a.SubmittedDate > b.SubmittedDate) return -1;
	                if (a.SubmittedDate < b.SubmittedDate) return 1;
	                return 0;
	            }
	
	            function price(a, b) {
	                if (a.TotalPrice > b.TotalPrice) return -1;
	                if (a.TotalPrice < b.TotalPrice) return 1;
	                return 0;
	            }
	
	            if (this.sort == 0) this.myReservations.sort(submitted);else if (this.sort == 1) this.myReservations.sort(start);else if (this.sort == 2) this.myReservations.sort(price);
	
	            return this.myReservations;
	        },
	        currencyComp: function currencyComp() {
	            return _store2.default.getters.CountryData.Currency;
	        }
	    },
	    mounted: function mounted() {
	        this.$ga.page(this.$router);
	        var self = this;
	        self.loadData();
	        this.refreshInterval = setInterval(function () {
	            self.loadData();
	        }, 360000);
	    },
	    beforeDestroy: function beforeDestroy() {
	        clearInterval(this.refreshInterval);
	    }
	
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = "https://www.dupaws.com/services/";
	exports.default = {
	  name: "shortcuts",
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    sitterIdComp: function sitterIdComp() {
	      if (_store2.default.getters.SitterId != null) {
	        return "/sitter/" + _store2.default.getters.SitterId;
	      }
	    }
	  },
	  methods: {
	    goAccount: function goAccount() {
	      _router2.default.push({ path: "/account", force: true });
	    },
	    goBookings: function goBookings() {
	      _router2.default.push({ path: "/my-sitter-reservations", force: true });
	    },
	    goProfileSetup: function goProfileSetup() {
	      _router2.default.push({ path: "/sitter-profile-edit/about", force: true });
	    },
	    goViewPublicProfile: function goViewPublicProfile() {
	      _router2.default.push({ path: this.sitterIdComp });
	    },
	    goContactSupport: function goContactSupport() {
	      _router2.default.push({ path: "/contact-support", force: true });
	    },
	    goCalendar: function goCalendar() {
	      _router2.default.push({ path: "/sitter-profile-edit/calendar", force: true });
	    }
	  }
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueSticky = __webpack_require__(672);
	
	var _vueSticky2 = _interopRequireDefault(_vueSticky);
	
	var _vue = __webpack_require__(16);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _sitterApi = __webpack_require__(28);
	
	var _sitterApi2 = _interopRequireDefault(_sitterApi);
	
	var _router = __webpack_require__(9);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'profile',
	    directives: {
	        'sticky': _vueSticky2.default
	    },
	    data: function data() {
	        return {
	            profileStatus: {
	                CompletePct: 0,
	                CurrentStatus: 'Loading',
	                IsProfileReady: false
	            }
	
	        };
	    },
	    updated: function updated() {
	        $('[data-toggle="popover"]').popover();
	    },
	
	    methods: {
	        updateProfileStatus: function updateProfileStatus() {
	            var self = this;
	            _sitterApi2.default.getSitterProfileStatus().then(function (data) {
	                self.profileStatus = data;
	            }).fail(function (error) {
	                console.log(error);
	            });
	        },
	
	        showPopup: function showPopup() {
	            var self = this;
	            swal({
	                title: "Profile Status",
	                text: "This is an indicator of your profile status, complete all required fields or go to Dashboard to see whats missing in your profile",
	                type: "success",
	                showCancelButton: true,
	                confirmButtonClass: 'btn-success',
	                confirmButtonText: "Go Dashboard",
	                cancelButtonClass: 'btn-info',
	                cancelButtonText: "Keep me here",
	                closeOnConfirm: true,
	                html: true
	            }, function () {
	                self.$router.push({ path: '/dashboard/feedback-performance' });
	            });
	        }
	
	    },
	    created: function created() {
	        var self = this;
	        if (!_store2.default.getters.authenticated && !localStorage.getItem('access_token')) {
	            console.log("am here not authenticated");
	            _router2.default.push({ path: '/login', query: { redirect: 'sitter-profile-edit' } });
	        } else {}
	    },
	    watch: {
	        '$route': function $route() {
	            if (_router2.default.currentRoute.fullPath == '/sitter-profile-edit') _router2.default.push({ path: 'sitter-profile-edit/about/' });
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        this.$ga.page(this.$router);
	        _sitterApi2.default.getSitterProfileStatus().then(function (data) {
	            self.profileStatus = data;
	        }).fail(function (error) {
	            console.log(error);
	        });
	
	        if (_router2.default.currentRoute.fullPath == '/sitter-profile-edit') _router2.default.push({ path: 'sitter-profile-edit/about/' });
	
	        if (!_store2.default.getters.authenticated && !localStorage.getItem('access_token')) {
	            console.log("am here redirecting to profile-edit");
	            _router2.default.push({ path: '/login', query: { redirect: 'sitter-profile-edit' } });
	        } else {}
	    }
	
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CalendarView = __webpack_require__(247);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _commonApi = __webpack_require__(10);
	
	var _commonApi2 = _interopRequireDefault(_commonApi);
	
	var _customerApi = __webpack_require__(13);
	
	var _customerApi2 = _interopRequireDefault(_customerApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'profileView',
	  data: function data() {
	    return {
	      title: 'Dupaws Sitter Profile',
	      number: 5,
	      SitterPublicDetails: '',
	      SitterPublicReviews: '',
	      errorMsg: '',
	      sun: 0,
	      mon: 0,
	      tue: 0,
	      wed: 0,
	      thu: 0,
	      fri: 0,
	      sat: 0
	
	    };
	  },
	  created: function created() {
	    if (this.$route.params.sitterId != null) {
	      this.getSitterPublicDetails(this.$route.params.sitterId);
	      this.getSitterPublicReviews(this.$route.params.sitterId);
	    }
	  },
	  mounted: function mounted() {
	
	    $('[data-tooltip]').tooltip();
	
	    if (this.$route.params.sitterId != null) {
	      this.getSitterPublicDetails(this.$route.params.sitterId);
	      this.getSitterPublicReviews(this.$route.params.sitterId);
	      this.setSitterProfileView(this.$route.params.sitterId);
	    }
	
	    if (localStorage.getItem('userRole') == "Client") {
	      _customerApi2.default.getPetsList();
	    }
	  },
	
	  computed: {
	
	    whatsappUrl: function whatsappUrl() {
	      return 'whatsapp://send?text=' + this.SitterPublicDetails.SitterMarketingUrl;
	    },
	    twitterUrl: function twitterUrl() {
	      return 'https://twitter.com/share?url=' + this.SitterPublicDetails.SitterMarketingUrl + '&via=dupaws&hashtags=dupaws';
	    },
	    linkedinUrl: function linkedinUrl() {
	      return 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.SitterPublicDetails.SitterMarketingUrl + '&source=LinkedIn';
	    },
	    googleUrl: function googleUrl() {
	      return 'https://plus.google.com/share?url=' + this.SitterPublicDetails.SitterMarketingUrl;
	    },
	    mailUrl: function mailUrl() {
	      return 'mailto:?subject=Just found the perfect pet sitter for you :)&body=' + this.SitterPublicDetails.SitterMarketingUrl;
	    },
	    countryCurrencyComp: function countryCurrencyComp() {
	      return _store2.default.getters.CountryData.Currency;
	    },
	    hasSkillsComp: function hasSkillsComp() {
	      if (this.petPrefComp.CanCPR || this.petPrefComp.CanInject || this.petPrefComp.CanOral) return true;else return false;
	    },
	    compProfilePic: function compProfilePic() {
	      return _store2.default.getters.profilePicUrl;
	    },
	    sitterPublicDetailComp: function sitterPublicDetailComp() {
	      return this.SitterPublicDetails;
	    },
	    bgImageComp: function bgImageComp() {
	      if (this.SitterPublicDetails.SitterPhotoDtos) if (this.SitterPublicDetails.SitterPhotoDtos.length > 0) {
	        var index = this.SitterPublicDetails.SitterPhotoDtos.findIndex(function (t) {
	          return t.Type === 0;
	        });
	        if (index != null && index != -1) {
	          return this.SitterPublicDetails.SitterPhotoDtos[index].Path;
	        }
	      }
	    },
	    LocationComp: function LocationComp() {
	      if (this.SitterPublicDetails.SitterLocationDtos) return this.SitterPublicDetails.SitterLocationDtos.CityName + ', ' + this.SitterPublicDetails.SitterLocationDtos.AreaName;
	    },
	    sitterPublicReviewsComp: function sitterPublicReviewsComp() {
	      if (this.SitterPublicReviews.length == 0) {
	        return null;
	      } else {
	        return this.SitterPublicReviews;
	      }
	    },
	    petPrefComp: function petPrefComp() {
	      if (this.SitterPublicDetails.PetPrefDtos) {
	        return this.SitterPublicDetails.PetPrefDtos;
	      }
	    },
	    homeDetailsComp: function homeDetailsComp() {
	      if (this.SitterPublicDetails.HomeDetailDtos) {
	        return this.SitterPublicDetails.HomeDetailDtos;
	      }
	    }
	
	  },
	  updated: function updated() {
	    this.$ga.page(this.$router);
	    $('[data-toggle="popover"]').popover();
	
	    $("[data-fancybox]").fancybox({
	      selector: '[data-fancybox="images"]',
	      loop: true
	    });
	  },
	
	  methods: {
	    shareLinkedin: function shareLinkedin() {
	      var self = this;
	      this.$ga.event('Share Button Clicked', 'linkedin', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId);
	    },
	    shareWhatsApp: function shareWhatsApp() {
	      var self = this;
	      this.$ga.event('Share Button Clicked', 'whatsup', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId);
	    },
	    shareGooglePlus: function shareGooglePlus() {
	      var self = this;
	      this.$ga.event('Share Button Clicked', 'google+', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId);
	    },
	    shareMail: function shareMail() {
	      var self = this;
	      this.$ga.event('Share Button Clicked', 'mail', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId);
	    },
	    hasTooltip: function hasTooltip() {
	
	      $(function () {
	        var HasTooltip = $('.hastooltip');
	        HasTooltip.on('click', function (e) {
	          e.preventDefault();
	          var isShowing = $(this).data('isShowing');
	          HasTooltip.removeData('isShowing');
	          if (isShowing !== 'true') {
	            HasTooltip.not(this).tooltip('hide');
	            $(this).data('isShowing', "true");
	            $(this).tooltip('show');
	          } else {
	            $(this).tooltip('hide');
	          }
	        }).tooltip({
	          animation: true,
	          trigger: 'manual'
	        });
	      });
	    },
	
	    reviewString: function reviewString(count) {
	      if (count == 1) return 'Review';else return 'Reviews';
	    },
	    howBookingWork: function howBookingWork() {
	      swal({
	        title: 'Booking a Sitter',
	        text: "When you initiate a booking request, you will be able to chat or request meeting with the sitter before booking takes place. Additionally you can request more than 1 sitter at a time",
	        type: "success",
	        confirmButtonClass: "btn-success",
	        confirmButtonText: 'Woof!',
	        allowOutsideClick: false,
	        closeOnConfirm: true
	      }, function (isConfirm) {
	        return;
	      });
	    },
	    shareFacebook: function shareFacebook() {
	      var self = this;
	      this.$ga.event('Share Button Clicked', 'facebook', 'https://www.dupaws.com/sitter/' + self.$route.params.sitterId);
	      var myQuote = self.sitterPublicDetailComp.Name + ' pet sitter page on Dupaws.com';
	      FB.ui({
	        method: 'share',
	        href: self.sitterPublicDetailComp.SitterMarketingUrl,
	        quote: myQuote,
	        hashtag: '#dupaws',
	        mobile_iframe: true
	      }, function (response) {
	        if (response && !response.error_message) {} else {}
	      });
	    },
	    isFavorite: function isFavorite(sitterId) {
	      if (this.userRoleComp == "Sitter") return false;
	      var result = $.grep(_store2.default.getters.FavoriteSitters, function (e) {
	        return e.SitterId == sitterId;
	      });
	      if (result.length > 0) return true;else return false;
	    },
	    lastSeenDate: function lastSeenDate(_lastSeenDate) {
	      return moment(_lastSeenDate).fromNow();
	    },
	    contactSitter: function contactSitter() {
	      var self = this;
	
	      if (_store2.default.getters.authenticated == false) swal({
	        title: "Sign In",
	        text: "You need to be logged in to Request a Reservation",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Login",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.$router.push({ path: '/login', query: { sitter: self.$route.params.sitterId } });
	      });else if (_store2.default.getters.userRole != "Client") {
	        swal("Hello", 'You need to be logged in as a Customer to request reservation', "info");
	      } else if (_store2.default.getters.PetsList.length < 1) {
	        swal({
	          title: "No Pets Found",
	          text: "Please register your Pet details before contacting a Sitter",
	          type: "info",
	          showCancelButton: true,
	          confirmButtonClass: 'btn-info',
	          confirmButtonText: "Add Pets",
	          closeOnConfirm: true,
	          html: true
	        }, function () {
	          self.$router.push({ path: '/pets-view/addpet', query: { sitter: self.$route.params.sitterId } });
	        });
	      } else if (_store2.default.getters.SubscriptionStatus.IsActive == false && self.sitterPublicDetailComp.IsActive == false) {
	        self.sendBasicAccountCheck();
	        fbq('track', "Lead", { content_name: 'Customer booking Basic Sitter request' });
	        swal({
	          title: "Subscription required",
	          text: "To contact a non-premium pet sitter, you need to have an active membership.",
	          type: "info",
	          showCancelButton: true,
	          confirmButtonClass: 'btn-success',
	          confirmButtonText: "Subscribe",
	          closeOnConfirm: true,
	          html: true
	        }, function () {
	          self.$router.push({ path: '/subscribe' });
	        });
	      } else if (_store2.default.getters.CountryData.CountryId != this.sitterPublicDetailComp.SitterLocationDtos.CountryId) {
	        swal("Hello", 'You cant contact Sitters that are in different country than yours, please change your country settings.', "info");
	      } else {
	        if (_store2.default.getters.PetsList.length < 1) {
	          swal({
	            title: "No Pets Found",
	            text: "Please register your Pet details before contacting a Sitter",
	            type: "info",
	            showCancelButton: true,
	            confirmButtonClass: 'btn-info',
	            confirmButtonText: "Add Pets",
	            closeOnConfirm: true,
	            html: true
	          }, function () {
	            self.$router.push({ path: '/pets-view/addpet', query: { sitter: self.$route.params.sitterId } });
	          });
	        } else {
	          self.$router.push({ path: '/reservation/' + self.$route.params.sitterId });
	        }
	      }
	    },
	    getSitterPublicDetails: function getSitterPublicDetails(sitterId) {
	      var self = this;
	      return $.ajax({
	        type: 'GET',
	        url: "https://www.dupaws.com/services/public/getSitterPublicDetails/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.SitterPublicDetails = data;
	          self.title = data.Name + ' ' + data.Title;
	          if (data.IsDogWalking) {
	            self.sun = data.DogWalkingDays & 1;
	            self.mon = data.DogWalkingDays & 2;
	            self.tue = data.DogWalkingDays & 4;
	            self.wed = data.DogWalkingDays & 8;
	            self.thu = data.DogWalkingDays & 16;
	            self.fri = data.DogWalkingDays & 32;
	            self.sat = data.DogWalkingDays & 64;
	          }
	          self.$emit('updateHead');
	        },
	        error: function error(data, status, _error) {
	          self.errorMsg = data.responseJSON.Message;
	        }
	      });
	    },
	    sendBasicAccountCheck: function sendBasicAccountCheck() {
	      var self = this;
	      $.ajax({
	        type: 'GET',
	        url: "https://www.dupaws.com/services/api/contactBasicAccount/" + self.$route.params.sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          console.log(data);
	        },
	        error: function error(data, status, _error2) {
	          console.log(data);
	        }
	      });
	    },
	    setSitterProfileView: function setSitterProfileView(sitterId) {
	      var self = this;
	      if (_store2.default.getters.authenticated == false) $.ajax({
	        type: 'POST',
	        url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {},
	        error: function error(data, status, _error3) {
	          self.errorMsg = data.responseJSON.Message;
	        }
	      });else if (_store2.default.getters.authenticated == true) {
	        $.ajax({
	          type: 'POST',
	          beforeSend: function beforeSend(xhr) {
	            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	          },
	          url: "https://www.dupaws.com/services/public/setProfileView/" + sitterId,
	          dataType: "json",
	          crossDomain: true,
	          contentType: "application/json; charset=utf-8",
	          success: function success(data) {},
	          error: function error(data, status, _error4) {
	            self.errorMsg = data.responseJSON.Message;
	          }
	        });
	      }
	    },
	
	    premiumSwal: function premiumSwal() {
	      swal({
	        title: 'Premium Member',
	        text: "You can contact and book Premium accounts directly without subscription or membership.",
	        type: "success",
	        confirmButtonClass: "btn-success",
	        confirmButtonText: 'Woof!',
	        allowOutsideClick: false,
	        closeOnConfirm: true
	      }, function (isConfirm) {
	        return;
	      });
	    },
	    getSitterPublicReviews: function getSitterPublicReviews(sitterId) {
	      var self = this;
	      return $.ajax({
	        type: 'GET',
	        url: "https://www.dupaws.com/services/public/getSitterPublicReviews/" + sitterId,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success(data) {
	          self.SitterPublicReviews = data;
	        },
	        error: function error(data, status, _error5) {
	          console.log("failed to get Sitter getSitterPublicReviews()" + data.responseText);
	        }
	      });
	    },
	
	    goSearchSitters: function goSearchSitters(sitterId) {
	      this.$router.push({ path: '/findsitters#user' + sitterId });
	    },
	    goHome: function goHome() {
	      this.$router.push({ path: '/' });
	    },
	    addToFavorites: function addToFavorites(sitter) {
	      self = this;
	      if (_store2.default.getters.authenticated == false) swal({
	        title: "Hello",
	        text: "You need to be logged in as a Customer to add sitters to your favorite account",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Login",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.$router.push({ path: '/login', query: { sitter: self.$route.params.sitterId } });
	      });else if (_store2.default.getters.userRole == "Sitter") {
	        swal("Hello", 'You cant add Sitters as favorites while logged in as a Sitter, please switch to Customer login then try again', "info");
	      } else {
	        _customerApi2.default.addSitterToFavorites(sitter);
	      }
	    }
	
	  },
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	
	      };
	    },
	    meta: function meta() {
	      return;
	      [{ name: 'application-name', content: 'Dupaws.com Sitter Profile' }, { name: 'description', content: this.title }, { name: 'keywords', content: this.title }, { property: 'fb:app_id', content: '279352372578608' }, { property: 'fb:admins', content: '636428053' }, { property: 'fb:pages', content: '1623158747696830' }];
	    }
	  },
	  components: {
	    CalendarView: _CalendarView2.default
	  }
	
	};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(3);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      fbSignInParams: {
	        scope: 'email,public_profile',
	        return_scopes: true
	      },
	      credentials: {
	        email: '',
	        password: '',
	        firstName: '',
	        lastName: '',
	        confirmPassword: ''
	
	      },
	      FBTokenInfo: {
	        Token: '',
	        Email: '',
	        Provider: 'Facebook',
	        ProfilePicUrl: '',
	        FirstName: '',
	        LastName: '',
	        CountryId: localStorage.getItem('CountryId'),
	        UserRole: 'Sitter'
	
	      },
	
	      error: '',
	      notification: ''
	
	    };
	  },
	  updated: function updated() {
	    var self = this;
	    this.$ga.page(this.$router);
	  },
	
	  methods: {
	    goDashboard: function goDashboard() {
	      var self = this;
	
	      if (self.userRoleComp == "Sitter" && localStorage.getItem('phoneConfirmed') == "False") {
	
	        swal({
	          title: "Mobile needs verifcation",
	          text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
	          type: "success",
	          showCancelButton: true,
	          confirmButtonClass: 'btn-success',
	          confirmButtonText: "Yes take me there!",
	          cancelButtonText: "Later",
	          allowOutsideClick: false,
	          closeOnConfirm: true
	        }, function (isConfirm) {
	          if (isConfirm) {
	            self.$router.push({ path: '/account', force: true });
	            return;
	          } else {
	            self.$router.push({ path: '/dashboard/feedback-performance', force: true });
	          }
	        });
	      } else {
	        self.$router.push({ path: '/dashboard/feedback-performance', force: true });
	      }
	    },
	    confirmSwitchAccount: function confirmSwitchAccount() {
	      var self = this;
	      swal({
	        title: "Switch Account Confirmation",
	        text: "You are currently logged in as " + self.userRoleComp + " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " + self.userRoleComp + " anytime",
	        type: "info",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-success',
	        confirmButtonText: "Yes, switch account",
	        closeOnConfirm: true,
	        html: true
	      }, function () {
	        self.switchAccount();
	      });
	    },
	    switchAccount: function switchAccount() {
	      var self = this;
	      $.ajax({
	        type: 'GET',
	        url: 'https://www.dupaws.com/services/api/account/SwitchRole/' + self.countryDataComp.CountryId,
	        contentType: "application/json; charset=utf-8",
	        beforeSend: function beforeSend(xhr) {
	          xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'));
	        },
	        success: function success(data) {
	          self.alert = data;
	          _auth2.default.logout();
	          self.$router.push({ path: '/login', query: { switch: 'yes' } });
	        },
	        error: function error() {
	          try {
	            self.error = "Failed switching account";
	          } catch (e) {
	            self.error = "Oops we are having problem logging to the server, please try again in a moment..";
	          }
	        }
	      });
	    },
	    validateBeforeSubmit: function validateBeforeSubmit() {
	      var _this = this;
	
	      var self = this;
	      this.$validator.validateAll().then(function (result) {
	        if (self.credentials.email.substr(self.credentials.email.length - 3) == "con") {
	          swal("Oops, your email looks incorrect", self.credentials.email, "info");
	          return;
	        }
	        if (result) {
	          _this.submit();
	          return;
	        }
	
	        swal("Something is missing", "Please complete all the required fields to continue.", "info");
	      });
	    },
	    submit: function submit() {
	      var self = this;
	      $(window).scrollTop(0);
	      var countryId = localStorage.getItem('CountryId');
	      var credentials = {
	
	        Email: this.credentials.email,
	        FirstName: this.credentials.firstName,
	        LastName: this.credentials.lastName,
	        Password: this.credentials.password,
	        CountryId: countryId,
	        Provider: 'Direct',
	        confirmPassword: this.credentials.password,
	        userRole: "Sitter",
	        ProfilePicUrl: ''
	      };
	
	      _auth2.default.register(this, credentials, 'sitter-profile-edit/about');
	    },
	    onSignInSuccess: function onSignInSuccess(response) {
	      var self = this;
	      console.log(response);
	      console.log(response.data);
	      self.error = '';
	      self.FBTokenInfo.ProfilePicUrl = "images/sitterProfilePic.png";
	
	      FB.api('/me', { fields: 'first_name,last_name,email' }, function (response) {
	        self.FBTokenInfo.FirstName = response.first_name;
	        self.FBTokenInfo.LastName = response.last_name;
	        self.FBTokenInfo.Email = response.email;
	        localStorage.setItem('email', response.email);
	        _store2.default.commit('email', localStorage.getItem('email'));
	        FB.getLoginStatus(function (response) {
	          self.FBTokenInfo.Token = response.authResponse.accessToken;
	          if (self.$route.query.redirect != null) {
	            _auth2.default.fbLogin(self, self.FBTokenInfo, self.$route.query.redirect);
	          } else {
	            _auth2.default.fbLogin(self, self.FBTokenInfo, 'sitter-profile-edit/about');
	          }
	        });
	      });
	    },
	    onSignInError: function onSignInError(error) {
	      console.log('Facebook auth error: ', error);
	      this.error = "Sorry but Facebook login failed";
	    },
	    SignOut: function SignOut(response) {
	      FB.logout(function (response) {});
	    }
	  },
	  computed: {
	    doubleRoleComp: function doubleRoleComp() {
	      if (localStorage.getItem('doubleRole') == "True") return true;else return false;
	    },
	    checkUserComp: function checkUserComp() {
	      return _store2.default.getters.authenticated;
	    },
	    filledRequired: function filledRequired() {
	
	      if (this.credentials.email == '' || this.credentials.password == '') {
	        return false;
	      }
	    },
	    errorMsg: function errorMsg() {
	      return this.error;
	    },
	    notificationMsg: function notificationMsg() {
	      return this.notification;
	    },
	    userRoleComp: function userRoleComp() {
	      return _store2.default.getters.userRole;
	    },
	    countryDataComp: function countryDataComp() {
	      return _store2.default.getters.CountryData;
	    }
	
	  }
	
	};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'terms',
	  data: function data() {
	    return {
	      active: false,
	      title: "Dupaws.com Dog Boarding, Cat Sitting and more",
	      scrollPosition: ''
	    };
	  },
	  updated: function updated() {},
	  mounted: function mounted() {
	    this.$ga.page(this.$router);
	  },
	
	  methods: {},
	
	  computed: {},
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: [{ name: 'application-name', content: 'Dupaws.com Pet Sitting' }, { name: 'description', content: 'Dupaws.com terms and conditions', id: 'desc' }, { property: 'fb:app_id', content: '279352372578608' }, { property: 'fb:admins', content: '636428053' }, { property: 'fb:pages', content: '1623158747696830' }],
	    link: [{ rel: 'canonical', href: 'https://www.dupaws.com/terms-and-conditions', id: 'canonical' }]
	  }
	
	};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      email: "",
	      pending: true
	    };
	  },
	
	  mounted: function mounted() {
	    if (this.$router.currentRoute.query.email != null) {
	      this.email = this.$router.currentRoute.query.email;
	      this.unSubscribe(this.email);
	    } else {
	      alert("error unsubscribing...");
	    }
	  },
	  methods: {
	    unSubscribe: function unSubscribe(email) {
	      var self = this;
	      $.ajax({
	        type: "POST",
	        data: email,
	        url: "https://www.dupaws.com/services/public/unSubscribe?email=" + email,
	        dataType: "json",
	        crossDomain: true,
	        contentType: "application/json; charset=utf-8",
	        success: function success() {
	          self.pending = false;
	        },
	        error: function error(data, status, _error) {
	          self.errorMsg = data.responseJSON.Message;
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 110,
		"./af.js": 110,
		"./ar": 117,
		"./ar-dz": 111,
		"./ar-dz.js": 111,
		"./ar-kw": 112,
		"./ar-kw.js": 112,
		"./ar-ly": 113,
		"./ar-ly.js": 113,
		"./ar-ma": 114,
		"./ar-ma.js": 114,
		"./ar-sa": 115,
		"./ar-sa.js": 115,
		"./ar-tn": 116,
		"./ar-tn.js": 116,
		"./ar.js": 117,
		"./az": 118,
		"./az.js": 118,
		"./be": 119,
		"./be.js": 119,
		"./bg": 120,
		"./bg.js": 120,
		"./bm": 121,
		"./bm.js": 121,
		"./bn": 122,
		"./bn.js": 122,
		"./bo": 123,
		"./bo.js": 123,
		"./br": 124,
		"./br.js": 124,
		"./bs": 125,
		"./bs.js": 125,
		"./ca": 126,
		"./ca.js": 126,
		"./cs": 127,
		"./cs.js": 127,
		"./cv": 128,
		"./cv.js": 128,
		"./cy": 129,
		"./cy.js": 129,
		"./da": 130,
		"./da.js": 130,
		"./de": 133,
		"./de-at": 131,
		"./de-at.js": 131,
		"./de-ch": 132,
		"./de-ch.js": 132,
		"./de.js": 133,
		"./dv": 134,
		"./dv.js": 134,
		"./el": 135,
		"./el.js": 135,
		"./en-au": 136,
		"./en-au.js": 136,
		"./en-ca": 137,
		"./en-ca.js": 137,
		"./en-gb": 138,
		"./en-gb.js": 138,
		"./en-ie": 139,
		"./en-ie.js": 139,
		"./en-nz": 140,
		"./en-nz.js": 140,
		"./eo": 141,
		"./eo.js": 141,
		"./es": 144,
		"./es-do": 142,
		"./es-do.js": 142,
		"./es-us": 143,
		"./es-us.js": 143,
		"./es.js": 144,
		"./et": 145,
		"./et.js": 145,
		"./eu": 146,
		"./eu.js": 146,
		"./fa": 147,
		"./fa.js": 147,
		"./fi": 148,
		"./fi.js": 148,
		"./fo": 149,
		"./fo.js": 149,
		"./fr": 152,
		"./fr-ca": 150,
		"./fr-ca.js": 150,
		"./fr-ch": 151,
		"./fr-ch.js": 151,
		"./fr.js": 152,
		"./fy": 153,
		"./fy.js": 153,
		"./gd": 154,
		"./gd.js": 154,
		"./gl": 155,
		"./gl.js": 155,
		"./gom-latn": 156,
		"./gom-latn.js": 156,
		"./gu": 157,
		"./gu.js": 157,
		"./he": 158,
		"./he.js": 158,
		"./hi": 159,
		"./hi.js": 159,
		"./hr": 160,
		"./hr.js": 160,
		"./hu": 161,
		"./hu.js": 161,
		"./hy-am": 162,
		"./hy-am.js": 162,
		"./id": 163,
		"./id.js": 163,
		"./is": 164,
		"./is.js": 164,
		"./it": 165,
		"./it.js": 165,
		"./ja": 166,
		"./ja.js": 166,
		"./jv": 167,
		"./jv.js": 167,
		"./ka": 168,
		"./ka.js": 168,
		"./kk": 169,
		"./kk.js": 169,
		"./km": 170,
		"./km.js": 170,
		"./kn": 171,
		"./kn.js": 171,
		"./ko": 172,
		"./ko.js": 172,
		"./ky": 173,
		"./ky.js": 173,
		"./lb": 174,
		"./lb.js": 174,
		"./lo": 175,
		"./lo.js": 175,
		"./lt": 176,
		"./lt.js": 176,
		"./lv": 177,
		"./lv.js": 177,
		"./me": 178,
		"./me.js": 178,
		"./mi": 179,
		"./mi.js": 179,
		"./mk": 180,
		"./mk.js": 180,
		"./ml": 181,
		"./ml.js": 181,
		"./mr": 182,
		"./mr.js": 182,
		"./ms": 184,
		"./ms-my": 183,
		"./ms-my.js": 183,
		"./ms.js": 184,
		"./mt": 185,
		"./mt.js": 185,
		"./my": 186,
		"./my.js": 186,
		"./nb": 187,
		"./nb.js": 187,
		"./ne": 188,
		"./ne.js": 188,
		"./nl": 190,
		"./nl-be": 189,
		"./nl-be.js": 189,
		"./nl.js": 190,
		"./nn": 191,
		"./nn.js": 191,
		"./pa-in": 192,
		"./pa-in.js": 192,
		"./pl": 193,
		"./pl.js": 193,
		"./pt": 195,
		"./pt-br": 194,
		"./pt-br.js": 194,
		"./pt.js": 195,
		"./ro": 196,
		"./ro.js": 196,
		"./ru": 197,
		"./ru.js": 197,
		"./sd": 198,
		"./sd.js": 198,
		"./se": 199,
		"./se.js": 199,
		"./si": 200,
		"./si.js": 200,
		"./sk": 201,
		"./sk.js": 201,
		"./sl": 202,
		"./sl.js": 202,
		"./sq": 203,
		"./sq.js": 203,
		"./sr": 205,
		"./sr-cyrl": 204,
		"./sr-cyrl.js": 204,
		"./sr.js": 205,
		"./ss": 206,
		"./ss.js": 206,
		"./sv": 207,
		"./sv.js": 207,
		"./sw": 208,
		"./sw.js": 208,
		"./ta": 209,
		"./ta.js": 209,
		"./te": 210,
		"./te.js": 210,
		"./tet": 211,
		"./tet.js": 211,
		"./th": 212,
		"./th.js": 212,
		"./tl-ph": 213,
		"./tl-ph.js": 213,
		"./tlh": 214,
		"./tlh.js": 214,
		"./tr": 215,
		"./tr.js": 215,
		"./tzl": 216,
		"./tzl.js": 216,
		"./tzm": 218,
		"./tzm-latn": 217,
		"./tzm-latn.js": 217,
		"./tzm.js": 218,
		"./uk": 219,
		"./uk.js": 219,
		"./ur": 220,
		"./ur.js": 220,
		"./uz": 222,
		"./uz-latn": 221,
		"./uz-latn.js": 221,
		"./uz.js": 222,
		"./vi": 223,
		"./vi.js": 223,
		"./x-pseudo": 224,
		"./x-pseudo.js": 224,
		"./yo": 225,
		"./yo.js": 225,
		"./zh-cn": 226,
		"./zh-cn.js": 226,
		"./zh-hk": 227,
		"./zh-hk.js": 227,
		"./zh-tw": 228,
		"./zh-tw.js": 228
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 530;


/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(422)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(254),
	  /* template */
	  __webpack_require__(610),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(423)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(255),
	  /* template */
	  __webpack_require__(611),
	  /* scopeId */
	  "data-v-1ca1428a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(427)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(256),
	  /* template */
	  __webpack_require__(615),
	  /* scopeId */
	  "data-v-20647244",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(440)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(257),
	  /* template */
	  __webpack_require__(628),
	  /* scopeId */
	  "data-v-477a37a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(471)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(258),
	  /* template */
	  __webpack_require__(659),
	  /* scopeId */
	  "data-v-d15e9156",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(454)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(260),
	  /* template */
	  __webpack_require__(642),
	  /* scopeId */
	  "data-v-7a1643c6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(468)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(261),
	  /* template */
	  __webpack_require__(656),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(439)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(262),
	  /* template */
	  __webpack_require__(627),
	  /* scopeId */
	  "data-v-45c9c2b6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(465)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(263),
	  /* template */
	  __webpack_require__(653),
	  /* scopeId */
	  "data-v-aa05f422",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(426)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(264),
	  /* template */
	  __webpack_require__(614),
	  /* scopeId */
	  "data-v-1f7f228f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(448)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(265),
	  /* template */
	  __webpack_require__(636),
	  /* scopeId */
	  "data-v-63c6db61",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(435)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(266),
	  /* template */
	  __webpack_require__(623),
	  /* scopeId */
	  "data-v-32b6a288",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(476)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(267),
	  /* template */
	  __webpack_require__(664),
	  /* scopeId */
	  "data-v-f1d519f0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(438)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(268),
	  /* template */
	  __webpack_require__(626),
	  /* scopeId */
	  "data-v-3d2efb4d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(475)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(269),
	  /* template */
	  __webpack_require__(663),
	  /* scopeId */
	  "data-v-ece92b36",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(430)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(270),
	  /* template */
	  __webpack_require__(618),
	  /* scopeId */
	  "data-v-286974e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(419)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(271),
	  /* template */
	  __webpack_require__(607),
	  /* scopeId */
	  "data-v-0f0ea939",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(425)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(272),
	  /* template */
	  __webpack_require__(613),
	  /* scopeId */
	  "data-v-1d704706",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(446)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(273),
	  /* template */
	  __webpack_require__(634),
	  /* scopeId */
	  "data-v-55bfc062",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(449)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(274),
	  /* template */
	  __webpack_require__(637),
	  /* scopeId */
	  "data-v-656b70ce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(457)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(275),
	  /* template */
	  __webpack_require__(645),
	  /* scopeId */
	  "data-v-7dc78558",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(437)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(276),
	  /* template */
	  __webpack_require__(625),
	  /* scopeId */
	  "data-v-3b3fe248",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(452)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(277),
	  /* template */
	  __webpack_require__(640),
	  /* scopeId */
	  "data-v-6be74c66",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(413)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(278),
	  /* template */
	  __webpack_require__(601),
	  /* scopeId */
	  "data-v-08476752",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(443)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(279),
	  /* template */
	  __webpack_require__(631),
	  /* scopeId */
	  "data-v-4eea7a76",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(442)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(280),
	  /* template */
	  __webpack_require__(630),
	  /* scopeId */
	  "data-v-4c2283f5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(456)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(282),
	  /* template */
	  __webpack_require__(644),
	  /* scopeId */
	  "data-v-7c343fb8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(441)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(283),
	  /* template */
	  __webpack_require__(629),
	  /* scopeId */
	  "data-v-4bf81376",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(444)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(284),
	  /* template */
	  __webpack_require__(632),
	  /* scopeId */
	  "data-v-4f5ecfe1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(447)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(285),
	  /* template */
	  __webpack_require__(635),
	  /* scopeId */
	  "data-v-60f75619",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(416)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(286),
	  /* template */
	  __webpack_require__(604),
	  /* scopeId */
	  "data-v-0c2a3e52",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(458)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(287),
	  /* template */
	  __webpack_require__(646),
	  /* scopeId */
	  "data-v-82fc3d00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(412)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(288),
	  /* template */
	  __webpack_require__(600),
	  /* scopeId */
	  "data-v-0472090a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(463)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(289),
	  /* template */
	  __webpack_require__(651),
	  /* scopeId */
	  "data-v-a617507c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(429)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(290),
	  /* template */
	  __webpack_require__(617),
	  /* scopeId */
	  "data-v-264fbc14",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(415)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(293),
	  /* template */
	  __webpack_require__(603),
	  /* scopeId */
	  "data-v-0b1e7c5e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(431)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(294),
	  /* template */
	  __webpack_require__(619),
	  /* scopeId */
	  "data-v-2b4f3231",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(434)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(295),
	  /* template */
	  __webpack_require__(622),
	  /* scopeId */
	  "data-v-3059a716",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(459)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(298),
	  /* template */
	  __webpack_require__(647),
	  /* scopeId */
	  "data-v-8d307aaa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(460)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(299),
	  /* template */
	  __webpack_require__(648),
	  /* scopeId */
	  "data-v-a0250c3a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(418)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(301),
	  /* template */
	  __webpack_require__(606),
	  /* scopeId */
	  "data-v-0e7b200e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(450)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(302),
	  /* template */
	  __webpack_require__(638),
	  /* scopeId */
	  "data-v-6876a305",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(467)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(304),
	  /* template */
	  __webpack_require__(655),
	  /* scopeId */
	  "data-v-be7165b8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(453)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(305),
	  /* template */
	  __webpack_require__(641),
	  /* scopeId */
	  "data-v-75be8318",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(428)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(306),
	  /* template */
	  __webpack_require__(616),
	  /* scopeId */
	  "data-v-22e5e915",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(472)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(307),
	  /* template */
	  __webpack_require__(660),
	  /* scopeId */
	  "data-v-d803abb6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(455)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(308),
	  /* template */
	  __webpack_require__(643),
	  /* scopeId */
	  "data-v-7b1830c4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(414)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(309),
	  /* template */
	  __webpack_require__(602),
	  /* scopeId */
	  "data-v-0a93d6ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(477)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(310),
	  /* template */
	  __webpack_require__(665),
	  /* scopeId */
	  "data-v-f2ab1712",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(432)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(311),
	  /* template */
	  __webpack_require__(620),
	  /* scopeId */
	  "data-v-2cf0b2d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(461)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(312),
	  /* template */
	  __webpack_require__(649),
	  /* scopeId */
	  "data-v-a48a1086",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(417)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(315),
	  /* template */
	  __webpack_require__(605),
	  /* scopeId */
	  "data-v-0d4bf31f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(421)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(316),
	  /* template */
	  __webpack_require__(609),
	  /* scopeId */
	  "data-v-15d40b8c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(462)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(317),
	  /* template */
	  __webpack_require__(650),
	  /* scopeId */
	  "data-v-a5897708",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(464)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(318),
	  /* template */
	  __webpack_require__(652),
	  /* scopeId */
	  "data-v-a6a31aac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(436)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(319),
	  /* template */
	  __webpack_require__(624),
	  /* scopeId */
	  "data-v-35abb19f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.petComp) ? _c('div', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": _vm.petId,
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('img', {
	    staticClass: "pet-image",
	    staticStyle: {
	      "float": "left",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "src": _vm.profilePhotoPathComp
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "modal-title"
	  }, [_vm._v(" " + _vm._s(_vm.petComp.Name))]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(" " + _vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(" " + _vm._s(_vm.ageToString(_vm.petComp.AgeYears, _vm.petComp.AgeMonths)))])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [(_vm.petComp.PetPhotoDtos && _vm.petComp.PetPhotoDtos.length > 1) ? _c('div', {
	    staticClass: "photo-images"
	  }, [_c('div', _vm._l((_vm.petComp.PetPhotoDtos), function(photo) {
	    return _c('div', {
	      staticClass: "thumb-wrap",
	      attrs: {
	        "href": photo.Path,
	        "data-fancybox": "pet-photo"
	      }
	    }, [_c('img', {
	      staticClass: "small-images",
	      staticStyle: {
	        "margin": "2px"
	      },
	      attrs: {
	        "src": photo.Path
	      }
	    })])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.petComp.PetPhotoDtos && _vm.petComp.PetPhotoDtos.length > 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('h4', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(" Health Status")]), _vm._v(" "), _c('ul', {
	    staticStyle: {
	      "list-style-type": "none",
	      "padding": "5px"
	    }
	  }, [(_vm.petComp.RabiesVaccinated != true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Rabies Vaccinated")]) : _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Rabies Vaccinated")]), _vm._v(" "), (_vm.petComp.IsNeuteredOrSpayed != true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Neutered or Spayed")]) : _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Neutered or Spayed")]), _vm._v(" "), (_vm.petComp.TicksOrFleas != true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Clean from Ticks & Fleas")]) : _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Clean from Ticks & Fleas")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('h4', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(" More Information")]), _vm._v(" "), _c('ul', {
	    staticStyle: {
	      "list-style-type": "none",
	      "padding": "5px"
	    }
	  }, [(_vm.petComp.IsRegisteredwithColar != true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Registered with municipality")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsRegisteredwithColar == true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Registered with municipality")]) : _vm._e(), _vm._v(" "), (_vm.petComp.MicrochipId == null) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" MicrochipId")]) : _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" MicrochipId: " + _vm._s(_vm.petComp.MicrochipId))]), _vm._v(" "), (_vm.petComp.PreferredVet) ? _c('li', [_c('strong', [_vm._v("Preferred Vet in case of emergency:")]), _vm._v("  " + _vm._s(_vm.petComp.PreferredVet))]) : _vm._e(), _vm._v(" "), (_vm.petComp.Remarks) ? _c('li', [_c('strong', [_vm._v("Remarks:")]), _vm._v("  " + _vm._s(_vm.petComp.Remarks))]) : _vm._e()])])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "pet-wrapper"
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    staticStyle: {
	      "min-width": "60px",
	      "min-height": "60px",
	      "border": "1px solid #c3c3c3"
	    },
	    attrs: {
	      "src": _vm.profilePhotoPathComp,
	      "alt": "",
	      "height": "80",
	      "width": "80"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left"
	  }, [_c('h4', {
	    staticClass: "media-heading main-name",
	    staticStyle: {
	      "padding-bottom": "0px",
	      "margin-bottom": "3px"
	    }
	  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.petComp.Name))])]), _vm._v(" "), _c('p', {
	    staticClass: "small text-muted",
	    staticStyle: {
	      "padding-top": "0px",
	      "margin-top": "0px",
	      "padding-bottom": "0px",
	      "margin-bottom": "3px"
	    }
	  }, [_vm._v(_vm._s(_vm.ageToString(_vm.petComp.AgeYears, _vm.petComp.AgeMonths)))]), _vm._v(" "), _c('p', {
	    staticClass: "small text-muted",
	    staticStyle: {
	      "padding-top": "0px",
	      "margin-top": "0px",
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(_vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-right"
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.viewPetDetails()
	      }
	    }
	  }, [_vm._v("View")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block  btn-info",
	    on: {
	      "click": function($event) {
	        _vm.updatePetDetails()
	      }
	    }
	  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-warning",
	    on: {
	      "click": function($event) {
	        _vm.deletePet()
	      }
	    }
	  }, [_vm._v("Delete")])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")])])
	}]}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('CustomerConfirmedReservations')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-sm hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center hidden-md hidden-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-10 col-sm-offset-1"
	  }, [_c('hr', {
	    staticClass: "hidden-xs hidden-sm",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "10px"
	    }
	  })])
	}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "image-preview"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.photo),
	      expression: "!photo"
	    }],
	    staticClass: "fa fa-spinner fa-spin fa-6x fa-fw"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        _vm.deleteImage()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "title": "Delete this photo"
	    }
	  })]), _vm._v(" "), _c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.photo),
	      expression: "photo"
	    }],
	    staticClass: "background-image img img-responsive",
	    attrs: {
	      "id": "imgPrevBackground",
	      "src": _vm.photoComp
	    }
	  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
	    staticClass: "progress progress-image"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped",
	    style: ({
	      width: _vm.uploadCompletePct
	    }),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "my-button"
	  }, [_c('label', {
	    staticClass: "btn btn-success btn-title"
	  }, [_vm._v("\n        " + _vm._s(_vm.UploadPhotoTxtComp) + " "), _c('i', {
	    staticClass: "fa fa-camera"
	  }), _c('input', {
	    staticClass: "file",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "accept": "image/jpeg, image/bmp, image/png"
	    },
	    on: {
	      "change": _vm.previewThumbnail
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "crop-avatar"
	    }
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "modalBackground",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [_c('div', {
	    staticClass: "img-container col-md-6",
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px",
	      "overflow": "hidden"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "100%",
	      "overflow": "hidden"
	    },
	    attrs: {
	      "id": "cropMeBackground",
	      "src": _vm.uploadedImageSrc,
	      "alt": "Picture",
	      "crossorigin": ""
	    }
	  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-title",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.saveImage
	    }
	  }, [_vm._v("\n              Save Image\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-title",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.cancelSave
	    }
	  }, [_vm._v("\n              Cancel\n            ")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', {
	    staticClass: "modal-title"
	  }, [_c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" Add background photo\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 hidden-xs hidden-sm"
	  }, [_c('h4', [_vm._v("How it will look on your profile")]), _vm._v(" "), _c('div', {
	    staticClass: "docs-preview clearfix"
	  }, [_c('div', {
	    staticClass: "img-preview preview-md"
	  })])])
	}]}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "max-width": "500px"
	    },
	    attrs: {
	      "id": "login-overlay"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(!_vm.checkUser) ? _c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-block",
	    on: {
	      "click": _vm.goLogin
	    }
	  }, [_vm._v("\n              Login\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block",
	    on: {
	      "click": _vm.goHome
	    }
	  }, [_vm._v("\n              Home\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.checkUser) ? _c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px",
	      "min-height": "200px"
	    }
	  }, [(_vm.pending == true) ? _c('div', [_c('p', [_vm._v("\n                  Name: "), _c('strong', [_vm._v(_vm._s(_vm.compUserName))])]), _vm._v(" "), (_vm.compBookingId) ? _c('p', [_c('span', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.related),
	      expression: "related"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.related) ? _vm._i(_vm.related, null) > -1 : (_vm.related)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.related,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.related = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.related = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.related = $$c
	        }
	      }
	    }
	  })]), _vm._v("\n                  Issue is related to\n                  "), _c('strong', [_vm._v("Booking No: " + _vm._s(_vm.compBookingId))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Describe your problem below:")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ticket.Description),
	      expression: "ticket.Description"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:8'),
	      expression: "'required|min:8'"
	    }],
	    staticClass: "form-control",
	    class: {
	      input: true,
	        'has-error': _vm.errors.has('description'),
	    },
	    attrs: {
	      "name": "description",
	      "rows": "3",
	      "placeholder": "please describe your problem here",
	      "data-vv-delay": "1000",
	      "id": "supportTextArea"
	    },
	    domProps: {
	      "value": (_vm.ticket.Description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.ticket, "Description", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('description')),
	      expression: "errors.has('description')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first("description")))])])]) : _vm._e(), _vm._v(" "), (_vm.sent == true) ? _c('div', [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-success"
	  }, [_c('p', [_vm._v(_vm._s(_vm.alertMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sent) ? _c('button', {
	    staticClass: "btn btn-success btn-block",
	    attrs: {
	      "disabled": _vm.errors.has('description') || !_vm.ticket.Description
	    },
	    on: {
	      "click": function($event) {
	        _vm.createTicket()
	      }
	    }
	  }, [_vm._v("\n                Create Ticket\n              ")]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('button', {
	    staticClass: "btn btn-success btn-block",
	    attrs: {
	      "disabled": _vm.sent
	    },
	    on: {
	      "click": function($event) {
	        _vm.createTicket()
	      }
	    }
	  }, [_vm._v("\n                Ticket Sent Successfully\n              ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("\n              Go Home\n            ")])]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header text-center",
	    staticStyle: {
	      "padding-top": "0px !important",
	      "padding-bottom": "0px !important"
	    }
	  }, [_c('h2', [_c('i', {
	    staticClass: "fa fa-support"
	  }), _vm._v(" Contact Support")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('div', [_c('h3', [_vm._v("\n                  You have to be logged in to create a customer support ticket\n                ")])])])
	}]}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/pets-view/mypets"
	    }
	  }, [_c('a', [_vm._v("My Pets")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/pets-view/addpet"
	    }
	  }, [_c('a', [_vm._v("Add Pet")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('router-view')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-paw "
	  }), _vm._v(" Manage your Pets info")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "text-center hidden-sm hidden-md hidden-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-paw "
	  }), _vm._v(" Manage your Pets info")])
	}]}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('br', {
	    staticClass: "hidden-sm hidden-xs"
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "sticky",
	      rawName: "v-sticky",
	      value: ({
	        zIndex: 4,
	        stickyTop: 1
	      }),
	      expression: "{ zIndex: 4, stickyTop: 1 }"
	    }],
	    staticClass: "progress",
	    staticStyle: {
	      "margin-bottom": "10px"
	    },
	    attrs: {
	      "id": "progress"
	    }
	  }, [_c('div', {
	    staticClass: "progress-bar",
	    class: {
	      'progress-bar-warning': !_vm.profileStatus.IsProfileReady, 'progress-bar-info': _vm.profileStatus.IsProfileReady
	    },
	    style: ({
	      width: _vm.profileStatus.CompletePct + '%'
	    }),
	    attrs: {
	      "role": "progressbar"
	    }
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.profileStatus.CurrentStatus) + " "), (!_vm.profileStatus.IsProfileReady) ? _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "14px",
	      "color": "#8f47a4"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPopup()
	      }
	    }
	  }) : _vm._e()])])]), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs hidden-xs"
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/about"
	    }
	  }, [_c('a', [_vm._v("About Me")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/petpreferences"
	    }
	  }, [_c('a', [_vm._v("Pet Preferences")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/servicerates"
	    }
	  }, [_c('a', [_vm._v("Service Rates")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/calendar"
	    }
	  }, [_c('a', [_vm._v("Calendar")])])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs hidden-sm hidden-md hidden-lg"
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/about"
	    }
	  }, [_c('a', [_vm._v("About")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/petpreferences"
	    }
	  }, [_c('a', [_vm._v("Prefs")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/servicerates"
	    }
	  }, [_c('a', [_vm._v("Rates")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitter-profile-edit/calendar"
	    }
	  }, [_c('a', [_vm._v("Calendar")])])], 1), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Sitter Profile Setup")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "text-center hidden-sm hidden-md hidden-lg",
	    staticStyle: {
	      "margin-bottom": "5px",
	      "margin-top": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Sitter Profile Setup")])
	}]}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "col-md-12 col-xs-12 wrapper-box"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-8 col-lg-7 col-xs-12 remove-margins"
	  }, [_vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.Title),
	      expression: "sitterProfile.Title"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Title: e.g your trusted dog buddy!"
	    },
	    domProps: {
	      "value": (_vm.sitterProfile.Title)
	    },
	    on: {
	      "change": function($event) {
	        _vm.somethingChanged()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterProfile, "Title", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("introduce yourself and let Pet parents know you better, take your time tell them why you are their best sitter")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.AboutMe),
	      expression: "sitterProfile.AboutMe"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "rows": "5",
	      "placeholder": "Describe yourself and add anything you want about your work and prevoius pet experiences"
	    },
	    domProps: {
	      "value": (_vm.sitterProfile.AboutMe)
	    },
	    on: {
	      "change": function($event) {
	        _vm.somethingChanged()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterProfile, "AboutMe", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('UploadBackgroundPhoto')], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-xs-12 remove-margins"
	  }, [_vm._m(3), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("To make your profile standout upload 3 or more photos.")]), _vm._v(" "), _c('div', {
	    staticClass: "images-custom-container"
	  }, [_vm._l((_vm.sitterPhotoList), function(photo, index) {
	    return (_vm.sitterPhotoList != 0) ? _c('div', {
	      staticClass: "image-class"
	    }, [_c('ProfilePhotoView', {
	      key: photo.SitterPhotoId,
	      attrs: {
	        "photoIdProp": photo.SitterPhotoId,
	        "index": index
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "close",
	      on: {
	        "click": function($event) {
	          _vm.deleteImage(photo)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash",
	      attrs: {
	        "title": "Delete this photo"
	      }
	    })])], 1) : _vm._e()
	  }), _vm._v(" "), _c('div', {
	    staticClass: "image-class"
	  }, [_c('UploadAddMore')], 1)], 2)]), _vm._v(" "), (_vm.sitterProfile) ? _c('div', {
	    staticClass: "col-sm-8 col-xs-12 remove-margins"
	  }, [(_vm.sitterProfile.HomeDetailDto) ? _c('div', [_c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px",
	      "padding-bottom": "0px"
	    }
	  }, [_vm._v("Home Details")]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox",
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-top": "0px"
	    }
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.HomeDetailDto.IsHasChildren),
	      expression: "sitterProfile.HomeDetailDto.IsHasChildren"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasChildren) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasChildren, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasChildren)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasChildren,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasChildren = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasChildren = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasChildren", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                         Children under 10 years at Home")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.HomeDetailDto.IsSmokeFree),
	      expression: "sitterProfile.HomeDetailDto.IsSmokeFree"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsSmokeFree) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsSmokeFree, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsSmokeFree)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterProfile.HomeDetailDto.IsSmokeFree,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsSmokeFree = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsSmokeFree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsSmokeFree", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                         Smoke Free Household")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.HomeDetailDto.IsHasDog),
	      expression: "sitterProfile.HomeDetailDto.IsHasDog"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasDog) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasDog, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasDog)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasDog,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasDog = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasDog = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasDog", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                         I have resident Dog at home")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.HomeDetailDto.IsHasCat),
	      expression: "sitterProfile.HomeDetailDto.IsHasCat"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasCat) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasCat, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasCat)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasCat,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasCat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasCat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasCat", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                         I have resident Cat at home")])]), _vm._v(" "), _c('h3', [_vm._v("Home Type")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.HomeDetailDto.HomeType),
	      expression: "sitterProfile.HomeDetailDto.HomeType"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.sitterProfile.HomeDetailDto, "HomeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }, _vm._l((_vm.homeTypes), function(homeType) {
	    return _c('option', {
	      domProps: {
	        "value": homeType.value
	      }
	    }, [_vm._v("\n                        " + _vm._s(homeType.text) + "\n                    ")])
	  }))]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.citiesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.SitterLocationDto.CityId),
	      expression: "sitterProfile.SitterLocationDto.CityId"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.sitterProfile.SitterLocationDto, "CityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v(_vm._s(_vm.selectCityComp))]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
	    return _c('option', {
	      domProps: {
	        "value": city.CityId
	      }
	    }, [_vm._v("\n                        " + _vm._s(city.CityName) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), ((!_vm.areasList || _vm.areasList.length == 0)) ? _c('div', {
	    staticClass: "form-location",
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.areasList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterProfile.SitterLocationDto.AreaId),
	      expression: "sitterProfile.SitterLocationDto.AreaId"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "margin-top": "5px"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.sitterProfile.SitterLocationDto, "AreaId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Select your neighbor")]), _vm._v(" "), _vm._l((_vm.areasList), function(area) {
	    return _c('option', {
	      domProps: {
	        "value": area.AreaId
	      }
	    }, [_vm._v("\n                        " + _vm._s(area.AreaName) + "\n                    ")])
	  })], 2) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12",
	    staticStyle: {
	      "margin": "0px",
	      "padding": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12 col-xs-12",
	    staticStyle: {
	      "margin": "0px",
	      "padding": "0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn  large-pad btn-success btn-block btn-lg",
	    staticStyle: {
	      "margin-top": "20px",
	      "margin-left": "0px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateSitterProfile()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Profile Title "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Info about yourself "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_vm._v("Background Image "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px",
	      "margin-top": "0px"
	    }
	  }, [_vm._v("Profile Image, minimum 1 personal "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_vm._v("Location Details "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    staticClass: "form-control input-text"
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Select your neighbor")])])])
	}]}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.customEmailData) ? _c('div', {
	    staticClass: "container"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "filters"
	  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.countriesListComp) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.CountryId),
	      expression: "customEmailData.CountryId"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.customEmailData, "CountryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Filter specific country")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All Countries")]), _vm._v(" "), _vm._l((_vm.countriesListComp), function(country) {
	    return _c('option', {
	      domProps: {
	        "value": country.CountryId
	      }
	    }, [_vm._v("\n                                  " + _vm._s(country.CountryName) + "\n                                ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.AudienceId),
	      expression: "customEmailData.AudienceId"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.customEmailData.AudienceId, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.customEmailData, "AudienceId", "0")
	      }
	    }
	  }), _vm._v("Sitters Only")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.AudienceId),
	      expression: "customEmailData.AudienceId"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.customEmailData.AudienceId, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.customEmailData, "AudienceId", "1")
	      }
	    }
	  }), _vm._v("Customers Only")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.SendSms),
	      expression: "customEmailData.SendSms"
	    }],
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.customEmailData.SendSms, true)
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.customEmailData, "SendSms", true)
	      }
	    }
	  }), _vm._v("Send SMS")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.SendSms),
	      expression: "customEmailData.SendSms"
	    }],
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.customEmailData.SendSms, false)
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.customEmailData, "SendSms", false)
	      }
	    }
	  }), _vm._v("Dont send SMS")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', [_vm._v("Custom Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.CustomEmail),
	      expression: "customEmailData.CustomEmail"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Custom Email"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.CustomEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "CustomEmail", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Custom Firstname")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.CustomFirstName),
	      expression: "customEmailData.CustomFirstName"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Custom FirstName"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.CustomFirstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "CustomFirstName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('h5', [_vm._v("Email Template, please fill in all fields")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.Subject),
	      expression: "customEmailData.Subject"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (Email Subject)"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.Subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "Subject", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.CustomHeader),
	      expression: "customEmailData.CustomHeader"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Custom Header <p>"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.CustomHeader)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "CustomHeader", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.MainMessage),
	      expression: "customEmailData.MainMessage"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Main Message <h1>"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.MainMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "MainMessage", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.customEmailData.SendSms) ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.MessageSms),
	      expression: "customEmailData.MessageSms"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "3",
	      "placeholder": "SMS Message"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.MessageSms)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "MessageSms", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.customEmailData.SendSms) ? _c('br') : _vm._e(), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.SubMessage),
	      expression: "customEmailData.SubMessage"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "3",
	      "placeholder": "Sub Message <h4>"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.SubMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "SubMessage", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.ButtonTitle),
	      expression: "customEmailData.ButtonTitle"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Button Title"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.ButtonTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "ButtonTitle", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customEmailData.ButtonLink),
	      expression: "customEmailData.ButtonLink"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "placeholder": "Button Link (Url format https://xxxx.com)"
	    },
	    domProps: {
	      "value": (_vm.customEmailData.ButtonLink)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.customEmailData, "ButtonLink", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-warning btn-block",
	    attrs: {
	      "disabled": _vm.sent
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendCustomEmail()
	      }
	    }
	  }, [_vm._v("Send Email")])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	}]}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-12 col-xs-12 scrollable-menu wrapper-box",
	    on: {
	      "click": function($event) {
	        _vm.hasTooltip()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_c('br'), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n      Added as Favorite\n      "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Shows how many different users added you as their favorite."
	    }
	  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.FavoriteTimes))])]), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n      Repeated stays\n      "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Increases each time a previous client books your services again, this will increase your search ranking."
	    }
	  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.RepeatedStays))])]), _vm._v(" "), (_vm.performanceComp.AverageResponseTime) ? _c('p', {
	    staticClass: "small",
	    class: {
	      'text-danger': _vm.longAvgResponseComp
	    }
	  }, [_c('strong', [_vm._v("Avg Response Time")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
	    }
	  }), _vm._v(":"), _c('strong', [_vm._v(" " + _vm._s(_vm.performanceComp.AverageResponseTime))])]) : _vm._e(), _vm._v(" "), (!_vm.performanceComp.AverageResponseTime) ? _c('p', {
	    staticClass: "text-success small"
	  }, [_c('strong', [_vm._v("Avg Response Time ")]), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "The average time you take to reply or send customer a message or accept or deny a booking, please make sure to always respond as soon as possible."
	    }
	  }), _vm._v(":"), _c('strong', [_vm._v(" no requests yet.")])]) : _vm._e(), _vm._v(" "), (_vm.performanceComp.ResponseRate != 0) ? _c('p', {
	    staticClass: "small",
	    class: {
	      'text-danger': _vm.responseRateComp
	    }
	  }, [_c('strong', [_vm._v("Response Rate ")]), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "The percentage of booking requests you received and didn't respond to within 3 days."
	    }
	  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.ResponseRate) + "%")])]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n      Avg Rating\n      "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Average rating stars out of 5 that has been submitted by how many people."
	    }
	  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.ratingComp))])]), _vm._v(" "), _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n      Profile Views\n      "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Increases each time someone visits or views your public profile."
	    }
	  }), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.performanceComp.ProfileViews))])]), _vm._v(" "), (_vm.currentStatusComp) ? _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n      Profile Completeness\n      "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "This is an automated system that measures your profile for missing items, required items will show in red while optional items are shown in green."
	    }
	  }), _vm._v(":"), _c('strong', [_vm._v(" " + _vm._s(_vm.currentStatusComp))])]) : _vm._e(), _vm._v(" "), (_vm.profileMissingInfoComp) ? _c('div', [_c('hr', {
	    staticClass: "hidden-md hidden-lg",
	    staticStyle: {
	      "margin-top": "10px",
	      "margin-bottom": "10px"
	    }
	  }), _vm._v(" "), (_vm.profileMissingInfoComp.length > 0) ? _c('p', {
	    staticClass: "small"
	  }, [_vm._v("\n        Profile Pending Items\n        "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Each missing item here can be added by following the link in the description."
	    }
	  }), _vm._v(":\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profileMissingInfoComp), function(item) {
	    return _c('div', [(item.IsRequired) ? _c('p', {
	      staticClass: "text-danger small"
	    }, [_vm._v("\n          " + _vm._s(item.MissingDesc) + "\n          "), _c('a', {
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.routerGo(item.MissingLink)
	        }
	      }
	    }, [_vm._v(_vm._s(item.MissingLinkDesc))])]) : _c('p', {
	      staticClass: "text-success"
	    }, [_vm._v("\n          " + _vm._s(item.MissingDesc) + "\n          "), _c('a', {
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.routerGo(item.MissingLink)
	        }
	      }
	    }, [_vm._v(_vm._s(item.MissingLinkDesc))])])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.performanceComp.IsStayPreferenceSet == false) ? _c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.goBookingPreference()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" New (Booking Preference)\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-success btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goCalendar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" Update Calendar\n    ")]), _vm._v(" "), _c('div', [(_vm.performanceComp.IsStayPreferenceSet == false) ? _c('button', {
	    staticClass: "hidden-sm hidden-xs btn btn-lg btn-info",
	    staticStyle: {
	      "margin-top": "5px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBookingPreference()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" New (Booking Preference)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false && _vm.singaporeComp == false) ? _c('button', {
	    staticClass: "btn btn-lg btn-premium hidden-sm hidden-xs",
	    staticStyle: {
	      "margin-top": "5px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("\n        Go Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false && _vm.singaporeComp == false) ? _c('button', {
	    staticClass: "btn btn-lg btn-premium btn-block hidden-lg hidden-md",
	    staticStyle: {
	      "margin-top": "5px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("\n        Go Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })]) : _vm._e(), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "10px",
	      "margin-bottom": "10px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('h4', [_vm._v("Share your profile with friends and family")]), _vm._v(" "), _c('div', {
	    staticClass: "center-block",
	    staticStyle: {
	      "margin-left": "-4px"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareFacebook()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook fa-3x social",
	    attrs: {
	      "id": "social-fb"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": _vm.twitterUrl
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-twitter fa-3x social",
	    attrs: {
	      "id": "social-tw"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "disabled": !_vm.performanceComp.IsProfileReady,
	      "target": "_top",
	      "href": _vm.linkedinUrl
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin fa-3x social",
	    attrs: {
	      "id": "social-ln"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "disabled": !_vm.performanceComp.IsProfileReady,
	      "target": "_top",
	      "href": _vm.googleUrl
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus fa-3x social",
	    attrs: {
	      "id": "social-gp"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-md hidden-lg",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "disabled": !_vm.performanceComp.IsProfileReady,
	      "href": _vm.whatsappUrl,
	      "data-action": "share/whatsapp/share"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-whatsapp fa-3x social",
	    attrs: {
	      "id": "social-wa"
	    }
	  })])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    on: {
	      "click": function($event) {
	        _vm.hasTooltip()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "container",
	    staticStyle: {
	      "padding-left": "0px"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "5px",
	      "margin-bottom": "5px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("Home >")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSearchSitters(_vm.sitterPublicDetailComp.SitterId)
	      }
	    }
	  }, [_vm._v("Search Sitters >")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "text-decoration": "none"
	    }
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))])])]), _vm._v(" "), (_vm.sitterPublicDetailComp) ? _c('div', {
	    staticClass: "container some-style"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "bgWrap"
	  }, [_c('div', {
	    staticClass: "col-sm-12 bgCover ",
	    style: ({
	      backgroundImage: 'url(' + _vm.bgImageComp + ')'
	    })
	  }, [_c('div', {
	    staticClass: "photo-images"
	  }, _vm._l((_vm.sitterPublicDetailComp.SitterPhotoDtos), function(photo, index) {
	    return (photo.Type != 0) ? _c('div', {
	      staticClass: "thumb-wrap"
	    }, [_c('a', {
	      attrs: {
	        "href": photo.Path,
	        "data-fancybox": "images"
	      }
	    }, [_c('img', {
	      staticClass: "small-images",
	      attrs: {
	        "src": photo.Path
	      }
	    })])]) : _vm._e()
	  }))])]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 hidden-sm hidden-md hidden-lg"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    attrs: {
	      "src": _vm.sitterPublicDetailComp.ProfilePicUrl,
	      "alt": "",
	      "height": "100",
	      "width": "100"
	    }
	  }), _vm._v(" "), (_vm.sitterPublicDetailComp.IsOnline == true) ? _c('div', {
	    staticClass: "rank-label-container",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewProfile(_vm.sitter)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "label label-default rank-label"
	  }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h2', {
	    staticClass: "media-heading main-name"
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))]), _vm._v(" "), _c('h6', [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" " + _vm._s(_vm.LocationComp))]), _vm._v(" "), (_vm.sitterPublicDetailComp.RatingCount > 0) ? _c('div', [_vm._l((_vm.sitterPublicDetailComp.RatingAvg), function(n) {
	    return _c('i', {
	      staticClass: "fa fa-star fa-1x inline",
	      staticStyle: {
	        "color": "#ffd118"
	      }
	    })
	  }), _vm._v(" "), _c('h6', {
	    staticClass: " inline"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.RatingCount) + " " + _vm._s(_vm.reviewString(_vm.sitterPublicDetailComp.RatingCount)))])], 2) : _vm._e()])]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-xs hidden-sm media-right media-top",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-container": "body",
	      "data-placement": "top",
	      "data-content": "Add or Remove from Favorites",
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-md hidden-lg media-right media-top",
	    attrs: {
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "row"
	  }, [(_vm.sitterPublicDetailComp.IsActive == true) ? _c('div', {
	    staticClass: "alert alert-premium",
	    on: {
	      "click": function($event) {
	        _vm.premiumSwal()
	      }
	    }
	  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [(!_vm.sitterPublicDetailComp.AverageResponseTime == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Average Response Time: " + _vm._s(_vm.sitterPublicDetailComp.AverageResponseTime))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.ResponseRate == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [(_vm.sitterPublicDetailComp.ResponseRate > 90) ? _c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }) : _vm._e(), _vm._v(" Response Rate: " + _vm._s(_vm.sitterPublicDetailComp.ResponseRate) + "%")]) : _vm._e(), _vm._v(" "), (_vm.sitterPublicDetailComp.LastOnline && _vm.sitterPublicDetailComp.IsOnline == false) ? _c('h5', {
	    staticClass: "performance"
	  }, [_vm._v(" Last Seen: " + _vm._s(_vm.lastSeenDate(_vm.sitterPublicDetailComp.LastOnline)))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.RepeatedStays == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-handshake-o"
	  }), _vm._v(" Number of Repeated Clients: " + _vm._s(_vm.sitterPublicDetailComp.RepeatedStays))]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.sitterPublicDetailComp.SitterServiceDtos), function(item) {
	    return _c('table', {
	      staticClass: "table-condensed col-xs-12"
	    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', [(item.IsOffered) ? _c('tr', [_c('td', {
	      staticClass: "h4 col-xs-7",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_vm._v(_vm._s(item.Description) + " "), (item.ServiceType <= 4) ? _c('i', {
	      staticClass: "fa fa-question-circle",
	      staticStyle: {
	        "font-size": "12px",
	        "color": "orange"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Boarding (sitter's home), Sitting (parent's home)."
	      }
	    }) : _vm._e()]), _c('td', {
	      staticClass: "h4 col-xs-5",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.Price))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "font-size": "14px"
	      }
	    }, [_vm._v(_vm._s(item.DescriptionPer))])])]) : _vm._e()])])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 hidden-sm hidden-md hidden-lg"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-lg  btn-block btn-title",
	    staticStyle: {
	      "margin-top": "10px!important"
	    },
	    on: {
	      "click": function($event) {
	        _vm.contactSitter()
	      }
	    }
	  }, [_vm._v("Contact " + _vm._s(_vm.sitterPublicDetailComp.FirstName) + " "), _c('i', {
	    staticClass: "fa fa-commenting-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.howBookingWork()
	      }
	    }
	  }, [_vm._v("How booking or meet and greet work?")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(3), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Title))]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.AboutMe))]), _vm._v(" "), (_vm.petPrefComp.Restrictions) ? _c('div', [_c('h4', [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + " Restrictions")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.petPrefComp.Restrictions))])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.Experience) ? _c('div', [_c('h4', [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + " Experience with animals")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.petPrefComp.Experience))])]) : _vm._e()]), _vm._v(" "), (_vm.sitterPublicReviewsComp) ? _c('div', {
	    staticClass: "col-sm-10 col-xs-12"
	  }, [_vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', _vm._l((_vm.sitterPublicReviewsComp), function(review, index) {
	    return _c('div', {
	      staticClass: "media"
	    }, [_c('div', {
	      staticClass: "media-left"
	    }, [_c('img', {
	      staticClass: "img-responsive img-rounded img-min-size",
	      attrs: {
	        "src": review.ReviewerPicUrl,
	        "alt": "",
	        "height": "75",
	        "width": "75"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "media-left head-title"
	    }, [_c('h4', {
	      staticClass: "media-heading ",
	      staticStyle: {
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(_vm._s(review.ReviewerName))]), _vm._v(" "), _c('div', [_vm._l((review.Rating), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x",
	        staticStyle: {
	          "color": "#ffd118"
	        }
	      })
	    }), _vm._v(" "), _c('p', {
	      staticStyle: {
	        "font-size": "small",
	        "margin-top": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Posted " + _vm._s(review.ReviewDate))])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(review.Description) + " ")]), _vm._v(" "), (index != _vm.sitterPublicReviewsComp.length - 1) ? _c('hr') : _vm._e()])
	  }))]) : _vm._e()]), _vm._v(" "), (_vm.sitterPublicDetailComp.IsDogWalking) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _vm._v(" "), _c('h4', [_vm._v("Walking during the following days")]), _vm._v(" "), (_vm.sun > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_c('span', [_vm._v("Sun")])]) : _vm._e(), _vm._v(" "), (_vm.mon > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Mon\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tue > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Tue\n        ")]) : _vm._e(), _vm._v(" "), (_vm.wed > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Wed\n        ")]) : _vm._e(), _vm._v(" "), (_vm.thu > 0) ? _c('label', {
	    staticClass: "small",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Thu\n        ")]) : _vm._e(), _vm._v(" "), (_vm.fri > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Fri\n        ")]) : _vm._e(), _vm._v(" "), (_vm.sat > 0) ? _c('label', {
	    staticClass: "small ",
	    staticStyle: {
	      "font-weight": "300"
	    }
	  }, [_vm._v("\n            Sat\n        ")]) : _vm._e(), _vm._v(" "), (_vm.sitterPublicDetailComp.DogWalkingAreas.length > 0) ? _c('div', [_c('h4', [_vm._v("Walking for the following locations only:")]), _vm._v(" "), _vm._l((_vm.sitterPublicDetailComp.DogWalkingAreas), function(area, index) {
	    return _c('label', {
	      staticClass: "small ",
	      staticStyle: {
	        "font-weight": "300"
	      }
	    }, [_vm._v("\n            " + _vm._s(area.AreaName) + " "), _c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (index != _vm.sitterPublicDetailComp.DogWalkingAreas.length - 1),
	        expression: "index!=sitterPublicDetailComp.DogWalkingAreas.length-1"
	      }]
	    }, [_vm._v(",")])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.sitterPublicDetailComp.DogWalkingRemarks != null) ? _c('div', [_c('h4', [_vm._v("Dog Walking Restrictions and Details:")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.DogWalkingRemarks) + " ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('h3', {
	    staticClass: "text-success"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + "'s Home")]), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 0) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(6), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Studio Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 1) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(7), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 1 Bedroom Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 2) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(8), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 2 Bedroom Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 3) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(9), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 3 Bedroom Apartment ")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 4) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(10), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Townhouse ")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 5) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(11), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Villa ")])]) : _vm._e(), _vm._v(" "), (!_vm.homeDetailsComp.IsSmokeFree) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(12), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Smoking allowed at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasChildren) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(13), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Children at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasCat) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(14), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Resident cat at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasDog) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(15), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Resident dog at home")])]) : _vm._e(), _vm._v(" "), (_vm.hasSkillsComp) ? _c('h3', {
	    staticClass: "text-success"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + "'s Skills")]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanCPR) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(16), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" CPR First Aid")])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanOral) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(17), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Oral Mediciation")])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanInject) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(18), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Can provide injections")])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 hidden-xs"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    attrs: {
	      "src": _vm.sitterPublicDetailComp.ProfilePicUrl,
	      "alt": "",
	      "height": "100",
	      "width": "100"
	    }
	  }), _vm._v(" "), (_vm.sitterPublicDetailComp.IsOnline == true) ? _c('div', {
	    staticClass: "rank-label-container",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewProfile(_vm.sitter)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "label label-default rank-label"
	  }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h2', {
	    staticClass: "media-heading main-name"
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))]), _vm._v(" "), _c('h6', [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" " + _vm._s(_vm.LocationComp))]), _vm._v(" "), (_vm.sitterPublicDetailComp.RatingCount != 0) ? _c('div', [_vm._l((_vm.sitterPublicDetailComp.RatingAvg), function(n) {
	    return _c('i', {
	      staticClass: "fa fa-star fa-1x inline",
	      staticStyle: {
	        "color": "#ffd118"
	      }
	    })
	  }), _vm._v(" "), _c('h6', {
	    staticClass: " inline"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.RatingCount) + " " + _vm._s(_vm.reviewString(_vm.sitterPublicDetailComp.RatingCount)))])], 2) : _vm._e()])]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-xs hidden-sm media-right media-top",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-container": "body",
	      "data-placement": "top",
	      "data-content": "Add or Remove from Favorites",
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-md hidden-lg media-right media-top",
	    attrs: {
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.sitterPublicDetailComp.IsActive == true) ? _c('div', {
	    staticClass: "alert alert-premium-lg",
	    staticStyle: {
	      "border-color": "rgb(229, 221, 232)",
	      "margin-top": "7px",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.premiumSwal()
	      }
	    }
	  }, [_vm._m(19)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [(!_vm.sitterPublicDetailComp.AverageResponseTime == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Response Time: " + _vm._s(_vm.sitterPublicDetailComp.AverageResponseTime))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.RepeatedStays == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-handshake-o"
	  }), _vm._v(" Client Repeated Stays: " + _vm._s(_vm.sitterPublicDetailComp.RepeatedStays))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.ResponseRate == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [(_vm.sitterPublicDetailComp.ResponseRate > 90) ? _c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }) : _vm._e(), _vm._v(" Response Rate: " + _vm._s(_vm.sitterPublicDetailComp.ResponseRate) + "%")]) : _vm._e(), _vm._v(" "), (_vm.sitterPublicDetailComp.LastOnline && _vm.sitterPublicDetailComp.IsOnline == false) ? _c('h5', {
	    staticClass: "performance"
	  }, [_vm._v("Last Seen: " + _vm._s(_vm.lastSeenDate(_vm.sitterPublicDetailComp.LastOnline)))]) : _vm._e()]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._l((_vm.sitterPublicDetailComp.SitterServiceDtos), function(item) {
	    return _c('table', {
	      staticClass: "table-condensed col-xs-12"
	    }, [_vm._m(21, true), _vm._v(" "), _c('tbody', [(item.IsOffered) ? _c('tr', [_c('td', {
	      staticClass: "h4 col-xs-7",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "4px"
	      }
	    }, [_vm._v(_vm._s(item.Description) + " "), (item.ServiceType <= 4) ? _c('i', {
	      staticClass: "fa fa-question-circle",
	      staticStyle: {
	        "font-size": "12px",
	        "color": "orange"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Boarding (sitter's home), Sitting (parent's home)."
	      }
	    }) : _vm._e()]), _c('td', {
	      staticClass: "h4 col-xs-5",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.Price))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "font-size": "14px"
	      }
	    }, [_vm._v(_vm._s(item.DescriptionPer) + " ")])])]) : _vm._e()])])
	  })], 2), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-lg  btn-block ",
	    on: {
	      "click": function($event) {
	        _vm.contactSitter()
	      }
	    }
	  }, [_vm._v("Contact " + _vm._s(_vm.sitterPublicDetailComp.FirstName) + " "), _c('i', {
	    staticClass: "fa fa-commenting-o"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.howBookingWork()
	      }
	    }
	  }, [_vm._v("How booking or meet and greet work?")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 pull-right"
	  }, [_vm._m(22), _vm._v(" "), _c('div', [(_vm.petPrefComp) ? _c('div', {
	    staticClass: "col-xs-12 wrapper",
	    staticStyle: {
	      "margin-bottom": "5%"
	    }
	  }, [_c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " cats "
	  }, [(_vm.petPrefComp.AcceptCats) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Cats",
	      "src": __webpack_require__(235)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Cats",
	      "src": __webpack_require__(239)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: " text-center"
	  }, [_vm._v("Cats ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " small-breeds"
	  }, [(_vm.petPrefComp.AcceptSmallDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Small Dogs 0-6 KG",
	      "src": __webpack_require__(242)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Small Dogs",
	      "src": __webpack_require__(240)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: " text-center"
	  }, [_vm._v(" Small ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " medium-breeds "
	  }, [(_vm.petPrefComp.AcceptMediumDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Medium Size Dogs 7-18 KG",
	      "src": __webpack_require__(236)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Medium Size Dogs",
	      "src": __webpack_require__(233)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: "text-center"
	  }, [_vm._v(" Medium ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " "
	  }, [(_vm.petPrefComp.AcceptLargeDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Large Dogs 19+ KG",
	      "src": __webpack_require__(238)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Large Dogs",
	      "src": __webpack_require__(234)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: "text-center"
	  }, [_vm._v(" Large ")])])])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('CalendarView', {
	    attrs: {
	      "sitterId": this.$route.params.sitterId
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.sitterPublicDetailComp) ? _c('div', {
	    staticClass: "hidden-md hidden-lg text-center"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSearchSitters(_vm.sitterPublicDetailComp.SitterId)
	      }
	    }
	  }, [_c('h3', [_vm._v("Back to Search Sitters")])])]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('div', [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-warning"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.errorMsg) ? _c('div', [(!_vm.sitterPublicDetailComp) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(24)]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin": "0px"
	    }
	  }, [_vm._v(" Premium Member "), _c('i', {
	    staticClass: "fa fa-paw"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-id-badge"
	  }), _vm._v(" Offered Services ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Profile Details ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Reviews")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" Dog Walking")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(46),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(43),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(44),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(45),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(231),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(241),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(237),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin": "0px",
	      "margin-left": "12px"
	    }
	  }, [_vm._v(" Premium Member "), _c('i', {
	    staticClass: "fa fa-paw"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-id-badge"
	  }), _vm._v(" Offered Services ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  }), _vm._v(" Hosting Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" Availability")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "container-fluid main-body fix-bottom",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "selectCountry",
	      "data-backdrop": "static",
	      "show": "true",
	      "data-keyboard": "false",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog "
	  }, [_c('div', {
	    staticClass: "modal-content col-sm-offset-2 col-sm-8"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body ",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well"
	  }, _vm._l((_vm.countriesList), function(country) {
	    return _c('div', {
	      staticStyle: {
	        "margin": "5px"
	      }
	    }, [_c('a', {
	      staticClass: "dropdown-toggle",
	      attrs: {
	        "href": "javascript:;",
	        "data-toggle": "dropdown",
	        "role": "button",
	        "aria-haspopup": "true",
	        "aria-expanded": "false"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setCountry(country.CountryId)
	        }
	      }
	    }, [_c('img', {
	      staticClass: "img img-rounded",
	      staticStyle: {
	        "width": "auto",
	        "height": "35px",
	        "max-height": "5vh"
	      },
	      attrs: {
	        "alt": "Country",
	        "src": country.CountryFlag,
	        "crossOrigin": "Anonymous"
	      }
	    }), _vm._v(" "), _c('a', [_c('strong', [_vm._v(" " + _vm._s(country.CountryName))])])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    staticStyle: {
	      "font-size": "16px"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.getNewCountry()
	      }
	    }
	  }, [_vm._v("Want your country to be listed?")])])])])])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-default paw hidden-xs",
	    attrs: {
	      "role": "navigation "
	    }
	  }, [_c('div', {
	    staticClass: "container-fluid container-main "
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.routerGoHome()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "navbar-brand"
	  }, [_c('span', [_c('img', {
	    class: {
	      'tinted': _vm.active
	    },
	    attrs: {
	      "alt": "Dupaws Home",
	      "id": "logo",
	      "src": __webpack_require__(232),
	      "height": "58"
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.active = true
	      },
	      "mouseleave": function($event) {
	        _vm.active = false
	      }
	    }
	  })])])]), _vm._v(" "), (_vm.compUserRole != _vm.admin) ? _c('div', [(!_vm.checkUser) ? _c('ul', {
	    staticClass: "nav navbar-nav  navbar-right "
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/findsitters"
	    }
	  }, [_c('a', {
	    staticClass: "hidden-sm navbar-link"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search Sitters")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/login"
	    }
	  }, [_c('a', [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('span', {
	    staticClass: "navbar-toggle pull-right bookings-button",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_c('router-link', {
	    staticStyle: {
	      "list-style-type": "none"
	    },
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-sitter-reservations"
	    }
	  }, [_c('i', {
	    staticClass: "icon-fix fa fa-bookmark-o"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('span', {
	    staticClass: "navbar-toggle pull-right bookings-button",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_c('router-link', {
	    staticStyle: {
	      "list-style-type": "none"
	    },
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-reservations"
	    }
	  }, [_c('i', {
	    staticClass: "icon-fix fa fa-bookmark-o"
	  })])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "list-style-type": "none"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "margin-right": "0px",
	      "margin-left": "5px",
	      "padding-left": "0px",
	      "outline": "none"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showCountries()
	      }
	    }
	  }, [_c('i', [(_vm.countryDataComp.CountryFlag) ? _c('img', {
	    staticClass: "img img-rounded",
	    staticStyle: {
	      "text-indent": "-9999px",
	      "width": "auto",
	      "height": "35px",
	      "margin-bottom": "5px",
	      "outline": "none"
	    },
	    attrs: {
	      "alt": "Countries Selector",
	      "src": _vm.countryDataComp.CountryFlag,
	      "crossOrigin": "Anonymous"
	    }
	  }) : _vm._e()])])]), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('router-link', {
	    staticClass: "text-success",
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/become-a-sitter"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v(" Become a Sitter  "), _c('i', {
	    staticClass: "fa fa-heart-o",
	    class: {
	      'animated bounceIn': _vm.heartClass
	    },
	    staticStyle: {
	      "font-weight": "600"
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.heartClass = true
	      },
	      "mouseleave": function($event) {
	        _vm.heartClass = false
	      }
	    }
	  })])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.checkUser),
	      expression: "checkUser"
	    }],
	    staticClass: "nav navbar-nav navbar-right"
	  }, [(_vm.compUserRole != _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-xs hidden-sm",
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/findsitters"
	    }
	  }, [_c('a', {
	    staticClass: "navbar-link"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-xs hidden-sm",
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-reservations"
	    }
	  }, [_c('a', {
	    staticClass: "navbar-link"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-xs hidden-sm",
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/dashboard/feedback-performance"
	    }
	  }, [_c('a', {
	    staticClass: "navbar-link"
	  }, [_c('i', {
	    staticClass: "fa fa-globe "
	  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-xs hidden-sm",
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-sitter-reservations"
	    }
	  }, [_c('a', {
	    staticClass: "navbar-link"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('li', {
	    staticStyle: {
	      "list-style-type": "none"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "margin-right": "0px",
	      "margin-left": "5px",
	      "padding-left": "0px",
	      "outline": "none"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showCountries()
	      }
	    }
	  }, [_c('i', [_c('img', {
	    staticClass: "img img-rounded",
	    staticStyle: {
	      "width": "auto",
	      "height": "35px",
	      "margin-bottom": "5px"
	    },
	    attrs: {
	      "alt": "Flag",
	      "src": _vm.countryDataComp.CountryFlag,
	      "crossOrigin": "Anonymous"
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-md hidden-lg bookings-button",
	    attrs: {
	      "active-class": "active ",
	      "tag": "li",
	      "to": "/my-sitter-reservations"
	    }
	  }, [_c('div', {
	    staticClass: "icon-fix navbar-link"
	  }, [_c('i', {
	    staticClass: " fa fa-bookmark-o"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('router-link', {
	    staticClass: "hidden-md hidden-lg bookings-button",
	    attrs: {
	      "active-class": "active ",
	      "tag": "li",
	      "to": "/my-reservations"
	    }
	  }, [_c('div', {
	    staticClass: "icon-fix navbar-link"
	  }, [_c('i', {
	    staticClass: " fa fa-bookmark-o"
	  })])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticStyle: {
	      "list-style-type": "none"
	    }
	  }, [_c('div', {
	    staticClass: "notification-button",
	    attrs: {
	      "id": "webNotificationDropdown"
	    }
	  }, [_c('Notifications', {
	    attrs: {
	      "bindId": _vm.webDropdown
	    }
	  })], 1)]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown pull-right"
	  }, [(_vm.compUserName) ? _c('a', {
	    staticClass: "dropdown-toggle",
	    staticStyle: {
	      "margin-left": "3px"
	    },
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('img', {
	    staticClass: "img img-rounded",
	    staticStyle: {
	      "width": "auto",
	      "height": "50px",
	      "max-height": "5vh"
	    },
	    attrs: {
	      "alt": "User Profile Picture",
	      "src": _vm.compProfilePicUrl,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), _c('a', [_vm._v(" " + _vm._s(_vm.compUserName))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o"
	  }), _vm._v(" Account "), (_vm.mobileConfirmedComp) ? _c('label', {
	    staticClass: "badge badge-error"
	  }, [_vm._v("1")]) : _vm._e()])]), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', {
	    staticClass: "hidden-md hidden-lg"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goFindSitters()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goPetsView()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" Pets")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goCalendar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar "
	  }), _vm._v(" Update Calendar ")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    staticClass: "hidden-md hidden-lg",
	    attrs: {
	      "tag": "li",
	      "to": "/dashboard/feedback-performance"
	    }
	  }, [_c('a', [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/my-sitter-reservations"
	    }
	  }, [_c('a', [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/sitter-profile-edit/about"
	    }
	  }, [_c('a', [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Profile Setup")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goMyReservations()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goFavoriteSitters()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" Favorite Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client' && _vm.subscriptionStatusComp == false) ? _c('li', [_c('a', {
	    staticStyle: {
	      "color": "green !important"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Subscribe")])]) : _vm._e(), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('li', [_c('a', {
	    staticStyle: {
	      "font-weight": "600"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBecomeSitter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-heart-o",
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }), _vm._v(" Become a Sitter")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goToSitterProfile()
	      }
	    }
	  }, [_vm._v("View Public Profile")])]) : _vm._e(), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "padding": "0px",
	      "margin": "0px"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" Sign Out")])])], 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('div', [_c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/charts-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Charts Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/sitters-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Sitters Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/bookings-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Bookings Dashboard")])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown pull-right"
	  }, [(_vm.compUserName) ? _c('a', {
	    staticClass: "dropdown-toggle",
	    staticStyle: {
	      "margin-left": "3px"
	    },
	    attrs: {
	      "href": "javascript:;",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('img', {
	    staticClass: "img img-rounded",
	    staticStyle: {
	      "width": "auto",
	      "height": "50px",
	      "max-height": "5vh"
	    },
	    attrs: {
	      "alt": "User Profile Picture",
	      "src": _vm.compProfilePicUrl,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), _c('a', [_vm._v(" " + _vm._s(_vm.compUserName))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o"
	  }), _vm._v(" Account")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/users-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Users Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/charts-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Charts Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/sitters-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Sitters Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/bookings-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Bookings Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/tickets-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Tickets Dashboard")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": "/email-dashboard"
	    }
	  }, [_c('a', [_vm._v(" Custom Email Dashboard")])]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "padding": "0px",
	      "margin": "0px"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" Sign Out")])])], 1)])], 1)]) : _vm._e()])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-default navbar-static-top paw hidden-sm hidden-md hidden-lg"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [_vm._m(2), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.checkUser),
	      expression: "checkUser"
	    }],
	    staticClass: "navbar-toggle pull-right notification-button",
	    staticStyle: {
	      "padding": "0px"
	    },
	    attrs: {
	      "id": "mobileNotificationDropdown"
	    },
	    on: {
	      "click": function($event) {
	        _vm.closeNavbarIfOpen()
	      }
	    }
	  }, [_c('Notifications', {
	    attrs: {
	      "bindId": _vm.mobileDropdown
	    }
	  })], 1), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('span', {
	    staticClass: "navbar-toggle pull-right bookings-button",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_c('router-link', {
	    staticStyle: {
	      "list-style-type": "none"
	    },
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-sitter-reservations"
	    }
	  }, [_c('i', {
	    staticClass: "icon-fix fa fa-bookmark-o"
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('span', {
	    staticClass: "navbar-toggle pull-right bookings-button",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_c('router-link', {
	    staticStyle: {
	      "list-style-type": "none"
	    },
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/my-reservations"
	    }
	  }, [_c('i', {
	    staticClass: "icon-fix fa fa-bookmark-o"
	  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('span', {
	    staticClass: "pull-right"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showCountries()
	      }
	    }
	  }, [_c('i', [_c('img', {
	    staticClass: "img img-rounded",
	    staticStyle: {
	      "text-indent": "-9999px",
	      "width": "auto",
	      "height": "30px",
	      "margin-top": "10px",
	      "margin-right": "10px",
	      "max-height": "5vh"
	    },
	    attrs: {
	      "alt": "CF",
	      "src": _vm.countryDataComp.CountryFlag,
	      "crossOrigin": "Anonymous"
	    }
	  })])])]) : _vm._e(), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.routerGoHome()
	      }
	    }
	  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-collapse collapse",
	    attrs: {
	      "id": "navbar"
	    }
	  }, [_c('div', [(_vm.checkUser == true) ? _c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-book-o"
	  }), _vm._v(" Account "), (_vm.mobileConfirmedComp) ? _c('label', {
	    staticClass: "badge badge-error"
	  }, [_vm._v("1")]) : _vm._e()])]), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goFindSitters()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" Search Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goPetsView()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" My Pets")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSitterProfileEdit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Profile Setup")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSitterReservations()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v("  Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goCalendar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar "
	  }), _vm._v(" Update Calendar ")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goDashboard()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-globe "
	  }), _vm._v(" Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goMyReservations()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goFavoriteSitters()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" My Favorite Sitters")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.customer) ? _c('li', [_c('a', {
	    staticClass: "text-success",
	    staticStyle: {
	      "font-weight": "600"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBecomeSitter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-heart-o",
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }), _vm._v(" Become a Sitter")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client' && _vm.subscriptionStatusComp == false) ? _c('li', [_c('a', {
	    staticStyle: {
	      "color": "green"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Subscribe")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter' && _vm.subscriptionStatusComp == false && !_vm.singaporeComp) ? _c('li', [_c('a', {
	    staticStyle: {
	      "color": "rgb(147, 111, 159) !important"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" Go Premium")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.sitter) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goToSitterProfile()
	      }
	    }
	  }, [_vm._v("View Public Profile")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goUsersDashboard()
	      }
	    }
	  }, [_vm._v("Users Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSittersDashboard()
	      }
	    }
	  }, [_vm._v("Sitters Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBookingsDashboard()
	      }
	    }
	  }, [_vm._v("Bookings Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goChartsDashboard()
	      }
	    }
	  }, [_vm._v("Charts Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goTicketsDashboard()
	      }
	    }
	  }, [_vm._v("Tickets Dashboard")])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == _vm.admin) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goCustomEmailDashboard()
	      }
	    }
	  }, [_vm._v("Custom Email Dashboard")])]) : _vm._e(), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "padding": "0px",
	      "margin": "0px"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" Sign Out")])])]) : _vm._e(), _vm._v(" "), (!_vm.checkUser) ? _c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_vm._m(4), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/login"
	    }
	  }, [_c('a', [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), (_vm.checkUser == false) ? _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/findsitters"
	    }
	  }, [_c('a', [_vm._v(" Search Sitters "), _c('i', {
	    staticClass: "fa fa-search"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.sitter) ? _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/become-a-sitter"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("Become a Sitter "), _c('i', {
	    staticClass: "fa fa-heart-o",
	    staticStyle: {
	      "font-weight": "600"
	    }
	  })])]) : _vm._e()], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.mobileConfirmedComp && _vm.compUserRole != 'Sitter') ? _c('div', {
	    staticClass: "hidden-xs hidden-sm alert text-center alert-dismissible alert-success",
	    staticStyle: {
	      "margin-bottom": "0px",
	      "padding-top": "5px",
	      "padding-bottom": "5px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('span', {
	    staticClass: "h4"
	  }, [_c('i', {
	    staticClass: " fa fa-bell-o",
	    class: {
	      'animated swing': _vm.reminderClass
	    }
	  }), _vm._v("  Please verify your Mobile number to receive SMS updates, visit "), _c('a', {
	    staticClass: "h4",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_c('strong', [_vm._v("Account")])])])]) : _vm._e(), _vm._v(" "), (_vm.mobileConfirmedComp && _vm.compUserRole != 'Sitter') ? _c('div', {
	    staticClass: "hidden-lg hidden-md alert text-center alert-dismissible alert-success",
	    staticStyle: {
	      "margin-bottom": "0px",
	      "padding-top": "5px",
	      "padding-bottom": "5px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('span', {
	    staticClass: "h4"
	  }, [_c('i', {
	    staticClass: " fa fa-bell-o",
	    class: {
	      'animated swing': _vm.reminderClass
	    }
	  }), _vm._v("  Verify Mobile to get SMS updates "), _c('a', {
	    staticClass: "h4",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_c('strong', [_vm._v("Account")])])])]) : _vm._e(), _vm._v(" "), (_vm.sitterPremiumComp == false) ? _c('div', {
	    staticClass: "hidden-xs hidden-sm alert text-center alert-dismissible alert-info",
	    staticStyle: {
	      "margin-bottom": "0px",
	      "padding-top": "5px",
	      "padding-bottom": "5px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.hidePremium()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
	    staticClass: "h4",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("Go Premium "), _c('i', {
	    staticClass: " fa fa-paw",
	    class: {
	      'animated bounceIn': _vm.reminderClass
	    },
	    staticStyle: {
	      "font-size": "20px"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.sitterPremiumComp == false) ? _c('div', {
	    staticClass: "hidden-lg hidden-md alert text-center alert-dismissible alert-info",
	    staticStyle: {
	      "margin-bottom": "0px",
	      "padding-top": "5px",
	      "padding-bottom": "5px"
	    },
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.hidePremium()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
	    staticClass: "h4",
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v(" Go Premium "), _c('i', {
	    staticClass: " fa fa-paw",
	    class: {
	      'animated pulse': _vm.reminderClass
	    },
	    staticStyle: {
	      "font-size": "20px"
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
	    staticClass: "page-footer paw-footer",
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('div', {
	    staticClass: "container-fluid main-footer"
	  }, [_c('div', {
	    staticClass: "container center-block"
	  }, [_c('div', {
	    staticClass: "col-sm-3 col-xs-6"
	  }, [_c('h4', {
	    staticClass: "text-muted small-h4"
	  }, [_vm._v("Quick Links")]), _vm._v(" "), (!_vm.doubleRoleComp) ? _c('h5', [_vm._m(7)]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), (_vm.checkUser != true) ? _c('h5', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goLogin()
	      }
	    }
	  }, [_vm._v("Sign In")])]) : _vm._e(), _vm._v(" "), _c('h5', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goToSupport()
	      }
	    }
	  }, [_vm._v(" Contact Support "), _c('i', {
	    staticClass: "fa fa-support"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-xs-6"
	  }, [_c('h4', {
	    staticClass: "text-muted small-h4"
	  }, [_vm._v("Dupaws Info")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h5', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goTerms()
	      }
	    }
	  }, [_vm._v("Terms and Conditions")])]), _vm._v(" "), _c('h5', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goPrivacy()
	      }
	    }
	  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
	    staticClass: "container text-center text-muted"
	  }, [_c('br'), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "max-width": "600px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "center-block",
	    staticStyle: {
	      "margin-left": "-4px"
	    }
	  }, [_c('p', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-bottom": "2px"
	    }
	  }, [_vm._v("Send link to a friend")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareFacebook(_vm.myQuoteComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-facebook fa-2x social",
	    attrs: {
	      "id": "social-fb"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": _vm.twitterUrl
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareTwitter()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-twitter fa-2x social",
	    attrs: {
	      "id": "social-tw"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": _vm.linkedinUrl
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareLinkedin()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin fa-2x social",
	    attrs: {
	      "id": "social-ln"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_top",
	      "href": _vm.googleUrl
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareGooglePlus()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus fa-2x social",
	    attrs: {
	      "id": "social-gp"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "hidden-md hidden-lg",
	    attrs: {
	      "href": _vm.whatsappUrl,
	      "data-action": "share/whatsapp/share"
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareWhatsApp()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-whatsapp fa-2x social",
	    attrs: {
	      "id": "social-wa"
	    }
	  })]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "cursor": "pointer",
	      "color": "#fd7e14"
	    },
	    attrs: {
	      "target": "_top",
	      "href": _vm.mailUrl
	    },
	    on: {
	      "click": function($event) {
	        _vm.shareMail()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-square fa-2x social",
	    attrs: {
	      "id": "social-em"
	    }
	  })])])]), _vm._v(" "), _c('h5', {
	    staticClass: "text-muted"
	  }, [_vm._v("All rights reserved © Dupaws.com 2018")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" Please choose your country")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "hidden-sm"
	  }, [_c('a', {
	    staticClass: "navbar-link",
	    attrs: {
	      "href": "https://www.dupaws.com/pub/about"
	    }
	  }, [_vm._v(" About Us")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#navbar",
	      "aria-expanded": "false",
	      "aria-controls": "navbar"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "navbar-brand"
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "alt": "Dupaws Home",
	      "src": __webpack_require__(232),
	      "height": "46"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    staticClass: "navbar-link",
	    attrs: {
	      "href": "https://www.dupaws.com/pub/about"
	    }
	  }, [_vm._v(" About Us")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticStyle: {
	      "font-weight": "600"
	    },
	    attrs: {
	      "href": "/become-a-sitter"
	    }
	  }, [_vm._v(" Become a Sitter "), _c('i', {
	    staticClass: "fa fa-heart-o",
	    staticStyle: {
	      "font-weight": "600",
	      "font-size": "smaller"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/findsitters"
	    }
	  }, [_vm._v(" Search Sitters "), _c('i', {
	    staticClass: "fa fa-search"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/reviews"
	    }
	  }, [_vm._v("Customer Reviews")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/training"
	    }
	  }, [_vm._v("Brain Dog Training")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/about"
	    }
	  }, [_vm._v("About Us")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/faq"
	    }
	  }, [_vm._v("Frequently Asked Questions")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('a', {
	    attrs: {
	      "href": "mailto:info@dupaws.com"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o"
	  }), _vm._v(" info@dupaws.com")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12 col-sm-6 remove-margins"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-6"
	  }, [_c('h4', {
	    staticClass: "text-muted small-h4"
	  }, [_vm._v("Top Countries ")]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates"
	    }
	  }, [_vm._v(" United Arab Emirates ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/lebanon"
	    }
	  }, [_vm._v(" Lebanon ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/qatar"
	    }
	  }, [_vm._v(" Qatar")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/bahrain"
	    }
	  }, [_vm._v(" Bahrain")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/singapore"
	    }
	  }, [_vm._v(" Singapore")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/kuwait"
	    }
	  }, [_vm._v(" Kuwait")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-6"
	  }, [_c('h4', {
	    staticClass: "text-muted small-h4"
	  }, [_vm._v("Top Cities")]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-dubai"
	    }
	  }, [_vm._v("  Dubai ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-abu-dhabi"
	    }
	  }, [_vm._v("  Abu Dhabi ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-sharjah"
	    }
	  }, [_vm._v(" Sharjah ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/qatar/dog-boarding-in-doha"
	    }
	  }, [_vm._v("  Doha ")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/lebanon/dog-boarding-in-beirut"
	    }
	  }, [_vm._v(" Beirut")])])]), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/sitters/jordan/dog-boarding-in-amman"
	    }
	  }, [_vm._v("  Amman")])])])])])
	}]}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": _vm.petId,
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('img', {
	    staticClass: "pet-image",
	    staticStyle: {
	      "float": "left",
	      "margin-right": "5px"
	    },
	    attrs: {
	      "src": _vm.profilePhotoPathComp
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "modal-title",
	    staticStyle: {
	      "margin-bottom": "0px !important",
	      "margin-top": "0px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.petComp.Name))]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title",
	    staticStyle: {
	      "margin-bottom": "0px !important",
	      "margin-top": "0px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(" " + _vm._s(_vm.ageToString(_vm.petComp.AgeYears, _vm.petComp.AgeMonths)))])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [(_vm.morePics) ? _c('div', {
	    staticClass: "photo-images"
	  }, [_c('div', _vm._l((_vm.petComp.PetPhotoDtos), function(photo) {
	    return _c('div', {
	      staticClass: "thumb-wrap",
	      attrs: {
	        "href": photo.Path,
	        "data-fancybox": "pet-photo"
	      }
	    }, [_c('img', {
	      staticClass: "small-images",
	      staticStyle: {
	        "margin": "2px"
	      },
	      attrs: {
	        "src": photo.Path
	      }
	    })])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.morePics) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.noPetInfoComp == true) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._v("\n           This pet doesn't have optional details, feel free to ask the customer to update.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('ul', {
	    staticStyle: {
	      "list-style-type": "none",
	      "padding-bottom": "0px !important",
	      "margin-bottom": "0px !important",
	      "padding": "5px"
	    }
	  }, [(_vm.petComp.RabiesVaccinated != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Rabies Vaccinated")]) : _vm._e(), _vm._v(" "), (_vm.petComp.RabiesVaccinated == true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Rabies Vaccinated")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsNeuteredOrSpayed != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Neutered or Spayed")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsNeuteredOrSpayed == true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Neutered or Spayed")]) : _vm._e(), _vm._v(" "), (_vm.petComp.TicksOrFleas != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Clean from Ticks & Fleas")]) : _vm._e(), _vm._v(" "), (_vm.petComp.TicksOrFleas == true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Clean from Ticks & Fleas")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('ul', {
	    staticStyle: {
	      "list-style-type": "none",
	      "padding-top": "0px !important",
	      "margin-top": "0px !important",
	      "padding": "5px"
	    }
	  }, [(_vm.petComp.IsRegisteredwithColar != true && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" Registered with  municipality")]) : _vm._e(), _vm._v(" "), (_vm.petComp.IsRegisteredwithColar == true) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Registered with municipality")]) : _vm._e(), (_vm.petComp.MicrochipId == null && _vm.compUserRole == 'Client') ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" MicrochipId")]) : _vm._e(), _vm._v(" "), (_vm.petComp.MicrochipId) ? _c('li', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" MicrochipId: " + _vm._s(_vm.petComp.MicrochipId))]) : _vm._e(), _vm._v(" "), (_vm.petComp.PreferredVet) ? _c('li', [_vm._v("Preferred Vet in case of emergency:  " + _vm._s(_vm.petComp.PreferredVet))]) : _vm._e(), _vm._v(" "), (_vm.petComp.Remarks) ? _c('li', [_vm._v("Remarks:  " + _vm._s(_vm.petComp.Remarks))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [(_vm.compUserRole == 'Client') ? _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goUpdatePet(_vm.petComp)
	      }
	    }
	  }, [_vm._v("Update Info")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-sm-3 col-sm-offset-1"
	  }, [_c('div', {
	    staticClass: "filters"
	  }, [_vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "text-warning small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.ShowProfileReady),
	      expression: "searchData.ShowProfileReady"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.ShowProfileReady) ? _vm._i(_vm.searchData.ShowProfileReady, null) > -1 : (_vm.searchData.ShowProfileReady)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.ShowProfileReady,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.ShowProfileReady = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.ShowProfileReady = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "ShowProfileReady", $$c)
	        }
	      }
	    }
	  }), _c('strong', [_vm._v("Show Ready and Pending Approval Only")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.ShowNewRegistrations),
	      expression: "searchData.ShowNewRegistrations"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.ShowNewRegistrations) ? _vm._i(_vm.searchData.ShowNewRegistrations, null) > -1 : (_vm.searchData.ShowNewRegistrations)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.ShowNewRegistrations,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.ShowNewRegistrations = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.ShowNewRegistrations = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "ShowNewRegistrations", $$c)
	        }
	      }
	    }
	  }), _vm._v("Show New Registrations Only")])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.ShowSuspendedProfiles),
	      expression: "searchData.ShowSuspendedProfiles"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.ShowSuspendedProfiles) ? _vm._i(_vm.searchData.ShowSuspendedProfiles, null) > -1 : (_vm.searchData.ShowSuspendedProfiles)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.ShowSuspendedProfiles,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.ShowSuspendedProfiles = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.ShowSuspendedProfiles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "ShowSuspendedProfiles", $$c)
	        }
	      }
	    }
	  }), _vm._v("Show Suspended Profiles")])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.IsProfileApproved),
	      expression: "searchData.IsProfileApproved"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.IsProfileApproved) ? _vm._i(_vm.searchData.IsProfileApproved, null) > -1 : (_vm.searchData.IsProfileApproved)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.IsProfileApproved,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.IsProfileApproved = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.IsProfileApproved = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "IsProfileApproved", $$c)
	        }
	      }
	    }
	  }), _vm._v("Hide Approved Profiles")])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.IsRegisteredLastWeek),
	      expression: "searchData.IsRegisteredLastWeek"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.IsRegisteredLastWeek) ? _vm._i(_vm.searchData.IsRegisteredLastWeek, null) > -1 : (_vm.searchData.IsRegisteredLastWeek)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.IsRegisteredLastWeek,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.IsRegisteredLastWeek = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.IsRegisteredLastWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "IsRegisteredLastWeek", $$c)
	        }
	      }
	    }
	  }), _vm._v("Show Registered within 7 days")])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.ShowHalfCompleted),
	      expression: "searchData.ShowHalfCompleted"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.ShowHalfCompleted) ? _vm._i(_vm.searchData.ShowHalfCompleted, null) > -1 : (_vm.searchData.ShowHalfCompleted)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.ShowHalfCompleted,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.ShowHalfCompleted = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.ShowHalfCompleted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "ShowHalfCompleted", $$c)
	        }
	      }
	    }
	  }), _vm._v("Show Profiles with 50% or more completed only")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.countriesListComp) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.FilterCountryId),
	      expression: "searchData.FilterCountryId"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.searchData, "FilterCountryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Filter specific country")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All Countries")]), _vm._v(" "), _vm._l((_vm.countriesListComp), function(country) {
	    return _c('option', {
	      domProps: {
	        "value": country.CountryId
	      }
	    }, [_vm._v("\n                                    " + _vm._s(country.CountryName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block",
	    on: {
	      "click": function($event) {
	        _vm.resetFilters()
	      }
	    }
	  }, [_vm._v("Reset to default")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-block",
	    on: {
	      "click": function($event) {
	        _vm.applyFilters()
	      }
	    }
	  }, [_vm._v("Apply Filters")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger btn-block",
	    on: {
	      "click": function($event) {
	        _vm.addFreeSubscription()
	      }
	    }
	  }, [_vm._v("Add Free Subscription Singapore")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "input-group col-md-12"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.SearchText),
	      expression: "searchData.SearchText"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Sitters, by ID, Name or Email "
	    },
	    domProps: {
	      "value": (_vm.searchData.SearchText)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.getSearchText()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "SearchText", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.loading) ? _c('div', [_vm._l((_vm.sittersListComp), function(sitter, index) {
	    return (_vm.sittersListComp.length > 0) ? _c('div', {
	      staticClass: "col-sm-12"
	    }, [_c('div', {
	      staticClass: "sitterListbox card"
	    }, [_c('div', {
	      staticClass: "profile-img"
	    }, [_c('img', {
	      staticClass: "img-responsive img-rounded",
	      staticStyle: {
	        "min-width": "50px",
	        "min-height": "50px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": sitter.ProfilePicUrl,
	        "alt": "",
	        "height": "75",
	        "width": "75"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "profile-body "
	    }, [_c('button', {
	      staticClass: "btn btn-info btn-sm pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateEmail(sitter.Email)
	        }
	      }
	    }, [_vm._v("Change Email")]), _vm._v(" "), _c('h2', {
	      staticClass: "small",
	      class: {
	        'confirmed': sitter.EmailConfirmed
	      },
	      staticStyle: {
	        "margin-left": "13px"
	      }
	    }, [_vm._v(" " + _vm._s(sitter.Email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row"
	    }, [_c('div', {
	      staticClass: "content col-sm-4"
	    }, [(sitter.IsAdminSuspended) ? _c('p', {
	      staticClass: "text-danger"
	    }, [_c('strong', [_vm._v("Profile Currently Suspended")])]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" SitterId: "), _c('strong', [_vm._v(_vm._s(sitter.SitterId))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Name: " + _vm._s(sitter.FirstName) + " " + _vm._s(sitter.LastName))]), _vm._v(" "), _c('p', {
	      staticClass: "small",
	      class: {
	        'confirmed': sitter.PhoneConfirmed
	      },
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.getNumber(sitter)
	        }
	      }
	    }, [_c('strong', [_vm._v("Click to show phone")])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Registration Date: " + _vm._s(_vm.dateFormatter(sitter.RegistrationDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Registration Method: " + _vm._s(sitter.Provider))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Area: " + _vm._s(sitter.SitterLocationDto.AreaName))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" City: " + _vm._s(sitter.SitterLocationDto.CityName))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Country: " + _vm._s(sitter.SitterLocationDto.CountryName))]), _vm._v(" "), _c('h5', [_vm._v("Profile Rank Rate: " + _vm._s(sitter.ProfileRankRate))]), _vm._v(" "), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (sitter.ProfileRankRate),
	        expression: "sitter.ProfileRankRate"
	      }],
	      staticClass: "form-control",
	      domProps: {
	        "value": sitter.ProfileRankRate
	      },
	      on: {
	        "change": [function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(sitter, "ProfileRankRate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }, function($event) {
	          _vm.updateRank(sitter)
	        }]
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "0"
	      }
	    }, [_vm._v("Rank Zero")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "1"
	      }
	    }, [_vm._v("01 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "2"
	      }
	    }, [_vm._v("02 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "3"
	      }
	    }, [_vm._v("03 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "4"
	      }
	    }, [_vm._v("04 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "5"
	      }
	    }, [_vm._v("05 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "6"
	      }
	    }, [_vm._v("06")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "7"
	      }
	    }, [_vm._v("07")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "8"
	      }
	    }, [_vm._v("08 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "9"
	      }
	    }, [_vm._v("09 ")]), _vm._v(" "), _c('option', {
	      attrs: {
	        "value": "10"
	      }
	    }, [_vm._v("10 (Show first) ")])])]), _vm._v(" "), _c('div', {
	      staticClass: "content col-sm-8"
	    }, [_c('h5', [_vm._v("Profile Info")]), _vm._v(" "), (sitter.Title) ? _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Title: " + _vm._s(sitter.Title))]) : _vm._e(), _vm._v(" "), (sitter.PublicIdUrl) ? _c('p', {
	      staticClass: "small"
	    }, [_c('strong', [_vm._v(" Title: " + _vm._s(sitter.PublicIdUrl))])]) : _vm._e(), _vm._v(" "), (sitter.AboutMe) ? _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" About Me: " + _vm._s(sitter.AboutMe))]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "small",
	      class: {
	        'confirmed': sitter.IsProfileApproved
	      }
	    }, [_vm._v(" Profile Status: " + _vm._s(sitter.PerformanceDto.ProfileStatusDto.CurrentStatus))]), _vm._v(" "), (sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos) ? _c('div', [(sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos.length > 0) ? _c('p', {
	      staticClass: "small"
	    }, [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), _vm._l((sitter.PerformanceDto.ProfileStatusDto.ProfileMissingInfoDtos), function(item) {
	      return _c('div', [(item.IsRequired) ? _c('h6', {
	        staticClass: "text-danger"
	      }, [_vm._v(_vm._s(item.MissingDesc))]) : _c('h6', {
	        staticClass: "text-success"
	      }, [_vm._v(_vm._s(item.MissingDesc))])])
	    })], 2) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Remarks")]), _vm._v(" "), _c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (sitter.Remarks),
	        expression: "sitter.Remarks"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "rows": "2"
	      },
	      domProps: {
	        "value": (sitter.Remarks)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(sitter, "Remarks", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('a', {
	      staticStyle: {
	        "font-size": "13px"
	      },
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.saveRemarks(sitter)
	        }
	      }
	    }, [_vm._v("Save Remarks")])])]), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row pull-right"
	    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (sitter.IsInstagramWinner == false),
	        expression: "sitter.IsInstagramWinner==false"
	      }],
	      staticClass: "btn btn-success btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsInstagramWinner == true
	      },
	      on: {
	        "click": function($event) {
	          _vm.instagramWinner(sitter)
	        }
	      }
	    }, [_vm._v("Make Instagram Winner")]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (sitter.IsInstagramWinner == true),
	        expression: "sitter.IsInstagramWinner==true"
	      }],
	      staticClass: "btn btn-warning btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsInstagramWinner == false
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeInstagramWinner(sitter)
	        }
	      }
	    }, [_vm._v("Remove Instagram Winner")]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (sitter.IsAdminSuspended == false),
	        expression: "sitter.IsAdminSuspended==false"
	      }],
	      staticClass: "btn btn-danger btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsAdminSuspended == true
	      },
	      on: {
	        "click": function($event) {
	          _vm.suspendProfile(sitter)
	        }
	      }
	    }, [_vm._v("Suspend Profile")]), _vm._v(" "), _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (sitter.IsAdminSuspended == true),
	        expression: "sitter.IsAdminSuspended==true"
	      }],
	      staticClass: "btn btn-danger btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsAdminSuspended == false
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeSuspension(sitter)
	        }
	      }
	    }, [_vm._v("Remove Suspension")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-success btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.extendSubscription(sitter)
	        }
	      }
	    }, [_vm._v("Extend Subscription 30 days")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-warning btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsProfileApproved == false
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeApproval(sitter)
	        }
	      }
	    }, [_vm._v("Remove Approval")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-success btn-sm pull-right ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      attrs: {
	        "disabled": sitter.IsProfileApproved == true
	      },
	      on: {
	        "click": function($event) {
	          _vm.approveProfile(sitter)
	        }
	      }
	    }, [_vm._v("Approve")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-info btn-sm pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_vm._v("View Profile")])])]), _vm._v(" "), _c('br')]) : _vm._e()
	  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.sittersListComp.length == 0) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._m(5)]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Welcome to Sitters Dashboard")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-search"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('strong', [_vm._v(" Profile Pending Items "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "font-size": "12px",
	      "color": "orange"
	    }
	  }), _vm._v(":")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sitterListbox card"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Ooopsy, no results match your search.")])])
	}]}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container col-sm-12 col-xs-12"
	  }, [_c('h3', [_c('strong', [_vm._v(" " + _vm._s(_vm.email))])]), _vm._v(" "), (_vm.codeSent) ? _c('div', [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.codeSent) ? _c('div', [_vm._m(0), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    on: {
	      "click": function($event) {
	        _vm.sendCode()
	      }
	    }
	  }, [_vm._v("Generate Code")]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.pending) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.codeSent) ? _c('div', [_c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [(_vm.pending) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Verification Code",
	      "maxlength": "6",
	      "autocorrect": "off",
	      "autocomplete": "off",
	      "autocapitalize": "off",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [(_vm.pending) ? _c('button', {
	    staticClass: "btn btn-info",
	    staticStyle: {
	      "font-size": "small !important"
	    },
	    attrs: {
	      "disabled": _vm.count > 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendCode()
	      }
	    }
	  }, [_vm._v("Re-Send Code " + _vm._s(_vm.count) + " ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.closeEmail()
	      }
	    }
	  }, [_vm._v("Close")])])]) : _vm._e(), _vm._v(" "), (!_vm.pending) ? _c('button', {
	    staticClass: "btn btn-default pull-right",
	    on: {
	      "click": function($event) {
	        _vm.closeEmail()
	      }
	    }
	  }, [_vm._v("Close")]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v("We will generate a 6 digit code and send it to your registered email, press Generate Code when you are ready")])])
	}]}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('hr'), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.alert) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(_vm._s(_vm.alert))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "accountManager",
	      "data-backdrop": "static",
	      "show": "true",
	      "data-keyboard": "false",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog "
	  }, [_c('div', {
	    staticClass: "modal-content col-sm-offset-2 col-sm-8",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "modal-body ",
	    staticStyle: {
	      "overflow": "hidden",
	      "margin-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('div', [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v("Administrative Settings")]), _vm._v(" "), (_vm.userDataComp.Provider != 'Facebook') ? _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.changePassword()
	      }
	    }
	  }, [_vm._v("Change Password")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('button', {
	    staticClass: "btn btn-block btn-premium",
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("Go Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('button', {
	    staticClass: "btn btn-block btn-success",
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Subscribe")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.admin) ? _c('button', {
	    staticClass: "btn btn-block btn-warning",
	    on: {
	      "click": function($event) {
	        _vm.confirmSwitchAccount()
	      }
	    }
	  }, [_vm._v("Switch account to Sitter or Client")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('button', {
	    staticClass: "btn btn-block btn-danger",
	    on: {
	      "click": function($event) {
	        _vm.goSuspend()
	      }
	    }
	  }, [_vm._v("Suspend Account "), _c('i', {
	    staticClass: "fa fa-warning"
	  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.hideAccountManagementModal()
	      }
	    }
	  }, [_vm._v("Close")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6  col-md-5 col-lg-4 col-xs-12"
	  }, [_c('h4', [_vm._v("Profile Photo")]), _vm._v(" "), _c('ProfilePicUpload', {
	    staticStyle: {
	      "padding-left": "0px",
	      "min-height": "210px"
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Email")]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(3), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userDataComp.UserName),
	      expression: "userDataComp.UserName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.userDataComp.UserName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userDataComp, "UserName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('a', {
	    staticClass: "text-success",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.verifyEmail()
	      }
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.emailStatusComp))])])])]), _vm._v(" "), _c('h4', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userDataComp.FirstName),
	      expression: "userDataComp.FirstName"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": (_vm.userDataComp.FirstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userDataComp, "FirstName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userDataComp.LastName),
	      expression: "userDataComp.LastName"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": (_vm.userDataComp.LastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userDataComp, "LastName", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('h4', [_vm._v("Mobile Phone "), (_vm.compUserRole == 'Sitter') ? _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon",
	    attrs: {
	      "id": "basic-addon1"
	    }
	  }, [_vm._v(_vm._s(_vm.userDataComp.CountryCode))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userDataComp.PhoneNumber),
	      expression: "userDataComp.PhoneNumber"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "pattern": "\\d*",
	      "disabled": _vm.phoneNumberConfirmedComp
	    },
	    domProps: {
	      "value": (_vm.userDataComp.PhoneNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userDataComp, "PhoneNumber", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), (_vm.phoneNumberComp) ? _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('a', {
	    staticClass: "text-success",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.verifyPhone()
	      }
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.phoneStatusComp))])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.showAccountManagementModal()
	      }
	    }
	  }, [_vm._v("Optional Settings")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-success",
	    on: {
	      "click": function($event) {
	        _vm.updateUser()
	      }
	    }
	  }, [_vm._v("Save changes")]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "changePassword",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content "
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('ChangePassword', {
	    staticStyle: {
	      "padding-left": "0px"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "verifyEmail",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content "
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('VerifyEmail', {
	    staticStyle: {
	      "padding-left": "0px"
	    }
	  })], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "verifyPhone",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content "
	  }, [_vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('VerifyPhone', {
	    staticStyle: {
	      "padding-left": "0px"
	    },
	    attrs: {
	      "countryCode": _vm.countryDataComp.CountryCode,
	      "mobileNumber": _vm.userData.PhoneNumber
	    }
	  })], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-vcard-o"
	  }), _vm._v(" Manage your Account Info")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center hidden-sm hidden-md hidden-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-vcard-o"
	  }), _vm._v(" Manage your Account Info")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Account Management")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h4', [_vm._v(" Change Password")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h4', [_vm._v(" Verify Email")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h4', [_vm._v(" Verify Phone Number")])])
	}]}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image-wrap"
	  }, [_c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.profilePhoto),
	      expression: "profilePhoto"
	    }],
	    staticClass: "img",
	    attrs: {
	      "src": _vm.photoComp,
	      "crossOrigin": "Anonymous"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n    This declaration describes the procedures and technologies we use to\n    protect users personal information which is called Privacy Policy.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Information Collection")]), _vm._v(" "), _c('p', [_vm._v("\n    Below are the different kinds of information that we collect from our\n    users: -IP addresses, browser type, version, operating system, page views\n    and website navigation. -Information about individual name, mobile number,\n    email, billing details, address details, credit card details \"Although we\n    dont store credit card data on our servers and only use hashes to make any\n    subsequent transaction\". -User images, pet images, names, date of birth,\n    vaccinations, experience, restrictions, pets behavior in addition to any\n    information we seem viable to make sure both parties know all the required\n    details for a successful booking. -Any information that users might choose\n    to send us such as reviews, comments, feedback, service tickets and more\n    will be stored securely in our servers for reference. -We allow users to\n    have chat and messaging between each other and thus we cannot control what\n    users share on our platform.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Cookies and Local Storage")]), _vm._v(" "), _c('p', [_vm._v("\n    Our platform doesn't rely primarly on Cookies, we instead use whats called\n    LocalStorage and SessionStorage to store user data, this data is kept in\n    broweser history until a user signs-out or clear browser data. In the\n    future we might utilize Cookies or SessionCookies to enhance users\n    experience, but users can still work on the website with Cookies disabled.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("User data usage and retention")]), _vm._v(" "), _c('p', [_vm._v("\n    Users that directly register or connect via Facebook can decide to delete\n    their data at any point. All user data will be completely deleted from\n    Dupaws platform upon request by sending info@dupaws.com, data such as\n    first name, last name, email or booking requests will be permenantly\n    deleted from our platform (all servers and databases connected to Dupaws\n    services).\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Third Party")]), _vm._v(" "), _c('p', [_vm._v("\n    Similar to most major web platforms, we do utilize 3rd party integrations\n    with Google, Facebook and other important providers to enhance our users\n    experience in addition for analytics usage, our platform is hosted in EU\n    utilizing Google Cloud Services and Microsoft Azure for redundancy\n    purposes.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("International data transfers")]), _vm._v(" "), _c('p', [_vm._v("\n    Since our servers are located in EU countries, and most of our customers\n    are based in Middle Eastern region, we do transfer data from user browser\n    back to our servers securely over SSL \"Https\" connections.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Payment and Financial data")]), _vm._v(" "), _c('p', [_vm._v("\n    Dupaws primary focus is to ensure your data and credit card information\n    are safe, when you decide to make a payment on Dupaws, we will establish a\n    secure channel to our payment gateway processor and provide them with your\n    card information, Dupaws doesn't safe your credit card number, CSV or any\n    information that can be used to process your credit card in any way. The\n    only information that we may store are information necassary to save a\n    Token for your next purchase which will be used by the payment gateway\n    provider.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Use of other users data")]), _vm._v(" "), _c('p', [_vm._v("\n    You acknowledge and agree that you cannot share or use Dupaws members\n    information without explicit permission from the user.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Amendments")]), _vm._v(" "), _c('p', [_vm._v("\n    We may update this privacy policy at any given time, with each update you\n    get to see the version date in the bottom of this page to ensure that you\n    accepted the latest published version.\n  ")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("Updated Nov 16, 2021")])])
	}]}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.existingReservationComp) ? _c('div', {
	    staticClass: "container"
	  }, [_c('h2', {
	    staticClass: "small-h2 text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
	  }, [(_vm.existingReservationComp.CustomerStatus) ? _c('div', {
	    staticClass: "alert alert-dismissible",
	    class: _vm.existingReservationComp.StatusClass,
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Customer Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.CustomerStatus))])]) : _vm._e(), _vm._v(" "), (_vm.existingReservationComp.SitterStatus) ? _c('div', {
	    staticClass: "alert alert-dismissible",
	    class: _vm.existingReservationComp.StatusClass,
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Sitter Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.SitterStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_c('h4', [_c('strong', [_vm._v("Submitted date is " + _vm._s(_vm.dateFormatter(_vm.existingReservationComp.SubmittedDate)))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 remove-margins"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-circle",
	    attrs: {
	      "src": _vm.existingReservationComp.SitterProfilePic,
	      "alt": "",
	      "height": "25",
	      "width": "25"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h4', {
	    staticClass: "media-heading ",
	    staticStyle: {
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(" Sitter Name:  "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.SitterName))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 remove-margins"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-circle",
	    attrs: {
	      "src": _vm.existingReservationComp.CustomerProfilePic,
	      "alt": "",
	      "height": "25",
	      "width": "25"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h4', {
	    staticClass: "media-heading ",
	    staticStyle: {
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Customer Name: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.CustomerName))])])])])]), _vm._v(" "), _c('ChatHistory', {
	    attrs: {
	      "transactionId": _vm.reservationIdComp,
	      "submittedDate": _vm.existingReservationComp.SubmittedDate,
	      "preventChat": true
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-info btn-lg",
	    on: {
	      "click": function($event) {
	        _vm.goBookingsDashboard()
	      }
	    }
	  }, [_vm._v("Go to Bookings Dashboard")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
	    return _c('div', [_c('div', [_c('PetSelectCard', {
	      key: petCard.PetId,
	      attrs: {
	        "showDetails": true,
	        "petId": petCard.PetId
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('h5', {
	    staticClass: "small"
	  }, [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]), _vm._v(" "), _c('h5', {
	    staticClass: "small"
	  }, [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
	    return _c('h5', {
	      staticClass: "small"
	    }, [_vm._v(_vm._s(service.Description))])
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "text-success"
	  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp))])], 2)])]) : _c('div', {
	    staticClass: "container"
	  }, [_vm._m(2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('h1', [_c('i', {
	    staticClass: "fa fa-spinner fa-spin"
	  }), _vm._v(" Loading..")])])
	}]}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog "
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Take me Home")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', [_c('strong', [_vm._v("404 Page not found "), _c('i', {
	    staticClass: "fa fa-meh-o"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('h2', [_vm._v(" Oops the page requested was not Found")])]), _vm._v(" "), _c('br')])
	}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.signalReady) ? _c('ViewSitterReservationComponent') : _c('div', {
	    staticClass: "container"
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Preparing connection...")]), _vm._v(" "), _c('p', {
	    staticClass: "text-muted"
	  }, [_vm._v("\n      if this takes too long, it could be your network provider has a proxy or\n      firewall preventing chat to be established, or use a different browser\n      for this session as we have seen some features being blocked on old\n      Safari and Internet Explorer. Alternatively\n      "), _c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/contact-support"
	    }
	  }, [_vm._v(" contact support ")]), _vm._v("\n      if the issue persist.\n    ")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.loading == true) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length == 0 && !_vm.loading) ? _c('div', [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('h3', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_vm._v("No bookings available, visit "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSearchSitters()
	      }
	    }
	  }, [_c('strong', [_vm._v("Search Sitters")])]), _vm._v(" to book a sitter now.")])])]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0 && !_vm.loading) ? _c('div', {
	    staticClass: "hidden-lg hidden-md"
	  }, [_c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#filterSort"
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchCollapse()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-navicon"
	  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
	    staticClass: " hidden-md hidden-lg collapse",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    },
	    attrs: {
	      "id": "filterSort"
	    }
	  }, [_c('div', {
	    staticClass: "reservationSummary"
	  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', [_c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "0"
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "1"
	      }
	    }
	  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "2"
	      }
	    }
	  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.hideCompleted()
	      }
	    }
	  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.showCompleted()
	      }
	    }
	  }, [_vm._v("Show Completed or Expired")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0 && !_vm.loading) ? _c('div', {
	    staticClass: "hidden-xs hidden-sm col-sm-4 col-xs-12 "
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', [_c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "0"
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "1"
	      }
	    }
	  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "2"
	      }
	    }
	  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
	    staticClass: "btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.hideCompleted()
	      }
	    }
	  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
	    staticClass: "btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.showCompleted()
	      }
	    }
	  }, [_vm._v("Show Completed or Expired")])])]) : _vm._e(), _vm._v(" "), (_vm.myReservations) ? _c('div', {
	    staticClass: "col-sm-12 col-md-8 col-xs-12 pull-right"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.sortedReservationsComp), function(reservation, index) {
	    return _c('div', {
	      key: reservation.ReservationId,
	      staticClass: "wrapper "
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [_c('div', {
	      staticClass: "media-left",
	      staticStyle: {
	        "padding-top": "10px"
	      }
	    }, [_c('img', {
	      staticClass: "media-object img-responsive img-circle",
	      staticStyle: {
	        "min-width": "30px",
	        "min-height": "30px",
	        "border": "1px solid #c3c3c3",
	        "cursor": "pointer"
	      },
	      attrs: {
	        "src": reservation.SitterProfilePic,
	        "alt": "",
	        "height": "30",
	        "width": "30"
	      },
	      on: {
	        "click": function($event) {
	          _vm.goSitter(reservation.SitterId)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "media-left",
	      staticStyle: {
	        "padding-top": "10px"
	      }
	    }, [_c('a', {
	      staticClass: "media-heading main-name",
	      staticStyle: {
	        "padding-bottom": "0px",
	        "margin-bottom": "3px"
	      },
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.goSitter(reservation.SitterId)
	        }
	      }
	    }, [_c('strong', [_vm._v(" " + _vm._s(reservation.SitterName))])])]), _vm._v(" "), _c('div', {
	      staticClass: "media-bottom"
	    }, [_c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Booking number: "), _c('strong', [_vm._v(" " + _vm._s(reservation.BookingNumber) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(_vm.startDateComp(reservation)))]), _vm._v(" "), _c('span', [_vm._v("To "), _c('strong', [_vm._v(_vm._s(_vm.endDateComp(reservation)))])])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Submitted: "), _c('strong', [_vm._v(" " + _vm._s(_vm.sentDate(reservation.SubmittedDate)) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-success",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(" Starts")]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.startDate(reservation.StartDate)) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Total price: "), _c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(" " + _vm._s(_vm.customerTotalPrice(reservation.TotalPrice)) + " ")]), _vm._v(" " + _vm._s(_vm.currencyComp))]), _vm._v(" "), _c('h5', {
	      staticClass: "alert text-muted",
	      class: reservation.StatusClass
	    }, [_c('strong', [_vm._v("Status: ")]), _vm._v(" " + _vm._s(reservation.CustomerStatus))])])]), _vm._v(" "), _c('div', {
	      staticClass: "media-bottom",
	      staticStyle: {
	        "overflow": "hidden"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-success btn-block",
	      on: {
	        "click": function($event) {
	          _vm.goToReservation(reservation)
	        }
	      }
	    }, [_vm._v("Go to Booking ")]), _vm._v(" "), (_vm.bookingRemovable(reservation)) ? _c('button', {
	      staticClass: "btn btn-warning btn-block",
	      on: {
	        "click": function($event) {
	          _vm.removeBooking(reservation);
	          reservation.IsCustomerRemoved = true
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash-o"
	    }), _vm._v(" Remove from Bookings ")]) : _vm._e(), _vm._v(" "), (reservation.IsCustomerRemoved == true) ? _c('button', {
	      staticClass: "btn btn-warning btn-block",
	      attrs: {
	        "disabled": ""
	      }
	    }, [_vm._v("Removing..")]) : _vm._e()])])
	  }))]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Sort")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Sort")])
	}]}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "list-style": "none"
	    },
	    attrs: {
	      "id": _vm.bindId
	    }
	  }, [_c('div', {
	    staticClass: "dropdown-toggle unselectable notification-bell ",
	    attrs: {
	      "href": "javascript:;",
	      "role": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: " fa fa-bell-o animated",
	    class: {
	      'swing': _vm.active
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.active = true
	      },
	      "mouseleave": function($event) {
	        _vm.active = false
	      }
	    }
	  }), (_vm.unreadNotificationsComp.length > 0) ? _c('label', {
	    staticClass: "badge badge-error"
	  }, [_vm._v(_vm._s(_vm.unreadNotificationsComp.length))]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right scrollable-menu"
	  }, [_vm._l((_vm.notificationsComp), function(notification, index) {
	    return _c('li', {
	      key: notification.UserNotificatoionId
	    }, [_c('div', {
	      staticClass: "custom-class",
	      class: {
	        read: notification.IsRead
	      }
	    }, [_c('h5', [_c('button', {
	      staticClass: "close",
	      staticStyle: {
	        "font-size": "xx-large"
	      },
	      attrs: {
	        "type": "button",
	        "data-dismiss": "alert",
	        "aria-label": "Close"
	      },
	      on: {
	        "click": function($event) {
	          _vm.deleteNotification(notification)
	        }
	      }
	    }, [_c('span', {
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_vm._v("×")])])]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "margin-left": "3px"
	      }
	    }, [_c('img', {
	      staticClass: "img img-circle",
	      staticStyle: {
	        "width": "auto",
	        "height": "30px"
	      },
	      attrs: {
	        "src": notification.ProfilePic,
	        "crossOrigin": "Anonymous"
	      }
	    })]), _vm._v(" "), _c('strong', {
	      staticClass: "bold-text"
	    }, [_vm._v(_vm._s(notification.SenderName))]), _vm._v("   Booking :"), _c('strong', [_vm._v(" " + _vm._s(notification.BookingNumber) + " ")]), _vm._v(" "), _c('div', {
	      staticClass: "h5",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "5px",
	        "margin-left": "5px"
	      }
	    }, [_vm._v("\n          " + _vm._s(notification.Title) + " "), _c('small', {
	      staticClass: "pull-right text-muted"
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-time text-muted"
	    }), _vm._v(" " + _vm._s(_vm.sentDate(notification.SentDate)))])]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-info btn-block",
	      on: {
	        "click": function($event) {
	          _vm.viewNotification(notification)
	        }
	      }
	    }, [_vm._v("Visit Booking Page")]), _vm._v(" "), (index != (_vm.notificationsComp.length - 1)) ? _c('hr', {
	      staticStyle: {
	        "margin-bottom": "0px"
	      }
	    }) : _vm._e()])])
	  }), _vm._v(" "), (_vm.notificationsComp.length == 0) ? _c('li', [_vm._m(0)]) : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "custom-class"
	  }, [_c('h5', {
	    staticClass: "text-muted text-center"
	  }, [_c('strong', [_vm._v(" Dupaws notifications")])]), _vm._v(" "), _c('h5', {
	    staticClass: "text-center"
	  }, [_vm._v("You dont have any notifications yet")])])
	}]}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "max-width": "500px"
	    },
	    attrs: {
	      "id": "login-overlay"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.notification) ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible"
	  }, [_vm._m(2), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.notification) + "\r\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "form-group "
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "username"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.username) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('email')),
	      expression: "!errors.has('email')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.username),
	      expression: "credentials.username"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('email')
	    },
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "placeholder": "Email address",
	      "lazy": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.username)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "username", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help-inline text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('password')),
	      expression: "!errors.has('password')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:4'),
	      expression: "'required|min:4'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('password')
	    },
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": "Password",
	      "data-vv-delay": "1000"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-block btn-title",
	    attrs: {
	      "disabled": _vm.filledRequiredComp == false
	    },
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Login")])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header text-center",
	    staticStyle: {
	      "padding-top": "0px !important",
	      "padding-bottom": "0px !important"
	    }
	  }, [_c('h2', [_vm._v("Welcome to Dupaws.com")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pending) ? _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("UnSubscribing..")]) : _c('div', [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("\n      Successfully removed "), _c('strong', [_vm._v(_vm._s(_vm.email))]), _vm._v(" from our mailing list.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Thank you for being part of Dupaws.com")])])])
	},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', _vm._l((_vm.favoriteSittersComp), function(sitter, index) {
	    return (_vm.favoriteSittersComp && _vm.favoriteSittersComp.length > 0) ? _c('div', {
	      staticClass: "col-sm-12 pull-right hidden-sm hidden-xs"
	    }, [_c('div', {
	      staticClass: "card"
	    }, [_c('div', {
	      staticClass: "sitterListbox "
	    }, [(sitter.IsActive) ? _c('div', {
	      staticClass: "ribbon-container",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.premiumSwal()
	        }
	      }
	    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "profile-img"
	    }, [_c('img', {
	      staticClass: "img-responsive img-rounded",
	      staticStyle: {
	        "cursor": "pointer",
	        "min-width": "170px",
	        "min-height": "170px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": sitter.ProfilePhotoUrl,
	        "alt": "",
	        "height": "240",
	        "width": "240"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "profile-body "
	    }, [_c('div', {
	      staticClass: "profile-body-details"
	    }, [_c('h2', [_vm._v(_vm._s(sitter.Name))]), _vm._v(" "), _c('div', {
	      staticClass: "home-details align-right"
	    }, [_c('div', {
	      staticClass: "homewrapper"
	    }, [(sitter.IsHasCat) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Resident cat at home"
	      }
	    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasDog) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Resident dog at home"
	      }
	    }, [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasChildren) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Children at home"
	      }
	    }, [_vm._m(4, true)]) : _vm._e(), _vm._v(" "), (!sitter.IsSmokeFree) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Smoke allowed at home"
	      }
	    }, [_vm._m(5, true)]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isFavorite(sitter.SitterId) == true) ? _c('span', {
	      staticClass: "fa fa-2x favorite",
	      staticStyle: {
	        "margin-top": "2px"
	      },
	      attrs: {
	        "data-container": "body",
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-content": "Remove From Favorites"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-heart"
	    })]) : _c('span', {
	      staticClass: "fa fa-2x favorite",
	      staticStyle: {
	        "margin-top": "2px"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-container": "body",
	        "data-placement": "top",
	        "data-content": "Add to Favorites"
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-heart-o"
	    })])])]), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [(sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x inline",
	        staticStyle: {
	          "color": "#ffd118",
	          "font-size": "18px"
	        }
	      })
	    }), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted inline reviews small"
	    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " Reviews")])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted",
	      staticStyle: {
	        "padding-top": "2px",
	        "margin-top": "0px"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-map-marker"
	    }), _vm._v(" " + _vm._s(sitter.Location))]), _vm._v(" "), _c('h4', {
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px"
	      }
	    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
	      staticClass: "text-overflow"
	    }, [_vm._v(" " + _vm._s(sitter.AboutMe))])])])])]), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('div', {
	      staticStyle: {
	        "padding-left": "10px",
	        "padding-right": "10px"
	      }
	    }, [_c('hr', {
	      staticStyle: {
	        "margin": "5px"
	      }
	    }), _vm._v(" "), (!sitter.AverageResponseTime == 0) ? _c('figure', {
	      staticClass: "performance"
	    }, [_vm._m(6, true), _vm._v(" "), _c('strong', [_c('p', {
	      staticClass: "small text-center"
	    }, [_vm._v(_vm._s(sitter.AverageResponseTime))])])]) : _vm._e(), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('figure', {
	      staticClass: "performance"
	    }, [_vm._m(7, true), _vm._v(" "), _c('strong', [_c('p', {
	      staticClass: "small text-center"
	    }, [_vm._v(_vm._s(sitter.RepeatedStays) + " times")])])]) : _vm._e(), _vm._v(" "), _c('figure', {
	      staticClass: "performance pull-right"
	    }, [_vm._m(8, true), _vm._v(" "), _c('strong', [_c('p', {
	      staticClass: "small text-center"
	    }, [_c('span', {
	      staticClass: "small"
	    }, [_vm._v("From ")]), _vm._v(" "), _c('strong', {
	      staticStyle: {
	        "color": "#feb34f"
	      }
	    }, [_vm._v(_vm._s(sitter.Price))]), _c('span', {
	      staticClass: "small"
	    }, [_vm._v(" " + _vm._s(_vm.currencyComp))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
	      staticClass: "btn-block btn btn-success btn-title ",
	      staticStyle: {
	        "margin-top": "10px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_vm._v("Visit Profile")])])]) : _vm._e()
	  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.favoriteSittersComp), function(sitter, index) {
	    return (_vm.favoriteSittersComp && _vm.favoriteSittersComp.length > 0) ? _c('div', {
	      staticClass: "col-xs-12  hidden-md hidden-lg ",
	      staticStyle: {
	        "padding": "0px",
	        "margin": "0px"
	      }
	    }, [_c('div', {
	      staticClass: "sittersListMobile"
	    }, [(sitter.IsActive) ? _c('div', {
	      staticClass: "ribbon",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.premiumSwal()
	        }
	      }
	    }, [_vm._v("Premium "), _c('i', {
	      staticClass: "fa fa-paw"
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "small-border"
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [_c('div', {
	      staticClass: "media-left"
	    }, [_c('img', {
	      staticClass: "media-object img-responsive img-rounded",
	      staticStyle: {
	        "min-width": "60px",
	        "min-height": "60px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": sitter.ProfilePhotoUrl,
	        "alt": "",
	        "height": "80",
	        "width": "80"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }), _vm._v(" "), (sitter.IsOnline == true) ? _c('div', {
	      staticClass: "rank-label-container",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "label label-default rank-label"
	    }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "media-left head-title"
	    }, [_c('h4', {
	      staticStyle: {
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(sitter.Name))])]), _vm._v(" "), (sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x inline",
	        staticStyle: {
	          "margin": "0px",
	          "color": "#ffd118",
	          "font-size": "15px"
	        }
	      })
	    }), _vm._v(" "), _c('h5', {
	      staticClass: "text-muted inline reviews",
	      staticStyle: {
	        "padding": "0px",
	        "margin": "0px",
	        "font-size": "15px"
	      }
	    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " Reviews")])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted",
	      staticStyle: {
	        "padding-top": "2px",
	        "margin-top": "2px"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-map-marker"
	    }), _vm._v(" " + _vm._s(sitter.Location))])]), _vm._v(" "), _c('h4', {
	      staticStyle: {
	        "padding-top": "5px",
	        "margin-top": "5px",
	        "padding-bottom": "2px",
	        "margin-bottom": "2px"
	      }
	    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
	      staticClass: "text-overflow"
	    }, [_vm._v(" " + _vm._s(sitter.AboutMe))]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-9",
	      staticStyle: {
	        "padding-left": "0px",
	        "margin-left": "0px"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-success btn-block btn-title",
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_vm._v("Visit Profile")]), _vm._v(" "), (_vm.isFavorite(sitter.SitterId) == true) ? _c('button', {
	      staticClass: "btn btn-info btn-block btn-title",
	      attrs: {
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_vm._v("Added to favorites "), _c('i', {
	      staticClass: "fa fa-heart"
	    })]) : _c('button', {
	      staticClass: "btn btn-info btn-block btn-title",
	      attrs: {
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_vm._v("Add to favorites "), _c('i', {
	      staticClass: "fa fa-heart-o",
	      staticStyle: {
	        "color": "white"
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-3 price-wrap"
	    }, [_c('div', {
	      staticClass: "pricing-head-mobile"
	    }, [_c('h4', [_c('span', [_vm._v("from")]), _vm._v(_vm._s(sitter.Price)), _c('span', [_vm._v(_vm._s(_vm.currencyComp) + "/day")])])])])])])])]) : _vm._e()
	  }), _vm._v(" "), (!_vm.loading && _vm.favoriteSittersComp.length == 0) ? _c('div', [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("There are no Favorite Sitters added, please go to "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goFindSitters()
	      }
	    }
	  }, [_vm._v("Find Sitters")]), _vm._v(" to add favorites")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(9)]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" My Favorite Sitters")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "target": "_blank"
	    }
	  }, [_vm._v("Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(44),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(45),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(46),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('figcaption', {
	    staticClass: "small text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Response Time ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('figcaption', {
	    staticClass: "small text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-handshake-o"
	  }), _vm._v(" Repeated Bookings ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('figcaption', {
	    staticClass: "small text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Price Rates ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	}]}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('div', {
	    staticClass: "filters"
	  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.Incremental),
	      expression: "query.Incremental"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "true"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.query.Incremental, "true")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.query, "Incremental", "true")
	      }
	    }
	  }), _vm._v("Incremental")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.Incremental),
	      expression: "query.Incremental"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "false"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.query.Incremental, "false")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.query, "Incremental", "false")
	      }
	    }
	  }), _vm._v("Non-Incremental")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "chartsFromDate"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.FromDate),
	      expression: "query.FromDate"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "readonly": "true",
	      "placeholder": "From Date"
	    },
	    domProps: {
	      "value": (_vm.query.FromDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.query, "FromDate", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "chartsToDate"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.ToDate),
	      expression: "query.ToDate"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "readonly": "true",
	      "placeholder": "To Date"
	    },
	    domProps: {
	      "value": (_vm.query.ToDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.query, "ToDate", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm.countriesListComp) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.CountryId),
	      expression: "query.CountryId"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.query, "CountryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("\n                Filter specific country\n              ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All Countries")]), _vm._v(" "), _vm._l((_vm.countriesListComp), function(country) {
	    return _c('option', {
	      domProps: {
	        "value": country.CountryId
	      }
	    }, [_vm._v("\n                " + _vm._s(country.CountryName) + "\n              ")])
	  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Pet Owners vs Pet Sitters")]), _vm._v(" "), _c('line-chart', {
	    attrs: {
	      "chart-data": _vm.usersSittersData,
	      "options": _vm.chartOptions,
	      "width": 1200
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Bookings Chart")]), _vm._v(" "), _c('line-chart', {
	    attrs: {
	      "chart-data": _vm.bookingsChartData,
	      "options": _vm.chartOptions,
	      "width": 1200
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	}]}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(!_vm.subscriptionComp) ? _c('div', [_c('div', {
	    staticClass: "text-center hidden-xs"
	  }, [(_vm.userRoleComp == 'Client') ? _c('h1', [_vm._v("Become a member")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('h1', {
	    staticStyle: {
	      "color": "#926d9e"
	    }
	  }, [_vm._v("\n        Go Premium "), _c('i', {
	    staticClass: "fa fa-paw",
	    staticStyle: {
	      "font-size": "32px"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('p', {
	    staticClass: "lead",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        Get paid to cuddle with pets. Receive 5x more bookings.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('p', {
	    staticClass: "lead",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        The best experience for cats and dogs.\n      ")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "hidden-sm hidden-md hidden-lg"
	  }, [(_vm.userRoleComp == 'Client') ? _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("\n        Become a member\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('h1', {
	    staticClass: "text-center",
	    staticStyle: {
	      "color": "#926d9e"
	    }
	  }, [_vm._v("\n        Go Premium "), _c('i', {
	    staticClass: "fa fa-paw",
	    staticStyle: {
	      "font-size": "32px"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Sitter') ? _c('p', {
	    staticClass: "lead",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        Get paid to cuddle with pets. Receive 5x more bookings.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('p', {
	    staticClass: "lead",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        The best experience for cats and dogs.\n      ")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "paypalModal",
	      "data-backdrop": "static",
	      "show": "true",
	      "data-keyboard": "false",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content col-sm-offset-2 col-sm-8",
	    staticStyle: {
	      "padding": "0px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden",
	      "margin-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('div', [_c('p', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.Description))]), _vm._v(" package\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
	    staticClass: "h6"
	  }, [_vm._v("\n                  Notice: we dont re-charge your card when the plan\n                  expires.")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "paypal-button-container"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.hidePaypalModal()
	      }
	    }
	  }, [_vm._v("\n                Cancel\n              ")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "plans"
	  }, _vm._l((_vm.plansDto), function(plan) {
	    return _c('div', {
	      staticClass: "col-md-4 remove-margins-xs"
	    }, [_c('div', {
	      staticClass: "card-body"
	    }, [(plan.DaysDuration == 365) ? _c('div', {
	      staticClass: "ribbon"
	    }, [_vm._v("Best Value")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "card-header"
	    }, [_c('h4', {
	      staticClass: "text-center font-weight-normal"
	    }, [_vm._v("\n              " + _vm._s(plan.Description) + "\n            ")])]), _vm._v(" "), _c('div', {
	      staticClass: "text-center"
	    }, [_c('h1', {
	      staticClass: "card-title pricing-card-title"
	    }, [_vm._v("\n              $" + _vm._s(plan.Price) + " "), _c('small', {
	      staticClass: "text-muted"
	    }, [_vm._v("/ mo")])]), _vm._v(" "), _c('ul', {
	      staticClass: "list-unstyled"
	    }, [(plan.PlanType == 2) ? _c('div', [_c('li', [_vm._v("Booking requests from to all")]), _vm._v(" "), _c('li', [_vm._v("More cuddles and more profit")]), _vm._v(" "), _c('li', [_vm._v("Priority over basic profiles")]), _vm._v(" "), _c('li', [_vm._v("Premium Account profile badge")])]) : _vm._e(), _vm._v(" "), (plan.PlanType == 1) ? _c('div', [_c('li', [_vm._v("Access to all pet sitters")]), _vm._v(" "), _c('li', [_vm._v("Unlimited booking requests")]), _vm._v(" "), _c('li', [_vm._v("Meet and greet amazing people")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "padding": "15px"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-lg btn-info btn-block",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.showPaypalModal(plan)
	        }
	      }
	    }, [_vm._v("\n                Upgrade Account\n              ")])])])])])
	  })), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div')]) : _c('div', [_c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("You already have a valid subscription")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-md-offset-3",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("\n        Go home\n      ")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Payment method\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "pendingModal",
	      "data-backdrop": "static",
	      "show": "true",
	      "data-keyboard": "false",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content col-sm-offset-2 col-sm-8"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" Payment Pending\n            ")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden",
	      "margin-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('div', [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("\n                  Pending Payment Completion, please wait...\n                ")])])]), _vm._v(" "), _c('br')])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center hidden-xs"
	  }, [_c('p', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        Dupaws donates 10% of all subscriptions to feeding and helping stray\n        animals.\n      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hidden-sm hidden-md hidden-lg"
	  }, [_c('p', {
	    staticStyle: {
	      "margin-bottom": "0px",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("\n        Dupaws donates 10% of all subscriptions to feeding and helping stray\n        animals.\n      ")])])
	}]}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12 col-sm-12 container"
	  }, [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(_vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pending),
	      expression: "pending"
	    }],
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userData.OldPassword),
	      expression: "userData.OldPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Enter your old password"
	    },
	    domProps: {
	      "value": (_vm.userData.OldPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userData, "OldPassword", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pending),
	      expression: "pending"
	    }],
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userData.NewPassword),
	      expression: "userData.NewPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Enter your new password"
	    },
	    domProps: {
	      "value": (_vm.userData.NewPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userData, "NewPassword", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pending),
	      expression: "pending"
	    }],
	    staticClass: "btn btn-title btn-success",
	    on: {
	      "click": function($event) {
	        _vm.changePassword()
	      }
	    }
	  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pending),
	      expression: "pending"
	    }],
	    staticClass: "btn btn-title btn-default",
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  }, [_vm._v("\n      Cancel\n    ")])])])
	},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "findSitters",
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "container remove-margins"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "5px",
	      "margin-bottom": "5px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("Home >")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "text-decoration": "none"
	    }
	  }, [_vm._v("Search Sitters")])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 hidden-xs hidden-sm",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "filters",
	    on: {
	      "click": function($event) {
	        _vm.cleanAnchor()
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.citiesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.cityId),
	      expression: "queryDataComp.cityId"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "citySelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v(_vm._s(_vm.selectCityStatusComp))]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
	    return _c('option', {
	      domProps: {
	        "value": city.CityId
	      }
	    }, [_vm._v("\n                                    " + _vm._s(city.CityName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.servicesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.serviceType),
	      expression: "queryDataComp.serviceType"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "serviceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Choose your Service")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service) {
	    return _c('option', {
	      domProps: {
	        "value": service.ServiceType
	      }
	    }, [_vm._v("\n                                    " + _vm._s(service.ServiceName) + "\n                                  ")])
	  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-from-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "findSittersDatePickerFrom"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.start),
	      expression: "queryDataComp.start"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "placeholder": "Pick up",
	      "readonly": "true"
	    },
	    domProps: {
	      "value": (_vm.queryDataComp.start)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.queryDataComp, "start", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "findSittersDatePickerTo"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.end),
	      expression: "queryDataComp.end"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "placeholder": "Drop off",
	      "disabled": !_vm.queryDataComp.start,
	      "readonly": "true"
	    },
	    domProps: {
	      "value": (_vm.queryDataComp.end)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.queryDataComp, "end", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType == 6),
	      expression: "queryDataComp.serviceType==6"
	    }],
	    staticClass: "form-location"
	  }, [_c('hr'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("Dog walking for specific days")]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sun),
	      expression: "sun"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "1",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sun) ? _vm._i(_vm.sun, null) > -1 : _vm._q(_vm.sun, "1")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sun,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("1") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sun = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sun = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sun = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sun")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mon),
	      expression: "mon"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "2",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.mon) ? _vm._i(_vm.mon, null) > -1 : _vm._q(_vm.mon, "2")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.mon,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("2") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.mon = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.mon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.mon = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Mon")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tue),
	      expression: "tue"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "4",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.tue) ? _vm._i(_vm.tue, null) > -1 : _vm._q(_vm.tue, "4")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.tue,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("4") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.tue = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.tue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.tue = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Tue")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.wed),
	      expression: "wed"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "8",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.wed) ? _vm._i(_vm.wed, null) > -1 : _vm._q(_vm.wed, "8")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.wed,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("8") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.wed = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.wed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.wed = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Wed")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thu),
	      expression: "thu"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "16",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.thu) ? _vm._i(_vm.thu, null) > -1 : _vm._q(_vm.thu, "16")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.thu,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("16") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.thu = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.thu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.thu = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Thu")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fri),
	      expression: "fri"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "32",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.fri) ? _vm._i(_vm.fri, null) > -1 : _vm._q(_vm.fri, "32")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.fri,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("32") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.fri = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.fri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.fri = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Fri")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sat),
	      expression: "sat"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "64",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sat) ? _vm._i(_vm.sat, null) > -1 : _vm._q(_vm.sat, "64")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sat,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("64") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sat = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sat")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType != 6),
	      expression: "queryDataComp.serviceType!=6"
	    }],
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.homeTypesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.homeType),
	      expression: "queryDataComp.homeType"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "socialSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "homeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Social Preference")]), _vm._v(" "), _vm._l((_vm.homeTypesList), function(home) {
	    return _c('option', {
	      domProps: {
	        "value": home.HomeType
	      }
	    }, [_vm._v("\n                                    " + _vm._s(home.HomeTypeName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType != 6),
	      expression: "queryDataComp.serviceType!=6"
	    }],
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.petprefsList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.petpref),
	      expression: "queryDataComp.petpref"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "petprefSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "petpref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Pet Preference")]), _vm._v(" "), _vm._l((_vm.petprefsList), function(pet) {
	    return _c('option', {
	      domProps: {
	        "value": pet.PetPref
	      }
	    }, [_vm._v("\n                                    " + _vm._s(pet.PetPrefName) + "\n                                  ")])
	  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [(_vm.filteredAreasList && _vm.filteredAreasList.length > 0) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.filteredAreasList && _vm.filteredAreasList.length > 0) ? _c('div', {
	    staticClass: "form-group "
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.areaId),
	      expression: "queryDataComp.areaId"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "areaSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "areaId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Available Neighbors")]), _vm._v(" "), _vm._l((_vm.filteredAreasList), function(area) {
	    return _c('option', {
	      domProps: {
	        "value": area.AreaId
	      }
	    }, [_vm._v("\n                    " + _vm._s(area.AreaName) + "\n                  ")])
	  })], 2)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.resetFilters()
	      }
	    }
	  }, [_vm._v("Reset Filters")])])])]), _vm._v(" "), _c('button', {
	    staticClass: " hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#filters"
	    },
	    on: {
	      "click": function($event) {
	        _vm.cleanAnchor()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-navicon"
	  }), _vm._v("   Filters and Preferences")]), _vm._v(" "), _c('div', {
	    staticClass: "hidden-xs hidden-sm"
	  }, [_c('div', {
	    staticClass: "col-sm-8"
	  }, [_vm._m(3), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(0)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "smaller",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(0)
	      }
	    }
	  }, [_vm._v("Recommended")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(3)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "smaller",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(3)
	      }
	    }
	  }, [_vm._v("Reviews")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(1)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "smaller",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(1)
	      }
	    }
	  }, [_vm._v("Lowest Price")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(2)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "smaller",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(2)
	      }
	    }
	  }, [_vm._v("Highest Price")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(4)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "smaller",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(4)
	      }
	    }
	  }, [_vm._v("Fastest Response")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12  hidden-md hidden-lg collapse",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    },
	    attrs: {
	      "id": "filters"
	    }
	  }, [_c('hr', {
	    staticStyle: {
	      "margin-top": "9px",
	      "margin-bottom": "9px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "filters"
	  }, [_c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.citiesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.cityId),
	      expression: "queryDataComp.cityId"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "required": "",
	      "name": "citySelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v(_vm._s(_vm.selectCityStatusComp))]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
	    return _c('option', {
	      domProps: {
	        "value": city.CityId
	      }
	    }, [_vm._v("\n                                    " + _vm._s(city.CityName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.servicesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.serviceType),
	      expression: "queryDataComp.serviceType"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "serviceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Choose your Service")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service) {
	    return _c('option', {
	      domProps: {
	        "value": service.ServiceType
	      }
	    }, [_vm._v("\n                                    " + _vm._s(service.ServiceName) + "\n                                  ")])
	  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "form-from-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "findSittersDatePickerFromMobile"
	    }
	  }, [_c('label', {
	    staticClass: "form-control input-text",
	    attrs: {
	      "type": "text",
	      "readonly": "true"
	    },
	    model: {
	      value: (_vm.queryDataComp.start),
	      callback: function($$v) {
	        _vm.$set(_vm.queryDataComp, "start", $$v)
	      },
	      expression: "queryDataComp.start"
	    }
	  }, [_vm._v(_vm._s(_vm.startDateMobileComp))]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "findSittersDatePickerToMobile"
	    }
	  }, [_c('label', {
	    staticClass: "form-control input-text",
	    attrs: {
	      "type": "text",
	      "readonly": "true",
	      "disabled": !_vm.queryDataComp.start
	    },
	    model: {
	      value: (_vm.queryDataComp.end),
	      callback: function($$v) {
	        _vm.$set(_vm.queryDataComp, "end", $$v)
	      },
	      expression: "queryDataComp.end"
	    }
	  }, [_vm._v(_vm._s(_vm.endDateMobileComp))]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType != 6),
	      expression: "queryDataComp.serviceType!=6"
	    }],
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.homeTypesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.homeType),
	      expression: "queryDataComp.homeType"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "homeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Social Preference")]), _vm._v(" "), _vm._l((_vm.homeTypesList), function(home) {
	    return _c('option', {
	      domProps: {
	        "value": home.HomeType
	      }
	    }, [_vm._v("\n                                    " + _vm._s(home.HomeTypeName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType == 6),
	      expression: "queryDataComp.serviceType==6"
	    }],
	    staticClass: "form-location"
	  }, [_c('hr'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v("Dog walking for specific days")]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sun),
	      expression: "sun"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "1",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sun) ? _vm._i(_vm.sun, null) > -1 : _vm._q(_vm.sun, "1")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sun,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("1") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sun = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sun = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sun = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sun")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mon),
	      expression: "mon"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "2",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.mon) ? _vm._i(_vm.mon, null) > -1 : _vm._q(_vm.mon, "2")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.mon,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("2") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.mon = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.mon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.mon = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Mon")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tue),
	      expression: "tue"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "4",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.tue) ? _vm._i(_vm.tue, null) > -1 : _vm._q(_vm.tue, "4")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.tue,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("4") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.tue = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.tue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.tue = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Tue")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.wed),
	      expression: "wed"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "8",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.wed) ? _vm._i(_vm.wed, null) > -1 : _vm._q(_vm.wed, "8")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.wed,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("8") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.wed = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.wed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.wed = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Wed")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thu),
	      expression: "thu"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "16",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.thu) ? _vm._i(_vm.thu, null) > -1 : _vm._q(_vm.thu, "16")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.thu,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("16") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.thu = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.thu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.thu = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Thu")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fri),
	      expression: "fri"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "32",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.fri) ? _vm._i(_vm.fri, null) > -1 : _vm._q(_vm.fri, "32")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.fri,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("32") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.fri = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.fri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.fri = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Fri")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sat),
	      expression: "sat"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "true-value": "64",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sat) ? _vm._i(_vm.sat, null) > -1 : _vm._q(_vm.sat, "64")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sat,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("64") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sat = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sat")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.queryDataComp.serviceType != 6),
	      expression: "queryDataComp.serviceType!=6"
	    }],
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.petprefsList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.petpref),
	      expression: "queryDataComp.petpref"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "petprefSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "petpref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Pet Preference")]), _vm._v(" "), _vm._l((_vm.petprefsList), function(pet) {
	    return _c('option', {
	      domProps: {
	        "value": pet.PetPref
	      }
	    }, [_vm._v("\n                                    " + _vm._s(pet.PetPrefName) + "\n                                  ")])
	  })], 2) : _vm._e()])]), _vm._v(" "), ((!_vm.filteredAreasList || _vm.filteredAreasList.length == 0) && _vm.countryDataComp.CountryId != 9) ? _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    staticClass: "form-control input-text"
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v(_vm._s(_vm.selectAreaStatusComp))])])])]) : _vm._e(), _vm._v(" "), (_vm.filteredAreasList && _vm.filteredAreasList.length > 0) ? _c('div', {
	    staticClass: "form-location"
	  }, [(_vm.filteredAreasList) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.filteredAreasList) ? _c('div', {
	    staticClass: "form-group "
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.areaId),
	      expression: "queryDataComp.areaId"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "name": "areaSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "areaId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Available Neighbors")]), _vm._v(" "), _vm._l((_vm.filteredAreasList), function(area) {
	    return _c('option', {
	      domProps: {
	        "value": area.AreaId
	      }
	    }, [_vm._v("\n                                        " + _vm._s(area.AreaName) + "\n                                    ")])
	  })], 2)]) : _vm._e()]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.resetFilters()
	      }
	    }
	  }, [_vm._v("Reset Filters")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#filters"
	    },
	    on: {
	      "click": function($event) {
	        _vm.hideFilters()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-minus-square-o"
	  }), _vm._v("  Hide Filters\n                    ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sortyByMobile hidden-md hidden-lg"
	  }, [_c('div', {
	    staticStyle: {
	      "margin-top": "10px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm.sortingList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.sort),
	      expression: "queryDataComp.sort"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "id": "sortingList",
	      "required": "",
	      "name": "sortSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "sort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Select sorting option")]), _vm._v(" "), _vm._l((_vm.sortingList), function(sortType) {
	    return _c('option', {
	      domProps: {
	        "value": sortType.SortId
	      }
	    }, [_vm._v("\n                                " + _vm._s(sortType.SortName) + "\n                            ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', {
	    staticClass: "col-sm-8 pull-right hidden-xs hidden-sm"
	  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
	    staticClass: "hidden-md hidden-lg"
	  }, [_vm._m(7)]) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    ref: "sittersListDesktop"
	  }, _vm._l((_vm.sittersList), function(sitter, index) {
	    return (_vm.sittersList && _vm.sittersList.length > 0) ? _c('div', {
	      staticClass: "col-sm-8 pull-right hidden-xs hidden-sm"
	    }, [_c('div', {
	      staticClass: "card",
	      class: {
	        instagram: sitter.IsInstagramWinner
	      },
	      attrs: {
	        "data-index": index,
	        "data-item": "myname"
	      }
	    }, [_c('a', {
	      staticClass: "anchor",
	      attrs: {
	        "id": 'user' + sitter.SitterId
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "sitterListbox "
	    }, [(sitter.IsActive) ? _c('div', {
	      staticClass: "ribbon-container",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.premiumSwal()
	        }
	      }
	    }, [_vm._m(8, true)]) : _vm._e(), _vm._v(" "), (sitter.IsActive == false) ? _c('div', {
	      staticClass: "ribbon-container-basic",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.goSubscribe()
	        }
	      }
	    }, [_c('a', {
	      attrs: {
	        "target": "_blank"
	      }
	    }, [_vm._v("Basic")])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "profile-img"
	    }, [_c('a', {
	      attrs: {
	        "href": _vm.getHref(sitter),
	        "target": "_blank"
	      }
	    }, [_c('img', {
	      staticClass: "img-responsive img-rounded",
	      staticStyle: {
	        "cursor": "pointer",
	        "min-width": "170px",
	        "min-height": "170px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": sitter.ProfilePhotoUrl,
	        "alt": "",
	        "height": "240",
	        "width": "240"
	      }
	    }), _vm._v(" "), (sitter.IsOnline == true) ? _c('div', {
	      staticClass: "rank-label-container",
	      staticStyle: {
	        "cursor": "pointer"
	      }
	    }, [_c('span', {
	      staticClass: "label label-default rank-label"
	    }, [_vm._v(" Online")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "profile-body "
	    }, [_c('div', {
	      staticClass: "profile-body-details"
	    }, [_c('h2', [_vm._v(_vm._s(sitter.Name) + " "), (sitter.IsDogWalker) ? _c('span', {
	      staticStyle: {
	        "display": "inline",
	        "color": "#78b5d2"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Offers Dog Walking"
	      }
	    }, [_vm._v("   "), _c('i', {
	      staticClass: "fa fa-paw"
	    })]) : _vm._e()]), _vm._v(" "), _c('figure', {
	      staticStyle: {
	        "display": "inline-block",
	        "margin-left": "15px"
	      }
	    }, [_c('strong', [_c('p', {
	      staticClass: "small text-center"
	    }, [_c('span', {
	      staticClass: "small"
	    }, [_vm._v("From ")]), _vm._v(" "), _c('strong', {
	      staticStyle: {
	        "color": "#feb34f"
	      }
	    }, [_vm._v(_vm._s(sitter.Price))]), _c('span', {
	      staticClass: "small"
	    }, [_vm._v(" " + _vm._s(_vm.currencyComp))])])])]), _vm._v(" "), _c('div', {
	      staticClass: "home-details align-right"
	    }, [(sitter.IsInstagramWinner == true) ? _c('div', {
	      staticClass: "pull-right",
	      staticStyle: {
	        "margin-left": "10px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.instagramWinner(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-instagram fa-2x social",
	      attrs: {
	        "id": "social-ig-f"
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "homewrapper"
	    }, [(sitter.IsHasCat) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "resident cat at home"
	      }
	    }, [_vm._m(9, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasDog) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "resident dog at home"
	      }
	    }, [_vm._m(10, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasChildren) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "children at home"
	      }
	    }, [_vm._m(11, true)]) : _vm._e(), _vm._v(" "), (!sitter.IsSmokeFree) ? _c('div', {
	      staticClass: "home-icons",
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "smoking allowed at home"
	      }
	    }, [_vm._m(12, true)]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isFavorite(sitter.SitterId) == true) ? _c('span', {
	      staticClass: "fa fa-2x favorite",
	      staticStyle: {
	        "margin-top": "2px"
	      },
	      attrs: {
	        "data-container": "body",
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-content": "Remove From Favorites",
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-heart"
	    })]) : _c('span', {
	      staticClass: "fa fa-2x favorite",
	      staticStyle: {
	        "margin-top": "2px"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-container": "body",
	        "data-placement": "top",
	        "data-content": "Add to Favorites",
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-heart-o"
	    })])])]), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [(sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x inline",
	        staticStyle: {
	          "color": "#ffd118",
	          "font-size": "18px"
	        }
	      })
	    }), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted inline reviews small"
	    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " " + _vm._s(_vm.reviewString(sitter.RatingCount)))])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted",
	      staticStyle: {
	        "padding-top": "2px",
	        "margin-top": "0px"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-map-marker"
	    }), _vm._v(" " + _vm._s(sitter.Location))]), _vm._v(" "), _c('h4', {
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px"
	      }
	    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
	      staticClass: "text-overflow"
	    }, [_vm._v(" " + _vm._s(sitter.AboutMe))])])])])]), _vm._v(" "), _c('div', {
	      staticClass: "text-center",
	      staticStyle: {
	        "color": "green",
	        "padding-left": "10px",
	        "padding-right": "10px"
	      }
	    }, [_c('hr', {
	      staticStyle: {
	        "margin": "5px"
	      }
	    }), _vm._v(" "), (sitter.IsOnline == false && sitter.LastSeenOnline != null) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Last seen online: "), _c('strong', [_vm._v(_vm._s(_vm.lastSeenDate(sitter.LastSeenOnline)) + " ")])])]) : _vm._e(), _vm._v(" "), (sitter.ResponseRate != 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Response rate: "), _c('strong', [_vm._v(_vm._s(sitter.ResponseRate) + "% ")])])]) : _vm._e(), _vm._v(" "), (!sitter.AverageResponseTime == 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "0px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Avg Response: "), _c('strong', [_vm._v(_vm._s(sitter.AverageResponseTime) + " ")])])]) : _vm._e(), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "0px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Repeated client: "), _c('strong', [_vm._v(_vm._s(sitter.RepeatedStays) + " " + _vm._s(_vm.timeString(sitter.RepeatedStays)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      }
	    })]), _vm._v(" "), _c('button', {
	      staticClass: "btn-block btn btn-success btn-title ",
	      staticStyle: {
	        "margin-top": "10px"
	      },
	      attrs: {
	        "target": "_blank"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_vm._v("Visit Profile")])])]) : _vm._e()
	  })) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.paginationComp.TotalPages > 1) ? _c('div', {
	    staticClass: "col-sm-8 pull-right hidden-xs hidden-sm"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('nav', {
	    attrs: {
	      "aria-label": "Page navigation example"
	    }
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, _vm._l((_vm.totalPagesComp), function(item) {
	    return _c('li', {
	      staticClass: "page-item",
	      class: {
	        'active': _vm.isCurrentItem(item)
	      },
	      on: {
	        "click": function($event) {
	          _vm.updatePage(item)
	        }
	      }
	    }, [_c('a', {
	      staticClass: "page-link",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(item))])])
	  }))])])]) : _vm._e(), _vm._v(" "), (_vm.sittersList && _vm.sittersList.length == 0) ? _c('div', {
	    staticClass: "col-sm-8 pull-right hidden-xs hidden-sm"
	  }, [(!_vm.loading) ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('h5', [_vm._v("Sorry no sitters were found for your exact search, would you like to "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetFilters()
	      }
	    }
	  }, [_c('strong', [_vm._v("Reset Filters")])]), _vm._v(" and try again?")]), _vm._v(" "), (_vm.filteredAreasList && _vm.filteredAreasList.length > 0) ? _c('div', [_c('hr'), _vm._v(" "), _c('h5', [_vm._v("Note: The following areas have available sitters that match your preferences, click on any area to view profiles:")]), _vm._v(" "), _vm._l((_vm.filteredAreasList), function(area) {
	    return _c('div', [_c('a', {
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.changeArea(area)
	        }
	      }
	    }, [_vm._v(_vm._s(area.AreaName))])])
	  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_vm._l((_vm.sittersList), function(sitter, index) {
	    return (_vm.sittersList && _vm.sittersList.length > 0) ? _c('div', {
	      staticClass: "col-xs-12 hidden-md hidden-lg",
	      staticStyle: {
	        "padding": "0px",
	        "margin": "0px"
	      }
	    }, [_c('a', {
	      staticClass: "anchor",
	      attrs: {
	        "id": 'smuser' + sitter.SitterId
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "sittersListMobile"
	    }, [(sitter.IsActive) ? _c('div', {
	      staticClass: "ribbon",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.premiumSwal()
	        }
	      }
	    }, [_vm._v("Premium "), _c('i', {
	      staticClass: "fa fa-paw"
	    })]) : _vm._e(), _vm._v(" "), (sitter.IsActive == false) ? _c('div', {
	      staticClass: "ribbon-basic",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.goSubscribe()
	        }
	      }
	    }, [_vm._v("Basic")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "small-border",
	      class: {
	        instagram: sitter.IsInstagramWinner
	      }
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [(sitter.IsInstagramWinner == true) ? _c('div', {
	      staticClass: "pull-right",
	      on: {
	        "click": function($event) {
	          _vm.instagramWinner(sitter)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-instagram fa-2x social",
	      attrs: {
	        "id": "social-ig-f"
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "media-left"
	    }, [_c('img', {
	      staticClass: "media-object img-responsive img-rounded",
	      staticStyle: {
	        "min-width": "60px",
	        "min-height": "60px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": sitter.ProfilePhotoUrl,
	        "alt": "",
	        "height": "80",
	        "width": "80"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }), _vm._v(" "), (sitter.IsOnline == true) ? _c('div', {
	      staticClass: "rank-label-container",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "label label-default rank-label"
	    }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "media-left head-title"
	    }, [_c('h4', {
	      staticStyle: {
	        "display": "inline",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px",
	        "margin-top": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(sitter.Name) + " ")]), (sitter.IsDogWalker) ? _c('h4', {
	      staticStyle: {
	        "display": "inline",
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "color": "#78b5d2"
	      },
	      attrs: {
	        "data-toggle": "popover",
	        "data-trigger": "hover",
	        "data-placement": "top",
	        "data-container": "body",
	        "data-content": "Offers Dog Walking"
	      }
	    }, [_vm._v("   "), _c('i', {
	      staticClass: "fa fa-paw"
	    })]) : _vm._e()]), _vm._v(" "), (sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x inline",
	        staticStyle: {
	          "margin": "0px",
	          "color": "#ffd118",
	          "font-size": "15px"
	        }
	      })
	    }), _vm._v(" "), _c('h5', {
	      staticClass: "text-muted inline reviews",
	      staticStyle: {
	        "padding": "0px",
	        "margin": "0px",
	        "font-size": "15px"
	      }
	    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " " + _vm._s(_vm.reviewString(sitter.RatingCount)))])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
	      staticClass: "text-muted",
	      staticStyle: {
	        "padding-top": "2px",
	        "margin-top": "2px"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-map-marker"
	    }), _vm._v(" " + _vm._s(sitter.Location))])]), _vm._v(" "), _c('h4', {
	      staticStyle: {
	        "padding-top": "5px",
	        "margin-top": "5px",
	        "padding-bottom": "2px",
	        "margin-bottom": "2px"
	      }
	    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
	      staticClass: "text-overflow"
	    }, [_vm._v(" " + _vm._s(sitter.AboutMe))]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "color": "green"
	      }
	    }, [_c('hr', {
	      staticStyle: {
	        "margin": "5px"
	      }
	    }), _vm._v(" "), (sitter.IsOnline == false && sitter.LastSeenOnline != null) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "2px",
	        "margin-right": "10px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Last seen: "), _c('strong', [_vm._v(_vm._s(_vm.lastSeenDate(sitter.LastSeenOnline)) + "  ")])])]) : _vm._e(), _vm._v(" "), (sitter.ResponseRate != 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Response rate: "), _c('strong', [_vm._v(_vm._s(sitter.ResponseRate) + "%")])])]) : _vm._e(), _vm._v(" "), (!sitter.AverageResponseTime == 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "2px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Avg Response: "), _c('strong', [_vm._v(_vm._s(sitter.AverageResponseTime) + " ")])])]) : _vm._e(), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('figure', {
	      staticClass: "performance",
	      staticStyle: {
	        "margin": "5px",
	        "margin-left": "2px"
	      }
	    }, [_c('figcaption', {
	      staticClass: "h6 small",
	      staticStyle: {
	        "margin-top": "0px",
	        "margin-bottom": "0px",
	        "margin-left": "0px",
	        "margin-right": "10px"
	      }
	    }, [_vm._v("Repeated client: "), _c('strong', [_vm._v(_vm._s(sitter.RepeatedStays) + " " + _vm._s(_vm.timeString(sitter.RepeatedStays)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "margin-bottom": "10px"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-9",
	      staticStyle: {
	        "padding-left": "0px",
	        "margin-left": "0px"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-success btn-block btn-title",
	      on: {
	        "click": function($event) {
	          _vm.viewProfile(sitter)
	        }
	      }
	    }, [_vm._v("Visit Profile")]), _vm._v(" "), (_vm.isFavorite(sitter.SitterId) == true) ? _c('button', {
	      staticClass: "btn btn-info btn-block btn-title",
	      attrs: {
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_vm._v("Added to favorites "), _c('i', {
	      staticClass: "fa fa-heart"
	    })]) : _c('button', {
	      staticClass: "btn btn-info btn-block btn-title",
	      attrs: {
	        "lazy": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.addToFavorites(sitter)
	        }
	      }
	    }, [_vm._v("Add to favorites "), _c('i', {
	      staticClass: "fa fa-heart-o",
	      staticStyle: {
	        "color": "white"
	      }
	    })])]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-3 price-wrap"
	    }, [_c('div', {
	      staticClass: "pricing-head-mobile"
	    }, [_c('h4', [_c('span', [_vm._v("from")]), _vm._v(_vm._s(sitter.Price)), _c('span', [_vm._v(_vm._s(_vm.currencyComp) + "/day")])])])])])]), _vm._v(" "), _c('br')])]) : _vm._e()
	  }), _vm._v(" "), (!_vm.loading && _vm.paginationComp.TotalPages > 1) ? _c('div', {
	    staticClass: "col-xs-12  hidden-md hidden-lg "
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('nav', {
	    attrs: {
	      "aria-label": "Page navigation example"
	    }
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, _vm._l((_vm.totalPagesComp), function(item) {
	    return _c('li', {
	      staticClass: "page-item",
	      class: {
	        'active': _vm.isCurrentItem(item)
	      },
	      on: {
	        "click": function($event) {
	          _vm.updatePage(item)
	        }
	      }
	    }, [_c('a', {
	      staticClass: "page-link",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(item))])])
	  }))])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.sittersList && _vm.sittersList.length == 0) ? _c('div', {
	    staticClass: "col-xs-12  hidden-md hidden-lg  remove-margins"
	  }, [(!_vm.loading) ? _c('div', {
	    staticClass: "alert alert-info alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('h5', [_vm._v("Sorry no sitters were found for your search criteria, would you like to "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.resetFilters()
	      }
	    }
	  }, [_vm._v("Reset Filters")]), _vm._v(" and try again?")]), _vm._v(" "), (_vm.filteredAreasList && _vm.filteredAreasList.length > 0) ? _c('div', [_c('hr'), _vm._v(" "), _c('h5', [_vm._v("Note: The following areas have available sitters that match your preferences, click on any area to view profiles:")]), _vm._v(" "), _vm._l((_vm.filteredAreasList), function(area) {
	    return _c('div', [_c('a', {
	      attrs: {
	        "href": "javascript:;"
	      },
	      on: {
	        "click": function($event) {
	          _vm.changeArea(area)
	        }
	      }
	    }, [_vm._v(_vm._s(area.AreaName))])])
	  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "padding": "5px",
	      "display": "inline-block"
	    }
	  }, [_c('strong', [_vm._v("Sory by:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "target": "_blank"
	    }
	  }, [_vm._v("Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(44),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(45),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(43),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(46),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	}]}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.error) ? _c('div', [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.loading == true) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.reservationReadyComp && _vm.isActiveComp == true && !_vm.loading) ? _c('div', {
	    staticClass: "container"
	  }, [_c('h2', {
	    staticClass: "small-h2 text-center",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "ratingRequest",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('h4', [_c('i', {
	    staticClass: "fa fa-thumbs-o-up",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" How would you rate " + _vm._s(_vm.existingReservationComp.SitterName) + "?")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body ",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well"
	  }, [_c('div', [_c('star-rating', {
	    attrs: {
	      "show-rating": false,
	      "border-width": 3
	    },
	    on: {
	      "rating-selected": _vm.setRating
	    }
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reviewDesc),
	      expression: "reviewDesc"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "3",
	      "placeholder": "We would love to hear your feedback on this stay",
	      "id": "comment"
	    },
	    domProps: {
	      "value": (_vm.reviewDesc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reviewDesc = $event.target.value
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button",
	      "disabled": !_vm.customerRating
	    },
	    on: {
	      "click": function($event) {
	        _vm.submitRating()
	      }
	    }
	  }, [_vm._v("Send Rating")])])])])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "hidden-lg hidden-md"
	  }, [_c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#summary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchCollapse()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-navicon"
	  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
	    staticClass: " hidden-md hidden-lg collapse",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    },
	    attrs: {
	      "id": "summary"
	    }
	  }, [_c('div', {
	    staticClass: "reservationSummary"
	  }, [_vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
	    return _c('div', [_c('div', [_c('PetSelectCard', {
	      key: petCard.PetId,
	      attrs: {
	        "showDetails": true,
	        "petId": petCard.PetId
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "summary-desc"
	  }, [(!_vm.isDogWalking) ? _c('h5', [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]) : _vm._e(), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]) : _vm._e(), _vm._v(" "), (_vm.isDogWalking) ? _c('h5', [_vm._v("Starting " + _vm._s(_vm.startDateComp))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
	    return _c('h5', [_vm._v(_vm._s(service.Description))])
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "text-success"
	  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp) + " "), (_vm.isDogWalking) ? _c('span', [_vm._v(" per week")]) : _vm._e()])], 2)], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
	  }, [(_vm.existingReservationComp.CustomerStatus) ? _c('div', {
	    staticClass: "alert alert-dismissible",
	    class: _vm.existingReservationComp.StatusClass,
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.CustomerStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-circle",
	    attrs: {
	      "src": _vm.existingReservationComp.SitterProfilePic,
	      "alt": "",
	      "height": "25",
	      "width": "25"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h4', {
	    staticClass: "media-heading ",
	    staticStyle: {
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.existingReservationComp.SitterName))])]), _vm._v(" "), (_vm.signalReadyComp) ? _c('Chat', {
	    attrs: {
	      "isSitterAccepted": _vm.existingReservationComp.IsSitterAccepted,
	      "transactionId": _vm.reservationIdComp
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.rejectedComp) ? _c('div', {
	    staticClass: "buttons"
	  }, [(_vm.existingReservation.IsSitterAccepted == true) ? _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.existingReservation.IsConfirmedBooking),
	      expression: "!existingReservation.IsConfirmedBooking"
	    }],
	    staticClass: "btn btn-title btn-block btn-success",
	    staticStyle: {
	      "margin-bottom": "5px"
	    },
	    attrs: {
	      "data-toggle": "popover"
	    },
	    on: {
	      "click": function($event) {
	        _vm.confirmBooking()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-o"
	  }), _vm._v("\n            Confirm Booking")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.existingReservationComp.StatusCode == 0) ? _c('div', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.whatToDoNext()
	      }
	    }
	  }, [_vm._v("What should I do now?")])]) : _vm._e(), _vm._v(" "), (_vm.existingReservationComp.IsCustomerCancelled == false) ? _c('button', {
	    staticClass: "btn btn-block  btn-warning",
	    attrs: {
	      "data-toggle": "popover"
	    },
	    on: {
	      "click": function($event) {
	        _vm.cancelRequest()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash-o"
	  }), _vm._v(" Cancel Request")]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-info btn-lg",
	    on: {
	      "click": function($event) {
	        _vm.goMyReservations()
	      }
	    }
	  }, [_vm._v("View all Bookings")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-success btn-lg",
	    on: {
	      "click": function($event) {
	        _vm.findSitters()
	      }
	    }
	  }, [_vm._v("Find More Sitters "), _c('i', {
	    staticClass: "fa fa-paw"
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
	    return _c('div', [_c('div', [_c('PetSelectCard', {
	      key: petCard.PetId,
	      attrs: {
	        "showDetails": true,
	        "petId": petCard.PetId
	      }
	    })], 1)])
	  }), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', {
	    staticClass: "small"
	  }, [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]) : _vm._e(), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', {
	    staticClass: "small"
	  }, [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]) : _vm._e(), _vm._v(" "), (_vm.isDogWalking) ? _c('h5', [_vm._v("Starting " + _vm._s(_vm.startDateComp))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
	    return _c('h5', {
	      staticClass: "small"
	    }, [_vm._v(_vm._s(service.Description))])
	  }), _vm._v(" "), _c('h4', {
	    staticClass: "text-success"
	  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp) + " "), (_vm.isDogWalking) ? _c('span', [_vm._v(" per week")]) : _vm._e()])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false) ? _c('div', [_c('br'), _vm._v(" "), _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("You need to have an active membership to view this reservation")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Note: Only pet sitters who are Premium can respond to you without an active membership")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-md-offset-4"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-success",
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("Subscribe Now")])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {}, [_c('button', {
	    staticClass: "btn btn-info ",
	    on: {
	      "click": function($event) {
	        _vm.myReservations()
	      }
	    }
	  }, [_vm._v("Go to Bookings")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info ",
	    on: {
	      "click": function($event) {
	        _vm.findSitters()
	      }
	    }
	  }, [_vm._v("Find Sitters")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default pull-right",
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("Go Home")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', {
	    staticClass: "modal-title text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Reservation Completed ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "well"
	  }, [_c('p', [_vm._v("The sitter will be notified of your request and will review the details and answer you soon.")]), _vm._v(" "), _c('p', [_vm._v("You can send another reservation to different sitter as well to ensure that at least one of them is available, go to Find Sitters if you want to contact another sitter.")])])])
	}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row main-row",
	    attrs: {
	      "id": "myMain"
	    }
	  }, [_c('div', {
	    staticClass: "hero",
	    staticStyle: {
	      "max-height": "600px"
	    }
	  }, [_c('div', {
	    staticClass: "hero-text"
	  }, [_c('h1', {
	    staticClass: "title-text text-center",
	    staticStyle: {
	      "margin-bottom": "0px!important",
	      "padding-bottom": "0px!important"
	    }
	  }, [_vm._v("Find the perfect Sitter")]), _vm._v(" "), (_vm.countryDataComp.CountryId) ? _c('div', {
	    staticClass: "row find-container",
	    staticStyle: {
	      "margin": "0",
	      "padding": "0"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xs-12",
	    staticStyle: {
	      "margin": "0",
	      "padding": "0"
	    }
	  }, [_c('p', {
	    staticClass: "hidden-xs text-center",
	    staticStyle: {
	      "margin-top": "0px",
	      "font-size": "15px",
	      "color": "#656565"
	    }
	  }, [_vm._v("Cat and dog boarding just got awesome ")]), _vm._v(" "), _c('p', {
	    staticClass: " hidden-sm hidden-md hidden-lg text-center ",
	    staticStyle: {
	      "font-size": "14px",
	      "margin-top": "0px",
	      "color": "#656565"
	    }
	  }, [_vm._v("Cat and dog boarding just got awesome ")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "margin": "1px",
	      "padding": "1px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [(_vm.citiesList) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.queryDataComp.cityId),
	      expression: "queryDataComp.cityId"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "id": "citySelect",
	      "required": "",
	      "name": "citySelect",
	      "placeholder": "Select City"
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.searchSitters()
	      },
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.queryDataComp, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Select a City")]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
	    return _c('option', {
	      domProps: {
	        "value": city.CityId
	      }
	    }, [_vm._v("\n                  " + _vm._s(city.CityName) + "\n                ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin": "1px",
	      "padding": "1px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-lg btn-block btn-title-big hidden-xs fix-button  hidden-sm",
	    on: {
	      "mouseover": function($event) {
	        _vm.active = true
	      },
	      "mouseleave": function($event) {
	        _vm.active = false
	      },
	      "click": function($event) {
	        _vm.searchSitters()
	      }
	    }
	  }, [_vm._v(" Search   "), _c('i', {
	    staticClass: "animated bounceIn fa fa-paw "
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-lg btn-block btn-title-big hidden-md hidden-lg",
	    on: {
	      "mouseover": function($event) {
	        _vm.active = true
	      },
	      "mouseleave": function($event) {
	        _vm.active = false
	      },
	      "click": function($event) {
	        _vm.searchSitters()
	      }
	    }
	  }, [_vm._v(" Search "), _c('i', {
	    staticClass: "animated bounceIn fa fa-paw "
	  })])])]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-default nav-bottom paw"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_vm._l((5), function(n) {
	    return _c('i', {
	      staticClass: "fa fa-star fa-2x inline",
	      staticStyle: {
	        "color": "#ffd118",
	        "margin-top": "10px",
	        "margin-bottom": "10px"
	      }
	    })
	  }), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.staycationDataComp.ReviewsCount) + ") Pet parent verified reviews")])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.staycationDataComp.SittersImages != null) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "col-sm-6 "
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Recently joined Pet Buddies")]), _vm._v(" "), _c('flickity', {
	    ref: "flickity",
	    attrs: {
	      "options": _vm.flickityOptions
	    }
	  }, _vm._l((_vm.staycationDataComp.SittersImages), function(item) {
	    return _c('div', {
	      staticClass: "carousel-cell-sitter"
	    }, [_c('img', {
	      staticClass: "carousel-image",
	      attrs: {
	        "alt": "Dupaws Cute Pet",
	        "src": item.Path
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "centered"
	    }, [_c('span', {
	      staticClass: "span-centered"
	    }, [_vm._v(_vm._s(item.Name))])])])
	  }))], 1), _vm._v(" "), _c('br', {
	    staticClass: "hidden-sm hidden-md hidden-lg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 "
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Recently completed a stay")]), _vm._v(" "), _c('flickity', {
	    ref: "flickity",
	    attrs: {
	      "options": _vm.flickityOptions
	    }
	  }, _vm._l((_vm.staycationDataComp.PetsImages), function(item) {
	    return _c('div', {
	      staticClass: "carousel-cell-pet"
	    }, [_c('img', {
	      staticClass: "carousel-image",
	      attrs: {
	        "alt": "Dupaws Cute Pet",
	        "src": item.Path
	      }
	    }), _vm._v(" "), _c('h2', {
	      staticClass: "centered"
	    }, [_c('span', {
	      staticClass: "span-centered"
	    }, [_vm._v(_vm._s(item.Name))])])])
	  }))], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "hidden-md hidden-lg",
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_vm._v("Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center hidden-sm hidden-xs",
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_vm._v("Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3"
	  }, [_c('hr'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-lg btn-block ",
	    staticStyle: {
	      "font-size": "24px!important"
	    },
	    on: {
	      "click": function($event) {
	        _vm.searchSitters()
	      }
	    }
	  }, [_vm._v("Find Sitters "), _c('i', {
	    staticClass: "fa fa-paw"
	  })]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
	  }, [_vm._m(10), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-lg btn-block ",
	    staticStyle: {
	      "font-size": "24px!important"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBecomeSitter()
	      }
	    }
	  }, [_vm._v("Become a Sitter")])])])]), _vm._v(" "), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('h2', {
	    staticClass: "text-center "
	  }, [_vm._v("The next level of cat and dog boarding  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-3"
	  }, [_c('img', {
	    staticClass: "img img-responsive",
	    attrs: {
	      "alt": "Dupaws Cute Pet",
	      "src": "https://www.dupaws.com/services/images/site/petsbag.jpg",
	      "height": "300"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-9"
	  }, [_c('p', {
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_vm._v("\n  Are you always traveling with limited options on who to watch your pet? We know it can be a daunting task for pet parents to find a trusted and passionate person to look for their pets, thats why we created Dupaws.\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_vm._v("Dupaws is an online platform that allows you to quickly find a pet buddy in your area or community to stay with your pet while you are away to ensure stress free stay for your pet and peace of mind for you, think of it as the airbnb for pets.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('p', {
	    staticStyle: {
	      "font-size": "medium"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-quote-left fa-1x"
	  }), _vm._v(" She was great, welcoming, friendly, sending me videos of Lucky to know how is he doing, it truly shows her love for dogs ... i was feeling comfortable leaving my Lucky with her. I could see my dog was enjoying there. Surely will contact her again. "), _c('i', {
	    staticClass: "fa fa-quote-right fa-1x"
	  })])]), _vm._v(" "), _c('p', [_vm._v("Lucie N")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/pub/reviews"
	    }
	  }, [_vm._v("Read more reviews")]), _vm._v(" "), _c('hr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-default nav-bottom paw"
	  }, [_c('h2', {
	    staticClass: "text-center "
	  }, [_vm._v("How it works")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-fluid",
	    staticStyle: {
	      "padding-bottom": "20px",
	      "padding-top": "20px",
	      "background-color": "rgba(255, 254, 254, 0.72)"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "step1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('small', {
	    staticClass: "text-muted text-center"
	  }, [_vm._v("Go through profiles, compare ratings, prices & more")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "step2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10 col-sm-offset-1"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('small', {
	    staticClass: "text-muted text-center"
	  }, [_vm._v("Schedule a meet and greet in person before confirming")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "step3"
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "text-center"
	  }, [_c('small', {
	    staticClass: " text-muted text-center"
	  }, [_vm._v("Choose terms of payment that suits you and the sitter.")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-default nav-bottom paw"
	  }, [_c('h2', {
	    staticClass: "text-center "
	  }, [_vm._v("Featured In")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    staticStyle: {
	      "padding-bottom": "20px",
	      "padding-top": "20px",
	      "background-color": "rgba(255, 254, 254, 0.72)"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news2"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news4"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news5"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 col-sm-2 remove-margins"
	  }, [_c('div', {
	    staticClass: "news6"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('strong', [_c('p', {
	    staticClass: "text-center ",
	    staticStyle: {
	      "font-size": "larger",
	      "margin-top": "15px"
	    }
	  }, [_vm._v("Why Dupaws?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('hr', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('h5', {
	    staticClass: "text-center"
	  }, [_vm._v("Pamper your furry baby")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('small', {
	    staticClass: "text-center"
	  }, [_vm._v("or")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('h5', {
	    staticClass: "text-center"
	  }, [_vm._v("Join our awesome community")])])
	}]}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.myReservations.length == 0 && !_vm.loading) ? _c('div', [_c('h4', {
	    staticClass: "hidden-xs hidden-sm text-center"
	  }, [_vm._v("No bookings available, visit "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSitterProfileEdit()
	      }
	    }
	  }, [_c('strong', [_vm._v("Profile Setup")])]), _vm._v(" to ensure that your profile is up to date or visit "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goDashboard()
	      }
	    }
	  }, [_c('strong', [_vm._v("Dashboard")])]), _vm._v(" to see how your profile is doing.")]), _vm._v(" "), _c('h4', {
	    staticClass: "hidden-md hidden-lg"
	  }, [_vm._v("No bookings available, visit "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSitterProfileEdit()
	      }
	    }
	  }, [_c('strong', [_vm._v("Profile Setup")])]), _vm._v(" to ensure that your profile is up to date or visit "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goDashboard()
	      }
	    }
	  }, [_c('strong', [_vm._v("Dashboard")])]), _vm._v(" to see how your profile is doing.")])]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0) ? _c('div', {
	    staticClass: "hidden-lg hidden-md"
	  }, [_c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#filterSort"
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchCollapse()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-navicon"
	  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
	    staticClass: " hidden-md hidden-lg collapse",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    },
	    attrs: {
	      "id": "filterSort"
	    }
	  }, [_c('div', {
	    staticClass: "reservationSummary"
	  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', [_c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "0"
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "1"
	      }
	    }
	  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "2"
	      }
	    }
	  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.hideCompleted()
	      }
	    }
	  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
	    staticClass: "btn btn-block btn-default",
	    on: {
	      "click": function($event) {
	        _vm.showCompleted()
	      }
	    }
	  }, [_vm._v("Show Completed or Expired")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.myReservations.length > 0 && !_vm.loading) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "hidden-sm hidden-xs col-sm-4 col-xs-12 "
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', [_c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "0"
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" Submitted Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "1"
	      }
	    }
	  }), _c('span', [_vm._v(" Start Date")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 remove-margins"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sort),
	      expression: "sort"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.sort, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.sort = "2"
	      }
	    }
	  }), _c('span', [_vm._v(" Total Price")])])])])])]), _vm._v(" "), (!_vm.hidden) ? _c('button', {
	    staticClass: "btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.hideCompleted()
	      }
	    }
	  }, [_vm._v("Hide Completed or Expired")]) : _c('button', {
	    staticClass: "btn btn-block btn-info",
	    on: {
	      "click": function($event) {
	        _vm.showCompleted()
	      }
	    }
	  }, [_vm._v("Show Completed or Expired")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-md-8 col-xs-12 pull-right"
	  }, _vm._l((_vm.sortedReservationsComp), function(reservation, index) {
	    return _c('div', {
	      key: reservation.ReservationId,
	      staticClass: "wrapper "
	    }, [_c('div', {
	      staticClass: "media-body"
	    }, [_c('div', {
	      staticClass: "media-left",
	      staticStyle: {
	        "padding-top": "10px"
	      }
	    }, [_c('img', {
	      staticClass: "media-object img-responsive img-circle",
	      staticStyle: {
	        "min-width": "30px",
	        "min-height": "30px",
	        "border": "1px solid #c3c3c3"
	      },
	      attrs: {
	        "src": reservation.CustomerProfilePic,
	        "alt": "",
	        "height": "30",
	        "width": "30"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "media-left",
	      staticStyle: {
	        "padding-top": "10px"
	      }
	    }, [_c('h4', {
	      staticClass: "media-heading main-name",
	      staticStyle: {
	        "padding-bottom": "0px",
	        "margin-bottom": "3px"
	      }
	    }, [_c('strong', [_vm._v(" " + _vm._s(reservation.CustomerName))])])]), _vm._v(" "), _c('div', {
	      staticClass: "media-bottom"
	    }, [_c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Booking number: "), _c('strong', [_vm._v(" " + _vm._s(reservation.BookingNumber) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(_vm.startDateComp(reservation)))]), _vm._v(" "), _c('span', [_vm._v("To "), _c('strong', [_vm._v(_vm._s(_vm.endDateComp(reservation)))])])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Submitted: "), _c('strong', [_vm._v(" " + _vm._s(_vm.sentDate(reservation.SubmittedDate)) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-success",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v("Starts  " + _vm._s(_vm.startDate(reservation.StartDate)) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small text-muted",
	      staticStyle: {
	        "padding-top": "0px",
	        "margin-top": "0px",
	        "padding-bottom": "0px",
	        "margin-bottom": "0px"
	      }
	    }, [_vm._v(" Total price: "), _c('strong', {
	      staticClass: "text-success"
	    }, [_vm._v(" " + _vm._s(reservation.TotalPrice) + " ")]), _vm._v(" " + _vm._s(_vm.currencyComp))]), _vm._v(" "), _c('h5', {
	      staticClass: "alert text-muted",
	      class: reservation.StatusClass
	    }, [_c('strong', [_vm._v("Status: ")]), _vm._v(" " + _vm._s(reservation.SitterStatus))])])]), _vm._v(" "), _c('div', {
	      staticClass: "media-bottom",
	      staticStyle: {
	        "overflow": "hidden"
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-success btn-block",
	      on: {
	        "click": function($event) {
	          _vm.goToReservation(reservation)
	        }
	      }
	    }, [_vm._v("Go to Booking ")]), _vm._v(" "), (_vm.bookingRemovable(reservation)) ? _c('button', {
	      staticClass: "btn btn-warning btn-block",
	      on: {
	        "click": function($event) {
	          _vm.removeBooking(reservation);
	          reservation.IsSitterRemoved = true
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash-o"
	    }), _vm._v(" Remove from Bookings ")]) : _vm._e(), _vm._v(" "), (reservation.IsSitterRemoved == true) ? _c('button', {
	      staticClass: "btn btn-warning btn-block",
	      attrs: {
	        "disabled": ""
	      }
	    }, [_vm._v("Removing..")]) : _vm._e()])])
	  }))]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(2)]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Sort")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Sort")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-sm-3 col-sm-offset-1"
	  }, [_c('div', {
	    staticClass: "filters"
	  }, [_vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.HideOpen),
	      expression: "searchData.HideOpen"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.HideOpen) ? _vm._i(_vm.searchData.HideOpen, null) > -1 : (_vm.searchData.HideOpen)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.HideOpen,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.HideOpen = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.HideOpen = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "HideOpen", $$c)
	        }
	      }
	    }
	  }), _vm._v("Hide Open Tickets")])]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.HideResolved),
	      expression: "searchData.HideResolved"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.searchData.HideResolved) ? _vm._i(_vm.searchData.HideResolved, null) > -1 : (_vm.searchData.HideResolved)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.searchData.HideResolved,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.searchData.HideResolved = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.searchData.HideResolved = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.searchData, "HideResolved", $$c)
	        }
	      }
	    }
	  }), _vm._v("Hide Resolved Tickets")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "input-group col-md-12"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.SearchText),
	      expression: "searchData.SearchText"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Ticket No or Email address"
	    },
	    domProps: {
	      "value": (_vm.searchData.SearchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "SearchText", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((_vm.ticketsListComp), function(ticket, index) {
	    return (_vm.ticketsListComp.length > 0) ? _c('div', {
	      staticClass: "col-sm-12"
	    }, [_c('div', {
	      staticClass: "sitterListbox card"
	    }, [_c('div', {
	      staticClass: "profile-body "
	    }, [_c('div', {
	      staticClass: "bottom-row"
	    }, [_c('div', {
	      staticClass: "content col-sm-4"
	    }, [_c('h5', [_vm._v(" Ticket Status")]), _vm._v(" "), _c('div', {
	      staticClass: "form-group"
	    }, [_c('div', {
	      staticClass: "form-group "
	    }, [(_vm.ticketStatusList) ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (ticket.StatusCode),
	        expression: "ticket.StatusCode"
	      }],
	      staticClass: "form-control ",
	      attrs: {
	        "required": "",
	        "name": "ticketStatusList"
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(ticket, "StatusCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "null",
	        "disabled": "",
	        "selected": "",
	        "hidden": ""
	      }
	    }, [_vm._v("Select ticket state")]), _vm._v(" "), _vm._l((_vm.ticketStatusList), function(ticket) {
	      return _c('option', {
	        domProps: {
	          "value": ticket.StatusCode
	        }
	      }, [_vm._v("\n                                    " + _vm._s(ticket.StatusName) + "\n                                  ")])
	    })], 2) : _vm._e()])]), _vm._v(" "), _c('p', [_vm._v("Email: "), _c('strong', [_vm._v(_vm._s(ticket.Email))])]), _vm._v(" "), _c('p', [_vm._v("Role: "), _c('strong', [_vm._v(_vm._s(ticket.Role))])]), _vm._v(" "), _c('p', [_vm._v("Submitted Date: "), _c('strong', [_vm._v(_vm._s(_vm.dateFormatter(ticket.CreatedDate)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "content col-sm-8"
	    }, [_c('h5', [_vm._v("Ticket Number "), _c('strong', [_vm._v(_vm._s(ticket.TicketNo))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Description: " + _vm._s(ticket.Description) + " ")]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Remarks")]), _vm._v(" "), _c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (ticket.Remarks),
	        expression: "ticket.Remarks"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "rows": "3"
	      },
	      domProps: {
	        "value": (ticket.Remarks)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(ticket, "Remarks", $event.target.value)
	        }
	      }
	    })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row pull-right"
	    }, [_c('button', {
	      staticClass: "btn btn-success btn-sm ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.saveTicket(ticket)
	        }
	      }
	    }, [_vm._v("Save Ticket Status")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
	  }), _vm._v(" "), (_vm.ticketsListComp.length == 0) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._m(3)]) : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Welcome to Tickets Dashboard")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-search"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sitterListbox card"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" Goodsy, no results match your search :)")])])
	}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "container remove-margins"
	  }, [(_vm.petsListComp) ? _c('div', [(_vm.petsListComp.length < 1) ? _c('div', [_c('h4', [_vm._v("No pets added yet, please Add new pet")])]) : _vm._e(), _vm._v(" "), (_vm.petsListComp && _vm.petsListComp.length > 0) ? _c('div', _vm._l((_vm.petsListComp), function(pet, index) {
	    return _c('div', {
	      staticClass: "col-sm-6 col-md-5 col-lg-4 col-xs-12 remove-margins"
	    }, [_c('PetProfileCard', {
	      key: pet.PetId,
	      attrs: {
	        "petId": pet.PetId
	      }
	    })], 1)
	  })) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.petsListComp && _vm.petsListComp.length > 0) ? _c('div', {
	    staticClass: "container remove-margins"
	  }, [_c('br'), _vm._v(" "), _c('a', {
	    staticClass: "btn-success btn-lg",
	    attrs: {
	      "href": "https://www.dupaws.com/findsitters"
	    }
	  }, [_vm._v("Find and Book Pet Sitters")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container col-sm-12 col-xs-12"
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.mobileNumber))])]), _vm._v(" "), (_vm.codeSent) ? _c('div', [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.codeSent) ? _c('div', [_vm._m(0), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success",
	    on: {
	      "click": function($event) {
	        _vm.sendCode()
	      }
	    }
	  }, [_vm._v("Generate Code")]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.pending) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.codeSent) ? _c('div', [_c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [(_vm.pending) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "pattern": "\\d*",
	      "type": "text",
	      "placeholder": "Verification Code",
	      "maxlength": "6",
	      "autocorrect": "off",
	      "autocomplete": "off",
	      "autocapitalize": "off",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [(_vm.pending) ? _c('button', {
	    staticClass: "btn btn-info",
	    staticStyle: {
	      "font-size": "small !important"
	    },
	    attrs: {
	      "disabled": _vm.count > 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendCode()
	      }
	    }
	  }, [_vm._v("Re-Send Code " + _vm._s(_vm.count) + " ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.notReceiving) ? _c('div', {
	    staticStyle: {
	      "padding": "3px"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.notReceivingMessages()
	      }
	    }
	  }, [_vm._v("Not receiving messages?")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.closePhone()
	      }
	    }
	  }, [_vm._v("Close")])])]) : _vm._e(), _vm._v(" "), (!_vm.pending) ? _c('button', {
	    staticClass: "btn btn-default pull-right",
	    on: {
	      "click": function($event) {
	        _vm.closePhone()
	      }
	    }
	  }, [_vm._v("Close")]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v("We will generate a 6 digit code and send it to your registered phone, press Generate Code when you are ready")])])
	}]}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "input-group col-md-offset-3 col-md-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.SearchText),
	      expression: "searchData.SearchText"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Users, by ID, Name or Email "
	    },
	    domProps: {
	      "value": (_vm.searchData.SearchText)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.getSearchText()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "SearchText", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.loading) ? _c('div', [_vm._l((_vm.usersList), function(user, index) {
	    return (_vm.usersList.length > 0) ? _c('div', {
	      staticClass: " col-md-offset-2 col-md-8"
	    }, [_c('div', {
	      staticClass: "sitterListbox card"
	    }, [_c('div', {
	      staticClass: "profile-body "
	    }, [_c('h2', {
	      staticClass: "small",
	      class: {
	        'confirmed': user.IsConfirmedEmail
	      },
	      staticStyle: {
	        "margin-left": "13px"
	      }
	    }, [_vm._v(" " + _vm._s(user.Email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	      staticClass: "content col-sm-12"
	    }, [(!user.IsEnabled) ? _c('h4', {
	      staticStyle: {
	        "margin-top": "0px",
	        "color": "red"
	      }
	    }, [_vm._v("User Disabled by admin")]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Name: " + _vm._s(user.FirstName) + " " + _vm._s(user.LastName))]), _vm._v(" "), (user.SitterId != 0) ? _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" SitterId: "), _c('strong', [_vm._v(_vm._s(user.SitterId))])]) : _vm._e(), _vm._v(" "), (user.IsSitterSubscription) ? _c('div', {
	      staticClass: "confirmed"
	    }, [_c('p', {
	      staticClass: "small text-success"
	    }, [_vm._v("Sitter Subscription StartDate: " + _vm._s(_vm.dateFormatter(user.SitterSubscriptionStartDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small text-success"
	    }, [_vm._v("Sitter Subscription EndDate: " + _vm._s(_vm.dateFormatter(user.SitterSubscriptionEndDate)))])]) : _vm._e(), _vm._v(" "), (user.CustomerId != 0) ? _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" CustomerId: "), _c('strong', [_vm._v(_vm._s(user.CustomerId))])]) : _vm._e(), _vm._v(" "), (user.IsCustomerSubscription) ? _c('div', [_c('p', {
	      staticClass: "small text-success"
	    }, [_vm._v("Customer Subscription StartDate: " + _vm._s(_vm.dateFormatter(user.CustomerSubscriptionStartDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small text-success"
	    }, [_vm._v("Customer Subscription EndDate: " + _vm._s(_vm.dateFormatter(user.CustomerSubscriptionEndDate)))])]) : _vm._e(), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Registration Date: " + _vm._s(_vm.dateFormatter(user.RegistrationDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Registration Method: " + _vm._s(user.RegisterationMethod))]), _vm._v(" "), _c('p', {
	      staticClass: "small",
	      class: {
	        'confirmed': user.IsConfirmedPhone
	      }
	    }, [_c('strong', [_vm._v("0" + _vm._s(user.PhoneNumber))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Country: " + _vm._s(user.CountryName))]), _vm._v(" "), (user.IsEnabled) ? _c('button', {
	      staticClass: "btn btn-sm btn-danger pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.disableAccount(user.Email)
	        }
	      }
	    }, [_vm._v("Disable Access")]) : _vm._e(), _vm._v(" "), (!user.IsEnabled) ? _c('button', {
	      staticClass: "btn btn-sm btn-success pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.enableAccount(user.Email)
	        }
	      }
	    }, [_vm._v("Enable Access")]) : _vm._e(), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-sm pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateEmail(user.Email)
	        }
	      }
	    }, [_vm._v("Change Email")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-sm pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updatePhone(user.Email)
	        }
	      }
	    }, [_vm._v("Change Phone")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-sm pull-right",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.confirmPhone(user.Email)
	        }
	      }
	    }, [_vm._v("Confirm Phone")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')]) : _vm._e()
	  }), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.usersList.length == 0) ? _c('div', {
	    staticClass: "col-md-offset-3 col-md-6"
	  }, [_vm._m(3)]) : _vm._e()], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Welcome to Users Dashboard")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-search"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sitterListbox card"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Ooopsy, no results match your search.")])])
	}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "calendarComponent"
	    }
	  }, [_c('br'), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('div', {
	    attrs: {
	      "id": "calendar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "remove-margins col-sm-12 col-xs-12"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn-block btn btn-info",
	    on: {
	      "click": function($event) {
	        _vm.addNewEventButton()
	      }
	    }
	  }, [_vm._v("Add a new event")]), _vm._v(" "), _c('button', {
	    staticClass: "btn-block btn btn-lg btn-success",
	    on: {
	      "click": function($event) {
	        _vm.goDashboard()
	      }
	    }
	  }, [_vm._v("Go to dashboard")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "calModal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _vm._v(" "), (_vm.tempEvent.type == 1) ? _c('h4', {
	    staticClass: "modal-title"
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 0) ? _c('h4', {
	    staticClass: "modal-title"
	  }, [_c('i', {
	    staticClass: "fa fa-plane"
	  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 2) ? _c('h4', {
	    staticClass: "modal-title"
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    attrs: {
	      "id": "modalBody"
	    }
	  }, [_c('h4', [_c('strong', [_vm._v(" " + _vm._s(_vm.tempEvent.start) + " ")]), _vm._v(" to "), _c('strong', [_vm._v(" " + _vm._s(_vm.tempEvent.end) + " ")])]), _vm._v(" "), (_vm.tempEvent.type == 1) ? _c('div', [_c('h4', [_vm._v("This event cant be deleted, it's associated with "), _c('strong', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goReservation(_vm.tempEvent.reservationId)
	      }
	    }
	  }, [_vm._v("Booking: " + _vm._s(_vm.tempEvent.bookingNumber))])])]), _vm._v(" "), (_vm.tempEvent.blocking == true) ? _c('div', {
	    staticClass: "alert h4 alert-info alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(1), _vm._v("\n                    No one else can book you for these dates, to change this click here\n                    "), _c('strong', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.noBlocking(_vm.tempEvent.id)
	      }
	    }
	  }, [_vm._v(" mark as available ")])])]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.blocking == false) ? _c('div', {
	    staticClass: "alert h4 alert-info alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(2), _vm._v("\n                    People will still be able to book you during these dates.\n                    "), _c('strong', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.noBlocking(_vm.tempEvent.id)
	      }
	    }
	  }, [_vm._v(" mark as un-available ")])])]) : _vm._e(), _vm._v(" "), _c('alert', [_c('strong', [_vm._v("click here")])])], 1) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 0 || _vm.tempEvent.type == 2) ? _c('h4', [_vm._v("Click delete to remove this event from your calendar")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [(_vm.tempEvent.type == 0 || _vm.tempEvent.type == 2) ? _c('button', {
	    staticClass: "btn btn-title btn-info",
	    on: {
	      "click": _vm.deleteEvent
	    }
	  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-title btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "newEntryModal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(3), _vm._v(" "), _c('h3', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "newModalTitle"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" " + _vm._s(_vm.scheduleComp))])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "newModalBody"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 remove-margins"
	  }, [_c('p'), _c('h4', [_vm._v("Choose Event Type")]), _c('p'), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.eventTypes) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newEvent.eventType),
	      expression: "newEvent.eventType"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "id": "eventTypes",
	      "required": "",
	      "name": "eventTypes"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.newEvent, "eventType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.eventTypes), function(event) {
	    return _c('option', {
	      domProps: {
	        "value": event.type
	      }
	    }, [_vm._v("\n                                " + _vm._s(event.title) + "\n                            ")])
	  })) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 remove-margins"
	  }, [_c('div', {
	    staticClass: "col-md-4 remove-margins margin-big-right"
	  }, [_c('h4', {
	    staticStyle: {
	      "margin-bottom": "2px"
	    }
	  }, [_vm._v("From")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "datetimepickerFrom"
	    }
	  }, [_c('label', {
	    staticClass: "form-control ",
	    attrs: {
	      "type": "text",
	      "readonly": "true"
	    },
	    model: {
	      value: (_vm.newEvent.start),
	      callback: function($$v) {
	        _vm.$set(_vm.newEvent, "start", $$v)
	      },
	      expression: "newEvent.start"
	    }
	  }, [_vm._v(_vm._s(_vm.newEvent.start))]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 remove-margins margin-big-left"
	  }, [_c('h4', {
	    staticStyle: {
	      "margin-bottom": "2px"
	    }
	  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "datetimepickerTo"
	    }
	  }, [_c('div', [_c('label', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "readonly": "true"
	    },
	    model: {
	      value: (_vm.newEvent.end),
	      callback: function($$v) {
	        _vm.$set(_vm.newEvent, "end", $$v)
	      },
	      expression: "newEvent.end"
	    }
	  }, [_vm._v(_vm._s(_vm.newEvent.end))])]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-title btn-success",
	    on: {
	      "click": function($event) {
	        _vm.saveEvent()
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-title btn-default",
	    on: {
	      "click": function($event) {
	        _vm.cancelEvent()
	      }
	    }
	  }, [_vm._v("Cancel")])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("close")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("close")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-calendar"
	  })])
	}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('br', {
	    staticClass: "hidden-md hidden-lg"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_vm._v("My Account")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goBookings()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" My Bookings\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goCalendar()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" Calendar and Availability\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goProfileSetup()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Profile Setup\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goViewPublicProfile()
	      }
	    }
	  }, [_vm._v("\n    View Public Profile\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goContactSupport()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-support"
	  }), _vm._v(" Contact Support\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "container ",
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_c('h3', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewProfile()
	      }
	    }
	  }, [_vm._v("Back to " + _vm._s(_vm.initReservation.SitterName) + " Profile")])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content "
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "overflow": "hidden",
	      "padding": "3px"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_c('div', {
	    staticClass: "col-sm-12  col-xs-12"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_c('label', {
	    staticClass: "h3",
	    staticStyle: {
	      "margin-bottom": "5px",
	      "margin-top": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serviceType),
	      expression: "serviceType"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.serviceType, "1")
	    },
	    on: {
	      "click": function($event) {
	        _vm.setServiceBoarding()
	      },
	      "change": function($event) {
	        _vm.serviceType = "1"
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-6 "
	  }, [_c('label', {
	    staticClass: "h3",
	    staticStyle: {
	      "margin-bottom": "5px",
	      "margin-top": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serviceType),
	      expression: "serviceType"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.serviceType, "2")
	    },
	    on: {
	      "click": function($event) {
	        _vm.setServiceSitting()
	      },
	      "change": function($event) {
	        _vm.serviceType = "2"
	      }
	    }
	  }), _vm._m(3)])]), _vm._v(" "), (_vm.dogWalking == true) ? _c('div', {
	    staticClass: "col-xs-12 col-sm-6 "
	  }, [_c('label', {
	    staticClass: "h3",
	    staticStyle: {
	      "margin-bottom": "5px",
	      "margin-top": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serviceType),
	      expression: "serviceType"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "6"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.serviceType, "6")
	    },
	    on: {
	      "click": function($event) {
	        _vm.setServiceDogWalking()
	      },
	      "change": function($event) {
	        _vm.serviceType = "6"
	      }
	    }
	  }), _vm._m(4)])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('alert', {
	    attrs: {
	      "message": _vm.notification.DateMessage,
	      "type": 'alert-warning'
	    }
	  }), _vm._v(" "), _c('alert', {
	    attrs: {
	      "message": _vm.notification.PetMessage,
	      "type": 'alert-warning'
	    }
	  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "form-from-date"
	  }, [(_vm.serviceType == 6) ? _c('div', [_c('h5', [_vm._v("When do you prefer to start")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "ReservationFrom"
	    }
	  }, [_c('label', {
	    staticClass: "form-control input-text",
	    attrs: {
	      "type": "text",
	      "readonly": "true"
	    },
	    model: {
	      value: (_vm.datesData.start),
	      callback: function($$v) {
	        _vm.$set(_vm.datesData, "start", $$v)
	      },
	      expression: "datesData.start"
	    }
	  }, [_vm._v(_vm._s(_vm.startDateMobileComp))]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.serviceType != 6),
	      expression: "serviceType!=6"
	    }],
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "ReservationTo"
	    }
	  }, [_c('label', {
	    staticClass: "form-control input-text",
	    attrs: {
	      "type": "text",
	      "readonly": "true",
	      "disabled": !_vm.datesData.start
	    },
	    model: {
	      value: (_vm.datesData.end),
	      callback: function($$v) {
	        _vm.$set(_vm.datesData, "end", $$v)
	      },
	      expression: "datesData.end"
	    }
	  }, [_vm._v(_vm._s(_vm.endDateMobileComp))]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), (_vm.serviceType == 6) ? _c('div', {
	    staticClass: "form-location"
	  }, [_c('hr'), _vm._v(" "), _c('h5', [_vm._v("How many walks per week")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.initReservation.WalksPerWeek),
	      expression: "initReservation.WalksPerWeek"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "citySelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.initReservation, "WalksPerWeek", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.walksPerWeek), function(walk) {
	    return _c('option', {
	      domProps: {
	        "value": walk.time
	      }
	    }, [_vm._v("\n                                    " + _vm._s(walk.name) + "\n                                  ")])
	  }))])])]) : _vm._e(), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.initReservation.AvailablePetDtos), function(petCard) {
	    return _c('button', {
	      staticClass: "btn btn-default special-button margin-items",
	      class: {
	        active: petCard.IsSelected
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectPet(petCard)
	        }
	      }
	    }, [_c('PetSelectCard', {
	      key: petCard.PetId,
	      attrs: {
	        "petId": petCard.PetId
	      }
	    })], 1)
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-xs-12",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, _vm._l((_vm.initReservation.AvailableSitterServiceDtos), function(service) {
	    return (_vm.serviceType != 0) ? _c('div', {
	      staticClass: "margin-items"
	    }, [(service.ServiceType == 5) ? _c('button', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.serviceType == 1),
	        expression: "serviceType==1"
	      }],
	      staticClass: "btn btn-block btn-default",
	      class: {
	        active: service.IsSelected
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectService(service)
	        }
	      }
	    }, [_c('h4', [_c('i', {
	      staticClass: "fa fa-bus"
	    }), _vm._v(" " + _vm._s(service.Description) + " ")]), _vm._v(" "), _c('span', {
	      staticClass: "small"
	    }, [_vm._v(_vm._s(service.Price) + " "), _c('span', {
	      staticClass: "p smaller"
	    }, [_vm._v(_vm._s(service.DescriptionPer))])])]) : _vm._e()]) : _vm._e()
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h5', [_vm._v("Message to Sitter")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.initReservation.Message),
	      expression: "initReservation.Message"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "font-size": "16px"
	    },
	    attrs: {
	      "placeholder": _vm.messageToSitterComp,
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.initReservation.Message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.initReservation, "Message", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-md-offset-2 col-md-8 col-xs-12"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-lg btn-block",
	    on: {
	      "click": function($event) {
	        _vm.submitRequest()
	      }
	    }
	  }, [(_vm.sending == true) ? _c('i', {
	    staticClass: "fa fa-circle-o-notch fa-spin"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.buttonText))]), _vm._v(" "), _c('br')])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h3', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" Booking Request")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 1 - Choose Service Type")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v(" "), _c('i', {
	    staticClass: "fa fa-shopping-basket"
	  }), _vm._v("  Boarding at Sitters Home")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("  "), _c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v(" Sitting at Owners Home")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("  "), _c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" Dog Walking ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success",
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  }, [_c('strong', [_vm._v("Step 2 - Select the Booking dates")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 3 - Select Pets to stay")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 4 - Optional Message to Sitter")])])
	}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "col-xs-12 col-md-12 wrapper-box"
	  }, [_c('div', {
	    staticClass: "row "
	  }, [_c('div', {
	    staticClass: "col-sm-5 col-xs-12"
	  }, [_vm._m(0), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.AcceptCats),
	      expression: "sitterPetPrefs.AcceptCats"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptCats) ? _vm._i(_vm.sitterPetPrefs.AcceptCats, null) > -1 : (_vm.sitterPetPrefs.AcceptCats)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.AcceptCats,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.AcceptCats = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.AcceptCats = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "AcceptCats", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Accepts Cats")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.AcceptSmallDogs),
	      expression: "sitterPetPrefs.AcceptSmallDogs"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptSmallDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptSmallDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptSmallDogs)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.AcceptSmallDogs,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.AcceptSmallDogs = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.AcceptSmallDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "AcceptSmallDogs", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Accept Small Dogs")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.AcceptMediumDogs),
	      expression: "sitterPetPrefs.AcceptMediumDogs"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptMediumDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptMediumDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptMediumDogs)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.AcceptMediumDogs,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.AcceptMediumDogs = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.AcceptMediumDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "AcceptMediumDogs", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Accept Medium Dogs")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.AcceptLargeDogs),
	      expression: "sitterPetPrefs.AcceptLargeDogs"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptLargeDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptLargeDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptLargeDogs)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.AcceptLargeDogs,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.AcceptLargeDogs = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.AcceptLargeDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "AcceptLargeDogs", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                         Accept Large Dogs")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Experience with Pets")]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.CanCPR),
	      expression: "sitterPetPrefs.CanCPR"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.CanCPR) ? _vm._i(_vm.sitterPetPrefs.CanCPR, null) > -1 : (_vm.sitterPetPrefs.CanCPR)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.CanCPR,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.CanCPR = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.CanCPR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "CanCPR", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Can provide basic CPR first aid")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.CanOral),
	      expression: "sitterPetPrefs.CanOral"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.CanOral) ? _vm._i(_vm.sitterPetPrefs.CanOral, null) > -1 : (_vm.sitterPetPrefs.CanOral)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.CanOral,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.CanOral = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.CanOral = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "CanOral", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Can administer Oral medication")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h5"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.CanInject),
	      expression: "sitterPetPrefs.CanInject"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sitterPetPrefs.CanInject) ? _vm._i(_vm.sitterPetPrefs.CanInject, null) > -1 : (_vm.sitterPetPrefs.CanInject)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.sitterPetPrefs.CanInject,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sitterPetPrefs.CanInject = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sitterPetPrefs.CanInject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.sitterPetPrefs, "CanInject", $$c)
	        }
	      }, function($event) {
	        _vm.somethingChanged()
	      }]
	    }
	  }), _vm._v("\n                          Can provide injections if needed")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8 col-md-7 col-xs-12"
	  }, [_c('h3', [_vm._v("My Experience with Pets")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.Experience),
	      expression: "sitterPetPrefs.Experience"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "5",
	      "placeholder": "i.e I had 2 dogs for 5 years back home"
	    },
	    domProps: {
	      "value": (_vm.sitterPetPrefs.Experience)
	    },
	    on: {
	      "change": function($event) {
	        _vm.somethingChanged()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterPetPrefs, "Experience", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8 col-md-7 col-xs-12"
	  }, [_c('h3', [_vm._v("My Restrictions and Conditions")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterPetPrefs.Restrictions),
	      expression: "sitterPetPrefs.Restrictions"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "5",
	      "placeholder": "If you have any specific restrictions for Dogs or Cats that you accept, please mention them here"
	    },
	    domProps: {
	      "value": (_vm.sitterPetPrefs.Restrictions)
	    },
	    on: {
	      "change": function($event) {
	        _vm.somethingChanged()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterPetPrefs, "Restrictions", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12 col-xs-12"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn-block btn btn-lg btn-success",
	    on: {
	      "click": function($event) {
	        _vm.updateSitterPetPrefs()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Accepting Cats or Dogs is required "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "image-display"
	  }, [_c('img', {
	    staticClass: "sitterphoto",
	    attrs: {
	      "id": "imgPrev",
	      "src": _vm.photoComp,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
	    staticClass: "progress progress-image"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped",
	    style: ({
	      width: _vm.uploadCompletePct
	    }),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "my-button"
	  }, [_c('label', {
	    staticClass: "btn btn-title btn-success"
	  }, [_vm._v("\n        Upload Photo "), _c('i', {
	    staticClass: "fa fa-camera"
	  }), _c('input', {
	    staticClass: "file",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "accept": "image/jpeg, image/bmp, image/png"
	    },
	    on: {
	      "change": _vm.previewThumbnail
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "profilePicModal",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px",
	      "overflow": "hidden"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px"
	    },
	    attrs: {
	      "id": "profilePicCropper",
	      "src": _vm.uploadedImageSrc,
	      "alt": "Picture",
	      "crossorigin": ""
	    }
	  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-title btn-success",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.saveImage
	    }
	  }, [_vm._v("\n              Save Image\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-title btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.cancelSave
	    }
	  }, [_vm._v("\n              Cancel\n            ")])])])])])]), _vm._v(" "), _c('div')])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modalLabel"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" Account Picture\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 hidden-xs hidden-sm"
	  }, [_c('div', {
	    staticClass: "docs-preview clearfix"
	  }, [_c('div', {
	    staticClass: "img-preview"
	  })])])
	}]}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "image-preview-wrapper"
	  }, [_c('div', {
	    staticClass: "image-preview"
	  }, [_c('img', {
	    staticClass: "buttonPhoto",
	    attrs: {
	      "id": "imgPrev",
	      "src": _vm.photoComp,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "my-button"
	  }, [_c('label', {
	    staticClass: "btn btn-title btn-success"
	  }, [_vm._v("\n          Photo "), _c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" "), _c('input', {
	    staticClass: "file",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "accept": "image/jpeg, image/bmp, image/png"
	    },
	    on: {
	      "change": _vm.previewThumbnail
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "cropModalAddMore",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px",
	      "overflow": "hidden"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px"
	    },
	    attrs: {
	      "id": "cropMeAddMore",
	      "src": _vm.uploadedImageSrc,
	      "alt": "Picture",
	      "crossorigin": ""
	    }
	  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
	    staticClass: "progress progress-image"
	  }, [_c('div', {
	    staticClass: "\n                    progress-bar progress-bar-success progress-bar-striped\n                  ",
	    style: ({
	      width: _vm.uploadCompletePct
	    }),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-title btn-success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.saveImage
	    }
	  }, [_vm._v("\n              Save Image\n            ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-title btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.cancelSave
	    }
	  }, [_vm._v("\n              Cancel\n            ")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modalLabel"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" Add Photo\n            ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 hidden-xs hidden-sm"
	  }, [_c('div', {
	    staticClass: "docs-preview clearfix"
	  }, [_c('div', {
	    staticClass: "img-preview preview-md"
	  })])])
	}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.signalReady) ? _c('ViewReservationComponent') : _c('div', {
	    staticClass: "container"
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Preparing connection...")]), _vm._v(" "), _c('p', {
	    staticClass: "text-muted"
	  }, [_vm._v("\n      if this takes too long, it could be your network provider has a proxy or\n      firewall preventing chat to be established, or use a different browser\n      for this session as we have seen some features being blocked on old\n      Safari and Internet Explorer. Alternatively\n      "), _c('a', {
	    attrs: {
	      "href": "https://www.dupaws.com/contact-support"
	    }
	  }, [_vm._v(" contact support ")]), _vm._v("\n      if the issue persist.\n    ")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "container",
	    staticStyle: {
	      "padding-left": "0px"
	    }
	  }, [_c('h3', [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("Home >")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSearchSitters()
	      }
	    }
	  }, [_vm._v("Search Sitters >")]), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "text-decoration": "none"
	    }
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))])])]), _vm._v(" "), (_vm.sitterPublicDetailComp) ? _c('div', {
	    staticClass: "container some-style"
	  }, [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "col-sm-12 bgCover ",
	    style: ({
	      backgroundImage: 'url(' + _vm.bgImageComp + ')'
	    })
	  }, [_c('div', {
	    staticClass: "photo-images"
	  }, _vm._l((_vm.sitterPublicDetailComp.SitterPhotoDtos), function(photo, index) {
	    return (photo.Type != 0) ? _c('div', {
	      staticClass: "thumb-wrap"
	    }, [_c('a', {
	      attrs: {
	        "href": photo.Path,
	        "data-fancybox": "images"
	      }
	    }, [_c('img', {
	      staticClass: "small-images",
	      attrs: {
	        "src": photo.Path
	      }
	    })])]) : _vm._e()
	  }))]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 hidden-sm hidden-md hidden-lg"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    attrs: {
	      "src": _vm.sitterPublicDetailComp.ProfilePicUrl,
	      "alt": "",
	      "height": "100",
	      "width": "100"
	    }
	  }), _vm._v(" "), (_vm.sitterPublicDetailComp.IsOnline == true) ? _c('div', {
	    staticClass: "rank-label-container",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewProfile(_vm.sitter)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "label label-default rank-label"
	  }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h2', {
	    staticClass: "media-heading main-name"
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))]), _vm._v(" "), _c('h6', [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" " + _vm._s(_vm.LocationComp))]), _vm._v(" "), (_vm.sitterPublicDetailComp.RatingCount > 0) ? _c('div', [_vm._l((_vm.sitterPublicDetailComp.RatingAvg), function(n) {
	    return _c('i', {
	      staticClass: "fa fa-star fa-1x inline",
	      staticStyle: {
	        "color": "#ffd118"
	      }
	    })
	  }), _vm._v(" "), _c('h6', {
	    staticClass: " inline"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.RatingCount) + " Reviews")])], 2) : _vm._e()])]), _vm._v(" "), _c('a', {
	    staticClass: "media-right media-top",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-container": "body",
	      "data-placement": "top",
	      "data-content": "Add or Remove from Favorites",
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [(!_vm.sitterPublicDetailComp.AverageResponseTime == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Average Response Time: " + _vm._s(_vm.sitterPublicDetailComp.AverageResponseTime))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.RepeatedStays == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-handshake-o"
	  }), _vm._v(" Number of Repeated Bookings: " + _vm._s(_vm.sitterPublicDetailComp.RepeatedStays))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.sitterPublicDetailComp.SitterServiceDtos), function(item) {
	    return _c('table', {
	      staticClass: "table-condensed col-xs-12"
	    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [(item.IsOffered) ? _c('tr', [_c('td', {
	      staticClass: "h4 col-xs-7",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_vm._v(_vm._s(item.Description))]), _c('td', {
	      staticClass: "h4 col-xs-5",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.Price))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "font-size": "14px"
	      }
	    }, [_vm._v(_vm._s(item.DescriptionPer))])])]) : _vm._e()])])
	  })], 2), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-lg  btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.contactSitter()
	      }
	    }
	  }, [_vm._v("Book Reservation")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(2), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Title))]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.AboutMe))]), _vm._v(" "), (_vm.petPrefComp.Restrictions) ? _c('div', [_c('h4', [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + " Restrictions")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.petPrefComp.Restrictions))])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.Experience) ? _c('div', [_c('h4', [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + " Experience")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "white-space": "pre-wrap"
	    }
	  }, [_vm._v(_vm._s(_vm.petPrefComp.Experience))])]) : _vm._e()]), _vm._v(" "), (_vm.sitterPublicReviewsComp) ? _c('div', {
	    staticClass: "col-sm-10 col-xs-12"
	  }, [_vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', _vm._l((_vm.sitterPublicReviewsComp), function(review) {
	    return _c('div', {
	      staticClass: "media"
	    }, [_c('div', {
	      staticClass: "media-left"
	    }, [_c('img', {
	      staticClass: "img-responsive img-rounded img-min-size",
	      attrs: {
	        "src": review.ReviewerPicUrl,
	        "alt": "",
	        "height": "75",
	        "width": "75"
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "media-left head-title"
	    }, [_c('h4', {
	      staticClass: "media-heading  inline"
	    }, [_vm._v(_vm._s(review.ReviewerName))]), _vm._v(" "), _c('h6', {
	      staticClass: " inline"
	    }, [_vm._v(" posted " + _vm._s(review.ReviewDate))]), _vm._v(" "), _c('div', _vm._l((review.Rating), function(n) {
	      return _c('i', {
	        staticClass: "fa fa-star fa-1x",
	        staticStyle: {
	          "color": "#ffd118"
	        }
	      })
	    })), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(review.Description) + " ")])]), _vm._v(" "), _c('hr')])
	  }))]) : _vm._e()]), _vm._v(" "), (_vm.homeDetailsComp) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('h3', {
	    staticClass: "text-success"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + "'s Home")]), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 0) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(4), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Studio Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 1) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(5), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 1 Bedroom Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 2) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(6), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 2 Bedroom Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 3) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(7), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" 3 Bedroom Apartment")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 4) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(8), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Townhouse")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.HomeType == 5) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(9), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Villa")])]) : _vm._e(), _vm._v(" "), (!_vm.homeDetailsComp.IsSmokeFree) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(10), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Smoking allowed at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasChildren) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(11), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Children at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasCat) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(12), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Resident cat at home")])]) : _vm._e(), _vm._v(" "), (_vm.homeDetailsComp.IsHasDog) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(13), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Resident dog at home")])]) : _vm._e(), _vm._v(" "), (_vm.hasSkillsComp) ? _c('h3', {
	    staticClass: "text-success"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.Name) + "'s Skills")]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanCPR) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(14), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" CPR First Aid")])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanOral) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(15), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Oral Mediciation")])]) : _vm._e(), _vm._v(" "), (_vm.petPrefComp.CanInject) ? _c('div', {
	    staticClass: "fancy-container"
	  }, [_vm._m(16), _vm._v(" "), _c('span', {
	    staticClass: "h4 "
	  }, [_vm._v(" Can provide injections")])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 hidden-xs"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    attrs: {
	      "src": _vm.sitterPublicDetailComp.ProfilePicUrl,
	      "alt": "",
	      "height": "100",
	      "width": "100"
	    }
	  }), _vm._v(" "), (_vm.sitterPublicDetailComp.IsOnline == true) ? _c('div', {
	    staticClass: "rank-label-container",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.viewProfile(_vm.sitter)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "label label-default rank-label"
	  }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h2', {
	    staticClass: "media-heading main-name"
	  }, [_vm._v(_vm._s(_vm.sitterPublicDetailComp.Name))]), _vm._v(" "), _c('h6', [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" " + _vm._s(_vm.LocationComp))]), _vm._v(" "), (_vm.sitterPublicDetailComp.RatingCount != 0) ? _c('div', [_vm._l((_vm.sitterPublicDetailComp.RatingAvg), function(n) {
	    return _c('i', {
	      staticClass: "fa fa-star fa-1x inline",
	      staticStyle: {
	        "color": "#ffd118"
	      }
	    })
	  }), _vm._v(" "), _c('h6', {
	    staticClass: " inline"
	  }, [_vm._v(" " + _vm._s(_vm.sitterPublicDetailComp.RatingCount) + " Reviews")])], 2) : _vm._e()])]), _vm._v(" "), _c('a', {
	    staticClass: "media-right media-top",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-container": "body",
	      "data-placement": "top",
	      "data-content": "Add or Remove from Favorites",
	      "lazy": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addToFavorites(_vm.sitterPublicDetailComp)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa favorite fa-2x ",
	    class: [{
	      'fa-heart': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == true
	    }, {
	      'fa-heart-o': _vm.isFavorite(_vm.sitterPublicDetailComp.SitterId) == false
	    }],
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [(!_vm.sitterPublicDetailComp.AverageResponseTime == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Response Time: " + _vm._s(_vm.sitterPublicDetailComp.AverageResponseTime))]) : _vm._e(), _vm._v(" "), (!_vm.sitterPublicDetailComp.RepeatedStays == 0) ? _c('h5', {
	    staticClass: "performance"
	  }, [_c('i', {
	    staticClass: "fa fa-handshake-o"
	  }), _vm._v(" Client Repeated Stays: " + _vm._s(_vm.sitterPublicDetailComp.RepeatedStays))]) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._l((_vm.sitterPublicDetailComp.SitterServiceDtos), function(item) {
	    return _c('table', {
	      staticClass: "table-condensed col-xs-12"
	    }, [_vm._m(18, true), _vm._v(" "), _c('tbody', [(item.IsOffered) ? _c('tr', [_c('td', {
	      staticClass: "h4 col-xs-7",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "4px"
	      }
	    }, [_vm._v(_vm._s(item.Description))]), _c('td', {
	      staticClass: "h4 col-xs-5",
	      staticStyle: {
	        "padding-top": "0px",
	        "padding-bottom": "0px"
	      }
	    }, [_c('strong', [_vm._v(_vm._s(item.Price))]), _vm._v(" "), _c('span', {
	      staticStyle: {
	        "font-size": "14px"
	      }
	    }, [_vm._v(_vm._s(item.DescriptionPer))])])]) : _vm._e()])])
	  })], 2), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-lg  btn-block ",
	    on: {
	      "click": function($event) {
	        _vm.contactSitter()
	      }
	    }
	  }, [_vm._v("Book Reservation")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 pull-right"
	  }, [_c('br'), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', [(_vm.petPrefComp) ? _c('div', {
	    staticClass: "col-xs-12 wrapper",
	    staticStyle: {
	      "margin-bottom": "5%"
	    }
	  }, [_c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " cats "
	  }, [(_vm.petPrefComp.AcceptCats) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Cats",
	      "src": __webpack_require__(235)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Cats",
	      "src": __webpack_require__(239)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: " text-center"
	  }, [_vm._v("Cats ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " small-breeds"
	  }, [(_vm.petPrefComp.AcceptSmallDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Small Dogs",
	      "src": __webpack_require__(242)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Small Dogs",
	      "src": __webpack_require__(240)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: " text-center"
	  }, [_vm._v(" Small ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " medium-breeds "
	  }, [(_vm.petPrefComp.AcceptMediumDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Medium Size Dogs",
	      "src": __webpack_require__(236)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Medium Size Dogs",
	      "src": __webpack_require__(233)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: "text-center"
	  }, [_vm._v(" Medium ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "preference-images"
	  }, [_c('figure', {
	    staticClass: " "
	  }, [(_vm.petPrefComp.AcceptLargeDogs) ? _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Accepting Large Dogs",
	      "src": __webpack_require__(238)
	    }
	  }) : _c('img', {
	    staticClass: "img img-responsive pad-bottom",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Not Accepting Large Dogs",
	      "src": __webpack_require__(234)
	    }
	  }), _vm._v(" "), _c('figcaption', {
	    staticClass: "text-center"
	  }, [_vm._v(" Large ")])])])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('CalendarView', {
	    attrs: {
	      "sitterId": this.$route.params.sitterId
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('div', [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-warning"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.errorMsg) ? _c('div', [(!_vm.sitterPublicDetailComp) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(21)]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-id-badge"
	  }), _vm._v(" Offered Services ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" Profile Details ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" Reviews")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(14),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(46),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(43),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(44),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(45),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(231),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(241),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    staticClass: "icon-image",
	    attrs: {
	      "src": __webpack_require__(237),
	      "height": "25",
	      "width": "25"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-id-badge"
	  }), _vm._v(" Offered Services ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  }), _vm._v(" Hosting Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" Calendar")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.photoIdProp != 'abc') ? _c('div', {
	    staticClass: "image-wrap"
	  }, [_c('img', {
	    staticClass: "img",
	    attrs: {
	      "src": _vm.photoComp,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        _vm.deleteImage()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash",
	    attrs: {
	      "title": "Delete this photo"
	    }
	  })])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(!_vm.doubleRoleComp) ? _c('div', [_c('h1', {
	    staticClass: "text-center h4",
	    staticStyle: {
	      "font-weight": "600 !important",
	      "font-family": "'Merriweather', serif !important"
	    }
	  }, [_vm._v("\n      Get paid to play with pets\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
	    staticClass: "text-center h4",
	    staticStyle: {
	      "font-weight": "600 !important",
	      "font-family": "'Merriweather', serif !important"
	    }
	  }, [_vm._v("\n      100% commission free\n    ")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), (!_vm.checkUserComp) ? _c('div', [_c('div', {
	    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-lg btn-block",
	    staticStyle: {
	      "font-family": "'Merriweather', serif !important"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goSitterSignup()
	      }
	    }
	  }, [_vm._v("\n          Get Started\n        ")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.checkUserComp) ? _c('div', {
	    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.confirmSwitchAccount()
	      }
	    }
	  }, [_vm._v("\n        Switch Account\n      ")])]) : _vm._e()]) : _c('div', [_vm._m(3)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('img', {
	    staticClass: "img img-responsive",
	    attrs: {
	      "src": "https://www.dupaws.com/services/images/site/become-a-sitter.jpg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "col-sm-5 col-sm-offset-2 col-xs-12"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-check",
	    staticStyle: {
	      "color": "#00bd70"
	    }
	  }), _vm._v(" Set your own\n          price rates\n        ")]), _vm._v(" "), _c('p', [_c('i', {
	    staticClass: "fa fa-check",
	    staticStyle: {
	      "color": "#00bd70"
	    }
	  }), _vm._v(" Set your own\n          schedule and availability\n        ")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 col-xs-12"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-check",
	    staticStyle: {
	      "color": "#00bd70"
	    }
	  }), _vm._v(" Get paid 100%\n          commission free.\n        ")]), _vm._v(" "), _c('p', [_c('i', {
	    staticClass: "fa fa-check",
	    staticStyle: {
	      "color": "#00bd70"
	    }
	  }), _vm._v(" Only accept pets\n          that match your preferrence.\n        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('br'), _vm._v(" "), _c('h1', {
	    staticClass: "text-center h4",
	    staticStyle: {
	      "font-weight": "600 !important",
	      "font-family": "'Merriweather', serif !important"
	    }
	  }, [_vm._v("\n        How this work\n      ")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }), _vm._v(" "), _c('p', {}, [_vm._v("\n        It takes around 3 to 5 minutes to create a profile, once completed and\n        approved pet owners will be able to directly contact and book your\n        services.\n      ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("\n      Your account already registered as a sitter, go to\n      "), _c('a', {
	    attrs: {
	      "href": "/account"
	    }
	  }, [_c('strong', [_vm._v("account")])]), _vm._v(" to switch your role\n    ")])
	}]}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 hidden-xs hidden-sm"
	  }, [_c('h3', {
	    staticClass: "text-center text-muted",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("\n        Feedback and Performance\n      ")]), _vm._v(" "), _c('FeedbackAndPerformance', {
	    staticStyle: {
	      "margin-bottom": "20px"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 hidden-xs hidden-sm"
	  }, [_c('h3', {
	    staticClass: "text-center text-muted",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_vm._v("\n        Shortcuts\n      ")]), _vm._v(" "), _c('Shortcuts')], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "nav nav-tabs hidden-md hidden-lg"
	  }, [_c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/dashboard/feedback-performance"
	    }
	  }, [_c('a', [_vm._v("Performance")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "active-class": "active",
	      "tag": "li",
	      "to": "/dashboard/shortcuts"
	    }
	  }, [_c('a', [_vm._v("Shortcuts")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "tab-content hidden-md hidden-lg"
	  }, [_c('router-view')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-sm hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" Dashboard, profile and activity summary\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-10 col-sm-offset-1"
	  }, [_c('hr', {
	    staticClass: "hidden-xs hidden-sm",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center hidden-md hidden-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" Dashboard, profile and activity summary\n  ")])
	}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.reservationComp && _vm.isActiveComp == true && !_vm.loading) ? _c('div', {
	    staticClass: "container"
	  }, [_c('h2', {
	    staticClass: "small-h2 text-center",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.reservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "5px"
	    }
	  }), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "hidden-lg hidden-md"
	  }, [_c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#summary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchCollapse()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa fa-navicon"
	  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
	    staticClass: " hidden-md hidden-lg collapse",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    },
	    attrs: {
	      "id": "summary",
	      "aria-expanded": "true"
	    }
	  }, [_c('div', {
	    staticClass: "reservationSummary"
	  }, [_vm._l((_vm.reservationComp.AvailablePetDtos), function(petCard) {
	    return _c('div', [_c('div', [_c('PetSelectCard', {
	      key: petCard.PetId,
	      attrs: {
	        "showDetails": true,
	        "petId": petCard.PetId
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "summary-desc"
	  }, [_c('h5', [_vm._v("Total Days: " + _vm._s(_vm.reservationComp.TotalDays))]), _vm._v(" "), _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.reservationComp.ServicePriceSummaryDtos), function(service) {
	    return _c('h5', [_vm._v(_vm._s(service.Description))])
	  }), _vm._v(" "), _c('h5', {
	    staticClass: "text-success"
	  }, [_vm._v("Total Price: " + _vm._s(_vm.reservationComp.TotalPrice) + " " + _vm._s(_vm.currencyComp))])], 2)], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
	  }, [(_vm.reservationComp.SitterStatus) ? _c('div', {
	    staticClass: "alert alert-dismissible",
	    class: _vm.reservationComp.StatusClass,
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.reservationComp.SitterStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-circle",
	    attrs: {
	      "src": _vm.reservationComp.CustomerProfilePic,
	      "alt": "",
	      "height": "25",
	      "width": "25"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left head-title"
	  }, [_c('h4', {
	    staticClass: "media-heading ",
	    staticStyle: {
	      "display": "inline-block",
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.reservationComp.CustomerName))])]), _vm._v(" "), (_vm.signalReadyComp) ? _c('Chat', {
	    attrs: {
	      "isSitterAccepted": _vm.reservationComp.IsSitterAccepted,
	      "transactionId": _vm.reservationIdComp
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.rejectedComp) ? _c('div', {
	    staticClass: "buttons"
	  }, [(_vm.notStartedComp) ? _c('div', {
	    staticClass: "buttons-started"
	  }, [_c('button', {
	    staticClass: "btn btn-block btn-success",
	    attrs: {
	      "disabled": _vm.reservationComp.IsSitterAccepted == true
	    },
	    on: {
	      "click": function($event) {
	        _vm.acceptReservation()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v("\n                " + _vm._s(_vm.acceptedButton))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block  btn-warning",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top"
	    },
	    on: {
	      "click": function($event) {
	        _vm.rejectRequest()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash-o"
	  }), _vm._v("\n                Reject Request")]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.rejectedComp) ? _c('div', [(!_vm.reservationComp.IsSitterRemoved) ? _c('button', {
	    staticClass: "btn btn-warning btn-block",
	    staticStyle: {
	      "margin-bottom": "5px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.removeDashboard()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash-o"
	  }), _vm._v("\n            Remove from Bookings")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block btn-lg",
	    on: {
	      "click": function($event) {
	        _vm.goMySitterReservations()
	      }
	    }
	  }, [_vm._v("View all Bookings")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
	  }, [_c('h4', {
	    staticClass: "text-center"
	  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.reservationComp.AvailablePetDtos), function(petCard) {
	    return _c('div', {
	      key: petCard.PetId
	    }, [_c('div', [_c('PetSelectCard', {
	      attrs: {
	        "showDetails": true,
	        "petId": petCard.PetId
	      }
	    })], 1)])
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Total Days: " + _vm._s(_vm.reservationComp.TotalDays))]), _vm._v(" "), _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.reservationComp.ServicePriceSummaryDtos), function(service) {
	    return _c('h5', [_vm._v(_vm._s(service.Description))])
	  }), _vm._v(" "), _c('h5', {
	    staticClass: "text-success"
	  }, [_vm._v("Total Price: " + _vm._s(_vm.reservationComp.TotalPrice) + " " + _vm._s(_vm.currencyComp))])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
	    staticClass: "container"
	  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false) ? _c('div', [_c('br'), _vm._v(" "), _c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v("You need to have an active membership to view this reservation")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Note: Only customers who are members can reach out to you without Premium membership")]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-md-offset-4"
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-block btn-premium",
	    on: {
	      "click": function($event) {
	        _vm.goSubscribe()
	      }
	    }
	  }, [_vm._v("Go Premium "), _c('i', {
	    staticClass: "fa fa-paw"
	  })]), _vm._v(" "), _c('br')])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])])
	}]}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "max-width": "500px"
	    }
	  }, [(!_vm.checkUserComp) ? _c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [(_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_vm._m(1), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.errorMsg) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.notificationMsg) ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible"
	  }, [_vm._m(2), _vm._v("\n                " + _vm._s(_vm.notificationMsg) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', [_c('div', [_c('a', {
	    staticClass: "btn btn-lg btn-title btn-block btn-social btn-facebook",
	    staticStyle: {
	      "background-color": "#4267b2",
	      "color": "#fff",
	      "margin-top": "5px!important",
	      "margin": "20px auto 0px auto"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-facebook"
	  }), _vm._v(" "), _c('fb-signin-button', {
	    staticClass: "text-center",
	    attrs: {
	      "params": _vm.fbSignInParams
	    },
	    on: {
	      "success": _vm.onSignInSuccess,
	      "error": _vm.onSignInError
	    }
	  }, [_vm._v("\n                              Continue with Facebook\n                            ")])], 1)])])])])]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-bottom": "10px"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "text-center small"
	  }, [_vm._v("Or register using your email")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "padding-bottom": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('firstName')),
	      expression: "errors.has('firstName')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.firstName.length > 2) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('firstName')),
	      expression: "!errors.has('firstName')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.firstName),
	      expression: "credentials.firstName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('firstName')
	    },
	    attrs: {
	      "type": "text",
	      "name": "firstName",
	      "data-vv-as": "first name",
	      "placeholder": "First Name",
	      "tabindex": "1"
	    },
	    domProps: {
	      "value": (_vm.credentials.firstName)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "firstName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('firstName')),
	      expression: "errors.has('firstName')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lastName')),
	      expression: "errors.has('lastName')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.lastName.length > 2) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('lastName')),
	      expression: "!errors.has('lastName')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.lastName),
	      expression: "credentials.lastName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('lastName')
	    },
	    attrs: {
	      "type": "text",
	      "name": "lastName",
	      "data-vv-as": "last name",
	      "placeholder": "Last Name",
	      "tabindex": "2"
	    },
	    domProps: {
	      "value": (_vm.credentials.lastName)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "lastName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lastName')),
	      expression: "errors.has('lastName')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.email) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('email')),
	      expression: "!errors.has('email')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.email),
	      expression: "credentials.email",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('email')
	    },
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "data-vv-as": "email",
	      "placeholder": "Email",
	      "tabindex": "3"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('password')),
	      expression: "!errors.has('password')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('password')
	    },
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": "Password",
	      "tabindex": "4",
	      "data-vv-delay": "1500"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary pull-right btn-title",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "disabled": _vm.filledRequired == false,
	      "tabindex": "5"
	    },
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Signup")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.checkUserComp && _vm.userRoleComp != 'Sitter') ? _c('div', {
	    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("You already have a sitter account, click below to login as a sitter")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.confirmSwitchAccount()
	      }
	    }
	  }, [_vm._v("Switch Account")])]) : _vm._e(), _vm._v(" "), (_vm.checkUserComp && _vm.userRoleComp == 'Sitter') ? _c('div', [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v(" You are already logged in as a sitter ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-4 col-sm-offset-4"
	  }, [_c('button', {
	    staticClass: "btn btn-info btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.goDashboard()
	      }
	    }
	  }, [_vm._v("Go to Dashboard")])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header text-center",
	    staticStyle: {
	      "padding-top": "0px !important",
	      "padding-bottom": "0px !important"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("We are excited to have you with us ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "small",
	    staticStyle: {
	      "padding-left": "5px"
	    }
	  }, [_vm._v("By registering you agree to our "), _c('a', {
	    attrs: {
	      "href": "/terms-and-conditions"
	    }
	  }, [_vm._v("terms and conditions")])])
	}]}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('br'), _vm._v(" "), (!_vm.initializing) ? _c('div', {
	    staticClass: "container remove-margins"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-lg-8 col-md-10 col-xs-12 remove-margins"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-12 remove-margins"
	  }, [_c('div', [_c('div', {
	    staticClass: "flex-container"
	  }, _vm._l((_vm.petPhotoList), function(photo) {
	    return _c('div', [_c('PetPicView', {
	      key: photo.PetPhotoId,
	      attrs: {
	        "photoIdProp": photo.PetPhotoId
	      }
	    })], 1)
	  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "image-preview-wrapper"
	  }, [_c('div', {
	    staticClass: "image-preview"
	  }, [_c('img', {
	    staticClass: "buttonPhoto",
	    attrs: {
	      "id": "imgPrev",
	      "src": _vm.photoComp,
	      "crossOrigin": "Anonymous"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "my-button"
	  }, [_c('label', {
	    staticClass: "btn btn-success btn-title"
	  }, [_vm._v("\n                                                Photo "), _c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" "), _c('input', {
	    staticClass: "file",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "getImage",
	      "type": "file",
	      "accept": "image/jpeg, image/bmp, image/png"
	    },
	    on: {
	      "change": _vm.previewThumbnail
	    }
	  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "form-group "
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('petName')),
	      expression: "errors.has('petName')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.newPet.Name) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('petName')),
	      expression: "!errors.has('petName')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:2'),
	      expression: "'required|min:2'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.Name),
	      expression: "newPet.Name"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('petName')
	    },
	    attrs: {
	      "type": "text",
	      "name": "petName",
	      "data-vv-as": "pet name",
	      "placeholder": "Pet Name",
	      "data-vv-delay": "1000"
	    },
	    domProps: {
	      "value": (_vm.newPet.Name)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPet, "Name", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('petName')),
	      expression: "errors.has('petName')"
	    }],
	    staticClass: "help-inline text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('petName')))])]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-6"
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-title btn-block",
	    class: {
	      active: _vm.newPet.PetType == 2, 'btn-danger': !_vm.PetTypeSelected
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-right": "0px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updatePetType(2)
	      }
	    },
	    model: {
	      value: (_vm.newPet.PetType),
	      callback: function($$v) {
	        _vm.$set(_vm.newPet, "PetType", $$v)
	      },
	      expression: "newPet.PetType"
	    }
	  }, [_vm._v("Cat")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-6",
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default btn-title btn-block",
	    class: {
	      active: _vm.newPet.PetType == 1, 'btn-danger': !_vm.PetTypeSelected
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-right": "20px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updatePetType(1)
	      }
	    },
	    model: {
	      value: (_vm.newPet.PetType),
	      callback: function($$v) {
	        _vm.$set(_vm.newPet, "PetType", $$v)
	      },
	      expression: "newPet.PetType"
	    }
	  }, [_vm._v("Dog")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.Gender),
	      expression: "newPet.Gender"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "male",
	      "id": "male",
	      "value": "true"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.newPet.Gender, "true")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.newPet, "Gender", "true")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "h4",
	    class: {
	      'text-danger': !_vm.PetGenderSelectedComp
	    },
	    attrs: {
	      "for": "male"
	    }
	  }, [_vm._v("Male")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-6",
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "0px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.Gender),
	      expression: "newPet.Gender"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "female",
	      "name": "female",
	      "value": "false"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.newPet.Gender, "false")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.newPet, "Gender", "false")
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "h4",
	    class: {
	      'text-danger': !_vm.PetGenderSelectedComp
	    },
	    attrs: {
	      "for": "female"
	    }
	  }, [_vm._v("Female")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-xs-6",
	    staticStyle: {
	      "margin-left": "0px !important",
	      "padding-left": "0px"
	    }
	  }, [_c('label', [_vm._v("Age Years")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.AgeYears),
	      expression: "newPet.AgeYears"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "required": ""
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.newPet, "AgeYears", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v(" 0 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v(" 5 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v(" 6 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v(" 7 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v(" 8 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v(" 9 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v(" 10 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v(" 11 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v(" 12 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "13"
	    }
	  }, [_vm._v(" 13 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "14"
	    }
	  }, [_vm._v(" 14 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "15"
	    }
	  }, [_vm._v(" 15 ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px"
	    }
	  }, [_c('label', [_vm._v("Age Months")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.AgeMonths),
	      expression: "newPet.AgeMonths"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "required": ""
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.newPet, "AgeMonths", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v(" 0 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v(" 5 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v(" 6 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v(" 7 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v(" 8 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v(" 9 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v(" 10 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v(" 11 ")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v(" 12 ")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "collapse col-sm-12 remove-margins",
	    attrs: {
	      "id": "petOptional"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-12 remove-margins"
	  }, [_c('div', [_c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.IsRegisteredwithColar),
	      expression: "newPet.IsRegisteredwithColar"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newPet.IsRegisteredwithColar) ? _vm._i(_vm.newPet.IsRegisteredwithColar, null) > -1 : (_vm.newPet.IsRegisteredwithColar)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newPet.IsRegisteredwithColar,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newPet.IsRegisteredwithColar = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newPet.IsRegisteredwithColar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newPet, "IsRegisteredwithColar", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                             Does your pet have Munipicaty Colar and Registration?")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.IsNeuteredOrSpayed),
	      expression: "newPet.IsNeuteredOrSpayed"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newPet.IsNeuteredOrSpayed) ? _vm._i(_vm.newPet.IsNeuteredOrSpayed, null) > -1 : (_vm.newPet.IsNeuteredOrSpayed)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newPet.IsNeuteredOrSpayed,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newPet.IsNeuteredOrSpayed = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newPet.IsNeuteredOrSpayed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newPet, "IsNeuteredOrSpayed", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                            Is your Pet Neutered/Spayed?")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.TicksOrFleas),
	      expression: "newPet.TicksOrFleas"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newPet.TicksOrFleas) ? _vm._i(_vm.newPet.TicksOrFleas, null) > -1 : (_vm.newPet.TicksOrFleas)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newPet.TicksOrFleas,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newPet.TicksOrFleas = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newPet.TicksOrFleas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newPet, "TicksOrFleas", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                            Is your Pet clean from Ticks and Fleas?")])]), _vm._v(" "), _c('li', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "h4"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.RabiesVaccinated),
	      expression: "newPet.RabiesVaccinated"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.newPet.RabiesVaccinated) ? _vm._i(_vm.newPet.RabiesVaccinated, null) > -1 : (_vm.newPet.RabiesVaccinated)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.newPet.RabiesVaccinated,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.newPet.RabiesVaccinated = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.newPet.RabiesVaccinated = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.newPet, "RabiesVaccinated", $$c)
	        }
	      }
	    }
	  }), _vm._v("\n                            Has been Rabies Vaccinated?")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.MicrochipId),
	      expression: "newPet.MicrochipId"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Microchip ID"
	    },
	    domProps: {
	      "value": (_vm.newPet.MicrochipId)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPet, "MicrochipId", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.PreferredVet),
	      expression: "newPet.PreferredVet"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Any preferred Vets in case of an emergency?"
	    },
	    domProps: {
	      "value": (_vm.newPet.PreferredVet)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPet, "PreferredVet", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPet.Remarks),
	      expression: "newPet.Remarks"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "rows": "5",
	      "placeholder": "Anything the sitter should know about your pet? i.e alergies, medications, surgeries",
	      "id": "comment"
	    },
	    domProps: {
	      "value": (_vm.newPet.Remarks)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.newPet, "Remarks", $event.target.value)
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-12",
	    staticStyle: {
	      "margin-left": "0px",
	      "padding-left": "0px",
	      "margin-right": "0px",
	      "padding-right": "0px"
	    }
	  }, [_c('br'), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-block",
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#petOptional"
	    }
	  }, [_vm._v("\n                        Optional Details\n                ")]), _vm._v(" "), (_vm.editingMode == false) ? _c('button', {
	    staticClass: "btn btn-success btn-lg btn-block",
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Save & Continue")]) : _vm._e(), _vm._v(" "), (_vm.editingMode == true) ? _c('button', {
	    staticClass: "btn btn-success btn-lg btn-block",
	    on: {
	      "click": function($event) {
	        _vm.validateUpdate()
	      }
	    }
	  }, [_vm._v("Save & Continue")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "cropPetPhotoModal",
	      "role": "dialog",
	      "aria-labelledby": "modalLabel",
	      "tabindex": "-1"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(5), _vm._v(" "), _c('div', {
	    staticClass: "modal-body row"
	  }, [_c('div', {
	    staticClass: "col-md-6",
	    staticStyle: {
	      "max-width": "400px",
	      "max-height": "300px",
	      "overflow": "hidden"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "max-width": "100%",
	      "max-height": "300px"
	    },
	    attrs: {
	      "id": "cropPetPhotoCropper",
	      "src": _vm.uploadedImageSrcComp,
	      "alt": "Picture",
	      "crossorigin": ""
	    }
	  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
	    staticClass: "progress progress-image"
	  }, [_c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped",
	    style: ({
	      width: _vm.uploadCompletePct
	    }),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-title btn-success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.saveImage
	    }
	  }, [_vm._v("Save Image")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-title btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.cancelSave
	    }
	  }, [_vm._v("Close")])])])])])])]) : _c('div', {
	    staticClass: "container remove-margins"
	  }, [_c('h2', [_vm._v("Initializing Pet Data")]), _vm._v(" "), _c('p', [_vm._v("Please refresh your browser if this page takes too long")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 1: Upload Photo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 2: Enter Pet Name")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success"
	  }, [_c('strong', [_vm._v("Step 3: Select Pet Type")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_c('strong', [_vm._v("Step 4: Select Pet Gender")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-success",
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_c('strong', [_vm._v("Step 5: Specify Age")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h2', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "modalLabel"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" Add Pet Photo")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-6 hidden-xs hidden-sm"
	  }, [_c('div', {
	    staticClass: "docs-preview clearfix"
	  }, [_c('div', {
	    staticClass: "img-preview"
	  })])])
	}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "text-center"
	  }, [_vm._v(" Terms and Conditions")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Dupaws FZE")]), _vm._v(" (hereafter referred to as “Dupaws”, “Dupaws.com”, “us”, “we” or “our”) is an online platform to connect pet owners with pet sitters who wants to provide housing and care services, the services are offered at Dupaws.com platform (hereafter referred to “website”, “our platform”, “app”,“site”) where pet owners can find, book, communicate and review pet sitters who listed their profiles using our platform.\nAnyone who is willing to use Dupaws.com must register an account and accept our terms and conditions, by agreeing to these terms you are legally bound to all the terms listed in this article in addition you agree to our privacy policy rules.\nYou also understand that we may change the terms from time to time and that these changes can become effective immediately. When we notify our users (“Pet Sitters”, “Pet Owners” and anyone else using Dupaws.com), their continued access and use of Dupaws.com means they are accepting the new terms.\nDupaws.com is intended to be used solely by persons who are 18 years of age or older, by accessing or using any of Dupaws services you agree that you are 18 years old or older, if you are under 18 years old then you are prohibited from using this platform.\n")]), _vm._v(" "), _c('p', [_vm._v("\nDupaws is an online platform which Pet Sitters “Sitters” can create profiles, add their services, setup their service fees and Pet Owners “Clients” can use the platform to find their preferred Sitter, \nDupaws.com is not a Pet Care Service Facility or Provider, our Platform is used by Pet Sitters to list their services, and to facilitate the communication and interaction between Sitters and Clients, We do not employ any Sitter directly nor do we enforce Clients to use any specific Sitter, it’s the Clients responsibility to validate that the Sitter is the right person to take care of their Pet for the agreed duration or the agreed service, thus we are not liable for any incidents, damages, health or other problems that might occur to Pet Sitter or Pet Owner by using our platform.\n")]), _vm._v(" "), _c('p'), _c('h3', [_vm._v("Terms")]), _vm._v("\n“Pet Sitter”: is a member who creates a profile and list services he is willing to offer on Dupaws platform.\n“Pet Owner”: is a member who has a pet or pets and willing to hire a Pet Sitter for a specific services or multiple services for specific duration.\n“Services”: are the Pet Sitter allowed services such as Dog Sitting, Cat Sitting, Dog Walking, Home Sitting etc.\n“Platform”: means Dupaws website, mobile app, or any application used by the users to interact and use Dupaws collective services.\n“Content”: is any text, graphics, images, music, information, documents, data or other material.\n“Third Party”: means any entity that works with Dupaws such as contractors, marketing agencies, distributors, merchants, sponsors, vets or sponsors.\n"), _c('p'), _vm._v(" "), _c('h3', [_vm._v("Registration:")]), _vm._v(" "), _c('p', [_vm._v("\nFor users to start utilizing Dupaws services they need to be registered, if you decide to use the service and register you agree that you provide accurate and up-to-date information about yourself, your name, address, age and you cannot create more than one account with conflicting information. We keep your credentials (username and password) encrypted and safe in our database.  We will not share your username and password to any third-party entity.\nIn case you suspect that someone else is using your account you will inform us immediately.\n")]), _vm._v(" "), _c('h3', [_vm._v("Booking Policy:")]), _vm._v(" "), _c('p', [_vm._v("Dupaws prohibits booking animals or pets with special needs or requirements such as pets on antibiotics, pets that have severe allergies, dogs or cats who have aggressive behavioral issues, or are very young to be left alone, this is to ensure the safety of the pet and the pet sitter. Also no bookings should take place of breeds or speciies that are banned in the country of the sitter and pet owner, if you need to have boarding for such specific case then our recommendation is to contact your vet or nearby animal shelter and ask them for recommended place to keep your pet.")]), _vm._v(" "), _c('p', [_vm._v("For stays that are 3 days or longer, we require both the pet sitter and the pet owner to schedule a meet and greet in person to let the pet spend at least 1 day with the sitter on his own to ensure that both are perfect match to each other. pet owners or sitters who don't have the time to take this step are prohibited from booking long stays on Dupaws.com.")]), _vm._v(" "), _c('h3', [_vm._v("Communication:")]), _vm._v(" "), _c('p', [_vm._v("We prohibit users from sharing of their personal emails, phone numbers or any other contact method such as social media account until a booking is accepted by the pet sitter, this is to protect the privacy of all parties. Keep in mind that we might review each message being sent through our platform. Pet Sitters or Pet Owners who fail to follow this can get their account suspended indefinitely.")]), _vm._v(" "), _c('h3', [_vm._v("Cancellation/Refund Policy")]), _vm._v(" "), _c('p', [_vm._v("All membership plans (Pet owners Membership or Pet sitters Premium accounts) are not refundable, before upgrading your account to paid membership make sure to check if the free basic account addresses your needs.")]), _vm._v(" "), _c('h3', [_vm._v("Access")]), _vm._v(" "), _c('p', [_vm._v("Dupaws has the right under this agreement to limit, suspend or withdraw all your access to Dupaws if deemed necassary to protect Dupaws or it's users from any suspicious activity.")]), _vm._v(" "), _c('h3', [_vm._v("Liability and Release:")]), _vm._v(" "), _c('p', [_vm._v("\nYou agree that by using Dupaws or any of its services or related services, directly or indirectly release us from any physical or non-physical damage, whether it happened during the booking dates or outside booking dates. \n")]), _vm._v(" "), _c('h3', [_vm._v("Pets Re-homing:")]), _vm._v(" "), _c('p', [_vm._v("\nPet owners who fail to retrieve their pets within seven days after the end of booking dates will be applicable to animal abandonment and cruelty laws, Dupaws or the Pet Sitter will try to contact the pet owner by all feasable means before surrendering the pet to the animal control authorities within their country of booking. Dupaws takes this seriously and will report any such cases to authorities for full investigation.\n")]), _vm._v(" "), _c('h3', [_vm._v("Eligibility:")]), _vm._v(" "), _c('p', [_vm._v("By accessing and using Dupaws.com, you acknowledge and confirm that you are at least 18 years of age, if you are offering Pet Sitting or Pet Boarding Services you accept that you comply with your country local laws, you have obtained all the required and necessary licenses, permits needed to operate and offer such activities and that you comply with your country local laws and regulations or permits that might be requested in future by the legal entities.\nFor Pet owners, your pet needs to be in a healthy state and registered per country's local laws.\nWe expect all Dupaws users (Pet Sitters, Pet Owners or otherwise to confirm to the local imposed law and by using any of our services we expect that you already complied with the above requirements or other requirements per local regulations).\n")]), _vm._v(" "), _c('h3', [_vm._v("Content:")]), _vm._v(" "), _c('p', [_vm._v("We require users who are willing to use our services to upload some information about themselves, their pets, their homes such as images, text descriptions, reviews, opinions, about you or something else that we deem necessary to ensure we are aware of all the needed details to help facilitate the best possible services for our users. By accepting this article you permit Dupaws and/or any of our affiliate partners or third party providers to use, distribute, sublicense or modify this content at Dupaws own discretion, by accepting this you are allowing this content to be publicly shared, displayed, posted, downloaded, reproduced, printed or copied without your permission, any information or data added to Dupaws platform belongs to Dupaws and can be shared on third party sites such as social media or otherwise unless strictly specified by us, such as the combination of your username and password.\nYou grant Dupaws a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sub-licensable right to use any information, material, personal or non-personal that was submitted by any means to Dupaws to use for operating, promoting the site, sharing this information with third party entity or otherwise without your consent.\n")]), _vm._v(" "), _c('h3', [_vm._v("Privacy Policy:")]), _vm._v(" "), _c('p', [_vm._v("Dupaws takes the privacy of its users seriously, make sure to read all the details in Privacy Policy. ")]), _vm._v(" "), _c('h3', [_vm._v("Indemnity:")]), _vm._v(" "), _c('p', [_vm._v("You agree to release Dupaws and its affiliates, officers, employees, agents, suppliers and partners from any claims, demands, actions, proceedings, damages, costs, expenses of any type directly or indirectly whether affected you or someone you know.")]), _vm._v(" "), _c('h3', [_vm._v("Intellectual Property and copyrights:")]), _vm._v(" "), _c('p', [_vm._v("Dupaws provided materials, including but not limited to content such as text, review, feedback, description or software, apps, website, documents, products, logos, graphics, images and services are protected by copyright and trademark laws. None of the materials listed here can be modified or used without official express written permission from Dupaws FZE or any of its affiliate third party licensed partners. You also agree that your feedback or enhancement suggestions regarding any of Dupaws Services can be used without any obligation of compensation. Dupaws owns all rights in and to its trademarks, brand, logos, images and any other service related to us. This also can be a form of goods, toys, business cards, store or anything else that we use as a marketing tool or consumer goods.")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "font-weight": "600"
	    }
	  }, [_vm._v("Updated 12 May 2018")])])
	}]}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(!_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h1', {
	    staticClass: "text-center",
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }, [_vm._v("\n      Payment successful, thank you\n    ")]), _vm._v(" "), _c('div', {
	    staticClass: "card text-center col-md-offset-3 col-md-6"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "left",
	      "margin-left": "5px"
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.InvoiceNumber))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "left",
	      "margin-left": "5px"
	    }
	  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.subscriptionDto.TotalAmount))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "left",
	      "margin-left": "5px"
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.paymentDateComp))])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.Description))]), _vm._v(" valid until\n        "), _c('strong', [_vm._v(_vm._s(_vm.endDateComp))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-md-offset-3",
	    staticStyle: {
	      "margin-top": "0px",
	      "padding": "0px"
	    }
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("\n        Details will be sent shortly to\n        "), _c('strong', [_vm._v(_vm._s(_vm.subscriptionDto.Email))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-md-offset-3",
	    staticStyle: {
	      "margin-top": "15px",
	      "padding": "0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-success btn-block",
	    on: {
	      "click": function($event) {
	        _vm.goHome()
	      }
	    }
	  }, [_vm._v("\n        Go home\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(4)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticClass: "text-center"
	  }, [_c('i', {
	    staticClass: "fa fa-2x fa-check-circle-o",
	    staticStyle: {
	      "color": "#77c778"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "right",
	      "margin-right": "5px"
	    }
	  }, [_vm._v("\n          Invoice No:\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "right",
	      "margin-right": "5px"
	    }
	  }, [_vm._v("\n          Total Amount:\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "float": "right",
	      "margin-right": "5px"
	    }
	  }, [_vm._v("\n          Payment Date:\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	}]}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "calendarComponent"
	    }
	  }, [_c('br'), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "calendar"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h5', [_vm._v("Available for the following locations:")]), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "location-input-background form-control",
	    staticStyle: {
	      "z-index": "999999 !important",
	      "width": "100% !important"
	    },
	    attrs: {
	      "placeholder": _vm.myPlaceholder,
	      "id": "myinput"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-container",
	    attrs: {
	      "id": "countriesSwiper"
	    }
	  }, [_c('div', {
	    staticClass: "swiper-wrapper"
	  }, _vm._l((_vm.dogWalkingProfile.Areas), function(location) {
	    return _c('div', {
	      staticClass: "animated fadeInRight swiper-slide label label-info"
	    }, [_vm._v("\n        " + _vm._s(location.AreaName) + "\n        "), _c('button', {
	      staticClass: "close",
	      staticStyle: {
	        "position": "absolute",
	        "right": "5px",
	        "top": "5px"
	      },
	      attrs: {
	        "type": "button",
	        "data-dismiss": "alert",
	        "aria-label": "Close"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeLocation(location)
	        }
	      }
	    }, [_c('span', {
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_vm._v("×")])])])
	  }))]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }), _vm._v(" "), _c('h5', [_vm._v("Available on the following days:")]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline",
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allDays),
	      expression: "allDays"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.allDays) ? _vm._i(_vm.allDays, null) > -1 : (_vm.allDays)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.allDays,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.allDays = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.allDays = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.allDays = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("All Days")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sun),
	      expression: "sun"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "1",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sun) ? _vm._i(_vm.sun, null) > -1 : _vm._q(_vm.sun, "1")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sun,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("1") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sun = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sun = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sun = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sun")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mon),
	      expression: "mon"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "2",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.mon) ? _vm._i(_vm.mon, null) > -1 : _vm._q(_vm.mon, "2")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.mon,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("2") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.mon = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.mon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.mon = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Mon")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tue),
	      expression: "tue"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "4",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.tue) ? _vm._i(_vm.tue, null) > -1 : _vm._q(_vm.tue, "4")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.tue,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("4") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.tue = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.tue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.tue = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Tue")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.wed),
	      expression: "wed"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "8",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.wed) ? _vm._i(_vm.wed, null) > -1 : _vm._q(_vm.wed, "8")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.wed,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("8") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.wed = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.wed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.wed = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Wed")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.thu),
	      expression: "thu"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "16",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.thu) ? _vm._i(_vm.thu, null) > -1 : _vm._q(_vm.thu, "16")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.thu,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("16") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.thu = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.thu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.thu = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Thu")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fri),
	      expression: "fri"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "32",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.fri) ? _vm._i(_vm.fri, null) > -1 : _vm._q(_vm.fri, "32")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.fri,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("32") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.fri = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.fri = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.fri = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Fri")])]), _vm._v(" "), _c('label', {
	    staticClass: "small checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sat),
	      expression: "sat"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.allDays,
	      "true-value": "64",
	      "false-value": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.sat) ? _vm._i(_vm.sat, null) > -1 : _vm._q(_vm.sat, "64")
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.sat,
	          $$el = $event.target,
	          $$c = $$el.checked ? ("64") : ("0");
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.sat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.sat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.sat = $$c
	        }
	      }
	    }
	  }), _c('span', {
	    staticClass: "small"
	  }, [_vm._v("Sat")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Availability time and restrictions:")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dogWalkingProfile.Remarks),
	      expression: "dogWalkingProfile.Remarks"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "rows": "5",
	      "placeholder": "i.e I am only available from 5:00 PM to 7:00 PM, 9:00 AM to 10:00 AM on JLT"
	    },
	    domProps: {
	      "value": (_vm.dogWalkingProfile.Remarks)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.dogWalkingProfile, "Remarks", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
	    staticClass: "pull-right btn btn-warning",
	    staticStyle: {
	      "margin-left": "10px"
	    },
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("\n    Close\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "pull-right btn btn-success",
	    on: {
	      "click": function($event) {
	        _vm.saveChanges()
	      }
	    }
	  }, [_vm._v("\n    Save Changes\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "modal-dialog ",
	    staticStyle: {
	      "max-width": "500px"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.notification) ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible"
	  }, [_vm._m(2), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.notification) + "\r\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    staticStyle: {
	      "padding-bottom": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('firstName')),
	      expression: "errors.has('firstName')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.firstName.length > 2) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('firstName')),
	      expression: "!errors.has('firstName')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.firstName),
	      expression: "credentials.firstName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('firstName')
	    },
	    attrs: {
	      "type": "text",
	      "name": "firstName",
	      "data-vv-as": "first name",
	      "autofocus": "",
	      "placeholder": "First Name",
	      "tabindex": "1",
	      "lazy": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.firstName)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "firstName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('firstName')),
	      expression: "errors.has('firstName')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lastName')),
	      expression: "errors.has('lastName')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.lastName.length > 2) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('lastName')),
	      expression: "!errors.has('lastName')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:3'),
	      expression: "'required|min:3'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.lastName),
	      expression: "credentials.lastName",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('lastName')
	    },
	    attrs: {
	      "type": "text",
	      "name": "lastName",
	      "data-vv-as": "last name",
	      "placeholder": "Last Name",
	      "tabindex": "2",
	      "data-vv-delay": "1000"
	    },
	    domProps: {
	      "value": (_vm.credentials.lastName)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "lastName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lastName')),
	      expression: "errors.has('lastName')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.email) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('email')),
	      expression: "!errors.has('email')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.email),
	      expression: "credentials.email",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('email')
	    },
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "data-vv-as": "email",
	      "placeholder": "Email",
	      "tabindex": "3",
	      "data-vv-delay": "1000"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('password')),
	      expression: "!errors.has('password')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('password')
	    },
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": "Password",
	      "tabindex": "4",
	      "data-vv-delay": "1000"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary btn-title pull-right",
	    staticStyle: {
	      "margin-top": "10px"
	    },
	    attrs: {
	      "disabled": _vm.filledRequired == false,
	      "tabindex": "5"
	    },
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Signup")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header text-center",
	    staticStyle: {
	      "padding-top": "0px !important",
	      "padding-bottom": "0px !important"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("We are excited to have you with us!")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('div', {
	    directives: [{
	      name: "chat-scroll",
	      rawName: "v-chat-scroll",
	      value: ({
	        always: false
	      }),
	      expression: "{ always: false }"
	    }],
	    staticClass: "chat"
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('div', [(message.SenderId == _vm.senderIdComp) ? _c('li', {
	      staticClass: "right"
	    }, [_c('span', {
	      staticClass: "chat-img pull-left"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "chat-body clearfix"
	    }, [_c('p', {
	      staticClass: "chat-from"
	    }, [_vm._v("\n              " + _vm._s(message.MessageText) + "\n              "), _c('small', {
	      staticClass: "pull-right",
	      staticStyle: {
	        "padding": "5px"
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-time"
	    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])]) : _c('li', {
	      staticClass: "left clearfix"
	    }, [_c('span', {
	      staticClass: "chat-img pull-right"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "chat-body clearfix"
	    }, [_c('p', {
	      staticClass: "chat-to"
	    }, [_vm._v("\n              " + _vm._s(message.MessageText)), _c('small', {
	      staticClass: "pull-right",
	      staticStyle: {
	        "padding": "5px"
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-time"
	    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessage),
	      expression: "newMessage"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "disabled": _vm.preventChat,
	      "placeholder": "write anything and press send.",
	      "row": "3"
	    },
	    domProps: {
	      "value": (_vm.newMessage)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.sendMessage($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessage = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon btn",
	    attrs: {
	      "disabled": _vm.preventChat
	    },
	    on: {
	      "click": _vm.sendMessage
	    }
	  }, [_vm._v("Send")])])])])
	},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-sm-offset-3"
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content "
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "overflow": "hidden"
	    }
	  }, [_c('br'), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), (_vm.codeSentSuccess == false) ? _c('div', {
	    staticClass: "form-group "
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.userData.Email) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('email')),
	      expression: "!errors.has('email')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.userData.Email),
	      expression: "userData.Email",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('email')
	    },
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "placeholder": "Email address"
	    },
	    domProps: {
	      "value": (_vm.userData.Email)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.userData, "Email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help-inline text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]) : _vm._e(), _vm._v(" "), (!_vm.codeSentSuccess) ? _c('div', [(_vm.pressed == false) ? _c('div', {
	    staticClass: "alert alert-info"
	  }, [_c('p', [_vm._v("Press Generate code to continue, we will send a 6 digit code and send it to your email")])]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success pull-right",
	    attrs: {
	      "disabled": _vm.count > 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Generate Code " + _vm._s(_vm.count))])]) : _vm._e(), _vm._v(" "), (_vm.codeSentSuccess) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.codeFilled == false) ? _c('div', {
	    staticClass: "col-xs-6 remove-margins"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userData.Code),
	      expression: "userData.Code"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Verification Code",
	      "maxlength": "6",
	      "autocorrect": "off",
	      "autocomplete": "off",
	      "autocapitalize": "off",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": (_vm.userData.Code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userData, "Code", $event.target.value)
	      }
	    }
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.codeFilled && _vm.codeVerifySuccess == false) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('p', {
	    staticClass: "small"
	  }, [_c('strong', [_vm._v("Code: " + _vm._s(_vm.userData.Code))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.userData.Password) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('password')),
	      expression: "!errors.has('password')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userData.Password),
	      expression: "userData.Password"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('password')
	    },
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": "Password",
	      "data-vv-delay": "1500"
	    },
	    domProps: {
	      "value": (_vm.userData.Password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validatePassword()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.userData, "Password", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pending) ? _c('button', {
	    staticClass: "btn btn-info pull-right",
	    on: {
	      "click": function($event) {
	        _vm.validatePassword()
	      }
	    }
	  }, [_vm._v(" Change Password")]) : _vm._e(), _vm._v(" "), _c('div')]) : _vm._e()]), _vm._v(" "), _c('div')])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h4', [_vm._v(" Forgot my password")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "small"
	  }, [_c('strong', [_vm._v("Enter your new password below")])])
	}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    staticStyle: {
	      "max-width": "500px"
	    },
	    attrs: {
	      "id": "login-overlay"
	    }
	  }, [(_vm.authenticatedComp) ? _c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [(_vm.userRoleComp == 'Sitter') ? _c('h3', {
	    staticClass: "text-center modal-title"
	  }, [_vm._v(" You are logged in as a Sitter")]) : _vm._e(), _vm._v(" "), (_vm.userRoleComp == 'Client') ? _c('h3', {
	    staticClass: "text-center modal-title"
	  }, [_vm._v(" You are logged in as a Customer")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('a', {
	    staticClass: "text-center",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.goAccount()
	      }
	    }
	  }, [_vm._v("Go to account to switch role")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Back")])])])]) : _vm._e(), _vm._v(" "), (!_vm.authenticatedComp) ? _c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header text-center",
	    staticStyle: {
	      "padding-top": "0px !important",
	      "padding-bottom": "0px !important"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("The next level of dog boarding")]), _vm._v(" "), (_vm.switchAccountComp) ? _c('h3', {
	    staticClass: " alert alert-info"
	  }, [_vm._v("Please login again to complete switching your account")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger alert-dismissible"
	  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.notification) ? _c('div', {
	    staticClass: "alert alert-success alert-dismissible"
	  }, [_vm._m(1), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.notification) + "\r\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "well",
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "form-group "
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "username"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.username) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('email')),
	      expression: "!errors.has('email')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.credentials.username),
	      expression: "credentials.username",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('email')
	    },
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "placeholder": "Email address"
	    },
	    domProps: {
	      "value": (_vm.credentials.username)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "change": function($event) {
	        _vm.$set(_vm.credentials, "username", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    staticClass: "help-inline text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
	    staticClass: "inner-addon right-addon"
	  }, [_c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "fa fa-warning"
	  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.errors.has('password')),
	      expression: "!errors.has('password')"
	    }],
	    staticClass: "fa fa-paw text-success "
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    class: {
	      'input': true, 'has-error': _vm.errors.has('password')
	    },
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": "Password",
	      "data-vv-delay": "1500"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.validateBeforeSubmit()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    staticClass: "text-danger h5"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-block btn-title",
	    attrs: {
	      "disabled": _vm.filledRequired == false
	    },
	    on: {
	      "click": function($event) {
	        _vm.validateBeforeSubmit()
	      }
	    }
	  }, [_vm._v("Login")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-sm-12"
	  }, [_c('ul', {
	    staticClass: "list-unstyled",
	    staticStyle: {
	      "line-height": "2"
	    }
	  }, [_c('li', [_c('a', {
	    staticClass: "btn btn-lg btn-title btn-block btn-social btn-facebook",
	    staticStyle: {
	      "background-color": "#4267b2",
	      "color": "#fff",
	      "margin": "20px auto 0px auto"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-facebook"
	  }), _vm._v(" "), _c('fb-signin-button', {
	    staticClass: "text-center",
	    attrs: {
	      "params": _vm.fbSignInParams
	    },
	    on: {
	      "success": _vm.onSignInSuccess,
	      "error": _vm.onSignInError
	    }
	  }, [_vm._v("\r\n                              Continue with Facebook Account\r\n                            ")])], 1)])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default btn-block btn-title",
	    on: {
	      "click": function($event) {
	        _vm.goSignup()
	      }
	    }
	  }, [_vm._v("Register with your Email")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    staticClass: "card-link",
	    staticStyle: {
	      "padding-left": "5px",
	      "font-size": "14px"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.forgotPassword()
	      }
	    }
	  }, [_vm._v("Forgot Password?")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-bottom": "5px"
	    }
	  }), _vm._v(" "), _vm._m(2)])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "small",
	    staticStyle: {
	      "padding-left": "5px"
	    }
	  }, [_vm._v("By registering you agree to our "), _c('a', {
	    attrs: {
	      "href": "/terms-and-conditions"
	    }
	  }, [_vm._v("terms and conditions")])])
	}]}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "dogWalkingModal",
	      "data-backdrop": "static",
	      "show": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body",
	    attrs: {
	      "id": "modalBody"
	    }
	  }, [(_vm.sitterServices.CityId != null) ? _c('DogWalking', {
	    attrs: {
	      "cityId": _vm.sitterServices.CityId
	    }
	  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 col-xs-12 wrapper-box"
	  }, [_c('div', {
	    attrs: {
	      "name": "sitterServices"
	    }
	  }, [_c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_vm._m(1), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Customize your preferred durations.")]), _vm._v(" "), _c('div', {
	    staticClass: "wrapper-box  col-xs-12 col-sm-5 large-pad"
	  }, [_c('hr', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterServices.MinimumStayDays),
	      expression: "sitterServices.MinimumStayDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "pattern": "\\d*",
	      "aria-describedby": "sizing-addon2"
	    },
	    domProps: {
	      "value": (_vm.sitterServices.MinimumStayDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterServices, "MinimumStayDays", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterServices.MaximumStayDays),
	      expression: "sitterServices.MaximumStayDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "pattern": "\\d*",
	      "aria-describedby": "sizing-addon2"
	    },
	    domProps: {
	      "value": (_vm.sitterServices.MaximumStayDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterServices, "MaximumStayDays", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterServices.EarlierThanDays),
	      expression: "sitterServices.EarlierThanDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "pattern": "\\d*",
	      "aria-describedby": "sizing-addon2"
	    },
	    domProps: {
	      "value": (_vm.sitterServices.EarlierThanDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterServices, "EarlierThanDays", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sitterServices.LaterThanDays),
	      expression: "sitterServices.LaterThanDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "pattern": "\\d*",
	      "aria-describedby": "sizing-addon2"
	    },
	    domProps: {
	      "value": (_vm.sitterServices.LaterThanDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.sitterServices, "LaterThanDays", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Boarding means you can host pets at your own home, Sitting means you visit pet owner home.")]), _vm._v(" "), _vm._l((_vm.sitterServices.SitterServicesDto), function(service) {
	    return _c('div', {
	      staticClass: "wrapper-box  col-xs-12 col-sm-5 large-pad",
	      class: {
	        enabled: service.IsOffered
	      }
	    }, [_c('h3', {
	      class: {
	        'new-service': service.ServiceType == 6
	      }
	    }, [_vm._v(_vm._s(service.Description) + " "), (service.ServiceType == 6) ? _c('span', [_c('i', {
	      staticClass: "fa fa-paw"
	    }), _vm._v(" New "), (service.IsOffered) ? _c('button', {
	      staticClass: "btn btn-info btn-xs pull-right",
	      staticStyle: {
	        "font-size": "smaller!important"
	      },
	      attrs: {
	        "for": service.Description
	      },
	      on: {
	        "click": function($event) {
	          _vm.dogWalkingShow()
	        }
	      }
	    }, [_vm._v("Customize")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (service.Price),
	        expression: "service.Price"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "number",
	        "pattern": "\\d*",
	        "disabled": !service.IsOffered,
	        "placeholder": "Enter your price"
	      },
	      domProps: {
	        "value": (service.Price)
	      },
	      on: {
	        "change": function($event) {
	          _vm.somethingChanged()
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(service, "Price", $event.target.value)
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "input-group-addon"
	    }, [_c('strong', {
	      staticClass: "h5"
	    }, [_vm._v(_vm._s(service.DescriptionPer))])])]), _vm._v(" "), (_vm.sitterServices.CityId == null && service.ServiceType == 6) ? _c('div', [_c('p', {
	      staticClass: "small text-danger",
	      staticStyle: {
	        "margin-top": "8px"
	      }
	    }, [_vm._v("Please add your location from About page")])]) : _c('div', [_c('li', {
	      staticClass: "checkbox"
	    }, [_c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (service.IsOffered),
	        expression: "service.IsOffered"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "id": service.Description
	      },
	      domProps: {
	        "checked": Array.isArray(service.IsOffered) ? _vm._i(service.IsOffered, null) > -1 : (service.IsOffered)
	      },
	      on: {
	        "click": function($event) {
	          _vm.checkCityId(service)
	        },
	        "change": [function($event) {
	          var $$a = service.IsOffered,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (service.IsOffered = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (service.IsOffered = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.$set(service, "IsOffered", $$c)
	          }
	        }, function($event) {
	          _vm.somethingChanged()
	        }]
	      }
	    }), _vm._v(" "), (service.IsOffered) ? _c('label', {
	      staticClass: "small",
	      staticStyle: {
	        "padding-left": "0px"
	      },
	      attrs: {
	        "for": service.Description
	      }
	    }, [_vm._v("Added to My Profile")]) : _vm._e(), _vm._v(" "), (!service.IsOffered) ? _c('label', {
	      staticClass: "small",
	      staticStyle: {
	        "padding-left": "0px"
	      },
	      attrs: {
	        "for": service.Description
	      }
	    }, [_vm._v("Add to My Profile")]) : _vm._e()])])])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-8 col-md-10 col-sm-12  col-xs-12",
	    staticStyle: {
	      "margin": "0px",
	      "padding": "0px"
	    }
	  }, [_c('button', {
	    staticClass: "btn large-pad btn-success btn-block btn-lg",
	    staticStyle: {
	      "margin-top": "20px",
	      "margin-left": "0px"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateSitterServices()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("close")])]), _vm._v(" "), _c('h4', [_vm._v("Dog Walking Preference")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px",
	      "margin-top": "10px"
	    }
	  }, [_vm._v("Stay Duration Filter and Preference "), _c('span', {
	    staticClass: "color-orange",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "New Optional Feature, only receive bookings that match your preferences"
	    }
	  }, [_vm._v("★")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_vm._v("Minimum stay duration "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "If you set this field to 3 days then you will not receive booking requests for 1 or 2 days"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('strong', [_vm._v("Days")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_vm._v("Maximum stay duration "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "If you set this field to 7 days, then you will not receive any booking requests that spans more than 7 days"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('strong', [_vm._v("Days")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_vm._v("Dont receive requests starting before "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "If you set this to 3 days, then you will not receive booking requests that starts tomorrow or in 2 days (0 means you can receive booking requests starting today)"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('strong', [_vm._v("Days")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticStyle: {
	      "display": "inline-block"
	    }
	  }, [_vm._v("Dont receive requests starting after "), _c('i', {
	    staticClass: "fa fa-question-circle",
	    staticStyle: {
	      "color": "orange"
	    },
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Setting this to 90 days means, you will not receive booking requests starting after 3 months"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('strong', [_vm._v("Days")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticStyle: {
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v("Minimum one service should be added "), _c('span', {
	    staticClass: "red-star",
	    attrs: {
	      "data-toggle": "popover",
	      "data-trigger": "hover",
	      "data-placement": "top",
	      "data-container": "body",
	      "data-content": "Required to publish your profile"
	    }
	  }, [_vm._v("★")])])
	}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.message) ? _c('div', {
	    staticClass: "alert alert-dismissible",
	    class: _vm.alertType,
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('strong', [_vm._v("Warning!")]), _vm._v(" " + _vm._s(_vm.message) + "\r\n")]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "alert",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: {
	      'pet-wrapper': _vm.showDetails
	    }
	  }, [_c('div', {
	    staticClass: "media-body"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('img', {
	    staticClass: "media-object img-responsive img-rounded",
	    staticStyle: {
	      "min-width": "60px",
	      "min-height": "60px",
	      "border": "1px solid #c3c3c3"
	    },
	    attrs: {
	      "src": _vm.profilePhotoPathComp,
	      "alt": "",
	      "height": "80",
	      "width": "80"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "media-left"
	  }, [_c('h4', {
	    staticClass: "media-heading main-name",
	    staticStyle: {
	      "padding-bottom": "0px",
	      "margin-bottom": "3px"
	    }
	  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.petComp.Name))])]), _vm._v(" "), _c('h5', {
	    staticClass: "text-muted",
	    staticStyle: {
	      "padding-top": "0px",
	      "margin-top": "0px",
	      "padding-bottom": "0px",
	      "margin-bottom": "3px"
	    }
	  }, [_vm._v(" " + _vm._s(_vm.ageToString(_vm.petComp)))]), _vm._v(" "), _c('h5', {
	    staticStyle: {
	      "padding-top": "0px",
	      "margin-top": "0px",
	      "padding-bottom": "0px",
	      "margin-bottom": "0px"
	    }
	  }, [_vm._v(_vm._s(_vm.genderToString(_vm.petComp.Gender)) + " " + _vm._s(_vm.petTypeToString(_vm.petComp.PetType)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-right media-bottom"
	  }, [(_vm.showDetails) ? _c('button', {
	    staticClass: "btn btn-default ",
	    on: {
	      "click": function($event) {
	        _vm.viewPet()
	      }
	    }
	  }, [_vm._v("View Profile")]) : _vm._e(), _vm._v(" "), (_vm.viewPetModal) ? _c('PetDetailsView', {
	    attrs: {
	      "petId": _vm.petId
	    }
	  }) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', [_c('div', {
	    directives: [{
	      name: "chat-scroll",
	      rawName: "v-chat-scroll",
	      value: ({
	        always: false
	      }),
	      expression: "{ always: false }"
	    }],
	    staticClass: "chat"
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('div', {
	      key: message.MessageId
	    }, [(message.IsSitter) ? _c('li', {
	      staticClass: "right"
	    }, [_c('span', {
	      staticClass: "chat-img pull-left"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "chat-body clearfix"
	    }, [_c('p', {
	      staticClass: "chat-from"
	    }, [_vm._v("\n              " + _vm._s(message.MessageText) + "\n              "), _c('small', {
	      staticClass: "pull-right",
	      staticStyle: {
	        "padding": "5px"
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-time"
	    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])]) : _c('li', {
	      staticClass: "left clearfix"
	    }, [_c('span', {
	      staticClass: "chat-img pull-right"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "chat-body clearfix"
	    }, [_c('p', {
	      staticClass: "chat-to"
	    }, [_vm._v("\n              " + _vm._s(message.MessageText)), _c('small', {
	      staticClass: "pull-right",
	      staticStyle: {
	        "padding": "5px"
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-time"
	    }), _vm._v(_vm._s(_vm.sentDate(message.SentDate)))])])])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control input-text",
	    attrs: {
	      "disabled": _vm.preventChat,
	      "placeholder": "",
	      "row": "3"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon btn",
	    attrs: {
	      "disabled": _vm.preventChat
	    }
	  }, [_vm._v("Send")])])])])
	},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "col-sm-3 col-sm-offset-1"
	  }, [_c('div', {
	    staticClass: "filters"
	  }, [_vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "5"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "5")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "5")
	      }
	    }
	  }), _vm._v("Show Started")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "0"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "0")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "0")
	      }
	    }
	  }), _vm._v("Show all Bookings")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "1")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "1")
	      }
	    }
	  }), _vm._v("Show Completed")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "2")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "2")
	      }
	    }
	  }), _vm._v("Show Cancelled")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "3"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "3")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "3")
	      }
	    }
	  }), _vm._v("Show Pending")])]), _vm._v(" "), _c('div', {
	    staticClass: "radio"
	  }, [_c('label', {
	    staticClass: "small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingState),
	      expression: "searchData.BookingState"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "4"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.searchData.BookingState, "4")
	    },
	    on: {
	      "change": function($event) {
	        _vm.$set(_vm.searchData, "BookingState", "4")
	      }
	    }
	  }), _vm._v("Show Sitter not responding")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "bookingsDashbaordFrom"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.FromDate),
	      expression: "searchData.FromDate"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "readonly": "true",
	      "placeholder": "From Date"
	    },
	    domProps: {
	      "value": (_vm.searchData.FromDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "FromDate", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-to-date"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "bookingsDashbaordTo"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.ToDate),
	      expression: "searchData.ToDate"
	    }],
	    staticClass: "form-control input-text",
	    attrs: {
	      "readonly": "true",
	      "placeholder": "To Date"
	    },
	    domProps: {
	      "value": (_vm.searchData.ToDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "ToDate", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-location"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "form-group "
	  }, [(_vm.countriesListComp) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.BookingFilterCountryId),
	      expression: "searchData.BookingFilterCountryId"
	    }],
	    staticClass: "form-control ",
	    attrs: {
	      "required": "",
	      "name": "serviceSelect"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.searchData, "BookingFilterCountryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "disabled": "",
	      "selected": "",
	      "hidden": ""
	    }
	  }, [_vm._v("Filter specific country")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All Countries")]), _vm._v(" "), _vm._l((_vm.countriesListComp), function(country) {
	    return _c('option', {
	      domProps: {
	        "value": country.CountryId
	      }
	    }, [_vm._v("\n                                    " + _vm._s(country.CountryName) + "\n                                  ")])
	  })], 2) : _vm._e()])])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-success btn-block",
	    on: {
	      "click": function($event) {
	        _vm.applyFilters()
	      }
	    }
	  }, [_vm._v("Apply Filters")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "input-group col-md-12"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchData.SearchText),
	      expression: "searchData.SearchText"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search Bookings, by Booking Number, Sitter or Customer Name or Email"
	    },
	    domProps: {
	      "value": (_vm.searchData.SearchText)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.applyFilters()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.searchData, "SearchText", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._m(5), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(0)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(0)
	      }
	    }
	  }, [_vm._v("None")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(1)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(1)
	      }
	    }
	  }, [_vm._v("Recent Submitted Date")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(2)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(2)
	      }
	    }
	  }, [_vm._v("Oldest Submitted Date")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(3)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(3)
	      }
	    }
	  }, [_vm._v("Start Date")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(4)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(4)
	      }
	    }
	  }, [_vm._v("End Date")]), _vm._v(" "), _c('a', {
	    class: {
	      'strong-font': _vm.isCurrentSort(5)
	    },
	    staticStyle: {
	      "margin-top": "0px",
	      "padding-left": "5px",
	      "padding-right": "5px",
	      "display": "inline-block"
	    },
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.sortList(5)
	      }
	    }
	  }, [_vm._v("Sitter Id")]), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "margin-top": "0px"
	    }
	  })]), _vm._v(" "), _vm._l((_vm.bookingsListComp), function(booking, index) {
	    return (_vm.bookingsListComp.length > 0) ? _c('div', {
	      staticClass: "col-sm-12"
	    }, [_c('div', {
	      staticClass: "sitterListbox card"
	    }, [_c('div', {
	      staticClass: "profile-body "
	    }, [_c('div', {
	      staticClass: "bottom-row"
	    }, [_c('div', {
	      staticClass: "content col-sm-4"
	    }, [_c('h5', {
	      class: booking.StatusAdminClass
	    }, [_vm._v("Booking ID "), _c('strong', [_vm._v(_vm._s(booking.BookingNumber))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_c('strong', [_vm._v(" Sitter: " + _vm._s(booking.SitterName) + " ")])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_c('strong', [_vm._v(" Customer: " + _vm._s(booking.CustomerName))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Submitted: " + _vm._s(_vm.dateFormatter(booking.SubmittedDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Starts: " + _vm._s(_vm.dateFormatter(booking.StartDate)))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Ends: " + _vm._s(_vm.dateFormatter(booking.EndDate)))])]), _vm._v(" "), _c('div', {
	      staticClass: "content col-sm-8"
	    }, [_c('h5', [_vm._v(" Booking Status")]), _vm._v(" "), _c('p', {
	      class: booking.StatusAdminClass
	    }, [_c('strong', [_vm._v(_vm._s(booking.StatusAdminMessage))])]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Sitter Status: " + _vm._s(booking.SitterStatus))]), _vm._v(" "), _c('p', {
	      staticClass: "small"
	    }, [_vm._v(" Customer Status: " + _vm._s(booking.CustomerStatus))]), _vm._v(" "), _c('div', {
	      staticClass: "col-sm-12 remove-margins"
	    }, [_c('h5', [_c('strong', [_vm._v(_vm._s(booking.Country))])])])])]), _vm._v(" "), _c('div', {
	      staticClass: "bottom-row pull-right"
	    }, [_c('button', {
	      staticClass: "btn btn-info btn-sm ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.viewBooking(booking)
	        }
	      }
	    }, [_vm._v("View Booking")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm ",
	      staticStyle: {
	        "margin": "3px"
	      },
	      on: {
	        "click": function($event) {
	          _vm.adminHideBooking(booking)
	        }
	      }
	    }, [_vm._v("Hide Booking")])])])]), _vm._v(" "), _c('br')]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.bookingsListComp.length == 0) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_vm._m(7)]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Welcome to Bookings Dashboard")]), _vm._v(" "), _c('p', {
	    staticClass: "text-center"
	  }, [_vm._v(" By default showing all bookings that were submitted last 7 days")]), _vm._v(" "), _c('hr')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h5', [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Filters and Preferences")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "fa fa-search"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px",
	      "padding": "5px",
	      "display": "inline-block"
	    }
	  }, [_c('strong', [_vm._v("Sory by:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "bounce1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bounce3"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sitterListbox card"
	  }, [_c('p', [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" Ooopsy, no results match your search.")])])
	}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-12 remove-margins"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ConfirmedReservations')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "text-center hidden-sm hidden-xs"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', {
	    staticClass: "text-center hidden-md hidden-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" Bookings\n  ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('hr', {
	    staticClass: "hidden-xs hidden-sm",
	    staticStyle: {
	      "margin-top": "0px",
	      "margin-bottom": "0px"
	    }
	  })])
	}]}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.1a452d831d42d7b2ed28.js